
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ffqgm", function(module, exports) {

$parcel$export(module.exports, "createChat", () => $b19ca0fdfcbacc57$export$f680e1eadf80e402);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $eeJ70 = parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b19ca0fdfcbacc57$var$Fe = {
    webhookUrl: "http://localhost:5678",
    webhookConfig: {
        method: "POST",
        headers: {}
    },
    target: "#n8n-chat",
    mode: "window",
    loadPreviousSession: !0,
    chatInputKey: "chatInput",
    chatSessionKey: "sessionId",
    defaultLanguage: "en",
    showWelcomeScreen: !1,
    initialMessages: [
        "Hi there! \uD83D\uDC4B",
        "My name is Nathan. How can I assist you today?"
    ],
    i18n: {
        en: {
            title: "Hi there! \uD83D\uDC4B",
            subtitle: "Start a chat. We're here to help you 24/7.",
            footer: "",
            getStarted: "New Conversation",
            inputPlaceholder: "Type your question..",
            closeButtonTooltip: "Close chat"
        }
    },
    theme: {}
}, $b19ca0fdfcbacc57$var$Mo = "#n8n-chat", $b19ca0fdfcbacc57$var$Io = "n8n-chat", $b19ca0fdfcbacc57$var$ht = `${$b19ca0fdfcbacc57$var$Io}/sessionId`, $b19ca0fdfcbacc57$var$fr = "Chat", $b19ca0fdfcbacc57$var$pr = "ChatOptions";
var $b19ca0fdfcbacc57$var$X = [];
for(var $b19ca0fdfcbacc57$var$wn = 0; $b19ca0fdfcbacc57$var$wn < 256; ++$b19ca0fdfcbacc57$var$wn)$b19ca0fdfcbacc57$var$X.push(($b19ca0fdfcbacc57$var$wn + 256).toString(16).slice(1));
function $b19ca0fdfcbacc57$var$Oo(n, e = 0) {
    return ($b19ca0fdfcbacc57$var$X[n[e + 0]] + $b19ca0fdfcbacc57$var$X[n[e + 1]] + $b19ca0fdfcbacc57$var$X[n[e + 2]] + $b19ca0fdfcbacc57$var$X[n[e + 3]] + "-" + $b19ca0fdfcbacc57$var$X[n[e + 4]] + $b19ca0fdfcbacc57$var$X[n[e + 5]] + "-" + $b19ca0fdfcbacc57$var$X[n[e + 6]] + $b19ca0fdfcbacc57$var$X[n[e + 7]] + "-" + $b19ca0fdfcbacc57$var$X[n[e + 8]] + $b19ca0fdfcbacc57$var$X[n[e + 9]] + "-" + $b19ca0fdfcbacc57$var$X[n[e + 10]] + $b19ca0fdfcbacc57$var$X[n[e + 11]] + $b19ca0fdfcbacc57$var$X[n[e + 12]] + $b19ca0fdfcbacc57$var$X[n[e + 13]] + $b19ca0fdfcbacc57$var$X[n[e + 14]] + $b19ca0fdfcbacc57$var$X[n[e + 15]]).toLowerCase();
}
var $b19ca0fdfcbacc57$var$Je, $b19ca0fdfcbacc57$var$Fo = new Uint8Array(16);
function $b19ca0fdfcbacc57$var$Bo() {
    if (!$b19ca0fdfcbacc57$var$Je && ($b19ca0fdfcbacc57$var$Je = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !$b19ca0fdfcbacc57$var$Je)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $b19ca0fdfcbacc57$var$Je($b19ca0fdfcbacc57$var$Fo);
}
var $b19ca0fdfcbacc57$var$Po = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const $b19ca0fdfcbacc57$var$dt = {
    randomUUID: $b19ca0fdfcbacc57$var$Po
};
function $b19ca0fdfcbacc57$var$Be(n, e, t) {
    if ($b19ca0fdfcbacc57$var$dt.randomUUID && !e && !n) return $b19ca0fdfcbacc57$var$dt.randomUUID();
    n = n || {};
    var r = n.random || (n.rng || $b19ca0fdfcbacc57$var$Bo)();
    return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, $b19ca0fdfcbacc57$var$Oo(r);
}
async function $b19ca0fdfcbacc57$var$$o() {
    return "";
}
async function $b19ca0fdfcbacc57$var$Vn(...n) {
    var s, i;
    const e = await $b19ca0fdfcbacc57$var$$o(), t = (s = n[1]) == null ? void 0 : s.body, r = {
        ...e ? {
            authorization: `Bearer ${e}`
        } : {},
        ...(i = n[1]) == null ? void 0 : i.headers
    };
    return t instanceof FormData ? delete r["Content-Type"] : r["Content-Type"] = "application/json", await (await fetch(n[0], {
        ...n[1],
        mode: "cors",
        cache: "no-cache",
        headers: r
    })).json();
}
async function $b19ca0fdfcbacc57$var$hr(n, e = {}, t = {}) {
    let r = n;
    return Object.keys(e).length > 0 && (r = `${r}?${new URLSearchParams(e).toString()}`), await $b19ca0fdfcbacc57$var$Vn(r, {
        ...t,
        method: "GET"
    });
}
async function $b19ca0fdfcbacc57$var$dr(n, e = {}, t = {}) {
    return await $b19ca0fdfcbacc57$var$Vn(n, {
        ...t,
        method: "POST",
        body: JSON.stringify(e)
    });
}
async function $b19ca0fdfcbacc57$var$zo(n, e = {}, t = [], r = {}) {
    const o = new FormData();
    for(const s in e)o.append(s, e[s]);
    for (const s of t)o.append("files", s);
    return await $b19ca0fdfcbacc57$var$Vn(n, {
        ...r,
        method: "POST",
        body: o
    });
}
async function $b19ca0fdfcbacc57$var$Uo(n, e) {
    var r, o;
    return await (((r = e.webhookConfig) == null ? void 0 : r.method) === "POST" ? $b19ca0fdfcbacc57$var$dr : $b19ca0fdfcbacc57$var$hr)(`${e.webhookUrl}`, {
        action: "loadPreviousSession",
        [e.chatSessionKey]: n,
        ...e.metadata ? {
            metadata: e.metadata
        } : {}
    }, {
        headers: (o = e.webhookConfig) == null ? void 0 : o.headers
    });
}
async function $b19ca0fdfcbacc57$var$Ho(n, e, t, r) {
    var s, i, c;
    return e.length > 0 ? await $b19ca0fdfcbacc57$var$zo(`${r.webhookUrl}`, {
        action: "sendMessage",
        [r.chatSessionKey]: t,
        [r.chatInputKey]: n,
        ...r.metadata ? {
            metadata: r.metadata
        } : {}
    }, e, {
        headers: (s = r.webhookConfig) == null ? void 0 : s.headers
    }) : await (((i = r.webhookConfig) == null ? void 0 : i.method) === "POST" ? $b19ca0fdfcbacc57$var$dr : $b19ca0fdfcbacc57$var$hr)(`${r.webhookUrl}`, {
        action: "sendMessage",
        [r.chatSessionKey]: t,
        [r.chatInputKey]: n,
        ...r.metadata ? {
            metadata: r.metadata
        } : {}
    }, {
        headers: (c = r.webhookConfig) == null ? void 0 : c.headers
    });
}
function $b19ca0fdfcbacc57$var$Vo() {
    const n = /* @__PURE__ */ new Map();
    function e(o, s) {
        const i = n.get(o);
        i && i.splice(i.indexOf(s) >>> 0, 1);
    }
    function t(o, s) {
        let i = n.get(o);
        return i ? i.push(s) : i = [
            s
        ], n.set(o, i), ()=>e(o, s);
    }
    function r(o, s) {
        const i = n.get(o);
        i && i.slice().forEach(async (c)=>{
            await c(s);
        });
    }
    return {
        on: t,
        off: e,
        emit: r
    };
}
function $b19ca0fdfcbacc57$var$Go(n) {
    if (!document.querySelector(n)) {
        const t = document.createElement("div");
        n.startsWith("#") && (t.id = n.replace("#", "")), n.startsWith(".") && t.classList.add(n.replace(".", "")), document.body.appendChild(t);
    }
}
const $b19ca0fdfcbacc57$var$re = $b19ca0fdfcbacc57$var$Vo(), $b19ca0fdfcbacc57$var$jo = {
    install (n, e) {
        n.provide($b19ca0fdfcbacc57$var$pr, e);
        const t = (0, $01W3b.ref)([]), r = (0, $01W3b.ref)(null), o = (0, $01W3b.ref)(!1), s = (0, $01W3b.computed)(()=>(e.initialMessages ?? []).map((u)=>({
                    id: $b19ca0fdfcbacc57$var$Be(),
                    text: u,
                    sender: "bot",
                    createdAt: /* @__PURE__ */ new Date().toISOString()
                })));
        async function i(u, p = []) {
            const f = {
                id: $b19ca0fdfcbacc57$var$Be(),
                text: u,
                sender: "user",
                files: p,
                createdAt: /* @__PURE__ */ new Date().toISOString()
            };
            t.value.push(f), o.value = !0, (0, $TusQn.nextTick)(()=>{
                $b19ca0fdfcbacc57$var$re.emit("scrollToBottom");
            });
            const h = await $b19ca0fdfcbacc57$var$Ho(u, p, r.value, e);
            let d = h.output ?? h.text ?? "";
            if (d === "" && Object.keys(h).length > 0) try {
                d = JSON.stringify(h, null, 2);
            } catch  {}
            const g = {
                id: $b19ca0fdfcbacc57$var$Be(),
                text: d,
                sender: "bot",
                createdAt: /* @__PURE__ */ new Date().toISOString()
            };
            t.value.push(g), o.value = !1, (0, $TusQn.nextTick)(()=>{
                $b19ca0fdfcbacc57$var$re.emit("scrollToBottom");
            });
        }
        async function c() {
            if (!e.loadPreviousSession) return;
            const u = localStorage.getItem($b19ca0fdfcbacc57$var$ht) ?? $b19ca0fdfcbacc57$var$Be(), p = await $b19ca0fdfcbacc57$var$Uo(u, e), f = /* @__PURE__ */ new Date().toISOString();
            return t.value = ((p == null ? void 0 : p.data) || []).map((h, d)=>({
                    id: `${d}`,
                    text: h.kwargs.content,
                    sender: h.id.includes("HumanMessage") ? "user" : "bot",
                    createdAt: f
                })), t.value.length && (r.value = u), u;
        }
        async function a() {
            r.value = $b19ca0fdfcbacc57$var$Be(), localStorage.setItem($b19ca0fdfcbacc57$var$ht, r.value);
        }
        const l = {
            initialMessages: s,
            messages: t,
            currentSessionId: r,
            waitingForResponse: o,
            loadPreviousSession: c,
            startNewSession: a,
            sendMessage: i
        };
        n.provide($b19ca0fdfcbacc57$var$fr, l), n.config.globalProperties.$chat = l;
    }
};
function $b19ca0fdfcbacc57$var$Gn(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $b19ca0fdfcbacc57$var$Zo(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t = function r() {
            return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t.prototype = e.prototype;
    } else t = {};
    return Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(r) {
        var o = Object.getOwnPropertyDescriptor(n, r);
        Object.defineProperty(t, r, o.get ? o : {
            enumerable: !0,
            get: function() {
                return n[r];
            }
        });
    }), t;
}
function $b19ca0fdfcbacc57$var$gr(n) {
    return n instanceof Map ? n.clear = n.delete = n.set = function() {
        throw new Error("map is read-only");
    } : n instanceof Set && (n.add = n.clear = n.delete = function() {
        throw new Error("set is read-only");
    }), Object.freeze(n), Object.getOwnPropertyNames(n).forEach((e)=>{
        const t = n[e], r = typeof t;
        (r === "object" || r === "function") && !Object.isFrozen(t) && $b19ca0fdfcbacc57$var$gr(t);
    }), n;
}
class $b19ca0fdfcbacc57$var$gt {
    /**
   * @param {CompiledMode} mode
   */ constructor(e){
        e.data === void 0 && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1;
    }
    ignoreMatch() {
        this.isMatchIgnored = !0;
    }
}
function $b19ca0fdfcbacc57$var$mr(n) {
    return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function $b19ca0fdfcbacc57$var$ke(n, ...e) {
    const t = /* @__PURE__ */ Object.create(null);
    for(const r in n)t[r] = n[r];
    return e.forEach(function(r) {
        for(const o in r)t[o] = r[o];
    }), /** @type {T} */ t;
}
const $b19ca0fdfcbacc57$var$Ko = "</span>", $b19ca0fdfcbacc57$var$mt = (n)=>!!n.scope, $b19ca0fdfcbacc57$var$Wo = (n, { prefix: e })=>{
    if (n.startsWith("language:")) return n.replace("language:", "language-");
    if (n.includes(".")) {
        const t = n.split(".");
        return [
            `${e}${t.shift()}`,
            ...t.map((r, o)=>`${r}${"_".repeat(o + 1)}`)
        ].join(" ");
    }
    return `${e}${n}`;
};
class $b19ca0fdfcbacc57$var$Yo {
    /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */ constructor(e, t){
        this.buffer = "", this.classPrefix = t.classPrefix, e.walk(this);
    }
    /**
   * Adds texts to the output stream
   *
   * @param {string} text */ addText(e) {
        this.buffer += $b19ca0fdfcbacc57$var$mr(e);
    }
    /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */ openNode(e) {
        if (!$b19ca0fdfcbacc57$var$mt(e)) return;
        const t = $b19ca0fdfcbacc57$var$Wo(e.scope, {
            prefix: this.classPrefix
        });
        this.span(t);
    }
    /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */ closeNode(e) {
        $b19ca0fdfcbacc57$var$mt(e) && (this.buffer += $b19ca0fdfcbacc57$var$Ko);
    }
    /**
   * returns the accumulated buffer
  */ value() {
        return this.buffer;
    }
    // helpers
    /**
   * Builds a span element
   *
   * @param {string} className */ span(e) {
        this.buffer += `<span class="${e}">`;
    }
}
const $b19ca0fdfcbacc57$var$_t = (n = {})=>{
    const e = {
        children: []
    };
    return Object.assign(e, n), e;
};
class $b19ca0fdfcbacc57$var$jn {
    constructor(){
        this.rootNode = $b19ca0fdfcbacc57$var$_t(), this.stack = [
            this.rootNode
        ];
    }
    get top() {
        return this.stack[this.stack.length - 1];
    }
    get root() {
        return this.rootNode;
    }
    /** @param {Node} node */ add(e) {
        this.top.children.push(e);
    }
    /** @param {string} scope */ openNode(e) {
        const t = $b19ca0fdfcbacc57$var$_t({
            scope: e
        });
        this.add(t), this.stack.push(t);
    }
    closeNode() {
        if (this.stack.length > 1) return this.stack.pop();
    }
    closeAllNodes() {
        for(; this.closeNode(););
    }
    toJSON() {
        return JSON.stringify(this.rootNode, null, 4);
    }
    /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */ walk(e) {
        return this.constructor._walk(e, this.rootNode);
    }
    /**
   * @param {Renderer} builder
   * @param {Node} node
   */ static _walk(e, t) {
        return typeof t == "string" ? e.addText(t) : t.children && (e.openNode(t), t.children.forEach((r)=>this._walk(e, r)), e.closeNode(t)), e;
    }
    /**
   * @param {Node} node
   */ static _collapse(e) {
        typeof e != "string" && e.children && (e.children.every((t)=>typeof t == "string") ? e.children = [
            e.children.join("")
        ] : e.children.forEach((t)=>{
            $b19ca0fdfcbacc57$var$jn._collapse(t);
        }));
    }
}
class $b19ca0fdfcbacc57$var$Jo extends $b19ca0fdfcbacc57$var$jn {
    /**
   * @param {*} options
   */ constructor(e){
        super(), this.options = e;
    }
    /**
   * @param {string} text
   */ addText(e) {
        e !== "" && this.add(e);
    }
    /** @param {string} scope */ startScope(e) {
        this.openNode(e);
    }
    endScope() {
        this.closeNode();
    }
    /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */ __addSublanguage(e, t) {
        const r = e.root;
        t && (r.scope = `language:${t}`), this.add(r);
    }
    toHTML() {
        return new $b19ca0fdfcbacc57$var$Yo(this, this.options).value();
    }
    finalize() {
        return this.closeAllNodes(), !0;
    }
}
function $b19ca0fdfcbacc57$var$Ue(n) {
    return n ? typeof n == "string" ? n : n.source : null;
}
function $b19ca0fdfcbacc57$var$_r(n) {
    return $b19ca0fdfcbacc57$var$De("(?=", n, ")");
}
function $b19ca0fdfcbacc57$var$Xo(n) {
    return $b19ca0fdfcbacc57$var$De("(?:", n, ")*");
}
function $b19ca0fdfcbacc57$var$Qo(n) {
    return $b19ca0fdfcbacc57$var$De("(?:", n, ")?");
}
function $b19ca0fdfcbacc57$var$De(...n) {
    return n.map((t)=>$b19ca0fdfcbacc57$var$Ue(t)).join("");
}
function $b19ca0fdfcbacc57$var$es(n) {
    const e = n[n.length - 1];
    return typeof e == "object" && e.constructor === Object ? (n.splice(n.length - 1, 1), e) : {};
}
function $b19ca0fdfcbacc57$var$Zn(...n) {
    return "(" + ($b19ca0fdfcbacc57$var$es(n).capture ? "" : "?:") + n.map((r)=>$b19ca0fdfcbacc57$var$Ue(r)).join("|") + ")";
}
function $b19ca0fdfcbacc57$var$br(n) {
    return new RegExp(n.toString() + "|").exec("").length - 1;
}
function $b19ca0fdfcbacc57$var$ns(n, e) {
    const t = n && n.exec(e);
    return t && t.index === 0;
}
const $b19ca0fdfcbacc57$var$ts = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function $b19ca0fdfcbacc57$var$Kn(n, { joinWith: e }) {
    let t = 0;
    return n.map((r)=>{
        t += 1;
        const o = t;
        let s = $b19ca0fdfcbacc57$var$Ue(r), i = "";
        for(; s.length > 0;){
            const c = $b19ca0fdfcbacc57$var$ts.exec(s);
            if (!c) {
                i += s;
                break;
            }
            i += s.substring(0, c.index), s = s.substring(c.index + c[0].length), c[0][0] === "\\" && c[1] ? i += "\\" + String(Number(c[1]) + o) : (i += c[0], c[0] === "(" && t++);
        }
        return i;
    }).map((r)=>`(${r})`).join(e);
}
const $b19ca0fdfcbacc57$var$rs = /\b\B/, $b19ca0fdfcbacc57$var$vr = "[a-zA-Z]\\w*", $b19ca0fdfcbacc57$var$Wn = "[a-zA-Z_]\\w*", $b19ca0fdfcbacc57$var$kr = "\\b\\d+(\\.\\d+)?", $b19ca0fdfcbacc57$var$xr = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", $b19ca0fdfcbacc57$var$yr = "\\b(0b[01]+)", $b19ca0fdfcbacc57$var$os = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", $b19ca0fdfcbacc57$var$ss = (n = {})=>{
    const e = /^#![ ]*\//;
    return n.binary && (n.begin = $b19ca0fdfcbacc57$var$De(e, /.*\b/, n.binary, /\b.*/)), $b19ca0fdfcbacc57$var$ke({
        scope: "meta",
        begin: e,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */ "on:begin": (t, r)=>{
            t.index !== 0 && r.ignoreMatch();
        }
    }, n);
}, $b19ca0fdfcbacc57$var$He = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
}, $b19ca0fdfcbacc57$var$cs = {
    scope: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [
        $b19ca0fdfcbacc57$var$He
    ]
}, $b19ca0fdfcbacc57$var$is = {
    scope: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [
        $b19ca0fdfcbacc57$var$He
    ]
}, $b19ca0fdfcbacc57$var$as = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
}, $b19ca0fdfcbacc57$var$ln = function(n, e, t = {}) {
    const r = $b19ca0fdfcbacc57$var$ke({
        scope: "comment",
        begin: n,
        end: e,
        contains: []
    }, t);
    r.contains.push({
        scope: "doctag",
        // hack to avoid the space from being included. the space is necessary to
        // match here to prevent the plain text rule below from gobbling up doctags
        begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
        end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
        excludeBegin: !0,
        relevance: 0
    });
    const o = $b19ca0fdfcbacc57$var$Zn(// list of common 1 and 2 letter words in English
    "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, // contractions - can't we'd they're let's, etc
    /[A-Za-z]+[-][a-z]+/, // `no-way`, etc.
    /[A-Za-z][a-z]{2,}/);
    return r.contains.push({
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: $b19ca0fdfcbacc57$var$De(/[ ]+/, // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
        "(", o, /[.]?[:]?([.][ ]|[ ])/, "){3}")
    }), r;
}, $b19ca0fdfcbacc57$var$ls = $b19ca0fdfcbacc57$var$ln("//", "$"), $b19ca0fdfcbacc57$var$us = $b19ca0fdfcbacc57$var$ln("/\\*", "\\*/"), $b19ca0fdfcbacc57$var$fs = $b19ca0fdfcbacc57$var$ln("#", "$"), $b19ca0fdfcbacc57$var$ps = {
    scope: "number",
    begin: $b19ca0fdfcbacc57$var$kr,
    relevance: 0
}, $b19ca0fdfcbacc57$var$hs = {
    scope: "number",
    begin: $b19ca0fdfcbacc57$var$xr,
    relevance: 0
}, $b19ca0fdfcbacc57$var$ds = {
    scope: "number",
    begin: $b19ca0fdfcbacc57$var$yr,
    relevance: 0
}, $b19ca0fdfcbacc57$var$gs = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
        $b19ca0fdfcbacc57$var$He,
        {
            begin: /\[/,
            end: /\]/,
            relevance: 0,
            contains: [
                $b19ca0fdfcbacc57$var$He
            ]
        }
    ]
}, $b19ca0fdfcbacc57$var$ms = {
    scope: "title",
    begin: $b19ca0fdfcbacc57$var$vr,
    relevance: 0
}, $b19ca0fdfcbacc57$var$_s = {
    scope: "title",
    begin: $b19ca0fdfcbacc57$var$Wn,
    relevance: 0
}, $b19ca0fdfcbacc57$var$bs = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + $b19ca0fdfcbacc57$var$Wn,
    relevance: 0
}, $b19ca0fdfcbacc57$var$vs = function(n) {
    return Object.assign(n, {
        /** @type {ModeCallback} */ "on:begin": (e, t)=>{
            t.data._beginMatch = e[1];
        },
        /** @type {ModeCallback} */ "on:end": (e, t)=>{
            t.data._beginMatch !== e[1] && t.ignoreMatch();
        }
    });
};
var $b19ca0fdfcbacc57$var$Xe = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: $b19ca0fdfcbacc57$var$cs,
    BACKSLASH_ESCAPE: $b19ca0fdfcbacc57$var$He,
    BINARY_NUMBER_MODE: $b19ca0fdfcbacc57$var$ds,
    BINARY_NUMBER_RE: $b19ca0fdfcbacc57$var$yr,
    COMMENT: $b19ca0fdfcbacc57$var$ln,
    C_BLOCK_COMMENT_MODE: $b19ca0fdfcbacc57$var$us,
    C_LINE_COMMENT_MODE: $b19ca0fdfcbacc57$var$ls,
    C_NUMBER_MODE: $b19ca0fdfcbacc57$var$hs,
    C_NUMBER_RE: $b19ca0fdfcbacc57$var$xr,
    END_SAME_AS_BEGIN: $b19ca0fdfcbacc57$var$vs,
    HASH_COMMENT_MODE: $b19ca0fdfcbacc57$var$fs,
    IDENT_RE: $b19ca0fdfcbacc57$var$vr,
    MATCH_NOTHING_RE: $b19ca0fdfcbacc57$var$rs,
    METHOD_GUARD: $b19ca0fdfcbacc57$var$bs,
    NUMBER_MODE: $b19ca0fdfcbacc57$var$ps,
    NUMBER_RE: $b19ca0fdfcbacc57$var$kr,
    PHRASAL_WORDS_MODE: $b19ca0fdfcbacc57$var$as,
    QUOTE_STRING_MODE: $b19ca0fdfcbacc57$var$is,
    REGEXP_MODE: $b19ca0fdfcbacc57$var$gs,
    RE_STARTERS_RE: $b19ca0fdfcbacc57$var$os,
    SHEBANG: $b19ca0fdfcbacc57$var$ss,
    TITLE_MODE: $b19ca0fdfcbacc57$var$ms,
    UNDERSCORE_IDENT_RE: $b19ca0fdfcbacc57$var$Wn,
    UNDERSCORE_TITLE_MODE: $b19ca0fdfcbacc57$var$_s
});
function $b19ca0fdfcbacc57$var$ks(n, e) {
    n.input[n.index - 1] === "." && e.ignoreMatch();
}
function $b19ca0fdfcbacc57$var$xs(n, e) {
    n.className !== void 0 && (n.scope = n.className, delete n.className);
}
function $b19ca0fdfcbacc57$var$ys(n, e) {
    e && n.beginKeywords && (n.begin = "\\b(" + n.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", n.__beforeBegin = $b19ca0fdfcbacc57$var$ks, n.keywords = n.keywords || n.beginKeywords, delete n.beginKeywords, n.relevance === void 0 && (n.relevance = 0));
}
function $b19ca0fdfcbacc57$var$Es(n, e) {
    Array.isArray(n.illegal) && (n.illegal = $b19ca0fdfcbacc57$var$Zn(...n.illegal));
}
function $b19ca0fdfcbacc57$var$ws(n, e) {
    if (n.match) {
        if (n.begin || n.end) throw new Error("begin & end are not supported with match");
        n.begin = n.match, delete n.match;
    }
}
function $b19ca0fdfcbacc57$var$As(n, e) {
    n.relevance === void 0 && (n.relevance = 1);
}
const $b19ca0fdfcbacc57$var$Cs = (n, e)=>{
    if (!n.beforeMatch) return;
    if (n.starts) throw new Error("beforeMatch cannot be used with starts");
    const t = Object.assign({}, n);
    Object.keys(n).forEach((r)=>{
        delete n[r];
    }), n.keywords = t.keywords, n.begin = $b19ca0fdfcbacc57$var$De(t.beforeMatch, $b19ca0fdfcbacc57$var$_r(t.begin)), n.starts = {
        relevance: 0,
        contains: [
            Object.assign(t, {
                endsParent: !0
            })
        ]
    }, n.relevance = 0, delete t.beforeMatch;
}, $b19ca0fdfcbacc57$var$Ss = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    // common variable name
    "list",
    // common variable name
    "value"
], $b19ca0fdfcbacc57$var$Ds = "keyword";
function $b19ca0fdfcbacc57$var$Er(n, e, t = $b19ca0fdfcbacc57$var$Ds) {
    const r = /* @__PURE__ */ Object.create(null);
    return typeof n == "string" ? o(t, n.split(" ")) : Array.isArray(n) ? o(t, n) : Object.keys(n).forEach(function(s) {
        Object.assign(r, $b19ca0fdfcbacc57$var$Er(n[s], e, s));
    }), r;
    function o(s, i) {
        e && (i = i.map((c)=>c.toLowerCase())), i.forEach(function(c) {
            const a = c.split("|");
            r[a[0]] = [
                s,
                $b19ca0fdfcbacc57$var$Ts(a[0], a[1])
            ];
        });
    }
}
function $b19ca0fdfcbacc57$var$Ts(n, e) {
    return e ? Number(e) : $b19ca0fdfcbacc57$var$Rs(n) ? 0 : 1;
}
function $b19ca0fdfcbacc57$var$Rs(n) {
    return $b19ca0fdfcbacc57$var$Ss.includes(n.toLowerCase());
}
const $b19ca0fdfcbacc57$var$bt = {}, $b19ca0fdfcbacc57$var$Ce = (n)=>{
    console.error(n);
}, $b19ca0fdfcbacc57$var$vt = (n, ...e)=>{
    console.log(`WARN: ${n}`, ...e);
}, $b19ca0fdfcbacc57$var$Te = (n, e)=>{
    $b19ca0fdfcbacc57$var$bt[`${n}/${e}`] || (console.log(`Deprecated as of ${n}. ${e}`), $b19ca0fdfcbacc57$var$bt[`${n}/${e}`] = !0);
}, $b19ca0fdfcbacc57$var$on = new Error();
function $b19ca0fdfcbacc57$var$wr(n, e, { key: t }) {
    let r = 0;
    const o = n[t], s = {}, i = {};
    for(let c = 1; c <= e.length; c++)i[c + r] = o[c], s[c + r] = !0, r += $b19ca0fdfcbacc57$var$br(e[c - 1]);
    n[t] = i, n[t]._emit = s, n[t]._multi = !0;
}
function $b19ca0fdfcbacc57$var$Ls(n) {
    if (Array.isArray(n.begin)) {
        if (n.skip || n.excludeBegin || n.returnBegin) throw $b19ca0fdfcbacc57$var$Ce("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), $b19ca0fdfcbacc57$var$on;
        if (typeof n.beginScope != "object" || n.beginScope === null) throw $b19ca0fdfcbacc57$var$Ce("beginScope must be object"), $b19ca0fdfcbacc57$var$on;
        $b19ca0fdfcbacc57$var$wr(n, n.begin, {
            key: "beginScope"
        }), n.begin = $b19ca0fdfcbacc57$var$Kn(n.begin, {
            joinWith: ""
        });
    }
}
function $b19ca0fdfcbacc57$var$Ns(n) {
    if (Array.isArray(n.end)) {
        if (n.skip || n.excludeEnd || n.returnEnd) throw $b19ca0fdfcbacc57$var$Ce("skip, excludeEnd, returnEnd not compatible with endScope: {}"), $b19ca0fdfcbacc57$var$on;
        if (typeof n.endScope != "object" || n.endScope === null) throw $b19ca0fdfcbacc57$var$Ce("endScope must be object"), $b19ca0fdfcbacc57$var$on;
        $b19ca0fdfcbacc57$var$wr(n, n.end, {
            key: "endScope"
        }), n.end = $b19ca0fdfcbacc57$var$Kn(n.end, {
            joinWith: ""
        });
    }
}
function $b19ca0fdfcbacc57$var$qs(n) {
    n.scope && typeof n.scope == "object" && n.scope !== null && (n.beginScope = n.scope, delete n.scope);
}
function $b19ca0fdfcbacc57$var$Ms(n) {
    $b19ca0fdfcbacc57$var$qs(n), typeof n.beginScope == "string" && (n.beginScope = {
        _wrap: n.beginScope
    }), typeof n.endScope == "string" && (n.endScope = {
        _wrap: n.endScope
    }), $b19ca0fdfcbacc57$var$Ls(n), $b19ca0fdfcbacc57$var$Ns(n);
}
function $b19ca0fdfcbacc57$var$Is(n) {
    function e(i, c) {
        return new RegExp($b19ca0fdfcbacc57$var$Ue(i), "m" + (n.case_insensitive ? "i" : "") + (n.unicodeRegex ? "u" : "") + (c ? "g" : ""));
    }
    class t {
        constructor(){
            this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
        }
        // @ts-ignore
        addRule(c, a) {
            a.position = this.position++, this.matchIndexes[this.matchAt] = a, this.regexes.push([
                a,
                c
            ]), this.matchAt += $b19ca0fdfcbacc57$var$br(c) + 1;
        }
        compile() {
            this.regexes.length === 0 && (this.exec = ()=>null);
            const c = this.regexes.map((a)=>a[1]);
            this.matcherRe = e($b19ca0fdfcbacc57$var$Kn(c, {
                joinWith: "|"
            }), !0), this.lastIndex = 0;
        }
        /** @param {string} s */ exec(c) {
            this.matcherRe.lastIndex = this.lastIndex;
            const a = this.matcherRe.exec(c);
            if (!a) return null;
            const l = a.findIndex((p, f)=>f > 0 && p !== void 0), u = this.matchIndexes[l];
            return a.splice(0, l), Object.assign(a, u);
        }
    }
    class r {
        constructor(){
            this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
        }
        // @ts-ignore
        getMatcher(c) {
            if (this.multiRegexes[c]) return this.multiRegexes[c];
            const a = new t();
            return this.rules.slice(c).forEach(([l, u])=>a.addRule(l, u)), a.compile(), this.multiRegexes[c] = a, a;
        }
        resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
        }
        considerAll() {
            this.regexIndex = 0;
        }
        // @ts-ignore
        addRule(c, a) {
            this.rules.push([
                c,
                a
            ]), a.type === "begin" && this.count++;
        }
        /** @param {string} s */ exec(c) {
            const a = this.getMatcher(this.regexIndex);
            a.lastIndex = this.lastIndex;
            let l = a.exec(c);
            if (this.resumingScanAtSamePosition() && !(l && l.index === this.lastIndex)) {
                const u = this.getMatcher(0);
                u.lastIndex = this.lastIndex + 1, l = u.exec(c);
            }
            return l && (this.regexIndex += l.position + 1, this.regexIndex === this.count && this.considerAll()), l;
        }
    }
    function o(i) {
        const c = new r();
        return i.contains.forEach((a)=>c.addRule(a.begin, {
                rule: a,
                type: "begin"
            })), i.terminatorEnd && c.addRule(i.terminatorEnd, {
            type: "end"
        }), i.illegal && c.addRule(i.illegal, {
            type: "illegal"
        }), c;
    }
    function s(i, c) {
        const a = /** @type CompiledMode */ i;
        if (i.isCompiled) return a;
        [
            $b19ca0fdfcbacc57$var$xs,
            // do this early so compiler extensions generally don't have to worry about
            // the distinction between match/begin
            $b19ca0fdfcbacc57$var$ws,
            $b19ca0fdfcbacc57$var$Ms,
            $b19ca0fdfcbacc57$var$Cs
        ].forEach((u)=>u(i, c)), n.compilerExtensions.forEach((u)=>u(i, c)), i.__beforeBegin = null, [
            $b19ca0fdfcbacc57$var$ys,
            // do this later so compiler extensions that come earlier have access to the
            // raw array if they wanted to perhaps manipulate it, etc.
            $b19ca0fdfcbacc57$var$Es,
            // default to 1 relevance if not specified
            $b19ca0fdfcbacc57$var$As
        ].forEach((u)=>u(i, c)), i.isCompiled = !0;
        let l = null;
        return typeof i.keywords == "object" && i.keywords.$pattern && (i.keywords = Object.assign({}, i.keywords), l = i.keywords.$pattern, delete i.keywords.$pattern), l = l || /\w+/, i.keywords && (i.keywords = $b19ca0fdfcbacc57$var$Er(i.keywords, n.case_insensitive)), a.keywordPatternRe = e(l, !0), c && (i.begin || (i.begin = /\B|\b/), a.beginRe = e(a.begin), !i.end && !i.endsWithParent && (i.end = /\B|\b/), i.end && (a.endRe = e(a.end)), a.terminatorEnd = $b19ca0fdfcbacc57$var$Ue(a.end) || "", i.endsWithParent && c.terminatorEnd && (a.terminatorEnd += (i.end ? "|" : "") + c.terminatorEnd)), i.illegal && (a.illegalRe = e(/** @type {RegExp | string} */ i.illegal)), i.contains || (i.contains = []), i.contains = [].concat(...i.contains.map(function(u) {
            return $b19ca0fdfcbacc57$var$Os(u === "self" ? i : u);
        })), i.contains.forEach(function(u) {
            s(/** @type Mode */ u, a);
        }), i.starts && s(i.starts, c), a.matcher = o(a), a;
    }
    if (n.compilerExtensions || (n.compilerExtensions = []), n.contains && n.contains.includes("self")) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    return n.classNameAliases = $b19ca0fdfcbacc57$var$ke(n.classNameAliases || {}), s(/** @type Mode */ n);
}
function $b19ca0fdfcbacc57$var$Ar(n) {
    return n ? n.endsWithParent || $b19ca0fdfcbacc57$var$Ar(n.starts) : !1;
}
function $b19ca0fdfcbacc57$var$Os(n) {
    return n.variants && !n.cachedVariants && (n.cachedVariants = n.variants.map(function(e) {
        return $b19ca0fdfcbacc57$var$ke(n, {
            variants: null
        }, e);
    })), n.cachedVariants ? n.cachedVariants : $b19ca0fdfcbacc57$var$Ar(n) ? $b19ca0fdfcbacc57$var$ke(n, {
        starts: n.starts ? $b19ca0fdfcbacc57$var$ke(n.starts) : null
    }) : Object.isFrozen(n) ? $b19ca0fdfcbacc57$var$ke(n) : n;
}
var $b19ca0fdfcbacc57$var$Fs = "11.9.0";
class $b19ca0fdfcbacc57$var$Bs extends Error {
    constructor(e, t){
        super(e), this.name = "HTMLInjectionError", this.html = t;
    }
}
const $b19ca0fdfcbacc57$var$An = $b19ca0fdfcbacc57$var$mr, $b19ca0fdfcbacc57$var$kt = $b19ca0fdfcbacc57$var$ke, $b19ca0fdfcbacc57$var$xt = Symbol("nomatch"), $b19ca0fdfcbacc57$var$Ps = 7, $b19ca0fdfcbacc57$var$Cr = function(n) {
    const e = /* @__PURE__ */ Object.create(null), t = /* @__PURE__ */ Object.create(null), r = [];
    let o = !0;
    const s = "Could not find the language '{}', did you forget to load/include a language module?", i = {
        disableAutodetect: !0,
        name: "Plain text",
        contains: []
    };
    let c = {
        ignoreUnescapedHTML: !1,
        throwUnescapedHTML: !1,
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: "hljs-",
        cssSelector: "pre code",
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: $b19ca0fdfcbacc57$var$Jo
    };
    function a(m) {
        return c.noHighlightRe.test(m);
    }
    function l(m) {
        let k = m.className + " ";
        k += m.parentNode ? m.parentNode.className : "";
        const R = c.languageDetectRe.exec(k);
        if (R) {
            const F = j(R[1]);
            return F || ($b19ca0fdfcbacc57$var$vt(s.replace("{}", R[1])), $b19ca0fdfcbacc57$var$vt("Falling back to no-highlight mode for this block.", m)), F ? R[1] : "no-highlight";
        }
        return k.split(/\s+/).find((F)=>a(F) || j(F));
    }
    function u(m, k, R) {
        let F = "", U = "";
        typeof k == "object" ? (F = m, R = k.ignoreIllegals, U = k.language) : ($b19ca0fdfcbacc57$var$Te("10.7.0", "highlight(lang, code, ...args) has been deprecated."), $b19ca0fdfcbacc57$var$Te("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), U = m, F = k), R === void 0 && (R = !0);
        const W = {
            code: F,
            language: U
        };
        T("before:highlight", W);
        const ne = W.result ? W.result : p(W.language, W.code, R);
        return ne.code = W.code, T("after:highlight", ne), ne;
    }
    function p(m, k, R, F) {
        const U = /* @__PURE__ */ Object.create(null);
        function W(y, C) {
            return y.keywords[C];
        }
        function ne() {
            if (!N.keywords) {
                J.addText(V);
                return;
            }
            let y = 0;
            N.keywordPatternRe.lastIndex = 0;
            let C = N.keywordPatternRe.exec(V), I = "";
            for(; C;){
                I += V.substring(y, C.index);
                const H = fe.case_insensitive ? C[0].toLowerCase() : C[0], Q = W(N, H);
                if (Q) {
                    const [_e, go] = Q;
                    if (J.addText(I), I = "", U[H] = (U[H] || 0) + 1, U[H] <= $b19ca0fdfcbacc57$var$Ps && (Ye += go), _e.startsWith("_")) I += C[0];
                    else {
                        const mo = fe.classNameAliases[_e] || _e;
                        ue(C[0], mo);
                    }
                } else I += C[0];
                y = N.keywordPatternRe.lastIndex, C = N.keywordPatternRe.exec(V);
            }
            I += V.substring(y), J.addText(I);
        }
        function Ke() {
            if (V === "") return;
            let y = null;
            if (typeof N.subLanguage == "string") {
                if (!e[N.subLanguage]) {
                    J.addText(V);
                    return;
                }
                y = p(N.subLanguage, V, !0, ft[N.subLanguage]), ft[N.subLanguage] = /** @type {CompiledMode} */ y._top;
            } else y = h(V, N.subLanguage.length ? N.subLanguage : null);
            N.relevance > 0 && (Ye += y.relevance), J.__addSublanguage(y._emitter, y.language);
        }
        function oe() {
            N.subLanguage != null ? Ke() : ne(), V = "";
        }
        function ue(y, C) {
            y !== "" && (J.startScope(C), J.addText(y), J.endScope());
        }
        function it(y, C) {
            let I = 1;
            const H = C.length - 1;
            for(; I <= H;){
                if (!y._emit[I]) {
                    I++;
                    continue;
                }
                const Q = fe.classNameAliases[y[I]] || y[I], _e = C[I];
                Q ? ue(_e, Q) : (V = _e, ne(), V = ""), I++;
            }
        }
        function at(y, C) {
            return y.scope && typeof y.scope == "string" && J.openNode(fe.classNameAliases[y.scope] || y.scope), y.beginScope && (y.beginScope._wrap ? (ue(V, fe.classNameAliases[y.beginScope._wrap] || y.beginScope._wrap), V = "") : y.beginScope._multi && (it(y.beginScope, C), V = "")), N = Object.create(y, {
                parent: {
                    value: N
                }
            }), N;
        }
        function lt(y, C, I) {
            let H = $b19ca0fdfcbacc57$var$ns(y.endRe, I);
            if (H) {
                if (y["on:end"]) {
                    const Q = new $b19ca0fdfcbacc57$var$gt(y);
                    y["on:end"](C, Q), Q.isMatchIgnored && (H = !1);
                }
                if (H) {
                    for(; y.endsParent && y.parent;)y = y.parent;
                    return y;
                }
            }
            if (y.endsWithParent) return lt(y.parent, C, I);
        }
        function lo(y) {
            return N.matcher.regexIndex === 0 ? (V += y[0], 1) : (En = !0, 0);
        }
        function uo(y) {
            const C = y[0], I = y.rule, H = new $b19ca0fdfcbacc57$var$gt(I), Q = [
                I.__beforeBegin,
                I["on:begin"]
            ];
            for (const _e of Q)if (_e && (_e(y, H), H.isMatchIgnored)) return lo(C);
            return I.skip ? V += C : (I.excludeBegin && (V += C), oe(), !I.returnBegin && !I.excludeBegin && (V = C)), at(I, y), I.returnBegin ? 0 : C.length;
        }
        function fo(y) {
            const C = y[0], I = k.substring(y.index), H = lt(N, y, I);
            if (!H) return $b19ca0fdfcbacc57$var$xt;
            const Q = N;
            N.endScope && N.endScope._wrap ? (oe(), ue(C, N.endScope._wrap)) : N.endScope && N.endScope._multi ? (oe(), it(N.endScope, y)) : Q.skip ? V += C : (Q.returnEnd || Q.excludeEnd || (V += C), oe(), Q.excludeEnd && (V = C));
            do N.scope && J.closeNode(), !N.skip && !N.subLanguage && (Ye += N.relevance), N = N.parent;
            while (N !== H.parent);
            return H.starts && at(H.starts, y), Q.returnEnd ? 0 : C.length;
        }
        function po() {
            const y = [];
            for(let C = N; C !== fe; C = C.parent)C.scope && y.unshift(C.scope);
            y.forEach((C)=>J.openNode(C));
        }
        let We = {};
        function ut(y, C) {
            const I = C && C[0];
            if (V += y, I == null) return oe(), 0;
            if (We.type === "begin" && C.type === "end" && We.index === C.index && I === "") {
                if (V += k.slice(C.index, C.index + 1), !o) {
                    const H = new Error(`0 width match regex (${m})`);
                    throw H.languageName = m, H.badRule = We.rule, H;
                }
                return 1;
            }
            if (We = C, C.type === "begin") return uo(C);
            if (C.type === "illegal" && !R) {
                const H = new Error('Illegal lexeme "' + I + '" for mode "' + (N.scope || "<unnamed>") + '"');
                throw H.mode = N, H;
            } else if (C.type === "end") {
                const H = fo(C);
                if (H !== $b19ca0fdfcbacc57$var$xt) return H;
            }
            if (C.type === "illegal" && I === "") return 1;
            if (yn > 1e5 && yn > C.index * 3) throw new Error("potential infinite loop, way more iterations than matches");
            return V += I, I.length;
        }
        const fe = j(m);
        if (!fe) throw $b19ca0fdfcbacc57$var$Ce(s.replace("{}", m)), new Error('Unknown language: "' + m + '"');
        const ho = $b19ca0fdfcbacc57$var$Is(fe);
        let xn = "", N = F || ho;
        const ft = {}, J = new c.__emitter(c);
        po();
        let V = "", Ye = 0, ye = 0, yn = 0, En = !1;
        try {
            if (fe.__emitTokens) fe.__emitTokens(k, J);
            else {
                for(N.matcher.considerAll();;){
                    yn++, En ? En = !1 : N.matcher.considerAll(), N.matcher.lastIndex = ye;
                    const y = N.matcher.exec(k);
                    if (!y) break;
                    const C = k.substring(ye, y.index), I = ut(C, y);
                    ye = y.index + I;
                }
                ut(k.substring(ye));
            }
            return J.finalize(), xn = J.toHTML(), {
                language: m,
                value: xn,
                relevance: Ye,
                illegal: !1,
                _emitter: J,
                _top: N
            };
        } catch (y) {
            if (y.message && y.message.includes("Illegal")) return {
                language: m,
                value: $b19ca0fdfcbacc57$var$An(k),
                illegal: !0,
                relevance: 0,
                _illegalBy: {
                    message: y.message,
                    index: ye,
                    context: k.slice(ye - 100, ye + 100),
                    mode: y.mode,
                    resultSoFar: xn
                },
                _emitter: J
            };
            if (o) return {
                language: m,
                value: $b19ca0fdfcbacc57$var$An(k),
                illegal: !1,
                relevance: 0,
                errorRaised: y,
                _emitter: J,
                _top: N
            };
            throw y;
        }
    }
    function f(m) {
        const k = {
            value: $b19ca0fdfcbacc57$var$An(m),
            illegal: !1,
            relevance: 0,
            _top: i,
            _emitter: new c.__emitter(c)
        };
        return k._emitter.addText(m), k;
    }
    function h(m, k) {
        k = k || c.languages || Object.keys(e);
        const R = f(m), F = k.filter(j).filter(K).map((oe)=>p(oe, m, !1));
        F.unshift(R);
        const U = F.sort((oe, ue)=>{
            if (oe.relevance !== ue.relevance) return ue.relevance - oe.relevance;
            if (oe.language && ue.language) {
                if (j(oe.language).supersetOf === ue.language) return 1;
                if (j(ue.language).supersetOf === oe.language) return -1;
            }
            return 0;
        }), [W, ne] = U, Ke = W;
        return Ke.secondBest = ne, Ke;
    }
    function d(m, k, R) {
        const F = k && t[k] || R;
        m.classList.add("hljs"), m.classList.add(`language-${F}`);
    }
    function g(m) {
        let k = null;
        const R = l(m);
        if (a(R)) return;
        if (T("before:highlightElement", {
            el: m,
            language: R
        }), m.dataset.highlighted) {
            console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", m);
            return;
        }
        if (m.children.length > 0 && (c.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(m)), c.throwUnescapedHTML)) throw new $b19ca0fdfcbacc57$var$Bs("One of your code blocks includes unescaped HTML.", m.innerHTML);
        k = m;
        const F = k.textContent, U = R ? u(F, {
            language: R,
            ignoreIllegals: !0
        }) : h(F);
        m.innerHTML = U.value, m.dataset.highlighted = "yes", d(m, R, U.language), m.result = {
            language: U.language,
            // TODO: remove with version 11.0
            re: U.relevance,
            relevance: U.relevance
        }, U.secondBest && (m.secondBest = {
            language: U.secondBest.language,
            relevance: U.secondBest.relevance
        }), T("after:highlightElement", {
            el: m,
            result: U,
            text: F
        });
    }
    function E(m) {
        c = $b19ca0fdfcbacc57$var$kt(c, m);
    }
    const x = ()=>{
        D(), $b19ca0fdfcbacc57$var$Te("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    function b() {
        D(), $b19ca0fdfcbacc57$var$Te("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let A = !1;
    function D() {
        if (document.readyState === "loading") {
            A = !0;
            return;
        }
        document.querySelectorAll(c.cssSelector).forEach(g);
    }
    function L() {
        A && D();
    }
    typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", L, !1);
    function v(m, k) {
        let R = null;
        try {
            R = k(n);
        } catch (F) {
            if ($b19ca0fdfcbacc57$var$Ce("Language definition for '{}' could not be registered.".replace("{}", m)), o) $b19ca0fdfcbacc57$var$Ce(F);
            else throw F;
            R = i;
        }
        R.name || (R.name = m), e[m] = R, R.rawDefinition = k.bind(null, n), R.aliases && M(R.aliases, {
            languageName: m
        });
    }
    function O(m) {
        delete e[m];
        for (const k of Object.keys(t))t[k] === m && delete t[k];
    }
    function z() {
        return Object.keys(e);
    }
    function j(m) {
        return m = (m || "").toLowerCase(), e[m] || e[t[m]];
    }
    function M(m, { languageName: k }) {
        typeof m == "string" && (m = [
            m
        ]), m.forEach((R)=>{
            t[R.toLowerCase()] = k;
        });
    }
    function K(m) {
        const k = j(m);
        return k && !k.disableAutodetect;
    }
    function q(m) {
        m["before:highlightBlock"] && !m["before:highlightElement"] && (m["before:highlightElement"] = (k)=>{
            m["before:highlightBlock"](Object.assign({
                block: k.el
            }, k));
        }), m["after:highlightBlock"] && !m["after:highlightElement"] && (m["after:highlightElement"] = (k)=>{
            m["after:highlightBlock"](Object.assign({
                block: k.el
            }, k));
        });
    }
    function Z(m) {
        q(m), r.push(m);
    }
    function _(m) {
        const k = r.indexOf(m);
        k !== -1 && r.splice(k, 1);
    }
    function T(m, k) {
        const R = m;
        r.forEach(function(F) {
            F[R] && F[R](k);
        });
    }
    function w(m) {
        return $b19ca0fdfcbacc57$var$Te("10.7.0", "highlightBlock will be removed entirely in v12.0"), $b19ca0fdfcbacc57$var$Te("10.7.0", "Please use highlightElement now."), g(m);
    }
    Object.assign(n, {
        highlight: u,
        highlightAuto: h,
        highlightAll: D,
        highlightElement: g,
        // TODO: Remove with v12 API
        highlightBlock: w,
        configure: E,
        initHighlighting: x,
        initHighlightingOnLoad: b,
        registerLanguage: v,
        unregisterLanguage: O,
        listLanguages: z,
        getLanguage: j,
        registerAliases: M,
        autoDetection: K,
        inherit: $b19ca0fdfcbacc57$var$kt,
        addPlugin: Z,
        removePlugin: _
    }), n.debugMode = function() {
        o = !1;
    }, n.safeMode = function() {
        o = !0;
    }, n.versionString = $b19ca0fdfcbacc57$var$Fs, n.regex = {
        concat: $b19ca0fdfcbacc57$var$De,
        lookahead: $b19ca0fdfcbacc57$var$_r,
        either: $b19ca0fdfcbacc57$var$Zn,
        optional: $b19ca0fdfcbacc57$var$Qo,
        anyNumberOfTimes: $b19ca0fdfcbacc57$var$Xo
    };
    for(const m in $b19ca0fdfcbacc57$var$Xe)typeof $b19ca0fdfcbacc57$var$Xe[m] == "object" && $b19ca0fdfcbacc57$var$gr($b19ca0fdfcbacc57$var$Xe[m]);
    return Object.assign(n, $b19ca0fdfcbacc57$var$Xe), n;
}, $b19ca0fdfcbacc57$var$Ne = $b19ca0fdfcbacc57$var$Cr({});
$b19ca0fdfcbacc57$var$Ne.newInstance = ()=>$b19ca0fdfcbacc57$var$Cr({});
var $b19ca0fdfcbacc57$var$$s = $b19ca0fdfcbacc57$var$Ne;
$b19ca0fdfcbacc57$var$Ne.HighlightJS = $b19ca0fdfcbacc57$var$Ne;
$b19ca0fdfcbacc57$var$Ne.default = $b19ca0fdfcbacc57$var$Ne;
const $b19ca0fdfcbacc57$var$be = /* @__PURE__ */ $b19ca0fdfcbacc57$var$Gn($b19ca0fdfcbacc57$var$$s), $b19ca0fdfcbacc57$var$yt = "[A-Za-z$_][0-9A-Za-z$_]*", $b19ca0fdfcbacc57$var$zs = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
], $b19ca0fdfcbacc57$var$Us = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
], $b19ca0fdfcbacc57$var$Sr = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
], $b19ca0fdfcbacc57$var$Dr = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
], $b19ca0fdfcbacc57$var$Tr = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
], $b19ca0fdfcbacc57$var$Hs = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global"
], $b19ca0fdfcbacc57$var$Vs = [].concat($b19ca0fdfcbacc57$var$Tr, $b19ca0fdfcbacc57$var$Sr, $b19ca0fdfcbacc57$var$Dr);
function $b19ca0fdfcbacc57$var$Rr(n) {
    const e = n.regex, t = (k, { after: R })=>{
        const F = "</" + k[0].slice(1);
        return k.input.indexOf(F, R) !== -1;
    }, r = $b19ca0fdfcbacc57$var$yt, o = {
        begin: "<>",
        end: "</>"
    }, s = /<[A-Za-z0-9\\._:-]+\s*\/>/, i = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (k, R)=>{
            const F = k[0].length + k.index, U = k.input[F];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            U === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            U === ",") {
                R.ignoreMatch();
                return;
            }
            U === ">" && (t(k, {
                after: F
            }) || R.ignoreMatch());
            let W;
            const ne = k.input.substring(F);
            if (W = ne.match(/^\s*=/)) {
                R.ignoreMatch();
                return;
            }
            if ((W = ne.match(/^\s+extends\s+/)) && W.index === 0) {
                R.ignoreMatch();
                return;
            }
        }
    }, c = {
        $pattern: $b19ca0fdfcbacc57$var$yt,
        keyword: $b19ca0fdfcbacc57$var$zs,
        literal: $b19ca0fdfcbacc57$var$Us,
        built_in: $b19ca0fdfcbacc57$var$Vs,
        "variable.language": $b19ca0fdfcbacc57$var$Hs
    }, a = "[0-9](_?[0-9])*", l = `\\.(${a})`, u = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", p = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${u})((${l})|\\.)?|(${l}))[eE][+-]?(${a})\\b`
            },
            {
                begin: `\\b(${u})\\b((${l})\\b|\\.)?|(${l})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    }, f = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: c,
        contains: []
    }, h = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                n.BACKSLASH_ESCAPE,
                f
            ],
            subLanguage: "xml"
        }
    }, d = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                n.BACKSLASH_ESCAPE,
                f
            ],
            subLanguage: "css"
        }
    }, g = {
        begin: "gql`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                n.BACKSLASH_ESCAPE,
                f
            ],
            subLanguage: "graphql"
        }
    }, E = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            n.BACKSLASH_ESCAPE,
            f
        ]
    }, b = {
        className: "comment",
        variants: [
            n.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                relevance: 0,
                contains: [
                    {
                        begin: "(?=@[A-Za-z]+)",
                        relevance: 0,
                        contains: [
                            {
                                className: "doctag",
                                begin: "@[A-Za-z]+"
                            },
                            {
                                className: "type",
                                begin: "\\{",
                                end: "\\}",
                                excludeEnd: !0,
                                excludeBegin: !0,
                                relevance: 0
                            },
                            {
                                className: "variable",
                                begin: r + "(?=\\s*(-)|$)",
                                endsParent: !0,
                                relevance: 0
                            },
                            // eat spaces (not newlines) so we can find
                            // types or variables
                            {
                                begin: /(?=[^\n])\s/,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }),
            n.C_BLOCK_COMMENT_MODE,
            n.C_LINE_COMMENT_MODE
        ]
    }, A = [
        n.APOS_STRING_MODE,
        n.QUOTE_STRING_MODE,
        h,
        d,
        g,
        E,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        p
    ];
    f.contains = A.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: c,
        contains: [
            "self"
        ].concat(A)
    });
    const D = [].concat(b, f.contains), L = D.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: c,
            contains: [
                "self"
            ].concat(D)
        }
    ]), v = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: c,
        contains: L
    }, O = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    r,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    e.concat(r, "(", e.concat(/\./, r), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    r
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    }, z = {
        relevance: 0,
        match: e.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$b19ca0fdfcbacc57$var$Sr,
                ...$b19ca0fdfcbacc57$var$Dr
            ]
        }
    }, j = {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    }, M = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    r,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            v
        ],
        illegal: /%/
    }, K = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function q(k) {
        return e.concat("(?!", k.join("|"), ")");
    }
    const Z = {
        match: e.concat(/\b/, q([
            ...$b19ca0fdfcbacc57$var$Tr,
            "super",
            "import"
        ]), r, e.lookahead(/\(/)),
        className: "title.function",
        relevance: 0
    }, _ = {
        begin: e.concat(/\./, e.lookahead(e.concat(r, /(?![0-9A-Za-z$_(])/))),
        end: r,
        excludeBegin: !0,
        keywords: "prototype",
        className: "property",
        relevance: 0
    }, T = {
        match: [
            /get|set/,
            /\s+/,
            r,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                // eat to avoid empty params
                begin: /\(\)/
            },
            v
        ]
    }, w = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + n.UNDERSCORE_IDENT_RE + ")\\s*=>", m = {
        match: [
            /const|var|let/,
            /\s+/,
            r,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            // async is optional
            e.lookahead(w)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            v
        ]
    };
    return {
        name: "JavaScript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: c,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: L,
            CLASS_REFERENCE: z
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            n.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            j,
            n.APOS_STRING_MODE,
            n.QUOTE_STRING_MODE,
            h,
            d,
            g,
            E,
            b,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            p,
            z,
            {
                className: "attr",
                begin: r + e.lookahead(":"),
                relevance: 0
            },
            m,
            {
                // "value" container
                begin: "(" + n.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                relevance: 0,
                contains: [
                    b,
                    n.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: w,
                        returnBegin: !0,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: n.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: !0
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: !0,
                                        excludeEnd: !0,
                                        keywords: c,
                                        contains: L
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        // could be a comma delimited list of params to a function call
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        // JSX
                        variants: [
                            {
                                begin: o.begin,
                                end: o.end
                            },
                            {
                                match: s
                            },
                            {
                                begin: i.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": i.isTrulyOpeningTag,
                                end: i.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: i.begin,
                                end: i.end,
                                skip: !0,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            },
            M,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: "\\b(?!function)" + n.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                // end parens
                returnBegin: !0,
                label: "func.def",
                contains: [
                    v,
                    n.inherit(n.TITLE_MODE, {
                        begin: r,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            _,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: "\\$" + r,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    v
                ]
            },
            Z,
            K,
            O,
            T,
            {
                match: /\$[(.]/
            }
        ]
    };
}
function $b19ca0fdfcbacc57$var$Lr(n) {
    const e = n.regex, t = e.concat(/[\p{L}_]/u, e.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), r = /[\p{L}0-9._:-]+/u, o = {
        className: "symbol",
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    }, s = {
        begin: /\s/,
        contains: [
            {
                className: "keyword",
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    }, i = n.inherit(s, {
        begin: /\(/,
        end: /\)/
    }), c = n.inherit(n.APOS_STRING_MODE, {
        className: "string"
    }), a = n.inherit(n.QUOTE_STRING_MODE, {
        className: "string"
    }), l = {
        endsWithParent: !0,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: r,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "string",
                        endsParent: !0,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    o
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    o
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: "HTML, XML",
        aliases: [
            "html",
            "xhtml",
            "rss",
            "atom",
            "xjb",
            "xsd",
            "xsl",
            "plist",
            "wsf",
            "svg"
        ],
        case_insensitive: !0,
        unicodeRegex: !0,
        contains: [
            {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    s,
                    a,
                    c,
                    i,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: "meta",
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    s,
                                    i,
                                    a,
                                    c
                                ]
                            }
                        ]
                    }
                ]
            },
            n.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            o,
            // xml processing instructions
            {
                className: "meta",
                end: /\?>/,
                variants: [
                    {
                        begin: /<\?xml/,
                        relevance: 10,
                        contains: [
                            a
                        ]
                    },
                    {
                        begin: /<\?[a-z][a-z0-9]+/
                    }
                ]
            },
            {
                className: "tag",
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "style"
                },
                contains: [
                    l
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: !0,
                    subLanguage: [
                        "css",
                        "xml"
                    ]
                }
            },
            {
                className: "tag",
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "script"
                },
                contains: [
                    l
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: !0,
                    subLanguage: [
                        "javascript",
                        "handlebars",
                        "xml"
                    ]
                }
            },
            // we need this for now for jSX
            {
                className: "tag",
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: "tag",
                begin: e.concat(/</, e.lookahead(e.concat(t, // <tag/>
                // <tag>
                // <tag ...
                e.either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: "name",
                        begin: t,
                        relevance: 0,
                        starts: l
                    }
                ]
            },
            // close tag
            {
                className: "tag",
                begin: e.concat(/<\//, e.lookahead(e.concat(t, />/))),
                contains: [
                    {
                        className: "name",
                        begin: t,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: !0
                    }
                ]
            }
        ]
    };
}
const $b19ca0fdfcbacc57$var$un = (n, e)=>{
    const t = n.__vccOpts || n;
    for (const [r, o] of e)t[r] = o;
    return t;
}, $b19ca0fdfcbacc57$var$Gs = {}, $b19ca0fdfcbacc57$var$js = {
    class: "chat-button"
};
function $b19ca0fdfcbacc57$var$Zs(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", $b19ca0fdfcbacc57$var$js, [
        (0, $TusQn.renderSlot)(n.$slots, "default")
    ]);
}
const $b19ca0fdfcbacc57$var$Ks = /* @__PURE__ */ $b19ca0fdfcbacc57$var$un($b19ca0fdfcbacc57$var$Gs, [
    [
        "render",
        $b19ca0fdfcbacc57$var$Zs
    ]
]), $b19ca0fdfcbacc57$var$Ws = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Ys = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
}, null, -1), $b19ca0fdfcbacc57$var$Js = [
    $b19ca0fdfcbacc57$var$Ys
];
function $b19ca0fdfcbacc57$var$Xs(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$Ws, [
        ...$b19ca0fdfcbacc57$var$Js
    ]);
}
const $b19ca0fdfcbacc57$var$Qs = {
    name: "mdi-close",
    render: $b19ca0fdfcbacc57$var$Xs
};
function $b19ca0fdfcbacc57$var$Yn() {
    return (0, $TusQn.inject)($b19ca0fdfcbacc57$var$fr);
}
function $b19ca0fdfcbacc57$var$Ge() {
    return {
        options: (0, $TusQn.inject)($b19ca0fdfcbacc57$var$pr)
    };
}
function $b19ca0fdfcbacc57$var$fn() {
    const { options: n } = $b19ca0fdfcbacc57$var$Ge(), e = (n == null ? void 0 : n.defaultLanguage) ?? "en";
    function t(o) {
        var i, c;
        const s = (c = (i = n == null ? void 0 : n.i18n) == null ? void 0 : i[e]) == null ? void 0 : c[o];
        return (0, $01W3b.isRef)(s) ? s.value : s ?? o;
    }
    function r(o) {
        var s, i;
        return !!((i = (s = n == null ? void 0 : n.i18n) == null ? void 0 : s[e]) != null && i[o]);
    }
    return {
        t: t,
        te: r
    };
}
const $b19ca0fdfcbacc57$var$ec = {
    class: "chat-get-started"
}, $b19ca0fdfcbacc57$var$nc = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "GetStarted",
    setup (n) {
        const { t: e } = $b19ca0fdfcbacc57$var$fn();
        return (t, r)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$ec, [
                (0, $TusQn.createVNode)($b19ca0fdfcbacc57$var$Ks, {
                    onClick: r[0] || (r[0] = (o)=>t.$emit("click:button"))
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)((0, $01W3b.unref)(e)("getStarted")), 1)
                        ]),
                    _: 1
                })
            ]));
    }
}), $b19ca0fdfcbacc57$var$tc = {}, $b19ca0fdfcbacc57$var$rc = {
    class: "chat-powered-by"
}, $b19ca0fdfcbacc57$var$oc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("a", {
    href: "https://n8n.io?utm_source=n8n-external&utm_medium=widget-powered-by"
}, "n8n", -1);
function $b19ca0fdfcbacc57$var$sc(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$rc, [
        (0, $TusQn.createTextVNode)(" Powered by "),
        $b19ca0fdfcbacc57$var$oc
    ]);
}
const $b19ca0fdfcbacc57$var$cc = /* @__PURE__ */ $b19ca0fdfcbacc57$var$un($b19ca0fdfcbacc57$var$tc, [
    [
        "render",
        $b19ca0fdfcbacc57$var$sc
    ]
]), $b19ca0fdfcbacc57$var$ic = {
    class: "chat-get-started-footer"
}, $b19ca0fdfcbacc57$var$ac = {
    key: 0
}, $b19ca0fdfcbacc57$var$lc = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "GetStartedFooter",
    setup (n) {
        const { t: e, te: t } = $b19ca0fdfcbacc57$var$fn();
        return (r, o)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$ic, [
                (0, $01W3b.unref)(t)("footer") ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$ac, (0, $8POXm.toDisplayString)((0, $01W3b.unref)(e)("footer")), 1)) : (0, $TusQn.createCommentVNode)("", !0),
                (0, $TusQn.createVNode)($b19ca0fdfcbacc57$var$cc)
            ]));
    }
});
function $b19ca0fdfcbacc57$var$uc(n) {
    return (0, $01W3b.getCurrentScope)() ? ((0, $01W3b.onScopeDispose)(n), !0) : !1;
}
function $b19ca0fdfcbacc57$var$fc() {
    const n = /* @__PURE__ */ new Set(), e = (o)=>{
        n.delete(o);
    };
    return {
        on: (o)=>{
            n.add(o);
            const s = ()=>e(o);
            return $b19ca0fdfcbacc57$var$uc(s), {
                off: s
            };
        },
        off: e,
        trigger: (...o)=>Promise.all(Array.from(n).map((s)=>s(...o)))
    };
}
const $b19ca0fdfcbacc57$var$pc = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && (globalThis, WorkerGlobalScope);
const $b19ca0fdfcbacc57$var$hc = (n, e)=>Object.prototype.hasOwnProperty.call(n, e), $b19ca0fdfcbacc57$var$dc = $b19ca0fdfcbacc57$var$pc ? window.document : void 0, $b19ca0fdfcbacc57$var$gc = {
    multiple: !0,
    accept: "*",
    reset: !1,
    directory: !1
};
function $b19ca0fdfcbacc57$var$mc(n = {}) {
    const { document: e = $b19ca0fdfcbacc57$var$dc } = n, t = (0, $01W3b.ref)(null), { on: r, trigger: o } = $b19ca0fdfcbacc57$var$fc();
    let s;
    e && (s = e.createElement("input"), s.type = "file", s.onchange = (a)=>{
        const l = a.target;
        t.value = l.files, o(t.value);
    });
    const i = ()=>{
        t.value = null, s && s.value && (s.value = "", o(null));
    }, c = (a)=>{
        if (!s) return;
        const l = {
            ...$b19ca0fdfcbacc57$var$gc,
            ...n,
            ...a
        };
        s.multiple = l.multiple, s.accept = l.accept, s.webkitdirectory = l.directory, $b19ca0fdfcbacc57$var$hc(l, "capture") && (s.capture = l.capture), l.reset && i(), s.click();
    };
    return {
        files: (0, $01W3b.readonly)(t),
        open: c,
        reset: i,
        onChange: r
    };
}
const $b19ca0fdfcbacc57$var$_c = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$bc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .08V8zm-1 7V3.5L18.5 9zm10 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
}, null, -1), $b19ca0fdfcbacc57$var$vc = [
    $b19ca0fdfcbacc57$var$bc
];
function $b19ca0fdfcbacc57$var$kc(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$_c, [
        ...$b19ca0fdfcbacc57$var$vc
    ]);
}
const $b19ca0fdfcbacc57$var$xc = {
    name: "mdi-filePlus",
    render: $b19ca0fdfcbacc57$var$kc
}, $b19ca0fdfcbacc57$var$yc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Ec = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "m2 21l21-9L2 3v7l15 2l-15 2z"
}, null, -1), $b19ca0fdfcbacc57$var$wc = [
    $b19ca0fdfcbacc57$var$Ec
];
function $b19ca0fdfcbacc57$var$Ac(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$yc, [
        ...$b19ca0fdfcbacc57$var$wc
    ]);
}
const $b19ca0fdfcbacc57$var$Cc = {
    name: "mdi-send",
    render: $b19ca0fdfcbacc57$var$Ac
}, $b19ca0fdfcbacc57$var$Sc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Dc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12z"
}, null, -1), $b19ca0fdfcbacc57$var$Tc = [
    $b19ca0fdfcbacc57$var$Dc
];
function $b19ca0fdfcbacc57$var$Rc(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$Sc, [
        ...$b19ca0fdfcbacc57$var$Tc
    ]);
}
const $b19ca0fdfcbacc57$var$Lc = {
    name: "mdi-closeThick",
    render: $b19ca0fdfcbacc57$var$Rc
}, $b19ca0fdfcbacc57$var$Nc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$qc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m0 18h12v-8l-4 4l-2-2zM8 9a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2"
}, null, -1), $b19ca0fdfcbacc57$var$Mc = [
    $b19ca0fdfcbacc57$var$qc
];
function $b19ca0fdfcbacc57$var$Ic(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$Nc, [
        ...$b19ca0fdfcbacc57$var$Mc
    ]);
}
const $b19ca0fdfcbacc57$var$Oc = {
    name: "mdi-fileImage",
    render: $b19ca0fdfcbacc57$var$Ic
}, $b19ca0fdfcbacc57$var$Fc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Bc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm-1 11h-2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2c.4 0 .7.1 1 .3V11h3zm0-4V3.5L18.5 9z"
}, null, -1), $b19ca0fdfcbacc57$var$Pc = [
    $b19ca0fdfcbacc57$var$Bc
];
function $b19ca0fdfcbacc57$var$$c(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$Fc, [
        ...$b19ca0fdfcbacc57$var$Pc
    ]);
}
const $b19ca0fdfcbacc57$var$zc = {
    name: "mdi-fileMusic",
    render: $b19ca0fdfcbacc57$var$$c
}, $b19ca0fdfcbacc57$var$Uc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Hc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m9 16v-2H6v2zm3-4v-2H6v2z"
}, null, -1), $b19ca0fdfcbacc57$var$Vc = [
    $b19ca0fdfcbacc57$var$Hc
];
function $b19ca0fdfcbacc57$var$Gc(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$Uc, [
        ...$b19ca0fdfcbacc57$var$Vc
    ]);
}
const $b19ca0fdfcbacc57$var$Et = {
    name: "mdi-fileText",
    render: $b19ca0fdfcbacc57$var$Gc
}, $b19ca0fdfcbacc57$var$jc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Zc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m11 17v-6l-3 2.2V13H7v6h7v-2.2z"
}, null, -1), $b19ca0fdfcbacc57$var$Kc = [
    $b19ca0fdfcbacc57$var$Zc
];
function $b19ca0fdfcbacc57$var$Wc(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$jc, [
        ...$b19ca0fdfcbacc57$var$Kc
    ]);
}
const $b19ca0fdfcbacc57$var$Yc = {
    name: "mdi-fileVideo",
    render: $b19ca0fdfcbacc57$var$Wc
}, $b19ca0fdfcbacc57$var$Jc = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Xc = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2z"
}, null, -1), $b19ca0fdfcbacc57$var$Qc = [
    $b19ca0fdfcbacc57$var$Xc
];
function $b19ca0fdfcbacc57$var$ei(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$Jc, [
        ...$b19ca0fdfcbacc57$var$Qc
    ]);
}
const $b19ca0fdfcbacc57$var$ni = {
    name: "mdi-openInNew",
    render: $b19ca0fdfcbacc57$var$ei
}, $b19ca0fdfcbacc57$var$ti = {
    class: "chat-file-name"
}, $b19ca0fdfcbacc57$var$ri = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "ChatFile",
    props: {
        file: {},
        isRemovable: {
            type: Boolean
        },
        isPreviewable: {
            type: Boolean
        }
    },
    emits: [
        "remove"
    ],
    setup (n, { emit: e }) {
        const t = n, r = e, o = {
            document: $b19ca0fdfcbacc57$var$Et,
            audio: $b19ca0fdfcbacc57$var$zc,
            image: $b19ca0fdfcbacc57$var$Oc,
            video: $b19ca0fdfcbacc57$var$Yc
        }, s = (0, $01W3b.computed)(()=>{
            var a;
            const c = (a = t.file) == null ? void 0 : a.type.split("/")[0];
            return o[c] || $b19ca0fdfcbacc57$var$Et;
        });
        function i() {
            t.isRemovable && r("remove", t.file), t.isPreviewable && window.open(URL.createObjectURL(t.file));
        }
        return (c, a)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                class: "chat-file",
                onClick: i
            }, [
                (0, $TusQn.createVNode)((0, $01W3b.unref)(s)),
                (0, $TusQn.createElementVNode)("p", $b19ca0fdfcbacc57$var$ti, (0, $8POXm.toDisplayString)(c.file.name), 1),
                c.isRemovable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$Lc), {
                    key: 0,
                    class: "chat-file-delete"
                })) : (0, $TusQn.createCommentVNode)("", !0),
                c.isPreviewable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$ni), {
                    key: 1,
                    class: "chat-file-preview"
                })) : (0, $TusQn.createCommentVNode)("", !0)
            ]));
    }
}), $b19ca0fdfcbacc57$var$Nr = /* @__PURE__ */ $b19ca0fdfcbacc57$var$un($b19ca0fdfcbacc57$var$ri, [
    [
        "__scopeId",
        "data-v-c15a8ecf"
    ]
]), $b19ca0fdfcbacc57$var$oi = {
    class: "chat-inputs"
}, $b19ca0fdfcbacc57$var$si = [
    "disabled",
    "placeholder"
], $b19ca0fdfcbacc57$var$ci = {
    class: "chat-inputs-controls"
}, $b19ca0fdfcbacc57$var$ii = [
    "disabled"
], $b19ca0fdfcbacc57$var$ai = [
    "disabled"
], $b19ca0fdfcbacc57$var$li = {
    key: 0,
    class: "chat-files"
}, $b19ca0fdfcbacc57$var$ui = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "Input",
    emits: [
        "arrowKeyDown"
    ],
    setup (n, { emit: e }) {
        const t = e, { options: r } = $b19ca0fdfcbacc57$var$Ge(), o = $b19ca0fdfcbacc57$var$Yn(), { waitingForResponse: s } = o, { t: i } = $b19ca0fdfcbacc57$var$fn(), c = (0, $01W3b.ref)(null), a = (0, $01W3b.ref)(null), l = (0, $01W3b.ref)(""), u = (0, $01W3b.ref)(!1), p = (0, $01W3b.computed)(()=>{
            var q;
            return l.value === "" || s.value || ((q = r.disabled) == null ? void 0 : q.value) === !0;
        }), f = (0, $01W3b.computed)(()=>{
            var q;
            return ((q = r.disabled) == null ? void 0 : q.value) === !0;
        }), h = (0, $01W3b.computed)(()=>{
            var q;
            return d.value && s.value && !((q = r.disabled) != null && q.value);
        }), d = (0, $01W3b.computed)(()=>(0, $01W3b.unref)(r.allowFileUploads) === !0), g = (0, $01W3b.computed)(()=>(0, $01W3b.unref)(r.allowedFilesMimeTypes)), E = (0, $01W3b.computed)(()=>({
                "--controls-count": d.value ? 2 : 1
            })), { open: x, reset: b, onChange: A } = $b19ca0fdfcbacc57$var$mc({
            multiple: !0,
            reset: !1
        });
        A((q)=>{
            if (!q) return;
            const Z = new DataTransfer();
            if (c.value) for(let _ = 0; _ < c.value.length; _++)Z.items.add(c.value[_]);
            for(let _ = 0; _ < q.length; _++)Z.items.add(q[_]);
            c.value = Z.files;
        }), (0, $TusQn.onMounted)(()=>{
            $b19ca0fdfcbacc57$var$re.on("focusInput", L), $b19ca0fdfcbacc57$var$re.on("blurInput", D), $b19ca0fdfcbacc57$var$re.on("setInputValue", v);
        }), (0, $TusQn.onUnmounted)(()=>{
            $b19ca0fdfcbacc57$var$re.off("focusInput", L), $b19ca0fdfcbacc57$var$re.off("blurInput", D), $b19ca0fdfcbacc57$var$re.off("setInputValue", v);
        });
        function D() {
            a.value && a.value.blur();
        }
        function L() {
            a.value && a.value.focus();
        }
        function v(q) {
            l.value = q, L();
        }
        async function O(q) {
            if (q.preventDefault(), p.value) return;
            const Z = l.value;
            l.value = "", u.value = !0, await o.sendMessage(Z, Array.from(c.value ?? [])), u.value = !1, b(), c.value = null;
        }
        async function z(q) {
            q.shiftKey || await O(q);
        }
        function j(q) {
            if (!c.value) return;
            const Z = new DataTransfer();
            for(let _ = 0; _ < c.value.length; _++){
                const T = c.value[_];
                q.name !== T.name && Z.items.add(T);
            }
            b(), c.value = Z.files;
        }
        function M(q) {
            (q.key === "ArrowUp" || q.key === "ArrowDown") && (q.preventDefault(), t("arrowKeyDown", {
                key: q.key,
                currentInputValue: l.value
            }));
        }
        function K() {
            h.value || x({
                accept: (0, $01W3b.unref)(g)
            });
        }
        return (q, Z)=>{
            var _;
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                class: "chat-input",
                style: (0, $8POXm.normalizeStyle)(E.value),
                onKeydown: (0, $eeJ70.withModifiers)(M, [
                    "stop"
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", $b19ca0fdfcbacc57$var$oi, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                        ref_key: "chatTextArea",
                        ref: a,
                        "onUpdate:modelValue": Z[0] || (Z[0] = (T)=>l.value = T),
                        disabled: f.value,
                        placeholder: (0, $01W3b.unref)(i)("inputPlaceholder"),
                        onKeydown: (0, $eeJ70.withKeys)(z, [
                            "enter"
                        ])
                    }, null, 40, $b19ca0fdfcbacc57$var$si), [
                        [
                            (0, $eeJ70.vModelText),
                            l.value
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b19ca0fdfcbacc57$var$ci, [
                        d.value ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            disabled: h.value,
                            class: "chat-input-send-button",
                            onClick: K
                        }, [
                            (0, $TusQn.createVNode)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$xc), {
                                height: "24",
                                width: "24"
                            })
                        ], 8, $b19ca0fdfcbacc57$var$ii)) : (0, $TusQn.createCommentVNode)("", !0),
                        (0, $TusQn.createElementVNode)("button", {
                            disabled: p.value,
                            class: "chat-input-send-button",
                            onClick: O
                        }, [
                            (0, $TusQn.createVNode)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$Cc), {
                                height: "24",
                                width: "24"
                            })
                        ], 8, $b19ca0fdfcbacc57$var$ai)
                    ])
                ]),
                (_ = c.value) != null && _.length && !u.value ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$li, [
                    ((0, $TusQn.openBlock)(!0), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(c.value, (T)=>((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$Nr, {
                            key: T.name,
                            file: T,
                            "is-removable": !0,
                            onRemove: j
                        }, null, 8, [
                            "file"
                        ]))), 128))
                ])) : (0, $TusQn.createCommentVNode)("", !0)
            ], 36);
        };
    }
}), $b19ca0fdfcbacc57$var$fi = /* @__PURE__ */ $b19ca0fdfcbacc57$var$un($b19ca0fdfcbacc57$var$ui, [
    [
        "__scopeId",
        "data-v-2a7fb1c3"
    ]
]), $b19ca0fdfcbacc57$var$pi = {
    class: "chat-layout"
}, $b19ca0fdfcbacc57$var$hi = {
    key: 0,
    class: "chat-header"
}, $b19ca0fdfcbacc57$var$di = {
    key: 2,
    class: "chat-footer"
}, $b19ca0fdfcbacc57$var$gi = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "Layout",
    setup (n) {
        const e = (0, $01W3b.ref)(null);
        function t() {
            const r = e.value;
            r && (r.scrollTop = r.scrollHeight);
        }
        return (0, $TusQn.onMounted)(()=>{
            $b19ca0fdfcbacc57$var$re.on("scrollToBottom", t), window.addEventListener("resize", t);
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            $b19ca0fdfcbacc57$var$re.off("scrollToBottom", t), window.removeEventListener("resize", t);
        }), (r, o)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $b19ca0fdfcbacc57$var$pi, [
                r.$slots.header ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$hi, [
                    (0, $TusQn.renderSlot)(r.$slots, "header")
                ])) : (0, $TusQn.createCommentVNode)("", !0),
                r.$slots.default ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: 1,
                    ref_key: "chatBodyRef",
                    ref: e,
                    class: "chat-body"
                }, [
                    (0, $TusQn.renderSlot)(r.$slots, "default")
                ], 512)) : (0, $TusQn.createCommentVNode)("", !0),
                r.$slots.footer ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$di, [
                    (0, $TusQn.renderSlot)(r.$slots, "footer")
                ])) : (0, $TusQn.createCommentVNode)("", !0)
            ]));
    }
});
function $b19ca0fdfcbacc57$var$mi(n) {
    const e = n.regex, t = {}, r = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    t
                ]
            }
        ]
    };
    Object.assign(t, {
        className: "variable",
        variants: [
            {
                begin: e.concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                "(?![\\w\\d])(?![$])")
            },
            r
        ]
    });
    const o = {
        className: "subst",
        begin: /\$\(/,
        end: /\)/,
        contains: [
            n.BACKSLASH_ESCAPE
        ]
    }, s = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                n.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: "string"
                })
            ]
        }
    }, i = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            n.BACKSLASH_ESCAPE,
            t,
            o
        ]
    };
    o.contains.push(i);
    const c = {
        match: /\\"/
    }, a = {
        className: "string",
        begin: /'/,
        end: /'/
    }, l = {
        match: /\\'/
    }, u = {
        begin: /\$?\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            n.NUMBER_MODE,
            t
        ]
    }, p = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ], f = n.SHEBANG({
        binary: `(${p.join("|")})`,
        relevance: 10
    }), h = {
        className: "function",
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: !0,
        contains: [
            n.inherit(n.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    }, d = [
        "if",
        "then",
        "else",
        "elif",
        "fi",
        "for",
        "while",
        "until",
        "in",
        "do",
        "done",
        "case",
        "esac",
        "function",
        "select"
    ], g = [
        "true",
        "false"
    ], E = {
        match: /(\/[a-z._-]+)+/
    }, x = [
        "break",
        "cd",
        "continue",
        "eval",
        "exec",
        "exit",
        "export",
        "getopts",
        "hash",
        "pwd",
        "readonly",
        "return",
        "shift",
        "test",
        "times",
        "trap",
        "umask",
        "unset"
    ], b = [
        "alias",
        "bind",
        "builtin",
        "caller",
        "command",
        "declare",
        "echo",
        "enable",
        "help",
        "let",
        "local",
        "logout",
        "mapfile",
        "printf",
        "read",
        "readarray",
        "source",
        "type",
        "typeset",
        "ulimit",
        "unalias"
    ], A = [
        "autoload",
        "bg",
        "bindkey",
        "bye",
        "cap",
        "chdir",
        "clone",
        "comparguments",
        "compcall",
        "compctl",
        "compdescribe",
        "compfiles",
        "compgroups",
        "compquote",
        "comptags",
        "comptry",
        "compvalues",
        "dirs",
        "disable",
        "disown",
        "echotc",
        "echoti",
        "emulate",
        "fc",
        "fg",
        "float",
        "functions",
        "getcap",
        "getln",
        "history",
        "integer",
        "jobs",
        "kill",
        "limit",
        "log",
        "noglob",
        "popd",
        "print",
        "pushd",
        "pushln",
        "rehash",
        "sched",
        "setcap",
        "setopt",
        "stat",
        "suspend",
        "ttyctl",
        "unfunction",
        "unhash",
        "unlimit",
        "unsetopt",
        "vared",
        "wait",
        "whence",
        "where",
        "which",
        "zcompile",
        "zformat",
        "zftp",
        "zle",
        "zmodload",
        "zparseopts",
        "zprof",
        "zpty",
        "zregexparse",
        "zsocket",
        "zstyle",
        "ztcp"
    ], D = [
        "chcon",
        "chgrp",
        "chown",
        "chmod",
        "cp",
        "dd",
        "df",
        "dir",
        "dircolors",
        "ln",
        "ls",
        "mkdir",
        "mkfifo",
        "mknod",
        "mktemp",
        "mv",
        "realpath",
        "rm",
        "rmdir",
        "shred",
        "sync",
        "touch",
        "truncate",
        "vdir",
        "b2sum",
        "base32",
        "base64",
        "cat",
        "cksum",
        "comm",
        "csplit",
        "cut",
        "expand",
        "fmt",
        "fold",
        "head",
        "join",
        "md5sum",
        "nl",
        "numfmt",
        "od",
        "paste",
        "ptx",
        "pr",
        "sha1sum",
        "sha224sum",
        "sha256sum",
        "sha384sum",
        "sha512sum",
        "shuf",
        "sort",
        "split",
        "sum",
        "tac",
        "tail",
        "tr",
        "tsort",
        "unexpand",
        "uniq",
        "wc",
        "arch",
        "basename",
        "chroot",
        "date",
        "dirname",
        "du",
        "echo",
        "env",
        "expr",
        "factor",
        // "false", // keyword literal already
        "groups",
        "hostid",
        "id",
        "link",
        "logname",
        "nice",
        "nohup",
        "nproc",
        "pathchk",
        "pinky",
        "printenv",
        "printf",
        "pwd",
        "readlink",
        "runcon",
        "seq",
        "sleep",
        "stat",
        "stdbuf",
        "stty",
        "tee",
        "test",
        "timeout",
        // "true", // keyword literal already
        "tty",
        "uname",
        "unlink",
        "uptime",
        "users",
        "who",
        "whoami",
        "yes"
    ];
    return {
        name: "Bash",
        aliases: [
            "sh"
        ],
        keywords: {
            $pattern: /\b[a-z][a-z0-9._-]+\b/,
            keyword: d,
            literal: g,
            built_in: [
                ...x,
                ...b,
                // Shell modifiers
                "set",
                "shopt",
                ...A,
                ...D
            ]
        },
        contains: [
            f,
            // to catch known shells and boost relevancy
            n.SHEBANG(),
            // to catch unknown shells but still highlight the shebang
            h,
            u,
            n.HASH_COMMENT_MODE,
            s,
            E,
            i,
            c,
            a,
            l,
            t
        ]
    };
}
function $b19ca0fdfcbacc57$var$_i(n) {
    const e = n.regex, t = new RegExp("[\\p{XID_Start}_]\\p{XID_Continue}*", "u"), r = [
        "and",
        "as",
        "assert",
        "async",
        "await",
        "break",
        "case",
        "class",
        "continue",
        "def",
        "del",
        "elif",
        "else",
        "except",
        "finally",
        "for",
        "from",
        "global",
        "if",
        "import",
        "in",
        "is",
        "lambda",
        "match",
        "nonlocal|10",
        "not",
        "or",
        "pass",
        "raise",
        "return",
        "try",
        "while",
        "with",
        "yield"
    ], c = {
        $pattern: /[A-Za-z]\w+|__\w+__/,
        keyword: r,
        built_in: [
            "__import__",
            "abs",
            "all",
            "any",
            "ascii",
            "bin",
            "bool",
            "breakpoint",
            "bytearray",
            "bytes",
            "callable",
            "chr",
            "classmethod",
            "compile",
            "complex",
            "delattr",
            "dict",
            "dir",
            "divmod",
            "enumerate",
            "eval",
            "exec",
            "filter",
            "float",
            "format",
            "frozenset",
            "getattr",
            "globals",
            "hasattr",
            "hash",
            "help",
            "hex",
            "id",
            "input",
            "int",
            "isinstance",
            "issubclass",
            "iter",
            "len",
            "list",
            "locals",
            "map",
            "max",
            "memoryview",
            "min",
            "next",
            "object",
            "oct",
            "open",
            "ord",
            "pow",
            "print",
            "property",
            "range",
            "repr",
            "reversed",
            "round",
            "set",
            "setattr",
            "slice",
            "sorted",
            "staticmethod",
            "str",
            "sum",
            "super",
            "tuple",
            "type",
            "vars",
            "zip"
        ],
        literal: [
            "__debug__",
            "Ellipsis",
            "False",
            "None",
            "NotImplemented",
            "True"
        ],
        type: [
            "Any",
            "Callable",
            "Coroutine",
            "Dict",
            "List",
            "Literal",
            "Generic",
            "Optional",
            "Sequence",
            "Set",
            "Tuple",
            "Type",
            "Union"
        ]
    }, a = {
        className: "meta",
        begin: /^(>>>|\.\.\.) /
    }, l = {
        className: "subst",
        begin: /\{/,
        end: /\}/,
        keywords: c,
        illegal: /#/
    }, u = {
        begin: /\{\{/,
        relevance: 0
    }, p = {
        className: "string",
        contains: [
            n.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                end: /'''/,
                contains: [
                    n.BACKSLASH_ESCAPE,
                    a
                ],
                relevance: 10
            },
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                end: /"""/,
                contains: [
                    n.BACKSLASH_ESCAPE,
                    a
                ],
                relevance: 10
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                end: /'''/,
                contains: [
                    n.BACKSLASH_ESCAPE,
                    a,
                    u,
                    l
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                end: /"""/,
                contains: [
                    n.BACKSLASH_ESCAPE,
                    a,
                    u,
                    l
                ]
            },
            {
                begin: /([uU]|[rR])'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /([uU]|[rR])"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])'/,
                end: /'/
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])"/,
                end: /"/
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'/,
                end: /'/,
                contains: [
                    n.BACKSLASH_ESCAPE,
                    u,
                    l
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"/,
                end: /"/,
                contains: [
                    n.BACKSLASH_ESCAPE,
                    u,
                    l
                ]
            },
            n.APOS_STRING_MODE,
            n.QUOTE_STRING_MODE
        ]
    }, f = "[0-9](_?[0-9])*", h = `(\\b(${f}))?\\.(${f})|\\b(${f})\\.`, d = `\\b|${r.join("|")}`, g = {
        className: "number",
        relevance: 0,
        variants: [
            // exponentfloat, pointfloat
            // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
            // optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            // Note: no leading \b because floats can start with a decimal point
            // and we don't want to mishandle e.g. `fn(.5)`,
            // no trailing \b for pointfloat because it can end with a decimal point
            // and we don't want to mishandle e.g. `0..hex()`; this should be safe
            // because both MUST contain a decimal point and so cannot be confused with
            // the interior part of an identifier
            {
                begin: `(\\b(${f})|(${h}))[eE][+-]?(${f})[jJ]?(?=${d})`
            },
            {
                begin: `(${h})[jJ]?`
            },
            // decinteger, bininteger, octinteger, hexinteger
            // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
            // optionally "long" in Python 2
            // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
            // decinteger is optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${d})`
            },
            {
                begin: `\\b0[bB](_?[01])+[lL]?(?=${d})`
            },
            {
                begin: `\\b0[oO](_?[0-7])+[lL]?(?=${d})`
            },
            {
                begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${d})`
            },
            // imagnumber (digitpart-based)
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b(${f})[jJ](?=${d})`
            }
        ]
    }, E = {
        className: "comment",
        begin: e.lookahead(/# type:/),
        end: /$/,
        keywords: c,
        contains: [
            {
                // prevent keywords from coloring `type`
                begin: /# type:/
            },
            // comment within a datatype comment includes no keywords
            {
                begin: /#/,
                end: /\b\B/,
                endsWithParent: !0
            }
        ]
    }, x = {
        className: "params",
        variants: [
            // Exclude params in functions without params
            {
                className: "",
                begin: /\(\s*\)/,
                skip: !0
            },
            {
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                keywords: c,
                contains: [
                    "self",
                    a,
                    g,
                    p,
                    n.HASH_COMMENT_MODE
                ]
            }
        ]
    };
    return l.contains = [
        p,
        g,
        a
    ], {
        name: "Python",
        aliases: [
            "py",
            "gyp",
            "ipython"
        ],
        unicodeRegex: !0,
        keywords: c,
        illegal: /(<\/|\?)|=>/,
        contains: [
            a,
            g,
            {
                // very common convention
                begin: /\bself\b/
            },
            {
                // eat "if" prior to string so that it won't accidentally be
                // labeled as an f-string
                beginKeywords: "if",
                relevance: 0
            },
            p,
            E,
            n.HASH_COMMENT_MODE,
            {
                match: [
                    /\bdef/,
                    /\s+/,
                    t
                ],
                scope: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    x
                ]
            },
            {
                variants: [
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            t,
                            /\s*/,
                            /\(\s*/,
                            t,
                            /\s*\)/
                        ]
                    },
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            t
                        ]
                    }
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    6: "title.class.inherited"
                }
            },
            {
                className: "meta",
                begin: /^[\t ]*@/,
                end: /(?=#)|$/,
                contains: [
                    g,
                    x,
                    p
                ]
            }
        ]
    };
}
const $b19ca0fdfcbacc57$var$sn = "[A-Za-z$_][0-9A-Za-z$_]*", $b19ca0fdfcbacc57$var$qr = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
], $b19ca0fdfcbacc57$var$Mr = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
], $b19ca0fdfcbacc57$var$Ir = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
], $b19ca0fdfcbacc57$var$Or = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
], $b19ca0fdfcbacc57$var$Fr = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
], $b19ca0fdfcbacc57$var$Br = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global"
], $b19ca0fdfcbacc57$var$Pr = [].concat($b19ca0fdfcbacc57$var$Fr, $b19ca0fdfcbacc57$var$Ir, $b19ca0fdfcbacc57$var$Or);
function $b19ca0fdfcbacc57$var$bi(n) {
    const e = n.regex, t = (k, { after: R })=>{
        const F = "</" + k[0].slice(1);
        return k.input.indexOf(F, R) !== -1;
    }, r = $b19ca0fdfcbacc57$var$sn, o = {
        begin: "<>",
        end: "</>"
    }, s = /<[A-Za-z0-9\\._:-]+\s*\/>/, i = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (k, R)=>{
            const F = k[0].length + k.index, U = k.input[F];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            U === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            U === ",") {
                R.ignoreMatch();
                return;
            }
            U === ">" && (t(k, {
                after: F
            }) || R.ignoreMatch());
            let W;
            const ne = k.input.substring(F);
            if (W = ne.match(/^\s*=/)) {
                R.ignoreMatch();
                return;
            }
            if ((W = ne.match(/^\s+extends\s+/)) && W.index === 0) {
                R.ignoreMatch();
                return;
            }
        }
    }, c = {
        $pattern: $b19ca0fdfcbacc57$var$sn,
        keyword: $b19ca0fdfcbacc57$var$qr,
        literal: $b19ca0fdfcbacc57$var$Mr,
        built_in: $b19ca0fdfcbacc57$var$Pr,
        "variable.language": $b19ca0fdfcbacc57$var$Br
    }, a = "[0-9](_?[0-9])*", l = `\\.(${a})`, u = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", p = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${u})((${l})|\\.)?|(${l}))[eE][+-]?(${a})\\b`
            },
            {
                begin: `\\b(${u})\\b((${l})\\b|\\.)?|(${l})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    }, f = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: c,
        contains: []
    }, h = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                n.BACKSLASH_ESCAPE,
                f
            ],
            subLanguage: "xml"
        }
    }, d = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                n.BACKSLASH_ESCAPE,
                f
            ],
            subLanguage: "css"
        }
    }, g = {
        begin: "gql`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                n.BACKSLASH_ESCAPE,
                f
            ],
            subLanguage: "graphql"
        }
    }, E = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            n.BACKSLASH_ESCAPE,
            f
        ]
    }, b = {
        className: "comment",
        variants: [
            n.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                relevance: 0,
                contains: [
                    {
                        begin: "(?=@[A-Za-z]+)",
                        relevance: 0,
                        contains: [
                            {
                                className: "doctag",
                                begin: "@[A-Za-z]+"
                            },
                            {
                                className: "type",
                                begin: "\\{",
                                end: "\\}",
                                excludeEnd: !0,
                                excludeBegin: !0,
                                relevance: 0
                            },
                            {
                                className: "variable",
                                begin: r + "(?=\\s*(-)|$)",
                                endsParent: !0,
                                relevance: 0
                            },
                            // eat spaces (not newlines) so we can find
                            // types or variables
                            {
                                begin: /(?=[^\n])\s/,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }),
            n.C_BLOCK_COMMENT_MODE,
            n.C_LINE_COMMENT_MODE
        ]
    }, A = [
        n.APOS_STRING_MODE,
        n.QUOTE_STRING_MODE,
        h,
        d,
        g,
        E,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        p
    ];
    f.contains = A.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: c,
        contains: [
            "self"
        ].concat(A)
    });
    const D = [].concat(b, f.contains), L = D.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: c,
            contains: [
                "self"
            ].concat(D)
        }
    ]), v = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: c,
        contains: L
    }, O = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    r,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    e.concat(r, "(", e.concat(/\./, r), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    r
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    }, z = {
        relevance: 0,
        match: e.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$b19ca0fdfcbacc57$var$Ir,
                ...$b19ca0fdfcbacc57$var$Or
            ]
        }
    }, j = {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    }, M = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    r,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            v
        ],
        illegal: /%/
    }, K = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function q(k) {
        return e.concat("(?!", k.join("|"), ")");
    }
    const Z = {
        match: e.concat(/\b/, q([
            ...$b19ca0fdfcbacc57$var$Fr,
            "super",
            "import"
        ]), r, e.lookahead(/\(/)),
        className: "title.function",
        relevance: 0
    }, _ = {
        begin: e.concat(/\./, e.lookahead(e.concat(r, /(?![0-9A-Za-z$_(])/))),
        end: r,
        excludeBegin: !0,
        keywords: "prototype",
        className: "property",
        relevance: 0
    }, T = {
        match: [
            /get|set/,
            /\s+/,
            r,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                // eat to avoid empty params
                begin: /\(\)/
            },
            v
        ]
    }, w = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + n.UNDERSCORE_IDENT_RE + ")\\s*=>", m = {
        match: [
            /const|var|let/,
            /\s+/,
            r,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            // async is optional
            e.lookahead(w)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            v
        ]
    };
    return {
        name: "JavaScript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: c,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: L,
            CLASS_REFERENCE: z
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            n.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            j,
            n.APOS_STRING_MODE,
            n.QUOTE_STRING_MODE,
            h,
            d,
            g,
            E,
            b,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            p,
            z,
            {
                className: "attr",
                begin: r + e.lookahead(":"),
                relevance: 0
            },
            m,
            {
                // "value" container
                begin: "(" + n.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                relevance: 0,
                contains: [
                    b,
                    n.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: w,
                        returnBegin: !0,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: n.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: !0
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: !0,
                                        excludeEnd: !0,
                                        keywords: c,
                                        contains: L
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        // could be a comma delimited list of params to a function call
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        // JSX
                        variants: [
                            {
                                begin: o.begin,
                                end: o.end
                            },
                            {
                                match: s
                            },
                            {
                                begin: i.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": i.isTrulyOpeningTag,
                                end: i.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: i.begin,
                                end: i.end,
                                skip: !0,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            },
            M,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: "\\b(?!function)" + n.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                // end parens
                returnBegin: !0,
                label: "func.def",
                contains: [
                    v,
                    n.inherit(n.TITLE_MODE, {
                        begin: r,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            _,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: "\\$" + r,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    v
                ]
            },
            Z,
            K,
            O,
            T,
            {
                match: /\$[(.]/
            }
        ]
    };
}
function $b19ca0fdfcbacc57$var$vi(n) {
    const e = $b19ca0fdfcbacc57$var$bi(n), t = $b19ca0fdfcbacc57$var$sn, r = [
        "any",
        "void",
        "number",
        "boolean",
        "string",
        "object",
        "never",
        "symbol",
        "bigint",
        "unknown"
    ], o = {
        beginKeywords: "namespace",
        end: /\{/,
        excludeEnd: !0,
        contains: [
            e.exports.CLASS_REFERENCE
        ]
    }, s = {
        beginKeywords: "interface",
        end: /\{/,
        excludeEnd: !0,
        keywords: {
            keyword: "interface extends",
            built_in: r
        },
        contains: [
            e.exports.CLASS_REFERENCE
        ]
    }, i = {
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use strict['"]/
    }, c = [
        "type",
        "namespace",
        "interface",
        "public",
        "private",
        "protected",
        "implements",
        "declare",
        "abstract",
        "readonly",
        "enum",
        "override"
    ], a = {
        $pattern: $b19ca0fdfcbacc57$var$sn,
        keyword: $b19ca0fdfcbacc57$var$qr.concat(c),
        literal: $b19ca0fdfcbacc57$var$Mr,
        built_in: $b19ca0fdfcbacc57$var$Pr.concat(r),
        "variable.language": $b19ca0fdfcbacc57$var$Br
    }, l = {
        className: "meta",
        begin: "@" + t
    }, u = (f, h, d)=>{
        const g = f.contains.findIndex((E)=>E.label === h);
        if (g === -1) throw new Error("can not find mode to replace");
        f.contains.splice(g, 1, d);
    };
    Object.assign(e.keywords, a), e.exports.PARAMS_CONTAINS.push(l), e.contains = e.contains.concat([
        l,
        o,
        s
    ]), u(e, "shebang", n.SHEBANG()), u(e, "use_strict", i);
    const p = e.contains.find((f)=>f.label === "func.def");
    return p.relevance = 0, Object.assign(e, {
        name: "TypeScript",
        aliases: [
            "ts",
            "tsx",
            "mts",
            "cts"
        ]
    }), e;
}
function $b19ca0fdfcbacc57$var$ki(n, e) {
    var t, r, o = n.attrs[n.attrIndex("href")][1];
    for(t = 0; t < e.length; ++t){
        if (r = e[t], typeof r.matcher == "function") {
            if (r.matcher(o, r)) return r;
            continue;
        }
        return r;
    }
}
function $b19ca0fdfcbacc57$var$xi(n, e, t) {
    Object.keys(t).forEach(function(r) {
        var o, s = t[r];
        r === "className" && (r = "class"), o = e[n].attrIndex(r), o < 0 ? e[n].attrPush([
            r,
            s
        ]) : e[n].attrs[o][1] = s;
    });
}
function $b19ca0fdfcbacc57$var$$r(n, e) {
    e ? e = Array.isArray(e) ? e : [
        e
    ] : e = [], Object.freeze(e);
    var t = n.renderer.rules.link_open || this.defaultRender;
    n.renderer.rules.link_open = function(r, o, s, i, c) {
        var a = $b19ca0fdfcbacc57$var$ki(r[o], e), l = a && a.attrs;
        return l && $b19ca0fdfcbacc57$var$xi(o, r, l), t(r, o, s, i, c);
    };
}
$b19ca0fdfcbacc57$var$$r.defaultRender = function(n, e, t, r, o) {
    return o.renderToken(n, e, t);
};
var $b19ca0fdfcbacc57$var$yi = $b19ca0fdfcbacc57$var$$r;
const $b19ca0fdfcbacc57$var$Ei = /* @__PURE__ */ $b19ca0fdfcbacc57$var$Gn($b19ca0fdfcbacc57$var$yi);
var $b19ca0fdfcbacc57$var$$ = {};
const $b19ca0fdfcbacc57$var$wi = "\xc1", $b19ca0fdfcbacc57$var$Ai = "\xe1", $b19ca0fdfcbacc57$var$Ci = "\u0102", $b19ca0fdfcbacc57$var$Si = "\u0103", $b19ca0fdfcbacc57$var$Di = "\u223E", $b19ca0fdfcbacc57$var$Ti = "\u223F", $b19ca0fdfcbacc57$var$Ri = "\u223E\u0333", $b19ca0fdfcbacc57$var$Li = "\xc2", $b19ca0fdfcbacc57$var$Ni = "\xe2", $b19ca0fdfcbacc57$var$qi = "\xb4", $b19ca0fdfcbacc57$var$Mi = "\u0410", $b19ca0fdfcbacc57$var$Ii = "\u0430", $b19ca0fdfcbacc57$var$Oi = "\xc6", $b19ca0fdfcbacc57$var$Fi = "\xe6", $b19ca0fdfcbacc57$var$Bi = "\u2061", $b19ca0fdfcbacc57$var$Pi = "\uD835\uDD04", $b19ca0fdfcbacc57$var$$i = "\uD835\uDD1E", $b19ca0fdfcbacc57$var$zi = "\xc0", $b19ca0fdfcbacc57$var$Ui = "\xe0", $b19ca0fdfcbacc57$var$Hi = "\u2135", $b19ca0fdfcbacc57$var$Vi = "\u2135", $b19ca0fdfcbacc57$var$Gi = "\u0391", $b19ca0fdfcbacc57$var$ji = "\u03B1", $b19ca0fdfcbacc57$var$Zi = "\u0100", $b19ca0fdfcbacc57$var$Ki = "\u0101", $b19ca0fdfcbacc57$var$Wi = "\u2A3F", $b19ca0fdfcbacc57$var$Yi = "&", $b19ca0fdfcbacc57$var$Ji = "&", $b19ca0fdfcbacc57$var$Xi = "\u2A55", $b19ca0fdfcbacc57$var$Qi = "\u2A53", $b19ca0fdfcbacc57$var$ea = "\u2227", $b19ca0fdfcbacc57$var$na = "\u2A5C", $b19ca0fdfcbacc57$var$ta = "\u2A58", $b19ca0fdfcbacc57$var$ra = "\u2A5A", $b19ca0fdfcbacc57$var$oa = "\u2220", $b19ca0fdfcbacc57$var$sa = "\u29A4", $b19ca0fdfcbacc57$var$ca = "\u2220", $b19ca0fdfcbacc57$var$ia = "\u29A8", $b19ca0fdfcbacc57$var$aa = "\u29A9", $b19ca0fdfcbacc57$var$la = "\u29AA", $b19ca0fdfcbacc57$var$ua = "\u29AB", $b19ca0fdfcbacc57$var$fa = "\u29AC", $b19ca0fdfcbacc57$var$pa = "\u29AD", $b19ca0fdfcbacc57$var$ha = "\u29AE", $b19ca0fdfcbacc57$var$da = "\u29AF", $b19ca0fdfcbacc57$var$ga = "\u2221", $b19ca0fdfcbacc57$var$ma = "\u221F", $b19ca0fdfcbacc57$var$_a = "\u22BE", $b19ca0fdfcbacc57$var$ba = "\u299D", $b19ca0fdfcbacc57$var$va = "\u2222", $b19ca0fdfcbacc57$var$ka = "\xc5", $b19ca0fdfcbacc57$var$xa = "\u237C", $b19ca0fdfcbacc57$var$ya = "\u0104", $b19ca0fdfcbacc57$var$Ea = "\u0105", $b19ca0fdfcbacc57$var$wa = "\uD835\uDD38", $b19ca0fdfcbacc57$var$Aa = "\uD835\uDD52", $b19ca0fdfcbacc57$var$Ca = "\u2A6F", $b19ca0fdfcbacc57$var$Sa = "\u2248", $b19ca0fdfcbacc57$var$Da = "\u2A70", $b19ca0fdfcbacc57$var$Ta = "\u224A", $b19ca0fdfcbacc57$var$Ra = "\u224B", $b19ca0fdfcbacc57$var$La = "'", $b19ca0fdfcbacc57$var$Na = "\u2061", $b19ca0fdfcbacc57$var$qa = "\u2248", $b19ca0fdfcbacc57$var$Ma = "\u224A", $b19ca0fdfcbacc57$var$Ia = "\xc5", $b19ca0fdfcbacc57$var$Oa = "\xe5", $b19ca0fdfcbacc57$var$Fa = "\uD835\uDC9C", $b19ca0fdfcbacc57$var$Ba = "\uD835\uDCB6", $b19ca0fdfcbacc57$var$Pa = "\u2254", $b19ca0fdfcbacc57$var$$a = "*", $b19ca0fdfcbacc57$var$za = "\u2248", $b19ca0fdfcbacc57$var$Ua = "\u224D", $b19ca0fdfcbacc57$var$Ha = "\xc3", $b19ca0fdfcbacc57$var$Va = "\xe3", $b19ca0fdfcbacc57$var$Ga = "\xc4", $b19ca0fdfcbacc57$var$ja = "\xe4", $b19ca0fdfcbacc57$var$Za = "\u2233", $b19ca0fdfcbacc57$var$Ka = "\u2A11", $b19ca0fdfcbacc57$var$Wa = "\u224C", $b19ca0fdfcbacc57$var$Ya = "\u03F6", $b19ca0fdfcbacc57$var$Ja = "\u2035", $b19ca0fdfcbacc57$var$Xa = "\u223D", $b19ca0fdfcbacc57$var$Qa = "\u22CD", $b19ca0fdfcbacc57$var$el = "\u2216", $b19ca0fdfcbacc57$var$nl = "\u2AE7", $b19ca0fdfcbacc57$var$tl = "\u22BD", $b19ca0fdfcbacc57$var$rl = "\u2305", $b19ca0fdfcbacc57$var$ol = "\u2306", $b19ca0fdfcbacc57$var$sl = "\u2305", $b19ca0fdfcbacc57$var$cl = "\u23B5", $b19ca0fdfcbacc57$var$il = "\u23B6", $b19ca0fdfcbacc57$var$al = "\u224C", $b19ca0fdfcbacc57$var$ll = "\u0411", $b19ca0fdfcbacc57$var$ul = "\u0431", $b19ca0fdfcbacc57$var$fl = "\u201E", $b19ca0fdfcbacc57$var$pl = "\u2235", $b19ca0fdfcbacc57$var$hl = "\u2235", $b19ca0fdfcbacc57$var$dl = "\u2235", $b19ca0fdfcbacc57$var$gl = "\u29B0", $b19ca0fdfcbacc57$var$ml = "\u03F6", $b19ca0fdfcbacc57$var$_l = "\u212C", $b19ca0fdfcbacc57$var$bl = "\u212C", $b19ca0fdfcbacc57$var$vl = "\u0392", $b19ca0fdfcbacc57$var$kl = "\u03B2", $b19ca0fdfcbacc57$var$xl = "\u2136", $b19ca0fdfcbacc57$var$yl = "\u226C", $b19ca0fdfcbacc57$var$El = "\uD835\uDD05", $b19ca0fdfcbacc57$var$wl = "\uD835\uDD1F", $b19ca0fdfcbacc57$var$Al = "\u22C2", $b19ca0fdfcbacc57$var$Cl = "\u25EF", $b19ca0fdfcbacc57$var$Sl = "\u22C3", $b19ca0fdfcbacc57$var$Dl = "\u2A00", $b19ca0fdfcbacc57$var$Tl = "\u2A01", $b19ca0fdfcbacc57$var$Rl = "\u2A02", $b19ca0fdfcbacc57$var$Ll = "\u2A06", $b19ca0fdfcbacc57$var$Nl = "\u2605", $b19ca0fdfcbacc57$var$ql = "\u25BD", $b19ca0fdfcbacc57$var$Ml = "\u25B3", $b19ca0fdfcbacc57$var$Il = "\u2A04", $b19ca0fdfcbacc57$var$Ol = "\u22C1", $b19ca0fdfcbacc57$var$Fl = "\u22C0", $b19ca0fdfcbacc57$var$Bl = "\u290D", $b19ca0fdfcbacc57$var$Pl = "\u29EB", $b19ca0fdfcbacc57$var$$l = "\u25AA", $b19ca0fdfcbacc57$var$zl = "\u25B4", $b19ca0fdfcbacc57$var$Ul = "\u25BE", $b19ca0fdfcbacc57$var$Hl = "\u25C2", $b19ca0fdfcbacc57$var$Vl = "\u25B8", $b19ca0fdfcbacc57$var$Gl = "\u2423", $b19ca0fdfcbacc57$var$jl = "\u2592", $b19ca0fdfcbacc57$var$Zl = "\u2591", $b19ca0fdfcbacc57$var$Kl = "\u2593", $b19ca0fdfcbacc57$var$Wl = "\u2588", $b19ca0fdfcbacc57$var$Yl = "=\u20E5", $b19ca0fdfcbacc57$var$Jl = "\u2261\u20E5", $b19ca0fdfcbacc57$var$Xl = "\u2AED", $b19ca0fdfcbacc57$var$Ql = "\u2310", $b19ca0fdfcbacc57$var$eu = "\uD835\uDD39", $b19ca0fdfcbacc57$var$nu = "\uD835\uDD53", $b19ca0fdfcbacc57$var$tu = "\u22A5", $b19ca0fdfcbacc57$var$ru = "\u22A5", $b19ca0fdfcbacc57$var$ou = "\u22C8", $b19ca0fdfcbacc57$var$su = "\u29C9", $b19ca0fdfcbacc57$var$cu = "\u2510", $b19ca0fdfcbacc57$var$iu = "\u2555", $b19ca0fdfcbacc57$var$au = "\u2556", $b19ca0fdfcbacc57$var$lu = "\u2557", $b19ca0fdfcbacc57$var$uu = "\u250C", $b19ca0fdfcbacc57$var$fu = "\u2552", $b19ca0fdfcbacc57$var$pu = "\u2553", $b19ca0fdfcbacc57$var$hu = "\u2554", $b19ca0fdfcbacc57$var$du = "\u2500", $b19ca0fdfcbacc57$var$gu = "\u2550", $b19ca0fdfcbacc57$var$mu = "\u252C", $b19ca0fdfcbacc57$var$_u = "\u2564", $b19ca0fdfcbacc57$var$bu = "\u2565", $b19ca0fdfcbacc57$var$vu = "\u2566", $b19ca0fdfcbacc57$var$ku = "\u2534", $b19ca0fdfcbacc57$var$xu = "\u2567", $b19ca0fdfcbacc57$var$yu = "\u2568", $b19ca0fdfcbacc57$var$Eu = "\u2569", $b19ca0fdfcbacc57$var$wu = "\u229F", $b19ca0fdfcbacc57$var$Au = "\u229E", $b19ca0fdfcbacc57$var$Cu = "\u22A0", $b19ca0fdfcbacc57$var$Su = "\u2518", $b19ca0fdfcbacc57$var$Du = "\u255B", $b19ca0fdfcbacc57$var$Tu = "\u255C", $b19ca0fdfcbacc57$var$Ru = "\u255D", $b19ca0fdfcbacc57$var$Lu = "\u2514", $b19ca0fdfcbacc57$var$Nu = "\u2558", $b19ca0fdfcbacc57$var$qu = "\u2559", $b19ca0fdfcbacc57$var$Mu = "\u255A", $b19ca0fdfcbacc57$var$Iu = "\u2502", $b19ca0fdfcbacc57$var$Ou = "\u2551", $b19ca0fdfcbacc57$var$Fu = "\u253C", $b19ca0fdfcbacc57$var$Bu = "\u256A", $b19ca0fdfcbacc57$var$Pu = "\u256B", $b19ca0fdfcbacc57$var$$u = "\u256C", $b19ca0fdfcbacc57$var$zu = "\u2524", $b19ca0fdfcbacc57$var$Uu = "\u2561", $b19ca0fdfcbacc57$var$Hu = "\u2562", $b19ca0fdfcbacc57$var$Vu = "\u2563", $b19ca0fdfcbacc57$var$Gu = "\u251C", $b19ca0fdfcbacc57$var$ju = "\u255E", $b19ca0fdfcbacc57$var$Zu = "\u255F", $b19ca0fdfcbacc57$var$Ku = "\u2560", $b19ca0fdfcbacc57$var$Wu = "\u2035", $b19ca0fdfcbacc57$var$Yu = "\u02D8", $b19ca0fdfcbacc57$var$Ju = "\u02D8", $b19ca0fdfcbacc57$var$Xu = "\xa6", $b19ca0fdfcbacc57$var$Qu = "\uD835\uDCB7", $b19ca0fdfcbacc57$var$ef = "\u212C", $b19ca0fdfcbacc57$var$nf = "\u204F", $b19ca0fdfcbacc57$var$tf = "\u223D", $b19ca0fdfcbacc57$var$rf = "\u22CD", $b19ca0fdfcbacc57$var$of = "\u29C5", $b19ca0fdfcbacc57$var$sf = "\\", $b19ca0fdfcbacc57$var$cf = "\u27C8", $b19ca0fdfcbacc57$var$af = "\u2022", $b19ca0fdfcbacc57$var$lf = "\u2022", $b19ca0fdfcbacc57$var$uf = "\u224E", $b19ca0fdfcbacc57$var$ff = "\u2AAE", $b19ca0fdfcbacc57$var$pf = "\u224F", $b19ca0fdfcbacc57$var$hf = "\u224E", $b19ca0fdfcbacc57$var$df = "\u224F", $b19ca0fdfcbacc57$var$gf = "\u0106", $b19ca0fdfcbacc57$var$mf = "\u0107", $b19ca0fdfcbacc57$var$_f = "\u2A44", $b19ca0fdfcbacc57$var$bf = "\u2A49", $b19ca0fdfcbacc57$var$vf = "\u2A4B", $b19ca0fdfcbacc57$var$kf = "\u2229", $b19ca0fdfcbacc57$var$xf = "\u22D2", $b19ca0fdfcbacc57$var$yf = "\u2A47", $b19ca0fdfcbacc57$var$Ef = "\u2A40", $b19ca0fdfcbacc57$var$wf = "\u2145", $b19ca0fdfcbacc57$var$Af = "\u2229\uFE00", $b19ca0fdfcbacc57$var$Cf = "\u2041", $b19ca0fdfcbacc57$var$Sf = "\u02C7", $b19ca0fdfcbacc57$var$Df = "\u212D", $b19ca0fdfcbacc57$var$Tf = "\u2A4D", $b19ca0fdfcbacc57$var$Rf = "\u010C", $b19ca0fdfcbacc57$var$Lf = "\u010D", $b19ca0fdfcbacc57$var$Nf = "\xc7", $b19ca0fdfcbacc57$var$qf = "\xe7", $b19ca0fdfcbacc57$var$Mf = "\u0108", $b19ca0fdfcbacc57$var$If = "\u0109", $b19ca0fdfcbacc57$var$Of = "\u2230", $b19ca0fdfcbacc57$var$Ff = "\u2A4C", $b19ca0fdfcbacc57$var$Bf = "\u2A50", $b19ca0fdfcbacc57$var$Pf = "\u010A", $b19ca0fdfcbacc57$var$$f = "\u010B", $b19ca0fdfcbacc57$var$zf = "\xb8", $b19ca0fdfcbacc57$var$Uf = "\xb8", $b19ca0fdfcbacc57$var$Hf = "\u29B2", $b19ca0fdfcbacc57$var$Vf = "\xa2", $b19ca0fdfcbacc57$var$Gf = "\xb7", $b19ca0fdfcbacc57$var$jf = "\xb7", $b19ca0fdfcbacc57$var$Zf = "\uD835\uDD20", $b19ca0fdfcbacc57$var$Kf = "\u212D", $b19ca0fdfcbacc57$var$Wf = "\u0427", $b19ca0fdfcbacc57$var$Yf = "\u0447", $b19ca0fdfcbacc57$var$Jf = "\u2713", $b19ca0fdfcbacc57$var$Xf = "\u2713", $b19ca0fdfcbacc57$var$Qf = "\u03A7", $b19ca0fdfcbacc57$var$ep = "\u03C7", $b19ca0fdfcbacc57$var$np = "\u02C6", $b19ca0fdfcbacc57$var$tp = "\u2257", $b19ca0fdfcbacc57$var$rp = "\u21BA", $b19ca0fdfcbacc57$var$op = "\u21BB", $b19ca0fdfcbacc57$var$sp = "\u229B", $b19ca0fdfcbacc57$var$cp = "\u229A", $b19ca0fdfcbacc57$var$ip = "\u229D", $b19ca0fdfcbacc57$var$ap = "\u2299", $b19ca0fdfcbacc57$var$lp = "\xae", $b19ca0fdfcbacc57$var$up = "\u24C8", $b19ca0fdfcbacc57$var$fp = "\u2296", $b19ca0fdfcbacc57$var$pp = "\u2295", $b19ca0fdfcbacc57$var$hp = "\u2297", $b19ca0fdfcbacc57$var$dp = "\u25CB", $b19ca0fdfcbacc57$var$gp = "\u29C3", $b19ca0fdfcbacc57$var$mp = "\u2257", $b19ca0fdfcbacc57$var$_p = "\u2A10", $b19ca0fdfcbacc57$var$bp = "\u2AEF", $b19ca0fdfcbacc57$var$vp = "\u29C2", $b19ca0fdfcbacc57$var$kp = "\u2232", $b19ca0fdfcbacc57$var$xp = "\u201D", $b19ca0fdfcbacc57$var$yp = "\u2019", $b19ca0fdfcbacc57$var$Ep = "\u2663", $b19ca0fdfcbacc57$var$wp = "\u2663", $b19ca0fdfcbacc57$var$Ap = ":", $b19ca0fdfcbacc57$var$Cp = "\u2237", $b19ca0fdfcbacc57$var$Sp = "\u2A74", $b19ca0fdfcbacc57$var$Dp = "\u2254", $b19ca0fdfcbacc57$var$Tp = "\u2254", $b19ca0fdfcbacc57$var$Rp = ",", $b19ca0fdfcbacc57$var$Lp = "@", $b19ca0fdfcbacc57$var$Np = "\u2201", $b19ca0fdfcbacc57$var$qp = "\u2218", $b19ca0fdfcbacc57$var$Mp = "\u2201", $b19ca0fdfcbacc57$var$Ip = "\u2102", $b19ca0fdfcbacc57$var$Op = "\u2245", $b19ca0fdfcbacc57$var$Fp = "\u2A6D", $b19ca0fdfcbacc57$var$Bp = "\u2261", $b19ca0fdfcbacc57$var$Pp = "\u222E", $b19ca0fdfcbacc57$var$$p = "\u222F", $b19ca0fdfcbacc57$var$zp = "\u222E", $b19ca0fdfcbacc57$var$Up = "\uD835\uDD54", $b19ca0fdfcbacc57$var$Hp = "\u2102", $b19ca0fdfcbacc57$var$Vp = "\u2210", $b19ca0fdfcbacc57$var$Gp = "\u2210", $b19ca0fdfcbacc57$var$jp = "\xa9", $b19ca0fdfcbacc57$var$Zp = "\xa9", $b19ca0fdfcbacc57$var$Kp = "\u2117", $b19ca0fdfcbacc57$var$Wp = "\u2233", $b19ca0fdfcbacc57$var$Yp = "\u21B5", $b19ca0fdfcbacc57$var$Jp = "\u2717", $b19ca0fdfcbacc57$var$Xp = "\u2A2F", $b19ca0fdfcbacc57$var$Qp = "\uD835\uDC9E", $b19ca0fdfcbacc57$var$eh = "\uD835\uDCB8", $b19ca0fdfcbacc57$var$nh = "\u2ACF", $b19ca0fdfcbacc57$var$th = "\u2AD1", $b19ca0fdfcbacc57$var$rh = "\u2AD0", $b19ca0fdfcbacc57$var$oh = "\u2AD2", $b19ca0fdfcbacc57$var$sh = "\u22EF", $b19ca0fdfcbacc57$var$ch = "\u2938", $b19ca0fdfcbacc57$var$ih = "\u2935", $b19ca0fdfcbacc57$var$ah = "\u22DE", $b19ca0fdfcbacc57$var$lh = "\u22DF", $b19ca0fdfcbacc57$var$uh = "\u21B6", $b19ca0fdfcbacc57$var$fh = "\u293D", $b19ca0fdfcbacc57$var$ph = "\u2A48", $b19ca0fdfcbacc57$var$hh = "\u2A46", $b19ca0fdfcbacc57$var$dh = "\u224D", $b19ca0fdfcbacc57$var$gh = "\u222A", $b19ca0fdfcbacc57$var$mh = "\u22D3", $b19ca0fdfcbacc57$var$_h = "\u2A4A", $b19ca0fdfcbacc57$var$bh = "\u228D", $b19ca0fdfcbacc57$var$vh = "\u2A45", $b19ca0fdfcbacc57$var$kh = "\u222A\uFE00", $b19ca0fdfcbacc57$var$xh = "\u21B7", $b19ca0fdfcbacc57$var$yh = "\u293C", $b19ca0fdfcbacc57$var$Eh = "\u22DE", $b19ca0fdfcbacc57$var$wh = "\u22DF", $b19ca0fdfcbacc57$var$Ah = "\u22CE", $b19ca0fdfcbacc57$var$Ch = "\u22CF", $b19ca0fdfcbacc57$var$Sh = "\xa4", $b19ca0fdfcbacc57$var$Dh = "\u21B6", $b19ca0fdfcbacc57$var$Th = "\u21B7", $b19ca0fdfcbacc57$var$Rh = "\u22CE", $b19ca0fdfcbacc57$var$Lh = "\u22CF", $b19ca0fdfcbacc57$var$Nh = "\u2232", $b19ca0fdfcbacc57$var$qh = "\u2231", $b19ca0fdfcbacc57$var$Mh = "\u232D", $b19ca0fdfcbacc57$var$Ih = "\u2020", $b19ca0fdfcbacc57$var$Oh = "\u2021", $b19ca0fdfcbacc57$var$Fh = "\u2138", $b19ca0fdfcbacc57$var$Bh = "\u2193", $b19ca0fdfcbacc57$var$Ph = "\u21A1", $b19ca0fdfcbacc57$var$$h = "\u21D3", $b19ca0fdfcbacc57$var$zh = "\u2010", $b19ca0fdfcbacc57$var$Uh = "\u2AE4", $b19ca0fdfcbacc57$var$Hh = "\u22A3", $b19ca0fdfcbacc57$var$Vh = "\u290F", $b19ca0fdfcbacc57$var$Gh = "\u02DD", $b19ca0fdfcbacc57$var$jh = "\u010E", $b19ca0fdfcbacc57$var$Zh = "\u010F", $b19ca0fdfcbacc57$var$Kh = "\u0414", $b19ca0fdfcbacc57$var$Wh = "\u0434", $b19ca0fdfcbacc57$var$Yh = "\u2021", $b19ca0fdfcbacc57$var$Jh = "\u21CA", $b19ca0fdfcbacc57$var$Xh = "\u2145", $b19ca0fdfcbacc57$var$Qh = "\u2146", $b19ca0fdfcbacc57$var$ed = "\u2911", $b19ca0fdfcbacc57$var$nd = "\u2A77", $b19ca0fdfcbacc57$var$td = "\xb0", $b19ca0fdfcbacc57$var$rd = "\u2207", $b19ca0fdfcbacc57$var$od = "\u0394", $b19ca0fdfcbacc57$var$sd = "\u03B4", $b19ca0fdfcbacc57$var$cd = "\u29B1", $b19ca0fdfcbacc57$var$id = "\u297F", $b19ca0fdfcbacc57$var$ad = "\uD835\uDD07", $b19ca0fdfcbacc57$var$ld = "\uD835\uDD21", $b19ca0fdfcbacc57$var$ud = "\u2965", $b19ca0fdfcbacc57$var$fd = "\u21C3", $b19ca0fdfcbacc57$var$pd = "\u21C2", $b19ca0fdfcbacc57$var$hd = "\xb4", $b19ca0fdfcbacc57$var$dd = "\u02D9", $b19ca0fdfcbacc57$var$gd = "\u02DD", $b19ca0fdfcbacc57$var$md = "`", $b19ca0fdfcbacc57$var$_d = "\u02DC", $b19ca0fdfcbacc57$var$bd = "\u22C4", $b19ca0fdfcbacc57$var$vd = "\u22C4", $b19ca0fdfcbacc57$var$kd = "\u22C4", $b19ca0fdfcbacc57$var$xd = "\u2666", $b19ca0fdfcbacc57$var$yd = "\u2666", $b19ca0fdfcbacc57$var$Ed = "\xa8", $b19ca0fdfcbacc57$var$wd = "\u2146", $b19ca0fdfcbacc57$var$Ad = "\u03DD", $b19ca0fdfcbacc57$var$Cd = "\u22F2", $b19ca0fdfcbacc57$var$Sd = "\xf7", $b19ca0fdfcbacc57$var$Dd = "\xf7", $b19ca0fdfcbacc57$var$Td = "\u22C7", $b19ca0fdfcbacc57$var$Rd = "\u22C7", $b19ca0fdfcbacc57$var$Ld = "\u0402", $b19ca0fdfcbacc57$var$Nd = "\u0452", $b19ca0fdfcbacc57$var$qd = "\u231E", $b19ca0fdfcbacc57$var$Md = "\u230D", $b19ca0fdfcbacc57$var$Id = "$", $b19ca0fdfcbacc57$var$Od = "\uD835\uDD3B", $b19ca0fdfcbacc57$var$Fd = "\uD835\uDD55", $b19ca0fdfcbacc57$var$Bd = "\xa8", $b19ca0fdfcbacc57$var$Pd = "\u02D9", $b19ca0fdfcbacc57$var$$d = "\u20DC", $b19ca0fdfcbacc57$var$zd = "\u2250", $b19ca0fdfcbacc57$var$Ud = "\u2251", $b19ca0fdfcbacc57$var$Hd = "\u2250", $b19ca0fdfcbacc57$var$Vd = "\u2238", $b19ca0fdfcbacc57$var$Gd = "\u2214", $b19ca0fdfcbacc57$var$jd = "\u22A1", $b19ca0fdfcbacc57$var$Zd = "\u2306", $b19ca0fdfcbacc57$var$Kd = "\u222F", $b19ca0fdfcbacc57$var$Wd = "\xa8", $b19ca0fdfcbacc57$var$Yd = "\u21D3", $b19ca0fdfcbacc57$var$Jd = "\u21D0", $b19ca0fdfcbacc57$var$Xd = "\u21D4", $b19ca0fdfcbacc57$var$Qd = "\u2AE4", $b19ca0fdfcbacc57$var$eg = "\u27F8", $b19ca0fdfcbacc57$var$ng = "\u27FA", $b19ca0fdfcbacc57$var$tg = "\u27F9", $b19ca0fdfcbacc57$var$rg = "\u21D2", $b19ca0fdfcbacc57$var$og = "\u22A8", $b19ca0fdfcbacc57$var$sg = "\u21D1", $b19ca0fdfcbacc57$var$cg = "\u21D5", $b19ca0fdfcbacc57$var$ig = "\u2225", $b19ca0fdfcbacc57$var$ag = "\u2913", $b19ca0fdfcbacc57$var$lg = "\u2193", $b19ca0fdfcbacc57$var$ug = "\u2193", $b19ca0fdfcbacc57$var$fg = "\u21D3", $b19ca0fdfcbacc57$var$pg = "\u21F5", $b19ca0fdfcbacc57$var$hg = "\u0311", $b19ca0fdfcbacc57$var$dg = "\u21CA", $b19ca0fdfcbacc57$var$gg = "\u21C3", $b19ca0fdfcbacc57$var$mg = "\u21C2", $b19ca0fdfcbacc57$var$_g = "\u2950", $b19ca0fdfcbacc57$var$bg = "\u295E", $b19ca0fdfcbacc57$var$vg = "\u2956", $b19ca0fdfcbacc57$var$kg = "\u21BD", $b19ca0fdfcbacc57$var$xg = "\u295F", $b19ca0fdfcbacc57$var$yg = "\u2957", $b19ca0fdfcbacc57$var$Eg = "\u21C1", $b19ca0fdfcbacc57$var$wg = "\u21A7", $b19ca0fdfcbacc57$var$Ag = "\u22A4", $b19ca0fdfcbacc57$var$Cg = "\u2910", $b19ca0fdfcbacc57$var$Sg = "\u231F", $b19ca0fdfcbacc57$var$Dg = "\u230C", $b19ca0fdfcbacc57$var$Tg = "\uD835\uDC9F", $b19ca0fdfcbacc57$var$Rg = "\uD835\uDCB9", $b19ca0fdfcbacc57$var$Lg = "\u0405", $b19ca0fdfcbacc57$var$Ng = "\u0455", $b19ca0fdfcbacc57$var$qg = "\u29F6", $b19ca0fdfcbacc57$var$Mg = "\u0110", $b19ca0fdfcbacc57$var$Ig = "\u0111", $b19ca0fdfcbacc57$var$Og = "\u22F1", $b19ca0fdfcbacc57$var$Fg = "\u25BF", $b19ca0fdfcbacc57$var$Bg = "\u25BE", $b19ca0fdfcbacc57$var$Pg = "\u21F5", $b19ca0fdfcbacc57$var$$g = "\u296F", $b19ca0fdfcbacc57$var$zg = "\u29A6", $b19ca0fdfcbacc57$var$Ug = "\u040F", $b19ca0fdfcbacc57$var$Hg = "\u045F", $b19ca0fdfcbacc57$var$Vg = "\u27FF", $b19ca0fdfcbacc57$var$Gg = "\xc9", $b19ca0fdfcbacc57$var$jg = "\xe9", $b19ca0fdfcbacc57$var$Zg = "\u2A6E", $b19ca0fdfcbacc57$var$Kg = "\u011A", $b19ca0fdfcbacc57$var$Wg = "\u011B", $b19ca0fdfcbacc57$var$Yg = "\xca", $b19ca0fdfcbacc57$var$Jg = "\xea", $b19ca0fdfcbacc57$var$Xg = "\u2256", $b19ca0fdfcbacc57$var$Qg = "\u2255", $b19ca0fdfcbacc57$var$em = "\u042D", $b19ca0fdfcbacc57$var$nm = "\u044D", $b19ca0fdfcbacc57$var$tm = "\u2A77", $b19ca0fdfcbacc57$var$rm = "\u0116", $b19ca0fdfcbacc57$var$om = "\u0117", $b19ca0fdfcbacc57$var$sm = "\u2251", $b19ca0fdfcbacc57$var$cm = "\u2147", $b19ca0fdfcbacc57$var$im = "\u2252", $b19ca0fdfcbacc57$var$am = "\uD835\uDD08", $b19ca0fdfcbacc57$var$lm = "\uD835\uDD22", $b19ca0fdfcbacc57$var$um = "\u2A9A", $b19ca0fdfcbacc57$var$fm = "\xc8", $b19ca0fdfcbacc57$var$pm = "\xe8", $b19ca0fdfcbacc57$var$hm = "\u2A96", $b19ca0fdfcbacc57$var$dm = "\u2A98", $b19ca0fdfcbacc57$var$gm = "\u2A99", $b19ca0fdfcbacc57$var$mm = "\u2208", $b19ca0fdfcbacc57$var$_m = "\u23E7", $b19ca0fdfcbacc57$var$bm = "\u2113", $b19ca0fdfcbacc57$var$vm = "\u2A95", $b19ca0fdfcbacc57$var$km = "\u2A97", $b19ca0fdfcbacc57$var$xm = "\u0112", $b19ca0fdfcbacc57$var$ym = "\u0113", $b19ca0fdfcbacc57$var$Em = "\u2205", $b19ca0fdfcbacc57$var$wm = "\u2205", $b19ca0fdfcbacc57$var$Am = "\u25FB", $b19ca0fdfcbacc57$var$Cm = "\u2205", $b19ca0fdfcbacc57$var$Sm = "\u25AB", $b19ca0fdfcbacc57$var$Dm = "\u2004", $b19ca0fdfcbacc57$var$Tm = "\u2005", $b19ca0fdfcbacc57$var$Rm = "\u2003", $b19ca0fdfcbacc57$var$Lm = "\u014A", $b19ca0fdfcbacc57$var$Nm = "\u014B", $b19ca0fdfcbacc57$var$qm = "\u2002", $b19ca0fdfcbacc57$var$Mm = "\u0118", $b19ca0fdfcbacc57$var$Im = "\u0119", $b19ca0fdfcbacc57$var$Om = "\uD835\uDD3C", $b19ca0fdfcbacc57$var$Fm = "\uD835\uDD56", $b19ca0fdfcbacc57$var$Bm = "\u22D5", $b19ca0fdfcbacc57$var$Pm = "\u29E3", $b19ca0fdfcbacc57$var$$m = "\u2A71", $b19ca0fdfcbacc57$var$zm = "\u03B5", $b19ca0fdfcbacc57$var$Um = "\u0395", $b19ca0fdfcbacc57$var$Hm = "\u03B5", $b19ca0fdfcbacc57$var$Vm = "\u03F5", $b19ca0fdfcbacc57$var$Gm = "\u2256", $b19ca0fdfcbacc57$var$jm = "\u2255", $b19ca0fdfcbacc57$var$Zm = "\u2242", $b19ca0fdfcbacc57$var$Km = "\u2A96", $b19ca0fdfcbacc57$var$Wm = "\u2A95", $b19ca0fdfcbacc57$var$Ym = "\u2A75", $b19ca0fdfcbacc57$var$Jm = "=", $b19ca0fdfcbacc57$var$Xm = "\u2242", $b19ca0fdfcbacc57$var$Qm = "\u225F", $b19ca0fdfcbacc57$var$e_ = "\u21CC", $b19ca0fdfcbacc57$var$n_ = "\u2261", $b19ca0fdfcbacc57$var$t_ = "\u2A78", $b19ca0fdfcbacc57$var$r_ = "\u29E5", $b19ca0fdfcbacc57$var$o_ = "\u2971", $b19ca0fdfcbacc57$var$s_ = "\u2253", $b19ca0fdfcbacc57$var$c_ = "\u212F", $b19ca0fdfcbacc57$var$i_ = "\u2130", $b19ca0fdfcbacc57$var$a_ = "\u2250", $b19ca0fdfcbacc57$var$l_ = "\u2A73", $b19ca0fdfcbacc57$var$u_ = "\u2242", $b19ca0fdfcbacc57$var$f_ = "\u0397", $b19ca0fdfcbacc57$var$p_ = "\u03B7", $b19ca0fdfcbacc57$var$h_ = "\xd0", $b19ca0fdfcbacc57$var$d_ = "\xf0", $b19ca0fdfcbacc57$var$g_ = "\xcb", $b19ca0fdfcbacc57$var$m_ = "\xeb", $b19ca0fdfcbacc57$var$__ = "\u20AC", $b19ca0fdfcbacc57$var$b_ = "!", $b19ca0fdfcbacc57$var$v_ = "\u2203", $b19ca0fdfcbacc57$var$k_ = "\u2203", $b19ca0fdfcbacc57$var$x_ = "\u2130", $b19ca0fdfcbacc57$var$y_ = "\u2147", $b19ca0fdfcbacc57$var$E_ = "\u2147", $b19ca0fdfcbacc57$var$w_ = "\u2252", $b19ca0fdfcbacc57$var$A_ = "\u0424", $b19ca0fdfcbacc57$var$C_ = "\u0444", $b19ca0fdfcbacc57$var$S_ = "\u2640", $b19ca0fdfcbacc57$var$D_ = "\uFB03", $b19ca0fdfcbacc57$var$T_ = "\uFB00", $b19ca0fdfcbacc57$var$R_ = "\uFB04", $b19ca0fdfcbacc57$var$L_ = "\uD835\uDD09", $b19ca0fdfcbacc57$var$N_ = "\uD835\uDD23", $b19ca0fdfcbacc57$var$q_ = "\uFB01", $b19ca0fdfcbacc57$var$M_ = "\u25FC", $b19ca0fdfcbacc57$var$I_ = "\u25AA", $b19ca0fdfcbacc57$var$O_ = "fj", $b19ca0fdfcbacc57$var$F_ = "\u266D", $b19ca0fdfcbacc57$var$B_ = "\uFB02", $b19ca0fdfcbacc57$var$P_ = "\u25B1", $b19ca0fdfcbacc57$var$$_ = "\u0192", $b19ca0fdfcbacc57$var$z_ = "\uD835\uDD3D", $b19ca0fdfcbacc57$var$U_ = "\uD835\uDD57", $b19ca0fdfcbacc57$var$H_ = "\u2200", $b19ca0fdfcbacc57$var$V_ = "\u2200", $b19ca0fdfcbacc57$var$G_ = "\u22D4", $b19ca0fdfcbacc57$var$j_ = "\u2AD9", $b19ca0fdfcbacc57$var$Z_ = "\u2131", $b19ca0fdfcbacc57$var$K_ = "\u2A0D", $b19ca0fdfcbacc57$var$W_ = "\xbd", $b19ca0fdfcbacc57$var$Y_ = "\u2153", $b19ca0fdfcbacc57$var$J_ = "\xbc", $b19ca0fdfcbacc57$var$X_ = "\u2155", $b19ca0fdfcbacc57$var$Q_ = "\u2159", $b19ca0fdfcbacc57$var$eb = "\u215B", $b19ca0fdfcbacc57$var$nb = "\u2154", $b19ca0fdfcbacc57$var$tb = "\u2156", $b19ca0fdfcbacc57$var$rb = "\xbe", $b19ca0fdfcbacc57$var$ob = "\u2157", $b19ca0fdfcbacc57$var$sb = "\u215C", $b19ca0fdfcbacc57$var$cb = "\u2158", $b19ca0fdfcbacc57$var$ib = "\u215A", $b19ca0fdfcbacc57$var$ab = "\u215D", $b19ca0fdfcbacc57$var$lb = "\u215E", $b19ca0fdfcbacc57$var$ub = "\u2044", $b19ca0fdfcbacc57$var$fb = "\u2322", $b19ca0fdfcbacc57$var$pb = "\uD835\uDCBB", $b19ca0fdfcbacc57$var$hb = "\u2131", $b19ca0fdfcbacc57$var$db = "\u01F5", $b19ca0fdfcbacc57$var$gb = "\u0393", $b19ca0fdfcbacc57$var$mb = "\u03B3", $b19ca0fdfcbacc57$var$_b = "\u03DC", $b19ca0fdfcbacc57$var$bb = "\u03DD", $b19ca0fdfcbacc57$var$vb = "\u2A86", $b19ca0fdfcbacc57$var$kb = "\u011E", $b19ca0fdfcbacc57$var$xb = "\u011F", $b19ca0fdfcbacc57$var$yb = "\u0122", $b19ca0fdfcbacc57$var$Eb = "\u011C", $b19ca0fdfcbacc57$var$wb = "\u011D", $b19ca0fdfcbacc57$var$Ab = "\u0413", $b19ca0fdfcbacc57$var$Cb = "\u0433", $b19ca0fdfcbacc57$var$Sb = "\u0120", $b19ca0fdfcbacc57$var$Db = "\u0121", $b19ca0fdfcbacc57$var$Tb = "\u2265", $b19ca0fdfcbacc57$var$Rb = "\u2267", $b19ca0fdfcbacc57$var$Lb = "\u2A8C", $b19ca0fdfcbacc57$var$Nb = "\u22DB", $b19ca0fdfcbacc57$var$qb = "\u2265", $b19ca0fdfcbacc57$var$Mb = "\u2267", $b19ca0fdfcbacc57$var$Ib = "\u2A7E", $b19ca0fdfcbacc57$var$Ob = "\u2AA9", $b19ca0fdfcbacc57$var$Fb = "\u2A7E", $b19ca0fdfcbacc57$var$Bb = "\u2A80", $b19ca0fdfcbacc57$var$Pb = "\u2A82", $b19ca0fdfcbacc57$var$$b = "\u2A84", $b19ca0fdfcbacc57$var$zb = "\u22DB\uFE00", $b19ca0fdfcbacc57$var$Ub = "\u2A94", $b19ca0fdfcbacc57$var$Hb = "\uD835\uDD0A", $b19ca0fdfcbacc57$var$Vb = "\uD835\uDD24", $b19ca0fdfcbacc57$var$Gb = "\u226B", $b19ca0fdfcbacc57$var$jb = "\u22D9", $b19ca0fdfcbacc57$var$Zb = "\u22D9", $b19ca0fdfcbacc57$var$Kb = "\u2137", $b19ca0fdfcbacc57$var$Wb = "\u0403", $b19ca0fdfcbacc57$var$Yb = "\u0453", $b19ca0fdfcbacc57$var$Jb = "\u2AA5", $b19ca0fdfcbacc57$var$Xb = "\u2277", $b19ca0fdfcbacc57$var$Qb = "\u2A92", $b19ca0fdfcbacc57$var$e0 = "\u2AA4", $b19ca0fdfcbacc57$var$n0 = "\u2A8A", $b19ca0fdfcbacc57$var$t0 = "\u2A8A", $b19ca0fdfcbacc57$var$r0 = "\u2A88", $b19ca0fdfcbacc57$var$o0 = "\u2269", $b19ca0fdfcbacc57$var$s0 = "\u2A88", $b19ca0fdfcbacc57$var$c0 = "\u2269", $b19ca0fdfcbacc57$var$i0 = "\u22E7", $b19ca0fdfcbacc57$var$a0 = "\uD835\uDD3E", $b19ca0fdfcbacc57$var$l0 = "\uD835\uDD58", $b19ca0fdfcbacc57$var$u0 = "`", $b19ca0fdfcbacc57$var$f0 = "\u2265", $b19ca0fdfcbacc57$var$p0 = "\u22DB", $b19ca0fdfcbacc57$var$h0 = "\u2267", $b19ca0fdfcbacc57$var$d0 = "\u2AA2", $b19ca0fdfcbacc57$var$g0 = "\u2277", $b19ca0fdfcbacc57$var$m0 = "\u2A7E", $b19ca0fdfcbacc57$var$_0 = "\u2273", $b19ca0fdfcbacc57$var$b0 = "\uD835\uDCA2", $b19ca0fdfcbacc57$var$v0 = "\u210A", $b19ca0fdfcbacc57$var$k0 = "\u2273", $b19ca0fdfcbacc57$var$x0 = "\u2A8E", $b19ca0fdfcbacc57$var$y0 = "\u2A90", $b19ca0fdfcbacc57$var$E0 = "\u2AA7", $b19ca0fdfcbacc57$var$w0 = "\u2A7A", $b19ca0fdfcbacc57$var$A0 = ">", $b19ca0fdfcbacc57$var$C0 = ">", $b19ca0fdfcbacc57$var$S0 = "\u226B", $b19ca0fdfcbacc57$var$D0 = "\u22D7", $b19ca0fdfcbacc57$var$T0 = "\u2995", $b19ca0fdfcbacc57$var$R0 = "\u2A7C", $b19ca0fdfcbacc57$var$L0 = "\u2A86", $b19ca0fdfcbacc57$var$N0 = "\u2978", $b19ca0fdfcbacc57$var$q0 = "\u22D7", $b19ca0fdfcbacc57$var$M0 = "\u22DB", $b19ca0fdfcbacc57$var$I0 = "\u2A8C", $b19ca0fdfcbacc57$var$O0 = "\u2277", $b19ca0fdfcbacc57$var$F0 = "\u2273", $b19ca0fdfcbacc57$var$B0 = "\u2269\uFE00", $b19ca0fdfcbacc57$var$P0 = "\u2269\uFE00", $b19ca0fdfcbacc57$var$$0 = "\u02C7", $b19ca0fdfcbacc57$var$z0 = "\u200A", $b19ca0fdfcbacc57$var$U0 = "\xbd", $b19ca0fdfcbacc57$var$H0 = "\u210B", $b19ca0fdfcbacc57$var$V0 = "\u042A", $b19ca0fdfcbacc57$var$G0 = "\u044A", $b19ca0fdfcbacc57$var$j0 = "\u2948", $b19ca0fdfcbacc57$var$Z0 = "\u2194", $b19ca0fdfcbacc57$var$K0 = "\u21D4", $b19ca0fdfcbacc57$var$W0 = "\u21AD", $b19ca0fdfcbacc57$var$Y0 = "^", $b19ca0fdfcbacc57$var$J0 = "\u210F", $b19ca0fdfcbacc57$var$X0 = "\u0124", $b19ca0fdfcbacc57$var$Q0 = "\u0125", $b19ca0fdfcbacc57$var$ev = "\u2665", $b19ca0fdfcbacc57$var$nv = "\u2665", $b19ca0fdfcbacc57$var$tv = "\u2026", $b19ca0fdfcbacc57$var$rv = "\u22B9", $b19ca0fdfcbacc57$var$ov = "\uD835\uDD25", $b19ca0fdfcbacc57$var$sv = "\u210C", $b19ca0fdfcbacc57$var$cv = "\u210B", $b19ca0fdfcbacc57$var$iv = "\u2925", $b19ca0fdfcbacc57$var$av = "\u2926", $b19ca0fdfcbacc57$var$lv = "\u21FF", $b19ca0fdfcbacc57$var$uv = "\u223B", $b19ca0fdfcbacc57$var$fv = "\u21A9", $b19ca0fdfcbacc57$var$pv = "\u21AA", $b19ca0fdfcbacc57$var$hv = "\uD835\uDD59", $b19ca0fdfcbacc57$var$dv = "\u210D", $b19ca0fdfcbacc57$var$gv = "\u2015", $b19ca0fdfcbacc57$var$mv = "\u2500", $b19ca0fdfcbacc57$var$_v = "\uD835\uDCBD", $b19ca0fdfcbacc57$var$bv = "\u210B", $b19ca0fdfcbacc57$var$vv = "\u210F", $b19ca0fdfcbacc57$var$kv = "\u0126", $b19ca0fdfcbacc57$var$xv = "\u0127", $b19ca0fdfcbacc57$var$yv = "\u224E", $b19ca0fdfcbacc57$var$Ev = "\u224F", $b19ca0fdfcbacc57$var$wv = "\u2043", $b19ca0fdfcbacc57$var$Av = "\u2010", $b19ca0fdfcbacc57$var$Cv = "\xcd", $b19ca0fdfcbacc57$var$Sv = "\xed", $b19ca0fdfcbacc57$var$Dv = "\u2063", $b19ca0fdfcbacc57$var$Tv = "\xce", $b19ca0fdfcbacc57$var$Rv = "\xee", $b19ca0fdfcbacc57$var$Lv = "\u0418", $b19ca0fdfcbacc57$var$Nv = "\u0438", $b19ca0fdfcbacc57$var$qv = "\u0130", $b19ca0fdfcbacc57$var$Mv = "\u0415", $b19ca0fdfcbacc57$var$Iv = "\u0435", $b19ca0fdfcbacc57$var$Ov = "\xa1", $b19ca0fdfcbacc57$var$Fv = "\u21D4", $b19ca0fdfcbacc57$var$Bv = "\uD835\uDD26", $b19ca0fdfcbacc57$var$Pv = "\u2111", $b19ca0fdfcbacc57$var$$v = "\xcc", $b19ca0fdfcbacc57$var$zv = "\xec", $b19ca0fdfcbacc57$var$Uv = "\u2148", $b19ca0fdfcbacc57$var$Hv = "\u2A0C", $b19ca0fdfcbacc57$var$Vv = "\u222D", $b19ca0fdfcbacc57$var$Gv = "\u29DC", $b19ca0fdfcbacc57$var$jv = "\u2129", $b19ca0fdfcbacc57$var$Zv = "\u0132", $b19ca0fdfcbacc57$var$Kv = "\u0133", $b19ca0fdfcbacc57$var$Wv = "\u012A", $b19ca0fdfcbacc57$var$Yv = "\u012B", $b19ca0fdfcbacc57$var$Jv = "\u2111", $b19ca0fdfcbacc57$var$Xv = "\u2148", $b19ca0fdfcbacc57$var$Qv = "\u2110", $b19ca0fdfcbacc57$var$ek = "\u2111", $b19ca0fdfcbacc57$var$nk = "\u0131", $b19ca0fdfcbacc57$var$tk = "\u2111", $b19ca0fdfcbacc57$var$rk = "\u22B7", $b19ca0fdfcbacc57$var$ok = "\u01B5", $b19ca0fdfcbacc57$var$sk = "\u21D2", $b19ca0fdfcbacc57$var$ck = "\u2105", $b19ca0fdfcbacc57$var$ik = "\u221E", $b19ca0fdfcbacc57$var$ak = "\u29DD", $b19ca0fdfcbacc57$var$lk = "\u0131", $b19ca0fdfcbacc57$var$uk = "\u22BA", $b19ca0fdfcbacc57$var$fk = "\u222B", $b19ca0fdfcbacc57$var$pk = "\u222C", $b19ca0fdfcbacc57$var$hk = "\u2124", $b19ca0fdfcbacc57$var$dk = "\u222B", $b19ca0fdfcbacc57$var$gk = "\u22BA", $b19ca0fdfcbacc57$var$mk = "\u22C2", $b19ca0fdfcbacc57$var$_k = "\u2A17", $b19ca0fdfcbacc57$var$bk = "\u2A3C", $b19ca0fdfcbacc57$var$vk = "\u2063", $b19ca0fdfcbacc57$var$kk = "\u2062", $b19ca0fdfcbacc57$var$xk = "\u0401", $b19ca0fdfcbacc57$var$yk = "\u0451", $b19ca0fdfcbacc57$var$Ek = "\u012E", $b19ca0fdfcbacc57$var$wk = "\u012F", $b19ca0fdfcbacc57$var$Ak = "\uD835\uDD40", $b19ca0fdfcbacc57$var$Ck = "\uD835\uDD5A", $b19ca0fdfcbacc57$var$Sk = "\u0399", $b19ca0fdfcbacc57$var$Dk = "\u03B9", $b19ca0fdfcbacc57$var$Tk = "\u2A3C", $b19ca0fdfcbacc57$var$Rk = "\xbf", $b19ca0fdfcbacc57$var$Lk = "\uD835\uDCBE", $b19ca0fdfcbacc57$var$Nk = "\u2110", $b19ca0fdfcbacc57$var$qk = "\u2208", $b19ca0fdfcbacc57$var$Mk = "\u22F5", $b19ca0fdfcbacc57$var$Ik = "\u22F9", $b19ca0fdfcbacc57$var$Ok = "\u22F4", $b19ca0fdfcbacc57$var$Fk = "\u22F3", $b19ca0fdfcbacc57$var$Bk = "\u2208", $b19ca0fdfcbacc57$var$Pk = "\u2062", $b19ca0fdfcbacc57$var$$k = "\u0128", $b19ca0fdfcbacc57$var$zk = "\u0129", $b19ca0fdfcbacc57$var$Uk = "\u0406", $b19ca0fdfcbacc57$var$Hk = "\u0456", $b19ca0fdfcbacc57$var$Vk = "\xcf", $b19ca0fdfcbacc57$var$Gk = "\xef", $b19ca0fdfcbacc57$var$jk = "\u0134", $b19ca0fdfcbacc57$var$Zk = "\u0135", $b19ca0fdfcbacc57$var$Kk = "\u0419", $b19ca0fdfcbacc57$var$Wk = "\u0439", $b19ca0fdfcbacc57$var$Yk = "\uD835\uDD0D", $b19ca0fdfcbacc57$var$Jk = "\uD835\uDD27", $b19ca0fdfcbacc57$var$Xk = "\u0237", $b19ca0fdfcbacc57$var$Qk = "\uD835\uDD41", $b19ca0fdfcbacc57$var$ex = "\uD835\uDD5B", $b19ca0fdfcbacc57$var$nx = "\uD835\uDCA5", $b19ca0fdfcbacc57$var$tx = "\uD835\uDCBF", $b19ca0fdfcbacc57$var$rx = "\u0408", $b19ca0fdfcbacc57$var$ox = "\u0458", $b19ca0fdfcbacc57$var$sx = "\u0404", $b19ca0fdfcbacc57$var$cx = "\u0454", $b19ca0fdfcbacc57$var$ix = "\u039A", $b19ca0fdfcbacc57$var$ax = "\u03BA", $b19ca0fdfcbacc57$var$lx = "\u03F0", $b19ca0fdfcbacc57$var$ux = "\u0136", $b19ca0fdfcbacc57$var$fx = "\u0137", $b19ca0fdfcbacc57$var$px = "\u041A", $b19ca0fdfcbacc57$var$hx = "\u043A", $b19ca0fdfcbacc57$var$dx = "\uD835\uDD0E", $b19ca0fdfcbacc57$var$gx = "\uD835\uDD28", $b19ca0fdfcbacc57$var$mx = "\u0138", $b19ca0fdfcbacc57$var$_x = "\u0425", $b19ca0fdfcbacc57$var$bx = "\u0445", $b19ca0fdfcbacc57$var$vx = "\u040C", $b19ca0fdfcbacc57$var$kx = "\u045C", $b19ca0fdfcbacc57$var$xx = "\uD835\uDD42", $b19ca0fdfcbacc57$var$yx = "\uD835\uDD5C", $b19ca0fdfcbacc57$var$Ex = "\uD835\uDCA6", $b19ca0fdfcbacc57$var$wx = "\uD835\uDCC0", $b19ca0fdfcbacc57$var$Ax = "\u21DA", $b19ca0fdfcbacc57$var$Cx = "\u0139", $b19ca0fdfcbacc57$var$Sx = "\u013A", $b19ca0fdfcbacc57$var$Dx = "\u29B4", $b19ca0fdfcbacc57$var$Tx = "\u2112", $b19ca0fdfcbacc57$var$Rx = "\u039B", $b19ca0fdfcbacc57$var$Lx = "\u03BB", $b19ca0fdfcbacc57$var$Nx = "\u27E8", $b19ca0fdfcbacc57$var$qx = "\u27EA", $b19ca0fdfcbacc57$var$Mx = "\u2991", $b19ca0fdfcbacc57$var$Ix = "\u27E8", $b19ca0fdfcbacc57$var$Ox = "\u2A85", $b19ca0fdfcbacc57$var$Fx = "\u2112", $b19ca0fdfcbacc57$var$Bx = "\xab", $b19ca0fdfcbacc57$var$Px = "\u21E4", $b19ca0fdfcbacc57$var$$x = "\u291F", $b19ca0fdfcbacc57$var$zx = "\u2190", $b19ca0fdfcbacc57$var$Ux = "\u219E", $b19ca0fdfcbacc57$var$Hx = "\u21D0", $b19ca0fdfcbacc57$var$Vx = "\u291D", $b19ca0fdfcbacc57$var$Gx = "\u21A9", $b19ca0fdfcbacc57$var$jx = "\u21AB", $b19ca0fdfcbacc57$var$Zx = "\u2939", $b19ca0fdfcbacc57$var$Kx = "\u2973", $b19ca0fdfcbacc57$var$Wx = "\u21A2", $b19ca0fdfcbacc57$var$Yx = "\u2919", $b19ca0fdfcbacc57$var$Jx = "\u291B", $b19ca0fdfcbacc57$var$Xx = "\u2AAB", $b19ca0fdfcbacc57$var$Qx = "\u2AAD", $b19ca0fdfcbacc57$var$ey = "\u2AAD\uFE00", $b19ca0fdfcbacc57$var$ny = "\u290C", $b19ca0fdfcbacc57$var$ty = "\u290E", $b19ca0fdfcbacc57$var$ry = "\u2772", $b19ca0fdfcbacc57$var$oy = "{", $b19ca0fdfcbacc57$var$sy = "[", $b19ca0fdfcbacc57$var$cy = "\u298B", $b19ca0fdfcbacc57$var$iy = "\u298F", $b19ca0fdfcbacc57$var$ay = "\u298D", $b19ca0fdfcbacc57$var$ly = "\u013D", $b19ca0fdfcbacc57$var$uy = "\u013E", $b19ca0fdfcbacc57$var$fy = "\u013B", $b19ca0fdfcbacc57$var$py = "\u013C", $b19ca0fdfcbacc57$var$hy = "\u2308", $b19ca0fdfcbacc57$var$dy = "{", $b19ca0fdfcbacc57$var$gy = "\u041B", $b19ca0fdfcbacc57$var$my = "\u043B", $b19ca0fdfcbacc57$var$_y = "\u2936", $b19ca0fdfcbacc57$var$by = "\u201C", $b19ca0fdfcbacc57$var$vy = "\u201E", $b19ca0fdfcbacc57$var$ky = "\u2967", $b19ca0fdfcbacc57$var$xy = "\u294B", $b19ca0fdfcbacc57$var$yy = "\u21B2", $b19ca0fdfcbacc57$var$Ey = "\u2264", $b19ca0fdfcbacc57$var$wy = "\u2266", $b19ca0fdfcbacc57$var$Ay = "\u27E8", $b19ca0fdfcbacc57$var$Cy = "\u21E4", $b19ca0fdfcbacc57$var$Sy = "\u2190", $b19ca0fdfcbacc57$var$Dy = "\u2190", $b19ca0fdfcbacc57$var$Ty = "\u21D0", $b19ca0fdfcbacc57$var$Ry = "\u21C6", $b19ca0fdfcbacc57$var$Ly = "\u21A2", $b19ca0fdfcbacc57$var$Ny = "\u2308", $b19ca0fdfcbacc57$var$qy = "\u27E6", $b19ca0fdfcbacc57$var$My = "\u2961", $b19ca0fdfcbacc57$var$Iy = "\u2959", $b19ca0fdfcbacc57$var$Oy = "\u21C3", $b19ca0fdfcbacc57$var$Fy = "\u230A", $b19ca0fdfcbacc57$var$By = "\u21BD", $b19ca0fdfcbacc57$var$Py = "\u21BC", $b19ca0fdfcbacc57$var$$y = "\u21C7", $b19ca0fdfcbacc57$var$zy = "\u2194", $b19ca0fdfcbacc57$var$Uy = "\u2194", $b19ca0fdfcbacc57$var$Hy = "\u21D4", $b19ca0fdfcbacc57$var$Vy = "\u21C6", $b19ca0fdfcbacc57$var$Gy = "\u21CB", $b19ca0fdfcbacc57$var$jy = "\u21AD", $b19ca0fdfcbacc57$var$Zy = "\u294E", $b19ca0fdfcbacc57$var$Ky = "\u21A4", $b19ca0fdfcbacc57$var$Wy = "\u22A3", $b19ca0fdfcbacc57$var$Yy = "\u295A", $b19ca0fdfcbacc57$var$Jy = "\u22CB", $b19ca0fdfcbacc57$var$Xy = "\u29CF", $b19ca0fdfcbacc57$var$Qy = "\u22B2", $b19ca0fdfcbacc57$var$eE = "\u22B4", $b19ca0fdfcbacc57$var$nE = "\u2951", $b19ca0fdfcbacc57$var$tE = "\u2960", $b19ca0fdfcbacc57$var$rE = "\u2958", $b19ca0fdfcbacc57$var$oE = "\u21BF", $b19ca0fdfcbacc57$var$sE = "\u2952", $b19ca0fdfcbacc57$var$cE = "\u21BC", $b19ca0fdfcbacc57$var$iE = "\u2A8B", $b19ca0fdfcbacc57$var$aE = "\u22DA", $b19ca0fdfcbacc57$var$lE = "\u2264", $b19ca0fdfcbacc57$var$uE = "\u2266", $b19ca0fdfcbacc57$var$fE = "\u2A7D", $b19ca0fdfcbacc57$var$pE = "\u2AA8", $b19ca0fdfcbacc57$var$hE = "\u2A7D", $b19ca0fdfcbacc57$var$dE = "\u2A7F", $b19ca0fdfcbacc57$var$gE = "\u2A81", $b19ca0fdfcbacc57$var$mE = "\u2A83", $b19ca0fdfcbacc57$var$_E = "\u22DA\uFE00", $b19ca0fdfcbacc57$var$bE = "\u2A93", $b19ca0fdfcbacc57$var$vE = "\u2A85", $b19ca0fdfcbacc57$var$kE = "\u22D6", $b19ca0fdfcbacc57$var$xE = "\u22DA", $b19ca0fdfcbacc57$var$yE = "\u2A8B", $b19ca0fdfcbacc57$var$EE = "\u22DA", $b19ca0fdfcbacc57$var$wE = "\u2266", $b19ca0fdfcbacc57$var$AE = "\u2276", $b19ca0fdfcbacc57$var$CE = "\u2276", $b19ca0fdfcbacc57$var$SE = "\u2AA1", $b19ca0fdfcbacc57$var$DE = "\u2272", $b19ca0fdfcbacc57$var$TE = "\u2A7D", $b19ca0fdfcbacc57$var$RE = "\u2272", $b19ca0fdfcbacc57$var$LE = "\u297C", $b19ca0fdfcbacc57$var$NE = "\u230A", $b19ca0fdfcbacc57$var$qE = "\uD835\uDD0F", $b19ca0fdfcbacc57$var$ME = "\uD835\uDD29", $b19ca0fdfcbacc57$var$IE = "\u2276", $b19ca0fdfcbacc57$var$OE = "\u2A91", $b19ca0fdfcbacc57$var$FE = "\u2962", $b19ca0fdfcbacc57$var$BE = "\u21BD", $b19ca0fdfcbacc57$var$PE = "\u21BC", $b19ca0fdfcbacc57$var$$E = "\u296A", $b19ca0fdfcbacc57$var$zE = "\u2584", $b19ca0fdfcbacc57$var$UE = "\u0409", $b19ca0fdfcbacc57$var$HE = "\u0459", $b19ca0fdfcbacc57$var$VE = "\u21C7", $b19ca0fdfcbacc57$var$GE = "\u226A", $b19ca0fdfcbacc57$var$jE = "\u22D8", $b19ca0fdfcbacc57$var$ZE = "\u231E", $b19ca0fdfcbacc57$var$KE = "\u21DA", $b19ca0fdfcbacc57$var$WE = "\u296B", $b19ca0fdfcbacc57$var$YE = "\u25FA", $b19ca0fdfcbacc57$var$JE = "\u013F", $b19ca0fdfcbacc57$var$XE = "\u0140", $b19ca0fdfcbacc57$var$QE = "\u23B0", $b19ca0fdfcbacc57$var$ew = "\u23B0", $b19ca0fdfcbacc57$var$nw = "\u2A89", $b19ca0fdfcbacc57$var$tw = "\u2A89", $b19ca0fdfcbacc57$var$rw = "\u2A87", $b19ca0fdfcbacc57$var$ow = "\u2268", $b19ca0fdfcbacc57$var$sw = "\u2A87", $b19ca0fdfcbacc57$var$cw = "\u2268", $b19ca0fdfcbacc57$var$iw = "\u22E6", $b19ca0fdfcbacc57$var$aw = "\u27EC", $b19ca0fdfcbacc57$var$lw = "\u21FD", $b19ca0fdfcbacc57$var$uw = "\u27E6", $b19ca0fdfcbacc57$var$fw = "\u27F5", $b19ca0fdfcbacc57$var$pw = "\u27F5", $b19ca0fdfcbacc57$var$hw = "\u27F8", $b19ca0fdfcbacc57$var$dw = "\u27F7", $b19ca0fdfcbacc57$var$gw = "\u27F7", $b19ca0fdfcbacc57$var$mw = "\u27FA", $b19ca0fdfcbacc57$var$_w = "\u27FC", $b19ca0fdfcbacc57$var$bw = "\u27F6", $b19ca0fdfcbacc57$var$vw = "\u27F6", $b19ca0fdfcbacc57$var$kw = "\u27F9", $b19ca0fdfcbacc57$var$xw = "\u21AB", $b19ca0fdfcbacc57$var$yw = "\u21AC", $b19ca0fdfcbacc57$var$Ew = "\u2985", $b19ca0fdfcbacc57$var$ww = "\uD835\uDD43", $b19ca0fdfcbacc57$var$Aw = "\uD835\uDD5D", $b19ca0fdfcbacc57$var$Cw = "\u2A2D", $b19ca0fdfcbacc57$var$Sw = "\u2A34", $b19ca0fdfcbacc57$var$Dw = "\u2217", $b19ca0fdfcbacc57$var$Tw = "_", $b19ca0fdfcbacc57$var$Rw = "\u2199", $b19ca0fdfcbacc57$var$Lw = "\u2198", $b19ca0fdfcbacc57$var$Nw = "\u25CA", $b19ca0fdfcbacc57$var$qw = "\u25CA", $b19ca0fdfcbacc57$var$Mw = "\u29EB", $b19ca0fdfcbacc57$var$Iw = "(", $b19ca0fdfcbacc57$var$Ow = "\u2993", $b19ca0fdfcbacc57$var$Fw = "\u21C6", $b19ca0fdfcbacc57$var$Bw = "\u231F", $b19ca0fdfcbacc57$var$Pw = "\u21CB", $b19ca0fdfcbacc57$var$$w = "\u296D", $b19ca0fdfcbacc57$var$zw = "\u200E", $b19ca0fdfcbacc57$var$Uw = "\u22BF", $b19ca0fdfcbacc57$var$Hw = "\u2039", $b19ca0fdfcbacc57$var$Vw = "\uD835\uDCC1", $b19ca0fdfcbacc57$var$Gw = "\u2112", $b19ca0fdfcbacc57$var$jw = "\u21B0", $b19ca0fdfcbacc57$var$Zw = "\u21B0", $b19ca0fdfcbacc57$var$Kw = "\u2272", $b19ca0fdfcbacc57$var$Ww = "\u2A8D", $b19ca0fdfcbacc57$var$Yw = "\u2A8F", $b19ca0fdfcbacc57$var$Jw = "[", $b19ca0fdfcbacc57$var$Xw = "\u2018", $b19ca0fdfcbacc57$var$Qw = "\u201A", $b19ca0fdfcbacc57$var$e1 = "\u0141", $b19ca0fdfcbacc57$var$n1 = "\u0142", $b19ca0fdfcbacc57$var$t1 = "\u2AA6", $b19ca0fdfcbacc57$var$r1 = "\u2A79", $b19ca0fdfcbacc57$var$o1 = "<", $b19ca0fdfcbacc57$var$s1 = "<", $b19ca0fdfcbacc57$var$c1 = "\u226A", $b19ca0fdfcbacc57$var$i1 = "\u22D6", $b19ca0fdfcbacc57$var$a1 = "\u22CB", $b19ca0fdfcbacc57$var$l1 = "\u22C9", $b19ca0fdfcbacc57$var$u1 = "\u2976", $b19ca0fdfcbacc57$var$f1 = "\u2A7B", $b19ca0fdfcbacc57$var$p1 = "\u25C3", $b19ca0fdfcbacc57$var$h1 = "\u22B4", $b19ca0fdfcbacc57$var$d1 = "\u25C2", $b19ca0fdfcbacc57$var$g1 = "\u2996", $b19ca0fdfcbacc57$var$m1 = "\u294A", $b19ca0fdfcbacc57$var$_1 = "\u2966", $b19ca0fdfcbacc57$var$b1 = "\u2268\uFE00", $b19ca0fdfcbacc57$var$v1 = "\u2268\uFE00", $b19ca0fdfcbacc57$var$k1 = "\xaf", $b19ca0fdfcbacc57$var$x1 = "\u2642", $b19ca0fdfcbacc57$var$y1 = "\u2720", $b19ca0fdfcbacc57$var$E1 = "\u2720", $b19ca0fdfcbacc57$var$w1 = "\u21A6", $b19ca0fdfcbacc57$var$A1 = "\u21A6", $b19ca0fdfcbacc57$var$C1 = "\u21A7", $b19ca0fdfcbacc57$var$S1 = "\u21A4", $b19ca0fdfcbacc57$var$D1 = "\u21A5", $b19ca0fdfcbacc57$var$T1 = "\u25AE", $b19ca0fdfcbacc57$var$R1 = "\u2A29", $b19ca0fdfcbacc57$var$L1 = "\u041C", $b19ca0fdfcbacc57$var$N1 = "\u043C", $b19ca0fdfcbacc57$var$q1 = "\u2014", $b19ca0fdfcbacc57$var$M1 = "\u223A", $b19ca0fdfcbacc57$var$I1 = "\u2221", $b19ca0fdfcbacc57$var$O1 = "\u205F", $b19ca0fdfcbacc57$var$F1 = "\u2133", $b19ca0fdfcbacc57$var$B1 = "\uD835\uDD10", $b19ca0fdfcbacc57$var$P1 = "\uD835\uDD2A", $b19ca0fdfcbacc57$var$$1 = "\u2127", $b19ca0fdfcbacc57$var$z1 = "\xb5", $b19ca0fdfcbacc57$var$U1 = "*", $b19ca0fdfcbacc57$var$H1 = "\u2AF0", $b19ca0fdfcbacc57$var$V1 = "\u2223", $b19ca0fdfcbacc57$var$G1 = "\xb7", $b19ca0fdfcbacc57$var$j1 = "\u229F", $b19ca0fdfcbacc57$var$Z1 = "\u2212", $b19ca0fdfcbacc57$var$K1 = "\u2238", $b19ca0fdfcbacc57$var$W1 = "\u2A2A", $b19ca0fdfcbacc57$var$Y1 = "\u2213", $b19ca0fdfcbacc57$var$J1 = "\u2ADB", $b19ca0fdfcbacc57$var$X1 = "\u2026", $b19ca0fdfcbacc57$var$Q1 = "\u2213", $b19ca0fdfcbacc57$var$eA = "\u22A7", $b19ca0fdfcbacc57$var$nA = "\uD835\uDD44", $b19ca0fdfcbacc57$var$tA = "\uD835\uDD5E", $b19ca0fdfcbacc57$var$rA = "\u2213", $b19ca0fdfcbacc57$var$oA = "\uD835\uDCC2", $b19ca0fdfcbacc57$var$sA = "\u2133", $b19ca0fdfcbacc57$var$cA = "\u223E", $b19ca0fdfcbacc57$var$iA = "\u039C", $b19ca0fdfcbacc57$var$aA = "\u03BC", $b19ca0fdfcbacc57$var$lA = "\u22B8", $b19ca0fdfcbacc57$var$uA = "\u22B8", $b19ca0fdfcbacc57$var$fA = "\u2207", $b19ca0fdfcbacc57$var$pA = "\u0143", $b19ca0fdfcbacc57$var$hA = "\u0144", $b19ca0fdfcbacc57$var$dA = "\u2220\u20D2", $b19ca0fdfcbacc57$var$gA = "\u2249", $b19ca0fdfcbacc57$var$mA = "\u2A70\u0338", $b19ca0fdfcbacc57$var$_A = "\u224B\u0338", $b19ca0fdfcbacc57$var$bA = "\u0149", $b19ca0fdfcbacc57$var$vA = "\u2249", $b19ca0fdfcbacc57$var$kA = "\u266E", $b19ca0fdfcbacc57$var$xA = "\u2115", $b19ca0fdfcbacc57$var$yA = "\u266E", $b19ca0fdfcbacc57$var$EA = "\xa0", $b19ca0fdfcbacc57$var$wA = "\u224E\u0338", $b19ca0fdfcbacc57$var$AA = "\u224F\u0338", $b19ca0fdfcbacc57$var$CA = "\u2A43", $b19ca0fdfcbacc57$var$SA = "\u0147", $b19ca0fdfcbacc57$var$DA = "\u0148", $b19ca0fdfcbacc57$var$TA = "\u0145", $b19ca0fdfcbacc57$var$RA = "\u0146", $b19ca0fdfcbacc57$var$LA = "\u2247", $b19ca0fdfcbacc57$var$NA = "\u2A6D\u0338", $b19ca0fdfcbacc57$var$qA = "\u2A42", $b19ca0fdfcbacc57$var$MA = "\u041D", $b19ca0fdfcbacc57$var$IA = "\u043D", $b19ca0fdfcbacc57$var$OA = "\u2013", $b19ca0fdfcbacc57$var$FA = "\u2924", $b19ca0fdfcbacc57$var$BA = "\u2197", $b19ca0fdfcbacc57$var$PA = "\u21D7", $b19ca0fdfcbacc57$var$$A = "\u2197", $b19ca0fdfcbacc57$var$zA = "\u2260", $b19ca0fdfcbacc57$var$UA = "\u2250\u0338", $b19ca0fdfcbacc57$var$HA = "\u200B", $b19ca0fdfcbacc57$var$VA = "\u200B", $b19ca0fdfcbacc57$var$GA = "\u200B", $b19ca0fdfcbacc57$var$jA = "\u200B", $b19ca0fdfcbacc57$var$ZA = "\u2262", $b19ca0fdfcbacc57$var$KA = "\u2928", $b19ca0fdfcbacc57$var$WA = "\u2242\u0338", $b19ca0fdfcbacc57$var$YA = "\u226B", $b19ca0fdfcbacc57$var$JA = "\u226A", $b19ca0fdfcbacc57$var$XA = `
`, $b19ca0fdfcbacc57$var$QA = "\u2204", $b19ca0fdfcbacc57$var$eC = "\u2204", $b19ca0fdfcbacc57$var$nC = "\uD835\uDD11", $b19ca0fdfcbacc57$var$tC = "\uD835\uDD2B", $b19ca0fdfcbacc57$var$rC = "\u2267\u0338", $b19ca0fdfcbacc57$var$oC = "\u2271", $b19ca0fdfcbacc57$var$sC = "\u2271", $b19ca0fdfcbacc57$var$cC = "\u2267\u0338", $b19ca0fdfcbacc57$var$iC = "\u2A7E\u0338", $b19ca0fdfcbacc57$var$aC = "\u2A7E\u0338", $b19ca0fdfcbacc57$var$lC = "\u22D9\u0338", $b19ca0fdfcbacc57$var$uC = "\u2275", $b19ca0fdfcbacc57$var$fC = "\u226B\u20D2", $b19ca0fdfcbacc57$var$pC = "\u226F", $b19ca0fdfcbacc57$var$hC = "\u226F", $b19ca0fdfcbacc57$var$dC = "\u226B\u0338", $b19ca0fdfcbacc57$var$gC = "\u21AE", $b19ca0fdfcbacc57$var$mC = "\u21CE", $b19ca0fdfcbacc57$var$_C = "\u2AF2", $b19ca0fdfcbacc57$var$bC = "\u220B", $b19ca0fdfcbacc57$var$vC = "\u22FC", $b19ca0fdfcbacc57$var$kC = "\u22FA", $b19ca0fdfcbacc57$var$xC = "\u220B", $b19ca0fdfcbacc57$var$yC = "\u040A", $b19ca0fdfcbacc57$var$EC = "\u045A", $b19ca0fdfcbacc57$var$wC = "\u219A", $b19ca0fdfcbacc57$var$AC = "\u21CD", $b19ca0fdfcbacc57$var$CC = "\u2025", $b19ca0fdfcbacc57$var$SC = "\u2266\u0338", $b19ca0fdfcbacc57$var$DC = "\u2270", $b19ca0fdfcbacc57$var$TC = "\u219A", $b19ca0fdfcbacc57$var$RC = "\u21CD", $b19ca0fdfcbacc57$var$LC = "\u21AE", $b19ca0fdfcbacc57$var$NC = "\u21CE", $b19ca0fdfcbacc57$var$qC = "\u2270", $b19ca0fdfcbacc57$var$MC = "\u2266\u0338", $b19ca0fdfcbacc57$var$IC = "\u2A7D\u0338", $b19ca0fdfcbacc57$var$OC = "\u2A7D\u0338", $b19ca0fdfcbacc57$var$FC = "\u226E", $b19ca0fdfcbacc57$var$BC = "\u22D8\u0338", $b19ca0fdfcbacc57$var$PC = "\u2274", $b19ca0fdfcbacc57$var$$C = "\u226A\u20D2", $b19ca0fdfcbacc57$var$zC = "\u226E", $b19ca0fdfcbacc57$var$UC = "\u22EA", $b19ca0fdfcbacc57$var$HC = "\u22EC", $b19ca0fdfcbacc57$var$VC = "\u226A\u0338", $b19ca0fdfcbacc57$var$GC = "\u2224", $b19ca0fdfcbacc57$var$jC = "\u2060", $b19ca0fdfcbacc57$var$ZC = "\xa0", $b19ca0fdfcbacc57$var$KC = "\uD835\uDD5F", $b19ca0fdfcbacc57$var$WC = "\u2115", $b19ca0fdfcbacc57$var$YC = "\u2AEC", $b19ca0fdfcbacc57$var$JC = "\xac", $b19ca0fdfcbacc57$var$XC = "\u2262", $b19ca0fdfcbacc57$var$QC = "\u226D", $b19ca0fdfcbacc57$var$eS = "\u2226", $b19ca0fdfcbacc57$var$nS = "\u2209", $b19ca0fdfcbacc57$var$tS = "\u2260", $b19ca0fdfcbacc57$var$rS = "\u2242\u0338", $b19ca0fdfcbacc57$var$oS = "\u2204", $b19ca0fdfcbacc57$var$sS = "\u226F", $b19ca0fdfcbacc57$var$cS = "\u2271", $b19ca0fdfcbacc57$var$iS = "\u2267\u0338", $b19ca0fdfcbacc57$var$aS = "\u226B\u0338", $b19ca0fdfcbacc57$var$lS = "\u2279", $b19ca0fdfcbacc57$var$uS = "\u2A7E\u0338", $b19ca0fdfcbacc57$var$fS = "\u2275", $b19ca0fdfcbacc57$var$pS = "\u224E\u0338", $b19ca0fdfcbacc57$var$hS = "\u224F\u0338", $b19ca0fdfcbacc57$var$dS = "\u2209", $b19ca0fdfcbacc57$var$gS = "\u22F5\u0338", $b19ca0fdfcbacc57$var$mS = "\u22F9\u0338", $b19ca0fdfcbacc57$var$_S = "\u2209", $b19ca0fdfcbacc57$var$bS = "\u22F7", $b19ca0fdfcbacc57$var$vS = "\u22F6", $b19ca0fdfcbacc57$var$kS = "\u29CF\u0338", $b19ca0fdfcbacc57$var$xS = "\u22EA", $b19ca0fdfcbacc57$var$yS = "\u22EC", $b19ca0fdfcbacc57$var$ES = "\u226E", $b19ca0fdfcbacc57$var$wS = "\u2270", $b19ca0fdfcbacc57$var$AS = "\u2278", $b19ca0fdfcbacc57$var$CS = "\u226A\u0338", $b19ca0fdfcbacc57$var$SS = "\u2A7D\u0338", $b19ca0fdfcbacc57$var$DS = "\u2274", $b19ca0fdfcbacc57$var$TS = "\u2AA2\u0338", $b19ca0fdfcbacc57$var$RS = "\u2AA1\u0338", $b19ca0fdfcbacc57$var$LS = "\u220C", $b19ca0fdfcbacc57$var$NS = "\u220C", $b19ca0fdfcbacc57$var$qS = "\u22FE", $b19ca0fdfcbacc57$var$MS = "\u22FD", $b19ca0fdfcbacc57$var$IS = "\u2280", $b19ca0fdfcbacc57$var$OS = "\u2AAF\u0338", $b19ca0fdfcbacc57$var$FS = "\u22E0", $b19ca0fdfcbacc57$var$BS = "\u220C", $b19ca0fdfcbacc57$var$PS = "\u29D0\u0338", $b19ca0fdfcbacc57$var$$S = "\u22EB", $b19ca0fdfcbacc57$var$zS = "\u22ED", $b19ca0fdfcbacc57$var$US = "\u228F\u0338", $b19ca0fdfcbacc57$var$HS = "\u22E2", $b19ca0fdfcbacc57$var$VS = "\u2290\u0338", $b19ca0fdfcbacc57$var$GS = "\u22E3", $b19ca0fdfcbacc57$var$jS = "\u2282\u20D2", $b19ca0fdfcbacc57$var$ZS = "\u2288", $b19ca0fdfcbacc57$var$KS = "\u2281", $b19ca0fdfcbacc57$var$WS = "\u2AB0\u0338", $b19ca0fdfcbacc57$var$YS = "\u22E1", $b19ca0fdfcbacc57$var$JS = "\u227F\u0338", $b19ca0fdfcbacc57$var$XS = "\u2283\u20D2", $b19ca0fdfcbacc57$var$QS = "\u2289", $b19ca0fdfcbacc57$var$eD = "\u2241", $b19ca0fdfcbacc57$var$nD = "\u2244", $b19ca0fdfcbacc57$var$tD = "\u2247", $b19ca0fdfcbacc57$var$rD = "\u2249", $b19ca0fdfcbacc57$var$oD = "\u2224", $b19ca0fdfcbacc57$var$sD = "\u2226", $b19ca0fdfcbacc57$var$cD = "\u2226", $b19ca0fdfcbacc57$var$iD = "\u2AFD\u20E5", $b19ca0fdfcbacc57$var$aD = "\u2202\u0338", $b19ca0fdfcbacc57$var$lD = "\u2A14", $b19ca0fdfcbacc57$var$uD = "\u2280", $b19ca0fdfcbacc57$var$fD = "\u22E0", $b19ca0fdfcbacc57$var$pD = "\u2280", $b19ca0fdfcbacc57$var$hD = "\u2AAF\u0338", $b19ca0fdfcbacc57$var$dD = "\u2AAF\u0338", $b19ca0fdfcbacc57$var$gD = "\u2933\u0338", $b19ca0fdfcbacc57$var$mD = "\u219B", $b19ca0fdfcbacc57$var$_D = "\u21CF", $b19ca0fdfcbacc57$var$bD = "\u219D\u0338", $b19ca0fdfcbacc57$var$vD = "\u219B", $b19ca0fdfcbacc57$var$kD = "\u21CF", $b19ca0fdfcbacc57$var$xD = "\u22EB", $b19ca0fdfcbacc57$var$yD = "\u22ED", $b19ca0fdfcbacc57$var$ED = "\u2281", $b19ca0fdfcbacc57$var$wD = "\u22E1", $b19ca0fdfcbacc57$var$AD = "\u2AB0\u0338", $b19ca0fdfcbacc57$var$CD = "\uD835\uDCA9", $b19ca0fdfcbacc57$var$SD = "\uD835\uDCC3", $b19ca0fdfcbacc57$var$DD = "\u2224", $b19ca0fdfcbacc57$var$TD = "\u2226", $b19ca0fdfcbacc57$var$RD = "\u2241", $b19ca0fdfcbacc57$var$LD = "\u2244", $b19ca0fdfcbacc57$var$ND = "\u2244", $b19ca0fdfcbacc57$var$qD = "\u2224", $b19ca0fdfcbacc57$var$MD = "\u2226", $b19ca0fdfcbacc57$var$ID = "\u22E2", $b19ca0fdfcbacc57$var$OD = "\u22E3", $b19ca0fdfcbacc57$var$FD = "\u2284", $b19ca0fdfcbacc57$var$BD = "\u2AC5\u0338", $b19ca0fdfcbacc57$var$PD = "\u2288", $b19ca0fdfcbacc57$var$$D = "\u2282\u20D2", $b19ca0fdfcbacc57$var$zD = "\u2288", $b19ca0fdfcbacc57$var$UD = "\u2AC5\u0338", $b19ca0fdfcbacc57$var$HD = "\u2281", $b19ca0fdfcbacc57$var$VD = "\u2AB0\u0338", $b19ca0fdfcbacc57$var$GD = "\u2285", $b19ca0fdfcbacc57$var$jD = "\u2AC6\u0338", $b19ca0fdfcbacc57$var$ZD = "\u2289", $b19ca0fdfcbacc57$var$KD = "\u2283\u20D2", $b19ca0fdfcbacc57$var$WD = "\u2289", $b19ca0fdfcbacc57$var$YD = "\u2AC6\u0338", $b19ca0fdfcbacc57$var$JD = "\u2279", $b19ca0fdfcbacc57$var$XD = "\xd1", $b19ca0fdfcbacc57$var$QD = "\xf1", $b19ca0fdfcbacc57$var$eT = "\u2278", $b19ca0fdfcbacc57$var$nT = "\u22EA", $b19ca0fdfcbacc57$var$tT = "\u22EC", $b19ca0fdfcbacc57$var$rT = "\u22EB", $b19ca0fdfcbacc57$var$oT = "\u22ED", $b19ca0fdfcbacc57$var$sT = "\u039D", $b19ca0fdfcbacc57$var$cT = "\u03BD", $b19ca0fdfcbacc57$var$iT = "#", $b19ca0fdfcbacc57$var$aT = "\u2116", $b19ca0fdfcbacc57$var$lT = "\u2007", $b19ca0fdfcbacc57$var$uT = "\u224D\u20D2", $b19ca0fdfcbacc57$var$fT = "\u22AC", $b19ca0fdfcbacc57$var$pT = "\u22AD", $b19ca0fdfcbacc57$var$hT = "\u22AE", $b19ca0fdfcbacc57$var$dT = "\u22AF", $b19ca0fdfcbacc57$var$gT = "\u2265\u20D2", $b19ca0fdfcbacc57$var$mT = ">\u20D2", $b19ca0fdfcbacc57$var$_T = "\u2904", $b19ca0fdfcbacc57$var$bT = "\u29DE", $b19ca0fdfcbacc57$var$vT = "\u2902", $b19ca0fdfcbacc57$var$kT = "\u2264\u20D2", $b19ca0fdfcbacc57$var$xT = "<\u20D2", $b19ca0fdfcbacc57$var$yT = "\u22B4\u20D2", $b19ca0fdfcbacc57$var$ET = "\u2903", $b19ca0fdfcbacc57$var$wT = "\u22B5\u20D2", $b19ca0fdfcbacc57$var$AT = "\u223C\u20D2", $b19ca0fdfcbacc57$var$CT = "\u2923", $b19ca0fdfcbacc57$var$ST = "\u2196", $b19ca0fdfcbacc57$var$DT = "\u21D6", $b19ca0fdfcbacc57$var$TT = "\u2196", $b19ca0fdfcbacc57$var$RT = "\u2927", $b19ca0fdfcbacc57$var$LT = "\xd3", $b19ca0fdfcbacc57$var$NT = "\xf3", $b19ca0fdfcbacc57$var$qT = "\u229B", $b19ca0fdfcbacc57$var$MT = "\xd4", $b19ca0fdfcbacc57$var$IT = "\xf4", $b19ca0fdfcbacc57$var$OT = "\u229A", $b19ca0fdfcbacc57$var$FT = "\u041E", $b19ca0fdfcbacc57$var$BT = "\u043E", $b19ca0fdfcbacc57$var$PT = "\u229D", $b19ca0fdfcbacc57$var$$T = "\u0150", $b19ca0fdfcbacc57$var$zT = "\u0151", $b19ca0fdfcbacc57$var$UT = "\u2A38", $b19ca0fdfcbacc57$var$HT = "\u2299", $b19ca0fdfcbacc57$var$VT = "\u29BC", $b19ca0fdfcbacc57$var$GT = "\u0152", $b19ca0fdfcbacc57$var$jT = "\u0153", $b19ca0fdfcbacc57$var$ZT = "\u29BF", $b19ca0fdfcbacc57$var$KT = "\uD835\uDD12", $b19ca0fdfcbacc57$var$WT = "\uD835\uDD2C", $b19ca0fdfcbacc57$var$YT = "\u02DB", $b19ca0fdfcbacc57$var$JT = "\xd2", $b19ca0fdfcbacc57$var$XT = "\xf2", $b19ca0fdfcbacc57$var$QT = "\u29C1", $b19ca0fdfcbacc57$var$eR = "\u29B5", $b19ca0fdfcbacc57$var$nR = "\u03A9", $b19ca0fdfcbacc57$var$tR = "\u222E", $b19ca0fdfcbacc57$var$rR = "\u21BA", $b19ca0fdfcbacc57$var$oR = "\u29BE", $b19ca0fdfcbacc57$var$sR = "\u29BB", $b19ca0fdfcbacc57$var$cR = "\u203E", $b19ca0fdfcbacc57$var$iR = "\u29C0", $b19ca0fdfcbacc57$var$aR = "\u014C", $b19ca0fdfcbacc57$var$lR = "\u014D", $b19ca0fdfcbacc57$var$uR = "\u03A9", $b19ca0fdfcbacc57$var$fR = "\u03C9", $b19ca0fdfcbacc57$var$pR = "\u039F", $b19ca0fdfcbacc57$var$hR = "\u03BF", $b19ca0fdfcbacc57$var$dR = "\u29B6", $b19ca0fdfcbacc57$var$gR = "\u2296", $b19ca0fdfcbacc57$var$mR = "\uD835\uDD46", $b19ca0fdfcbacc57$var$_R = "\uD835\uDD60", $b19ca0fdfcbacc57$var$bR = "\u29B7", $b19ca0fdfcbacc57$var$vR = "\u201C", $b19ca0fdfcbacc57$var$kR = "\u2018", $b19ca0fdfcbacc57$var$xR = "\u29B9", $b19ca0fdfcbacc57$var$yR = "\u2295", $b19ca0fdfcbacc57$var$ER = "\u21BB", $b19ca0fdfcbacc57$var$wR = "\u2A54", $b19ca0fdfcbacc57$var$AR = "\u2228", $b19ca0fdfcbacc57$var$CR = "\u2A5D", $b19ca0fdfcbacc57$var$SR = "\u2134", $b19ca0fdfcbacc57$var$DR = "\u2134", $b19ca0fdfcbacc57$var$TR = "\xaa", $b19ca0fdfcbacc57$var$RR = "\xba", $b19ca0fdfcbacc57$var$LR = "\u22B6", $b19ca0fdfcbacc57$var$NR = "\u2A56", $b19ca0fdfcbacc57$var$qR = "\u2A57", $b19ca0fdfcbacc57$var$MR = "\u2A5B", $b19ca0fdfcbacc57$var$IR = "\u24C8", $b19ca0fdfcbacc57$var$OR = "\uD835\uDCAA", $b19ca0fdfcbacc57$var$FR = "\u2134", $b19ca0fdfcbacc57$var$BR = "\xd8", $b19ca0fdfcbacc57$var$PR = "\xf8", $b19ca0fdfcbacc57$var$$R = "\u2298", $b19ca0fdfcbacc57$var$zR = "\xd5", $b19ca0fdfcbacc57$var$UR = "\xf5", $b19ca0fdfcbacc57$var$HR = "\u2A36", $b19ca0fdfcbacc57$var$VR = "\u2A37", $b19ca0fdfcbacc57$var$GR = "\u2297", $b19ca0fdfcbacc57$var$jR = "\xd6", $b19ca0fdfcbacc57$var$ZR = "\xf6", $b19ca0fdfcbacc57$var$KR = "\u233D", $b19ca0fdfcbacc57$var$WR = "\u203E", $b19ca0fdfcbacc57$var$YR = "\u23DE", $b19ca0fdfcbacc57$var$JR = "\u23B4", $b19ca0fdfcbacc57$var$XR = "\u23DC", $b19ca0fdfcbacc57$var$QR = "\xb6", $b19ca0fdfcbacc57$var$e2 = "\u2225", $b19ca0fdfcbacc57$var$n2 = "\u2225", $b19ca0fdfcbacc57$var$t2 = "\u2AF3", $b19ca0fdfcbacc57$var$r2 = "\u2AFD", $b19ca0fdfcbacc57$var$o2 = "\u2202", $b19ca0fdfcbacc57$var$s2 = "\u2202", $b19ca0fdfcbacc57$var$c2 = "\u041F", $b19ca0fdfcbacc57$var$i2 = "\u043F", $b19ca0fdfcbacc57$var$a2 = "%", $b19ca0fdfcbacc57$var$l2 = ".", $b19ca0fdfcbacc57$var$u2 = "\u2030", $b19ca0fdfcbacc57$var$f2 = "\u22A5", $b19ca0fdfcbacc57$var$p2 = "\u2031", $b19ca0fdfcbacc57$var$h2 = "\uD835\uDD13", $b19ca0fdfcbacc57$var$d2 = "\uD835\uDD2D", $b19ca0fdfcbacc57$var$g2 = "\u03A6", $b19ca0fdfcbacc57$var$m2 = "\u03C6", $b19ca0fdfcbacc57$var$_2 = "\u03D5", $b19ca0fdfcbacc57$var$b2 = "\u2133", $b19ca0fdfcbacc57$var$v2 = "\u260E", $b19ca0fdfcbacc57$var$k2 = "\u03A0", $b19ca0fdfcbacc57$var$x2 = "\u03C0", $b19ca0fdfcbacc57$var$y2 = "\u22D4", $b19ca0fdfcbacc57$var$E2 = "\u03D6", $b19ca0fdfcbacc57$var$w2 = "\u210F", $b19ca0fdfcbacc57$var$A2 = "\u210E", $b19ca0fdfcbacc57$var$C2 = "\u210F", $b19ca0fdfcbacc57$var$S2 = "\u2A23", $b19ca0fdfcbacc57$var$D2 = "\u229E", $b19ca0fdfcbacc57$var$T2 = "\u2A22", $b19ca0fdfcbacc57$var$R2 = "+", $b19ca0fdfcbacc57$var$L2 = "\u2214", $b19ca0fdfcbacc57$var$N2 = "\u2A25", $b19ca0fdfcbacc57$var$q2 = "\u2A72", $b19ca0fdfcbacc57$var$M2 = "\xb1", $b19ca0fdfcbacc57$var$I2 = "\xb1", $b19ca0fdfcbacc57$var$O2 = "\u2A26", $b19ca0fdfcbacc57$var$F2 = "\u2A27", $b19ca0fdfcbacc57$var$B2 = "\xb1", $b19ca0fdfcbacc57$var$P2 = "\u210C", $b19ca0fdfcbacc57$var$$2 = "\u2A15", $b19ca0fdfcbacc57$var$z2 = "\uD835\uDD61", $b19ca0fdfcbacc57$var$U2 = "\u2119", $b19ca0fdfcbacc57$var$H2 = "\xa3", $b19ca0fdfcbacc57$var$V2 = "\u2AB7", $b19ca0fdfcbacc57$var$G2 = "\u2ABB", $b19ca0fdfcbacc57$var$j2 = "\u227A", $b19ca0fdfcbacc57$var$Z2 = "\u227C", $b19ca0fdfcbacc57$var$K2 = "\u2AB7", $b19ca0fdfcbacc57$var$W2 = "\u227A", $b19ca0fdfcbacc57$var$Y2 = "\u227C", $b19ca0fdfcbacc57$var$J2 = "\u227A", $b19ca0fdfcbacc57$var$X2 = "\u2AAF", $b19ca0fdfcbacc57$var$Q2 = "\u227C", $b19ca0fdfcbacc57$var$eL = "\u227E", $b19ca0fdfcbacc57$var$nL = "\u2AAF", $b19ca0fdfcbacc57$var$tL = "\u2AB9", $b19ca0fdfcbacc57$var$rL = "\u2AB5", $b19ca0fdfcbacc57$var$oL = "\u22E8", $b19ca0fdfcbacc57$var$sL = "\u2AAF", $b19ca0fdfcbacc57$var$cL = "\u2AB3", $b19ca0fdfcbacc57$var$iL = "\u227E", $b19ca0fdfcbacc57$var$aL = "\u2032", $b19ca0fdfcbacc57$var$lL = "\u2033", $b19ca0fdfcbacc57$var$uL = "\u2119", $b19ca0fdfcbacc57$var$fL = "\u2AB9", $b19ca0fdfcbacc57$var$pL = "\u2AB5", $b19ca0fdfcbacc57$var$hL = "\u22E8", $b19ca0fdfcbacc57$var$dL = "\u220F", $b19ca0fdfcbacc57$var$gL = "\u220F", $b19ca0fdfcbacc57$var$mL = "\u232E", $b19ca0fdfcbacc57$var$_L = "\u2312", $b19ca0fdfcbacc57$var$bL = "\u2313", $b19ca0fdfcbacc57$var$vL = "\u221D", $b19ca0fdfcbacc57$var$kL = "\u221D", $b19ca0fdfcbacc57$var$xL = "\u2237", $b19ca0fdfcbacc57$var$yL = "\u221D", $b19ca0fdfcbacc57$var$EL = "\u227E", $b19ca0fdfcbacc57$var$wL = "\u22B0", $b19ca0fdfcbacc57$var$AL = "\uD835\uDCAB", $b19ca0fdfcbacc57$var$CL = "\uD835\uDCC5", $b19ca0fdfcbacc57$var$SL = "\u03A8", $b19ca0fdfcbacc57$var$DL = "\u03C8", $b19ca0fdfcbacc57$var$TL = "\u2008", $b19ca0fdfcbacc57$var$RL = "\uD835\uDD14", $b19ca0fdfcbacc57$var$LL = "\uD835\uDD2E", $b19ca0fdfcbacc57$var$NL = "\u2A0C", $b19ca0fdfcbacc57$var$qL = "\uD835\uDD62", $b19ca0fdfcbacc57$var$ML = "\u211A", $b19ca0fdfcbacc57$var$IL = "\u2057", $b19ca0fdfcbacc57$var$OL = "\uD835\uDCAC", $b19ca0fdfcbacc57$var$FL = "\uD835\uDCC6", $b19ca0fdfcbacc57$var$BL = "\u210D", $b19ca0fdfcbacc57$var$PL = "\u2A16", $b19ca0fdfcbacc57$var$$L = "?", $b19ca0fdfcbacc57$var$zL = "\u225F", $b19ca0fdfcbacc57$var$UL = '"', $b19ca0fdfcbacc57$var$HL = '"', $b19ca0fdfcbacc57$var$VL = "\u21DB", $b19ca0fdfcbacc57$var$GL = "\u223D\u0331", $b19ca0fdfcbacc57$var$jL = "\u0154", $b19ca0fdfcbacc57$var$ZL = "\u0155", $b19ca0fdfcbacc57$var$KL = "\u221A", $b19ca0fdfcbacc57$var$WL = "\u29B3", $b19ca0fdfcbacc57$var$YL = "\u27E9", $b19ca0fdfcbacc57$var$JL = "\u27EB", $b19ca0fdfcbacc57$var$XL = "\u2992", $b19ca0fdfcbacc57$var$QL = "\u29A5", $b19ca0fdfcbacc57$var$eN = "\u27E9", $b19ca0fdfcbacc57$var$nN = "\xbb", $b19ca0fdfcbacc57$var$tN = "\u2975", $b19ca0fdfcbacc57$var$rN = "\u21E5", $b19ca0fdfcbacc57$var$oN = "\u2920", $b19ca0fdfcbacc57$var$sN = "\u2933", $b19ca0fdfcbacc57$var$cN = "\u2192", $b19ca0fdfcbacc57$var$iN = "\u21A0", $b19ca0fdfcbacc57$var$aN = "\u21D2", $b19ca0fdfcbacc57$var$lN = "\u291E", $b19ca0fdfcbacc57$var$uN = "\u21AA", $b19ca0fdfcbacc57$var$fN = "\u21AC", $b19ca0fdfcbacc57$var$pN = "\u2945", $b19ca0fdfcbacc57$var$hN = "\u2974", $b19ca0fdfcbacc57$var$dN = "\u2916", $b19ca0fdfcbacc57$var$gN = "\u21A3", $b19ca0fdfcbacc57$var$mN = "\u219D", $b19ca0fdfcbacc57$var$_N = "\u291A", $b19ca0fdfcbacc57$var$bN = "\u291C", $b19ca0fdfcbacc57$var$vN = "\u2236", $b19ca0fdfcbacc57$var$kN = "\u211A", $b19ca0fdfcbacc57$var$xN = "\u290D", $b19ca0fdfcbacc57$var$yN = "\u290F", $b19ca0fdfcbacc57$var$EN = "\u2910", $b19ca0fdfcbacc57$var$wN = "\u2773", $b19ca0fdfcbacc57$var$AN = "}", $b19ca0fdfcbacc57$var$CN = "]", $b19ca0fdfcbacc57$var$SN = "\u298C", $b19ca0fdfcbacc57$var$DN = "\u298E", $b19ca0fdfcbacc57$var$TN = "\u2990", $b19ca0fdfcbacc57$var$RN = "\u0158", $b19ca0fdfcbacc57$var$LN = "\u0159", $b19ca0fdfcbacc57$var$NN = "\u0156", $b19ca0fdfcbacc57$var$qN = "\u0157", $b19ca0fdfcbacc57$var$MN = "\u2309", $b19ca0fdfcbacc57$var$IN = "}", $b19ca0fdfcbacc57$var$ON = "\u0420", $b19ca0fdfcbacc57$var$FN = "\u0440", $b19ca0fdfcbacc57$var$BN = "\u2937", $b19ca0fdfcbacc57$var$PN = "\u2969", $b19ca0fdfcbacc57$var$$N = "\u201D", $b19ca0fdfcbacc57$var$zN = "\u201D", $b19ca0fdfcbacc57$var$UN = "\u21B3", $b19ca0fdfcbacc57$var$HN = "\u211C", $b19ca0fdfcbacc57$var$VN = "\u211B", $b19ca0fdfcbacc57$var$GN = "\u211C", $b19ca0fdfcbacc57$var$jN = "\u211D", $b19ca0fdfcbacc57$var$ZN = "\u211C", $b19ca0fdfcbacc57$var$KN = "\u25AD", $b19ca0fdfcbacc57$var$WN = "\xae", $b19ca0fdfcbacc57$var$YN = "\xae", $b19ca0fdfcbacc57$var$JN = "\u220B", $b19ca0fdfcbacc57$var$XN = "\u21CB", $b19ca0fdfcbacc57$var$QN = "\u296F", $b19ca0fdfcbacc57$var$eq = "\u297D", $b19ca0fdfcbacc57$var$nq = "\u230B", $b19ca0fdfcbacc57$var$tq = "\uD835\uDD2F", $b19ca0fdfcbacc57$var$rq = "\u211C", $b19ca0fdfcbacc57$var$oq = "\u2964", $b19ca0fdfcbacc57$var$sq = "\u21C1", $b19ca0fdfcbacc57$var$cq = "\u21C0", $b19ca0fdfcbacc57$var$iq = "\u296C", $b19ca0fdfcbacc57$var$aq = "\u03A1", $b19ca0fdfcbacc57$var$lq = "\u03C1", $b19ca0fdfcbacc57$var$uq = "\u03F1", $b19ca0fdfcbacc57$var$fq = "\u27E9", $b19ca0fdfcbacc57$var$pq = "\u21E5", $b19ca0fdfcbacc57$var$hq = "\u2192", $b19ca0fdfcbacc57$var$dq = "\u2192", $b19ca0fdfcbacc57$var$gq = "\u21D2", $b19ca0fdfcbacc57$var$mq = "\u21C4", $b19ca0fdfcbacc57$var$_q = "\u21A3", $b19ca0fdfcbacc57$var$bq = "\u2309", $b19ca0fdfcbacc57$var$vq = "\u27E7", $b19ca0fdfcbacc57$var$kq = "\u295D", $b19ca0fdfcbacc57$var$xq = "\u2955", $b19ca0fdfcbacc57$var$yq = "\u21C2", $b19ca0fdfcbacc57$var$Eq = "\u230B", $b19ca0fdfcbacc57$var$wq = "\u21C1", $b19ca0fdfcbacc57$var$Aq = "\u21C0", $b19ca0fdfcbacc57$var$Cq = "\u21C4", $b19ca0fdfcbacc57$var$Sq = "\u21CC", $b19ca0fdfcbacc57$var$Dq = "\u21C9", $b19ca0fdfcbacc57$var$Tq = "\u219D", $b19ca0fdfcbacc57$var$Rq = "\u21A6", $b19ca0fdfcbacc57$var$Lq = "\u22A2", $b19ca0fdfcbacc57$var$Nq = "\u295B", $b19ca0fdfcbacc57$var$qq = "\u22CC", $b19ca0fdfcbacc57$var$Mq = "\u29D0", $b19ca0fdfcbacc57$var$Iq = "\u22B3", $b19ca0fdfcbacc57$var$Oq = "\u22B5", $b19ca0fdfcbacc57$var$Fq = "\u294F", $b19ca0fdfcbacc57$var$Bq = "\u295C", $b19ca0fdfcbacc57$var$Pq = "\u2954", $b19ca0fdfcbacc57$var$$q = "\u21BE", $b19ca0fdfcbacc57$var$zq = "\u2953", $b19ca0fdfcbacc57$var$Uq = "\u21C0", $b19ca0fdfcbacc57$var$Hq = "\u02DA", $b19ca0fdfcbacc57$var$Vq = "\u2253", $b19ca0fdfcbacc57$var$Gq = "\u21C4", $b19ca0fdfcbacc57$var$jq = "\u21CC", $b19ca0fdfcbacc57$var$Zq = "\u200F", $b19ca0fdfcbacc57$var$Kq = "\u23B1", $b19ca0fdfcbacc57$var$Wq = "\u23B1", $b19ca0fdfcbacc57$var$Yq = "\u2AEE", $b19ca0fdfcbacc57$var$Jq = "\u27ED", $b19ca0fdfcbacc57$var$Xq = "\u21FE", $b19ca0fdfcbacc57$var$Qq = "\u27E7", $b19ca0fdfcbacc57$var$eM = "\u2986", $b19ca0fdfcbacc57$var$nM = "\uD835\uDD63", $b19ca0fdfcbacc57$var$tM = "\u211D", $b19ca0fdfcbacc57$var$rM = "\u2A2E", $b19ca0fdfcbacc57$var$oM = "\u2A35", $b19ca0fdfcbacc57$var$sM = "\u2970", $b19ca0fdfcbacc57$var$cM = ")", $b19ca0fdfcbacc57$var$iM = "\u2994", $b19ca0fdfcbacc57$var$aM = "\u2A12", $b19ca0fdfcbacc57$var$lM = "\u21C9", $b19ca0fdfcbacc57$var$uM = "\u21DB", $b19ca0fdfcbacc57$var$fM = "\u203A", $b19ca0fdfcbacc57$var$pM = "\uD835\uDCC7", $b19ca0fdfcbacc57$var$hM = "\u211B", $b19ca0fdfcbacc57$var$dM = "\u21B1", $b19ca0fdfcbacc57$var$gM = "\u21B1", $b19ca0fdfcbacc57$var$mM = "]", $b19ca0fdfcbacc57$var$_M = "\u2019", $b19ca0fdfcbacc57$var$bM = "\u2019", $b19ca0fdfcbacc57$var$vM = "\u22CC", $b19ca0fdfcbacc57$var$kM = "\u22CA", $b19ca0fdfcbacc57$var$xM = "\u25B9", $b19ca0fdfcbacc57$var$yM = "\u22B5", $b19ca0fdfcbacc57$var$EM = "\u25B8", $b19ca0fdfcbacc57$var$wM = "\u29CE", $b19ca0fdfcbacc57$var$AM = "\u29F4", $b19ca0fdfcbacc57$var$CM = "\u2968", $b19ca0fdfcbacc57$var$SM = "\u211E", $b19ca0fdfcbacc57$var$DM = "\u015A", $b19ca0fdfcbacc57$var$TM = "\u015B", $b19ca0fdfcbacc57$var$RM = "\u201A", $b19ca0fdfcbacc57$var$LM = "\u2AB8", $b19ca0fdfcbacc57$var$NM = "\u0160", $b19ca0fdfcbacc57$var$qM = "\u0161", $b19ca0fdfcbacc57$var$MM = "\u2ABC", $b19ca0fdfcbacc57$var$IM = "\u227B", $b19ca0fdfcbacc57$var$OM = "\u227D", $b19ca0fdfcbacc57$var$FM = "\u2AB0", $b19ca0fdfcbacc57$var$BM = "\u2AB4", $b19ca0fdfcbacc57$var$PM = "\u015E", $b19ca0fdfcbacc57$var$$M = "\u015F", $b19ca0fdfcbacc57$var$zM = "\u015C", $b19ca0fdfcbacc57$var$UM = "\u015D", $b19ca0fdfcbacc57$var$HM = "\u2ABA", $b19ca0fdfcbacc57$var$VM = "\u2AB6", $b19ca0fdfcbacc57$var$GM = "\u22E9", $b19ca0fdfcbacc57$var$jM = "\u2A13", $b19ca0fdfcbacc57$var$ZM = "\u227F", $b19ca0fdfcbacc57$var$KM = "\u0421", $b19ca0fdfcbacc57$var$WM = "\u0441", $b19ca0fdfcbacc57$var$YM = "\u22A1", $b19ca0fdfcbacc57$var$JM = "\u22C5", $b19ca0fdfcbacc57$var$XM = "\u2A66", $b19ca0fdfcbacc57$var$QM = "\u2925", $b19ca0fdfcbacc57$var$eI = "\u2198", $b19ca0fdfcbacc57$var$nI = "\u21D8", $b19ca0fdfcbacc57$var$tI = "\u2198", $b19ca0fdfcbacc57$var$rI = "\xa7", $b19ca0fdfcbacc57$var$oI = ";", $b19ca0fdfcbacc57$var$sI = "\u2929", $b19ca0fdfcbacc57$var$cI = "\u2216", $b19ca0fdfcbacc57$var$iI = "\u2216", $b19ca0fdfcbacc57$var$aI = "\u2736", $b19ca0fdfcbacc57$var$lI = "\uD835\uDD16", $b19ca0fdfcbacc57$var$uI = "\uD835\uDD30", $b19ca0fdfcbacc57$var$fI = "\u2322", $b19ca0fdfcbacc57$var$pI = "\u266F", $b19ca0fdfcbacc57$var$hI = "\u0429", $b19ca0fdfcbacc57$var$dI = "\u0449", $b19ca0fdfcbacc57$var$gI = "\u0428", $b19ca0fdfcbacc57$var$mI = "\u0448", $b19ca0fdfcbacc57$var$_I = "\u2193", $b19ca0fdfcbacc57$var$bI = "\u2190", $b19ca0fdfcbacc57$var$vI = "\u2223", $b19ca0fdfcbacc57$var$kI = "\u2225", $b19ca0fdfcbacc57$var$xI = "\u2192", $b19ca0fdfcbacc57$var$yI = "\u2191", $b19ca0fdfcbacc57$var$EI = "\xad", $b19ca0fdfcbacc57$var$wI = "\u03A3", $b19ca0fdfcbacc57$var$AI = "\u03C3", $b19ca0fdfcbacc57$var$CI = "\u03C2", $b19ca0fdfcbacc57$var$SI = "\u03C2", $b19ca0fdfcbacc57$var$DI = "\u223C", $b19ca0fdfcbacc57$var$TI = "\u2A6A", $b19ca0fdfcbacc57$var$RI = "\u2243", $b19ca0fdfcbacc57$var$LI = "\u2243", $b19ca0fdfcbacc57$var$NI = "\u2A9E", $b19ca0fdfcbacc57$var$qI = "\u2AA0", $b19ca0fdfcbacc57$var$MI = "\u2A9D", $b19ca0fdfcbacc57$var$II = "\u2A9F", $b19ca0fdfcbacc57$var$OI = "\u2246", $b19ca0fdfcbacc57$var$FI = "\u2A24", $b19ca0fdfcbacc57$var$BI = "\u2972", $b19ca0fdfcbacc57$var$PI = "\u2190", $b19ca0fdfcbacc57$var$$I = "\u2218", $b19ca0fdfcbacc57$var$zI = "\u2216", $b19ca0fdfcbacc57$var$UI = "\u2A33", $b19ca0fdfcbacc57$var$HI = "\u29E4", $b19ca0fdfcbacc57$var$VI = "\u2223", $b19ca0fdfcbacc57$var$GI = "\u2323", $b19ca0fdfcbacc57$var$jI = "\u2AAA", $b19ca0fdfcbacc57$var$ZI = "\u2AAC", $b19ca0fdfcbacc57$var$KI = "\u2AAC\uFE00", $b19ca0fdfcbacc57$var$WI = "\u042C", $b19ca0fdfcbacc57$var$YI = "\u044C", $b19ca0fdfcbacc57$var$JI = "\u233F", $b19ca0fdfcbacc57$var$XI = "\u29C4", $b19ca0fdfcbacc57$var$QI = "/", $b19ca0fdfcbacc57$var$eO = "\uD835\uDD4A", $b19ca0fdfcbacc57$var$nO = "\uD835\uDD64", $b19ca0fdfcbacc57$var$tO = "\u2660", $b19ca0fdfcbacc57$var$rO = "\u2660", $b19ca0fdfcbacc57$var$oO = "\u2225", $b19ca0fdfcbacc57$var$sO = "\u2293", $b19ca0fdfcbacc57$var$cO = "\u2293\uFE00", $b19ca0fdfcbacc57$var$iO = "\u2294", $b19ca0fdfcbacc57$var$aO = "\u2294\uFE00", $b19ca0fdfcbacc57$var$lO = "\u221A", $b19ca0fdfcbacc57$var$uO = "\u228F", $b19ca0fdfcbacc57$var$fO = "\u2291", $b19ca0fdfcbacc57$var$pO = "\u228F", $b19ca0fdfcbacc57$var$hO = "\u2291", $b19ca0fdfcbacc57$var$dO = "\u2290", $b19ca0fdfcbacc57$var$gO = "\u2292", $b19ca0fdfcbacc57$var$mO = "\u2290", $b19ca0fdfcbacc57$var$_O = "\u2292", $b19ca0fdfcbacc57$var$bO = "\u25A1", $b19ca0fdfcbacc57$var$vO = "\u25A1", $b19ca0fdfcbacc57$var$kO = "\u2293", $b19ca0fdfcbacc57$var$xO = "\u228F", $b19ca0fdfcbacc57$var$yO = "\u2291", $b19ca0fdfcbacc57$var$EO = "\u2290", $b19ca0fdfcbacc57$var$wO = "\u2292", $b19ca0fdfcbacc57$var$AO = "\u2294", $b19ca0fdfcbacc57$var$CO = "\u25AA", $b19ca0fdfcbacc57$var$SO = "\u25A1", $b19ca0fdfcbacc57$var$DO = "\u25AA", $b19ca0fdfcbacc57$var$TO = "\u2192", $b19ca0fdfcbacc57$var$RO = "\uD835\uDCAE", $b19ca0fdfcbacc57$var$LO = "\uD835\uDCC8", $b19ca0fdfcbacc57$var$NO = "\u2216", $b19ca0fdfcbacc57$var$qO = "\u2323", $b19ca0fdfcbacc57$var$MO = "\u22C6", $b19ca0fdfcbacc57$var$IO = "\u22C6", $b19ca0fdfcbacc57$var$OO = "\u2606", $b19ca0fdfcbacc57$var$FO = "\u2605", $b19ca0fdfcbacc57$var$BO = "\u03F5", $b19ca0fdfcbacc57$var$PO = "\u03D5", $b19ca0fdfcbacc57$var$$O = "\xaf", $b19ca0fdfcbacc57$var$zO = "\u2282", $b19ca0fdfcbacc57$var$UO = "\u22D0", $b19ca0fdfcbacc57$var$HO = "\u2ABD", $b19ca0fdfcbacc57$var$VO = "\u2AC5", $b19ca0fdfcbacc57$var$GO = "\u2286", $b19ca0fdfcbacc57$var$jO = "\u2AC3", $b19ca0fdfcbacc57$var$ZO = "\u2AC1", $b19ca0fdfcbacc57$var$KO = "\u2ACB", $b19ca0fdfcbacc57$var$WO = "\u228A", $b19ca0fdfcbacc57$var$YO = "\u2ABF", $b19ca0fdfcbacc57$var$JO = "\u2979", $b19ca0fdfcbacc57$var$XO = "\u2282", $b19ca0fdfcbacc57$var$QO = "\u22D0", $b19ca0fdfcbacc57$var$eF = "\u2286", $b19ca0fdfcbacc57$var$nF = "\u2AC5", $b19ca0fdfcbacc57$var$tF = "\u2286", $b19ca0fdfcbacc57$var$rF = "\u228A", $b19ca0fdfcbacc57$var$oF = "\u2ACB", $b19ca0fdfcbacc57$var$sF = "\u2AC7", $b19ca0fdfcbacc57$var$cF = "\u2AD5", $b19ca0fdfcbacc57$var$iF = "\u2AD3", $b19ca0fdfcbacc57$var$aF = "\u2AB8", $b19ca0fdfcbacc57$var$lF = "\u227B", $b19ca0fdfcbacc57$var$uF = "\u227D", $b19ca0fdfcbacc57$var$fF = "\u227B", $b19ca0fdfcbacc57$var$pF = "\u2AB0", $b19ca0fdfcbacc57$var$hF = "\u227D", $b19ca0fdfcbacc57$var$dF = "\u227F", $b19ca0fdfcbacc57$var$gF = "\u2AB0", $b19ca0fdfcbacc57$var$mF = "\u2ABA", $b19ca0fdfcbacc57$var$_F = "\u2AB6", $b19ca0fdfcbacc57$var$bF = "\u22E9", $b19ca0fdfcbacc57$var$vF = "\u227F", $b19ca0fdfcbacc57$var$kF = "\u220B", $b19ca0fdfcbacc57$var$xF = "\u2211", $b19ca0fdfcbacc57$var$yF = "\u2211", $b19ca0fdfcbacc57$var$EF = "\u266A", $b19ca0fdfcbacc57$var$wF = "\xb9", $b19ca0fdfcbacc57$var$AF = "\xb2", $b19ca0fdfcbacc57$var$CF = "\xb3", $b19ca0fdfcbacc57$var$SF = "\u2283", $b19ca0fdfcbacc57$var$DF = "\u22D1", $b19ca0fdfcbacc57$var$TF = "\u2ABE", $b19ca0fdfcbacc57$var$RF = "\u2AD8", $b19ca0fdfcbacc57$var$LF = "\u2AC6", $b19ca0fdfcbacc57$var$NF = "\u2287", $b19ca0fdfcbacc57$var$qF = "\u2AC4", $b19ca0fdfcbacc57$var$MF = "\u2283", $b19ca0fdfcbacc57$var$IF = "\u2287", $b19ca0fdfcbacc57$var$OF = "\u27C9", $b19ca0fdfcbacc57$var$FF = "\u2AD7", $b19ca0fdfcbacc57$var$BF = "\u297B", $b19ca0fdfcbacc57$var$PF = "\u2AC2", $b19ca0fdfcbacc57$var$$F = "\u2ACC", $b19ca0fdfcbacc57$var$zF = "\u228B", $b19ca0fdfcbacc57$var$UF = "\u2AC0", $b19ca0fdfcbacc57$var$HF = "\u2283", $b19ca0fdfcbacc57$var$VF = "\u22D1", $b19ca0fdfcbacc57$var$GF = "\u2287", $b19ca0fdfcbacc57$var$jF = "\u2AC6", $b19ca0fdfcbacc57$var$ZF = "\u228B", $b19ca0fdfcbacc57$var$KF = "\u2ACC", $b19ca0fdfcbacc57$var$WF = "\u2AC8", $b19ca0fdfcbacc57$var$YF = "\u2AD4", $b19ca0fdfcbacc57$var$JF = "\u2AD6", $b19ca0fdfcbacc57$var$XF = "\u2926", $b19ca0fdfcbacc57$var$QF = "\u2199", $b19ca0fdfcbacc57$var$eB = "\u21D9", $b19ca0fdfcbacc57$var$nB = "\u2199", $b19ca0fdfcbacc57$var$tB = "\u292A", $b19ca0fdfcbacc57$var$rB = "\xdf", $b19ca0fdfcbacc57$var$oB = "	", $b19ca0fdfcbacc57$var$sB = "\u2316", $b19ca0fdfcbacc57$var$cB = "\u03A4", $b19ca0fdfcbacc57$var$iB = "\u03C4", $b19ca0fdfcbacc57$var$aB = "\u23B4", $b19ca0fdfcbacc57$var$lB = "\u0164", $b19ca0fdfcbacc57$var$uB = "\u0165", $b19ca0fdfcbacc57$var$fB = "\u0162", $b19ca0fdfcbacc57$var$pB = "\u0163", $b19ca0fdfcbacc57$var$hB = "\u0422", $b19ca0fdfcbacc57$var$dB = "\u0442", $b19ca0fdfcbacc57$var$gB = "\u20DB", $b19ca0fdfcbacc57$var$mB = "\u2315", $b19ca0fdfcbacc57$var$_B = "\uD835\uDD17", $b19ca0fdfcbacc57$var$bB = "\uD835\uDD31", $b19ca0fdfcbacc57$var$vB = "\u2234", $b19ca0fdfcbacc57$var$kB = "\u2234", $b19ca0fdfcbacc57$var$xB = "\u2234", $b19ca0fdfcbacc57$var$yB = "\u0398", $b19ca0fdfcbacc57$var$EB = "\u03B8", $b19ca0fdfcbacc57$var$wB = "\u03D1", $b19ca0fdfcbacc57$var$AB = "\u03D1", $b19ca0fdfcbacc57$var$CB = "\u2248", $b19ca0fdfcbacc57$var$SB = "\u223C", $b19ca0fdfcbacc57$var$DB = "\u205F\u200A", $b19ca0fdfcbacc57$var$TB = "\u2009", $b19ca0fdfcbacc57$var$RB = "\u2009", $b19ca0fdfcbacc57$var$LB = "\u2248", $b19ca0fdfcbacc57$var$NB = "\u223C", $b19ca0fdfcbacc57$var$qB = "\xde", $b19ca0fdfcbacc57$var$MB = "\xfe", $b19ca0fdfcbacc57$var$IB = "\u02DC", $b19ca0fdfcbacc57$var$OB = "\u223C", $b19ca0fdfcbacc57$var$FB = "\u2243", $b19ca0fdfcbacc57$var$BB = "\u2245", $b19ca0fdfcbacc57$var$PB = "\u2248", $b19ca0fdfcbacc57$var$$B = "\u2A31", $b19ca0fdfcbacc57$var$zB = "\u22A0", $b19ca0fdfcbacc57$var$UB = "\xd7", $b19ca0fdfcbacc57$var$HB = "\u2A30", $b19ca0fdfcbacc57$var$VB = "\u222D", $b19ca0fdfcbacc57$var$GB = "\u2928", $b19ca0fdfcbacc57$var$jB = "\u2336", $b19ca0fdfcbacc57$var$ZB = "\u2AF1", $b19ca0fdfcbacc57$var$KB = "\u22A4", $b19ca0fdfcbacc57$var$WB = "\uD835\uDD4B", $b19ca0fdfcbacc57$var$YB = "\uD835\uDD65", $b19ca0fdfcbacc57$var$JB = "\u2ADA", $b19ca0fdfcbacc57$var$XB = "\u2929", $b19ca0fdfcbacc57$var$QB = "\u2034", $b19ca0fdfcbacc57$var$eP = "\u2122", $b19ca0fdfcbacc57$var$nP = "\u2122", $b19ca0fdfcbacc57$var$tP = "\u25B5", $b19ca0fdfcbacc57$var$rP = "\u25BF", $b19ca0fdfcbacc57$var$oP = "\u25C3", $b19ca0fdfcbacc57$var$sP = "\u22B4", $b19ca0fdfcbacc57$var$cP = "\u225C", $b19ca0fdfcbacc57$var$iP = "\u25B9", $b19ca0fdfcbacc57$var$aP = "\u22B5", $b19ca0fdfcbacc57$var$lP = "\u25EC", $b19ca0fdfcbacc57$var$uP = "\u225C", $b19ca0fdfcbacc57$var$fP = "\u2A3A", $b19ca0fdfcbacc57$var$pP = "\u20DB", $b19ca0fdfcbacc57$var$hP = "\u2A39", $b19ca0fdfcbacc57$var$dP = "\u29CD", $b19ca0fdfcbacc57$var$gP = "\u2A3B", $b19ca0fdfcbacc57$var$mP = "\u23E2", $b19ca0fdfcbacc57$var$_P = "\uD835\uDCAF", $b19ca0fdfcbacc57$var$bP = "\uD835\uDCC9", $b19ca0fdfcbacc57$var$vP = "\u0426", $b19ca0fdfcbacc57$var$kP = "\u0446", $b19ca0fdfcbacc57$var$xP = "\u040B", $b19ca0fdfcbacc57$var$yP = "\u045B", $b19ca0fdfcbacc57$var$EP = "\u0166", $b19ca0fdfcbacc57$var$wP = "\u0167", $b19ca0fdfcbacc57$var$AP = "\u226C", $b19ca0fdfcbacc57$var$CP = "\u219E", $b19ca0fdfcbacc57$var$SP = "\u21A0", $b19ca0fdfcbacc57$var$DP = "\xda", $b19ca0fdfcbacc57$var$TP = "\xfa", $b19ca0fdfcbacc57$var$RP = "\u2191", $b19ca0fdfcbacc57$var$LP = "\u219F", $b19ca0fdfcbacc57$var$NP = "\u21D1", $b19ca0fdfcbacc57$var$qP = "\u2949", $b19ca0fdfcbacc57$var$MP = "\u040E", $b19ca0fdfcbacc57$var$IP = "\u045E", $b19ca0fdfcbacc57$var$OP = "\u016C", $b19ca0fdfcbacc57$var$FP = "\u016D", $b19ca0fdfcbacc57$var$BP = "\xdb", $b19ca0fdfcbacc57$var$PP = "\xfb", $b19ca0fdfcbacc57$var$$P = "\u0423", $b19ca0fdfcbacc57$var$zP = "\u0443", $b19ca0fdfcbacc57$var$UP = "\u21C5", $b19ca0fdfcbacc57$var$HP = "\u0170", $b19ca0fdfcbacc57$var$VP = "\u0171", $b19ca0fdfcbacc57$var$GP = "\u296E", $b19ca0fdfcbacc57$var$jP = "\u297E", $b19ca0fdfcbacc57$var$ZP = "\uD835\uDD18", $b19ca0fdfcbacc57$var$KP = "\uD835\uDD32", $b19ca0fdfcbacc57$var$WP = "\xd9", $b19ca0fdfcbacc57$var$YP = "\xf9", $b19ca0fdfcbacc57$var$JP = "\u2963", $b19ca0fdfcbacc57$var$XP = "\u21BF", $b19ca0fdfcbacc57$var$QP = "\u21BE", $b19ca0fdfcbacc57$var$e$ = "\u2580", $b19ca0fdfcbacc57$var$n$ = "\u231C", $b19ca0fdfcbacc57$var$t$ = "\u231C", $b19ca0fdfcbacc57$var$r$ = "\u230F", $b19ca0fdfcbacc57$var$o$ = "\u25F8", $b19ca0fdfcbacc57$var$s$ = "\u016A", $b19ca0fdfcbacc57$var$c$ = "\u016B", $b19ca0fdfcbacc57$var$i$ = "\xa8", $b19ca0fdfcbacc57$var$a$ = "_", $b19ca0fdfcbacc57$var$l$ = "\u23DF", $b19ca0fdfcbacc57$var$u$ = "\u23B5", $b19ca0fdfcbacc57$var$f$ = "\u23DD", $b19ca0fdfcbacc57$var$p$ = "\u22C3", $b19ca0fdfcbacc57$var$h$ = "\u228E", $b19ca0fdfcbacc57$var$d$ = "\u0172", $b19ca0fdfcbacc57$var$g$ = "\u0173", $b19ca0fdfcbacc57$var$m$ = "\uD835\uDD4C", $b19ca0fdfcbacc57$var$_$ = "\uD835\uDD66", $b19ca0fdfcbacc57$var$b$ = "\u2912", $b19ca0fdfcbacc57$var$v$ = "\u2191", $b19ca0fdfcbacc57$var$k$ = "\u2191", $b19ca0fdfcbacc57$var$x$ = "\u21D1", $b19ca0fdfcbacc57$var$y$ = "\u21C5", $b19ca0fdfcbacc57$var$E$ = "\u2195", $b19ca0fdfcbacc57$var$w$ = "\u2195", $b19ca0fdfcbacc57$var$A$ = "\u21D5", $b19ca0fdfcbacc57$var$C$ = "\u296E", $b19ca0fdfcbacc57$var$S$ = "\u21BF", $b19ca0fdfcbacc57$var$D$ = "\u21BE", $b19ca0fdfcbacc57$var$T$ = "\u228E", $b19ca0fdfcbacc57$var$R$ = "\u2196", $b19ca0fdfcbacc57$var$L$ = "\u2197", $b19ca0fdfcbacc57$var$N$ = "\u03C5", $b19ca0fdfcbacc57$var$q$ = "\u03D2", $b19ca0fdfcbacc57$var$M$ = "\u03D2", $b19ca0fdfcbacc57$var$I$ = "\u03A5", $b19ca0fdfcbacc57$var$O$ = "\u03C5", $b19ca0fdfcbacc57$var$F$ = "\u21A5", $b19ca0fdfcbacc57$var$B$ = "\u22A5", $b19ca0fdfcbacc57$var$P$ = "\u21C8", $b19ca0fdfcbacc57$var$$$ = "\u231D", $b19ca0fdfcbacc57$var$z$ = "\u231D", $b19ca0fdfcbacc57$var$U$ = "\u230E", $b19ca0fdfcbacc57$var$H$ = "\u016E", $b19ca0fdfcbacc57$var$V$ = "\u016F", $b19ca0fdfcbacc57$var$G$ = "\u25F9", $b19ca0fdfcbacc57$var$j$ = "\uD835\uDCB0", $b19ca0fdfcbacc57$var$Z$ = "\uD835\uDCCA", $b19ca0fdfcbacc57$var$K$ = "\u22F0", $b19ca0fdfcbacc57$var$W$ = "\u0168", $b19ca0fdfcbacc57$var$Y$ = "\u0169", $b19ca0fdfcbacc57$var$J$ = "\u25B5", $b19ca0fdfcbacc57$var$X$ = "\u25B4", $b19ca0fdfcbacc57$var$Q$ = "\u21C8", $b19ca0fdfcbacc57$var$ez = "\xdc", $b19ca0fdfcbacc57$var$nz = "\xfc", $b19ca0fdfcbacc57$var$tz = "\u29A7", $b19ca0fdfcbacc57$var$rz = "\u299C", $b19ca0fdfcbacc57$var$oz = "\u03F5", $b19ca0fdfcbacc57$var$sz = "\u03F0", $b19ca0fdfcbacc57$var$cz = "\u2205", $b19ca0fdfcbacc57$var$iz = "\u03D5", $b19ca0fdfcbacc57$var$az = "\u03D6", $b19ca0fdfcbacc57$var$lz = "\u221D", $b19ca0fdfcbacc57$var$uz = "\u2195", $b19ca0fdfcbacc57$var$fz = "\u21D5", $b19ca0fdfcbacc57$var$pz = "\u03F1", $b19ca0fdfcbacc57$var$hz = "\u03C2", $b19ca0fdfcbacc57$var$dz = "\u228A\uFE00", $b19ca0fdfcbacc57$var$gz = "\u2ACB\uFE00", $b19ca0fdfcbacc57$var$mz = "\u228B\uFE00", $b19ca0fdfcbacc57$var$_z = "\u2ACC\uFE00", $b19ca0fdfcbacc57$var$bz = "\u03D1", $b19ca0fdfcbacc57$var$vz = "\u22B2", $b19ca0fdfcbacc57$var$kz = "\u22B3", $b19ca0fdfcbacc57$var$xz = "\u2AE8", $b19ca0fdfcbacc57$var$yz = "\u2AEB", $b19ca0fdfcbacc57$var$Ez = "\u2AE9", $b19ca0fdfcbacc57$var$wz = "\u0412", $b19ca0fdfcbacc57$var$Az = "\u0432", $b19ca0fdfcbacc57$var$Cz = "\u22A2", $b19ca0fdfcbacc57$var$Sz = "\u22A8", $b19ca0fdfcbacc57$var$Dz = "\u22A9", $b19ca0fdfcbacc57$var$Tz = "\u22AB", $b19ca0fdfcbacc57$var$Rz = "\u2AE6", $b19ca0fdfcbacc57$var$Lz = "\u22BB", $b19ca0fdfcbacc57$var$Nz = "\u2228", $b19ca0fdfcbacc57$var$qz = "\u22C1", $b19ca0fdfcbacc57$var$Mz = "\u225A", $b19ca0fdfcbacc57$var$Iz = "\u22EE", $b19ca0fdfcbacc57$var$Oz = "|", $b19ca0fdfcbacc57$var$Fz = "\u2016", $b19ca0fdfcbacc57$var$Bz = "|", $b19ca0fdfcbacc57$var$Pz = "\u2016", $b19ca0fdfcbacc57$var$$z = "\u2223", $b19ca0fdfcbacc57$var$zz = "|", $b19ca0fdfcbacc57$var$Uz = "\u2758", $b19ca0fdfcbacc57$var$Hz = "\u2240", $b19ca0fdfcbacc57$var$Vz = "\u200A", $b19ca0fdfcbacc57$var$Gz = "\uD835\uDD19", $b19ca0fdfcbacc57$var$jz = "\uD835\uDD33", $b19ca0fdfcbacc57$var$Zz = "\u22B2", $b19ca0fdfcbacc57$var$Kz = "\u2282\u20D2", $b19ca0fdfcbacc57$var$Wz = "\u2283\u20D2", $b19ca0fdfcbacc57$var$Yz = "\uD835\uDD4D", $b19ca0fdfcbacc57$var$Jz = "\uD835\uDD67", $b19ca0fdfcbacc57$var$Xz = "\u221D", $b19ca0fdfcbacc57$var$Qz = "\u22B3", $b19ca0fdfcbacc57$var$e3 = "\uD835\uDCB1", $b19ca0fdfcbacc57$var$n3 = "\uD835\uDCCB", $b19ca0fdfcbacc57$var$t3 = "\u2ACB\uFE00", $b19ca0fdfcbacc57$var$r3 = "\u228A\uFE00", $b19ca0fdfcbacc57$var$o3 = "\u2ACC\uFE00", $b19ca0fdfcbacc57$var$s3 = "\u228B\uFE00", $b19ca0fdfcbacc57$var$c3 = "\u22AA", $b19ca0fdfcbacc57$var$i3 = "\u299A", $b19ca0fdfcbacc57$var$a3 = "\u0174", $b19ca0fdfcbacc57$var$l3 = "\u0175", $b19ca0fdfcbacc57$var$u3 = "\u2A5F", $b19ca0fdfcbacc57$var$f3 = "\u2227", $b19ca0fdfcbacc57$var$p3 = "\u22C0", $b19ca0fdfcbacc57$var$h3 = "\u2259", $b19ca0fdfcbacc57$var$d3 = "\u2118", $b19ca0fdfcbacc57$var$g3 = "\uD835\uDD1A", $b19ca0fdfcbacc57$var$m3 = "\uD835\uDD34", $b19ca0fdfcbacc57$var$_3 = "\uD835\uDD4E", $b19ca0fdfcbacc57$var$b3 = "\uD835\uDD68", $b19ca0fdfcbacc57$var$v3 = "\u2118", $b19ca0fdfcbacc57$var$k3 = "\u2240", $b19ca0fdfcbacc57$var$x3 = "\u2240", $b19ca0fdfcbacc57$var$y3 = "\uD835\uDCB2", $b19ca0fdfcbacc57$var$E3 = "\uD835\uDCCC", $b19ca0fdfcbacc57$var$w3 = "\u22C2", $b19ca0fdfcbacc57$var$A3 = "\u25EF", $b19ca0fdfcbacc57$var$C3 = "\u22C3", $b19ca0fdfcbacc57$var$S3 = "\u25BD", $b19ca0fdfcbacc57$var$D3 = "\uD835\uDD1B", $b19ca0fdfcbacc57$var$T3 = "\uD835\uDD35", $b19ca0fdfcbacc57$var$R3 = "\u27F7", $b19ca0fdfcbacc57$var$L3 = "\u27FA", $b19ca0fdfcbacc57$var$N3 = "\u039E", $b19ca0fdfcbacc57$var$q3 = "\u03BE", $b19ca0fdfcbacc57$var$M3 = "\u27F5", $b19ca0fdfcbacc57$var$I3 = "\u27F8", $b19ca0fdfcbacc57$var$O3 = "\u27FC", $b19ca0fdfcbacc57$var$F3 = "\u22FB", $b19ca0fdfcbacc57$var$B3 = "\u2A00", $b19ca0fdfcbacc57$var$P3 = "\uD835\uDD4F", $b19ca0fdfcbacc57$var$$3 = "\uD835\uDD69", $b19ca0fdfcbacc57$var$z3 = "\u2A01", $b19ca0fdfcbacc57$var$U3 = "\u2A02", $b19ca0fdfcbacc57$var$H3 = "\u27F6", $b19ca0fdfcbacc57$var$V3 = "\u27F9", $b19ca0fdfcbacc57$var$G3 = "\uD835\uDCB3", $b19ca0fdfcbacc57$var$j3 = "\uD835\uDCCD", $b19ca0fdfcbacc57$var$Z3 = "\u2A06", $b19ca0fdfcbacc57$var$K3 = "\u2A04", $b19ca0fdfcbacc57$var$W3 = "\u25B3", $b19ca0fdfcbacc57$var$Y3 = "\u22C1", $b19ca0fdfcbacc57$var$J3 = "\u22C0", $b19ca0fdfcbacc57$var$X3 = "\xdd", $b19ca0fdfcbacc57$var$Q3 = "\xfd", $b19ca0fdfcbacc57$var$eU = "\u042F", $b19ca0fdfcbacc57$var$nU = "\u044F", $b19ca0fdfcbacc57$var$tU = "\u0176", $b19ca0fdfcbacc57$var$rU = "\u0177", $b19ca0fdfcbacc57$var$oU = "\u042B", $b19ca0fdfcbacc57$var$sU = "\u044B", $b19ca0fdfcbacc57$var$cU = "\xa5", $b19ca0fdfcbacc57$var$iU = "\uD835\uDD1C", $b19ca0fdfcbacc57$var$aU = "\uD835\uDD36", $b19ca0fdfcbacc57$var$lU = "\u0407", $b19ca0fdfcbacc57$var$uU = "\u0457", $b19ca0fdfcbacc57$var$fU = "\uD835\uDD50", $b19ca0fdfcbacc57$var$pU = "\uD835\uDD6A", $b19ca0fdfcbacc57$var$hU = "\uD835\uDCB4", $b19ca0fdfcbacc57$var$dU = "\uD835\uDCCE", $b19ca0fdfcbacc57$var$gU = "\u042E", $b19ca0fdfcbacc57$var$mU = "\u044E", $b19ca0fdfcbacc57$var$_U = "\xff", $b19ca0fdfcbacc57$var$bU = "\u0178", $b19ca0fdfcbacc57$var$vU = "\u0179", $b19ca0fdfcbacc57$var$kU = "\u017A", $b19ca0fdfcbacc57$var$xU = "\u017D", $b19ca0fdfcbacc57$var$yU = "\u017E", $b19ca0fdfcbacc57$var$EU = "\u0417", $b19ca0fdfcbacc57$var$wU = "\u0437", $b19ca0fdfcbacc57$var$AU = "\u017B", $b19ca0fdfcbacc57$var$CU = "\u017C", $b19ca0fdfcbacc57$var$SU = "\u2128", $b19ca0fdfcbacc57$var$DU = "\u200B", $b19ca0fdfcbacc57$var$TU = "\u0396", $b19ca0fdfcbacc57$var$RU = "\u03B6", $b19ca0fdfcbacc57$var$LU = "\uD835\uDD37", $b19ca0fdfcbacc57$var$NU = "\u2128", $b19ca0fdfcbacc57$var$qU = "\u0416", $b19ca0fdfcbacc57$var$MU = "\u0436", $b19ca0fdfcbacc57$var$IU = "\u21DD", $b19ca0fdfcbacc57$var$OU = "\uD835\uDD6B", $b19ca0fdfcbacc57$var$FU = "\u2124", $b19ca0fdfcbacc57$var$BU = "\uD835\uDCB5", $b19ca0fdfcbacc57$var$PU = "\uD835\uDCCF", $b19ca0fdfcbacc57$var$$U = "\u200D", $b19ca0fdfcbacc57$var$zU = "\u200C", $b19ca0fdfcbacc57$var$UU = {
    Aacute: $b19ca0fdfcbacc57$var$wi,
    aacute: $b19ca0fdfcbacc57$var$Ai,
    Abreve: $b19ca0fdfcbacc57$var$Ci,
    abreve: $b19ca0fdfcbacc57$var$Si,
    ac: $b19ca0fdfcbacc57$var$Di,
    acd: $b19ca0fdfcbacc57$var$Ti,
    acE: $b19ca0fdfcbacc57$var$Ri,
    Acirc: $b19ca0fdfcbacc57$var$Li,
    acirc: $b19ca0fdfcbacc57$var$Ni,
    acute: $b19ca0fdfcbacc57$var$qi,
    Acy: $b19ca0fdfcbacc57$var$Mi,
    acy: $b19ca0fdfcbacc57$var$Ii,
    AElig: $b19ca0fdfcbacc57$var$Oi,
    aelig: $b19ca0fdfcbacc57$var$Fi,
    af: $b19ca0fdfcbacc57$var$Bi,
    Afr: $b19ca0fdfcbacc57$var$Pi,
    afr: $b19ca0fdfcbacc57$var$$i,
    Agrave: $b19ca0fdfcbacc57$var$zi,
    agrave: $b19ca0fdfcbacc57$var$Ui,
    alefsym: $b19ca0fdfcbacc57$var$Hi,
    aleph: $b19ca0fdfcbacc57$var$Vi,
    Alpha: $b19ca0fdfcbacc57$var$Gi,
    alpha: $b19ca0fdfcbacc57$var$ji,
    Amacr: $b19ca0fdfcbacc57$var$Zi,
    amacr: $b19ca0fdfcbacc57$var$Ki,
    amalg: $b19ca0fdfcbacc57$var$Wi,
    amp: $b19ca0fdfcbacc57$var$Yi,
    AMP: $b19ca0fdfcbacc57$var$Ji,
    andand: $b19ca0fdfcbacc57$var$Xi,
    And: $b19ca0fdfcbacc57$var$Qi,
    and: $b19ca0fdfcbacc57$var$ea,
    andd: $b19ca0fdfcbacc57$var$na,
    andslope: $b19ca0fdfcbacc57$var$ta,
    andv: $b19ca0fdfcbacc57$var$ra,
    ang: $b19ca0fdfcbacc57$var$oa,
    ange: $b19ca0fdfcbacc57$var$sa,
    angle: $b19ca0fdfcbacc57$var$ca,
    angmsdaa: $b19ca0fdfcbacc57$var$ia,
    angmsdab: $b19ca0fdfcbacc57$var$aa,
    angmsdac: $b19ca0fdfcbacc57$var$la,
    angmsdad: $b19ca0fdfcbacc57$var$ua,
    angmsdae: $b19ca0fdfcbacc57$var$fa,
    angmsdaf: $b19ca0fdfcbacc57$var$pa,
    angmsdag: $b19ca0fdfcbacc57$var$ha,
    angmsdah: $b19ca0fdfcbacc57$var$da,
    angmsd: $b19ca0fdfcbacc57$var$ga,
    angrt: $b19ca0fdfcbacc57$var$ma,
    angrtvb: $b19ca0fdfcbacc57$var$_a,
    angrtvbd: $b19ca0fdfcbacc57$var$ba,
    angsph: $b19ca0fdfcbacc57$var$va,
    angst: $b19ca0fdfcbacc57$var$ka,
    angzarr: $b19ca0fdfcbacc57$var$xa,
    Aogon: $b19ca0fdfcbacc57$var$ya,
    aogon: $b19ca0fdfcbacc57$var$Ea,
    Aopf: $b19ca0fdfcbacc57$var$wa,
    aopf: $b19ca0fdfcbacc57$var$Aa,
    apacir: $b19ca0fdfcbacc57$var$Ca,
    ap: $b19ca0fdfcbacc57$var$Sa,
    apE: $b19ca0fdfcbacc57$var$Da,
    ape: $b19ca0fdfcbacc57$var$Ta,
    apid: $b19ca0fdfcbacc57$var$Ra,
    apos: $b19ca0fdfcbacc57$var$La,
    ApplyFunction: $b19ca0fdfcbacc57$var$Na,
    approx: $b19ca0fdfcbacc57$var$qa,
    approxeq: $b19ca0fdfcbacc57$var$Ma,
    Aring: $b19ca0fdfcbacc57$var$Ia,
    aring: $b19ca0fdfcbacc57$var$Oa,
    Ascr: $b19ca0fdfcbacc57$var$Fa,
    ascr: $b19ca0fdfcbacc57$var$Ba,
    Assign: $b19ca0fdfcbacc57$var$Pa,
    ast: $b19ca0fdfcbacc57$var$$a,
    asymp: $b19ca0fdfcbacc57$var$za,
    asympeq: $b19ca0fdfcbacc57$var$Ua,
    Atilde: $b19ca0fdfcbacc57$var$Ha,
    atilde: $b19ca0fdfcbacc57$var$Va,
    Auml: $b19ca0fdfcbacc57$var$Ga,
    auml: $b19ca0fdfcbacc57$var$ja,
    awconint: $b19ca0fdfcbacc57$var$Za,
    awint: $b19ca0fdfcbacc57$var$Ka,
    backcong: $b19ca0fdfcbacc57$var$Wa,
    backepsilon: $b19ca0fdfcbacc57$var$Ya,
    backprime: $b19ca0fdfcbacc57$var$Ja,
    backsim: $b19ca0fdfcbacc57$var$Xa,
    backsimeq: $b19ca0fdfcbacc57$var$Qa,
    Backslash: $b19ca0fdfcbacc57$var$el,
    Barv: $b19ca0fdfcbacc57$var$nl,
    barvee: $b19ca0fdfcbacc57$var$tl,
    barwed: $b19ca0fdfcbacc57$var$rl,
    Barwed: $b19ca0fdfcbacc57$var$ol,
    barwedge: $b19ca0fdfcbacc57$var$sl,
    bbrk: $b19ca0fdfcbacc57$var$cl,
    bbrktbrk: $b19ca0fdfcbacc57$var$il,
    bcong: $b19ca0fdfcbacc57$var$al,
    Bcy: $b19ca0fdfcbacc57$var$ll,
    bcy: $b19ca0fdfcbacc57$var$ul,
    bdquo: $b19ca0fdfcbacc57$var$fl,
    becaus: $b19ca0fdfcbacc57$var$pl,
    because: $b19ca0fdfcbacc57$var$hl,
    Because: $b19ca0fdfcbacc57$var$dl,
    bemptyv: $b19ca0fdfcbacc57$var$gl,
    bepsi: $b19ca0fdfcbacc57$var$ml,
    bernou: $b19ca0fdfcbacc57$var$_l,
    Bernoullis: $b19ca0fdfcbacc57$var$bl,
    Beta: $b19ca0fdfcbacc57$var$vl,
    beta: $b19ca0fdfcbacc57$var$kl,
    beth: $b19ca0fdfcbacc57$var$xl,
    between: $b19ca0fdfcbacc57$var$yl,
    Bfr: $b19ca0fdfcbacc57$var$El,
    bfr: $b19ca0fdfcbacc57$var$wl,
    bigcap: $b19ca0fdfcbacc57$var$Al,
    bigcirc: $b19ca0fdfcbacc57$var$Cl,
    bigcup: $b19ca0fdfcbacc57$var$Sl,
    bigodot: $b19ca0fdfcbacc57$var$Dl,
    bigoplus: $b19ca0fdfcbacc57$var$Tl,
    bigotimes: $b19ca0fdfcbacc57$var$Rl,
    bigsqcup: $b19ca0fdfcbacc57$var$Ll,
    bigstar: $b19ca0fdfcbacc57$var$Nl,
    bigtriangledown: $b19ca0fdfcbacc57$var$ql,
    bigtriangleup: $b19ca0fdfcbacc57$var$Ml,
    biguplus: $b19ca0fdfcbacc57$var$Il,
    bigvee: $b19ca0fdfcbacc57$var$Ol,
    bigwedge: $b19ca0fdfcbacc57$var$Fl,
    bkarow: $b19ca0fdfcbacc57$var$Bl,
    blacklozenge: $b19ca0fdfcbacc57$var$Pl,
    blacksquare: $b19ca0fdfcbacc57$var$$l,
    blacktriangle: $b19ca0fdfcbacc57$var$zl,
    blacktriangledown: $b19ca0fdfcbacc57$var$Ul,
    blacktriangleleft: $b19ca0fdfcbacc57$var$Hl,
    blacktriangleright: $b19ca0fdfcbacc57$var$Vl,
    blank: $b19ca0fdfcbacc57$var$Gl,
    blk12: $b19ca0fdfcbacc57$var$jl,
    blk14: $b19ca0fdfcbacc57$var$Zl,
    blk34: $b19ca0fdfcbacc57$var$Kl,
    block: $b19ca0fdfcbacc57$var$Wl,
    bne: $b19ca0fdfcbacc57$var$Yl,
    bnequiv: $b19ca0fdfcbacc57$var$Jl,
    bNot: $b19ca0fdfcbacc57$var$Xl,
    bnot: $b19ca0fdfcbacc57$var$Ql,
    Bopf: $b19ca0fdfcbacc57$var$eu,
    bopf: $b19ca0fdfcbacc57$var$nu,
    bot: $b19ca0fdfcbacc57$var$tu,
    bottom: $b19ca0fdfcbacc57$var$ru,
    bowtie: $b19ca0fdfcbacc57$var$ou,
    boxbox: $b19ca0fdfcbacc57$var$su,
    boxdl: $b19ca0fdfcbacc57$var$cu,
    boxdL: $b19ca0fdfcbacc57$var$iu,
    boxDl: $b19ca0fdfcbacc57$var$au,
    boxDL: $b19ca0fdfcbacc57$var$lu,
    boxdr: $b19ca0fdfcbacc57$var$uu,
    boxdR: $b19ca0fdfcbacc57$var$fu,
    boxDr: $b19ca0fdfcbacc57$var$pu,
    boxDR: $b19ca0fdfcbacc57$var$hu,
    boxh: $b19ca0fdfcbacc57$var$du,
    boxH: $b19ca0fdfcbacc57$var$gu,
    boxhd: $b19ca0fdfcbacc57$var$mu,
    boxHd: $b19ca0fdfcbacc57$var$_u,
    boxhD: $b19ca0fdfcbacc57$var$bu,
    boxHD: $b19ca0fdfcbacc57$var$vu,
    boxhu: $b19ca0fdfcbacc57$var$ku,
    boxHu: $b19ca0fdfcbacc57$var$xu,
    boxhU: $b19ca0fdfcbacc57$var$yu,
    boxHU: $b19ca0fdfcbacc57$var$Eu,
    boxminus: $b19ca0fdfcbacc57$var$wu,
    boxplus: $b19ca0fdfcbacc57$var$Au,
    boxtimes: $b19ca0fdfcbacc57$var$Cu,
    boxul: $b19ca0fdfcbacc57$var$Su,
    boxuL: $b19ca0fdfcbacc57$var$Du,
    boxUl: $b19ca0fdfcbacc57$var$Tu,
    boxUL: $b19ca0fdfcbacc57$var$Ru,
    boxur: $b19ca0fdfcbacc57$var$Lu,
    boxuR: $b19ca0fdfcbacc57$var$Nu,
    boxUr: $b19ca0fdfcbacc57$var$qu,
    boxUR: $b19ca0fdfcbacc57$var$Mu,
    boxv: $b19ca0fdfcbacc57$var$Iu,
    boxV: $b19ca0fdfcbacc57$var$Ou,
    boxvh: $b19ca0fdfcbacc57$var$Fu,
    boxvH: $b19ca0fdfcbacc57$var$Bu,
    boxVh: $b19ca0fdfcbacc57$var$Pu,
    boxVH: $b19ca0fdfcbacc57$var$$u,
    boxvl: $b19ca0fdfcbacc57$var$zu,
    boxvL: $b19ca0fdfcbacc57$var$Uu,
    boxVl: $b19ca0fdfcbacc57$var$Hu,
    boxVL: $b19ca0fdfcbacc57$var$Vu,
    boxvr: $b19ca0fdfcbacc57$var$Gu,
    boxvR: $b19ca0fdfcbacc57$var$ju,
    boxVr: $b19ca0fdfcbacc57$var$Zu,
    boxVR: $b19ca0fdfcbacc57$var$Ku,
    bprime: $b19ca0fdfcbacc57$var$Wu,
    breve: $b19ca0fdfcbacc57$var$Yu,
    Breve: $b19ca0fdfcbacc57$var$Ju,
    brvbar: $b19ca0fdfcbacc57$var$Xu,
    bscr: $b19ca0fdfcbacc57$var$Qu,
    Bscr: $b19ca0fdfcbacc57$var$ef,
    bsemi: $b19ca0fdfcbacc57$var$nf,
    bsim: $b19ca0fdfcbacc57$var$tf,
    bsime: $b19ca0fdfcbacc57$var$rf,
    bsolb: $b19ca0fdfcbacc57$var$of,
    bsol: $b19ca0fdfcbacc57$var$sf,
    bsolhsub: $b19ca0fdfcbacc57$var$cf,
    bull: $b19ca0fdfcbacc57$var$af,
    bullet: $b19ca0fdfcbacc57$var$lf,
    bump: $b19ca0fdfcbacc57$var$uf,
    bumpE: $b19ca0fdfcbacc57$var$ff,
    bumpe: $b19ca0fdfcbacc57$var$pf,
    Bumpeq: $b19ca0fdfcbacc57$var$hf,
    bumpeq: $b19ca0fdfcbacc57$var$df,
    Cacute: $b19ca0fdfcbacc57$var$gf,
    cacute: $b19ca0fdfcbacc57$var$mf,
    capand: $b19ca0fdfcbacc57$var$_f,
    capbrcup: $b19ca0fdfcbacc57$var$bf,
    capcap: $b19ca0fdfcbacc57$var$vf,
    cap: $b19ca0fdfcbacc57$var$kf,
    Cap: $b19ca0fdfcbacc57$var$xf,
    capcup: $b19ca0fdfcbacc57$var$yf,
    capdot: $b19ca0fdfcbacc57$var$Ef,
    CapitalDifferentialD: $b19ca0fdfcbacc57$var$wf,
    caps: $b19ca0fdfcbacc57$var$Af,
    caret: $b19ca0fdfcbacc57$var$Cf,
    caron: $b19ca0fdfcbacc57$var$Sf,
    Cayleys: $b19ca0fdfcbacc57$var$Df,
    ccaps: $b19ca0fdfcbacc57$var$Tf,
    Ccaron: $b19ca0fdfcbacc57$var$Rf,
    ccaron: $b19ca0fdfcbacc57$var$Lf,
    Ccedil: $b19ca0fdfcbacc57$var$Nf,
    ccedil: $b19ca0fdfcbacc57$var$qf,
    Ccirc: $b19ca0fdfcbacc57$var$Mf,
    ccirc: $b19ca0fdfcbacc57$var$If,
    Cconint: $b19ca0fdfcbacc57$var$Of,
    ccups: $b19ca0fdfcbacc57$var$Ff,
    ccupssm: $b19ca0fdfcbacc57$var$Bf,
    Cdot: $b19ca0fdfcbacc57$var$Pf,
    cdot: $b19ca0fdfcbacc57$var$$f,
    cedil: $b19ca0fdfcbacc57$var$zf,
    Cedilla: $b19ca0fdfcbacc57$var$Uf,
    cemptyv: $b19ca0fdfcbacc57$var$Hf,
    cent: $b19ca0fdfcbacc57$var$Vf,
    centerdot: $b19ca0fdfcbacc57$var$Gf,
    CenterDot: $b19ca0fdfcbacc57$var$jf,
    cfr: $b19ca0fdfcbacc57$var$Zf,
    Cfr: $b19ca0fdfcbacc57$var$Kf,
    CHcy: $b19ca0fdfcbacc57$var$Wf,
    chcy: $b19ca0fdfcbacc57$var$Yf,
    check: $b19ca0fdfcbacc57$var$Jf,
    checkmark: $b19ca0fdfcbacc57$var$Xf,
    Chi: $b19ca0fdfcbacc57$var$Qf,
    chi: $b19ca0fdfcbacc57$var$ep,
    circ: $b19ca0fdfcbacc57$var$np,
    circeq: $b19ca0fdfcbacc57$var$tp,
    circlearrowleft: $b19ca0fdfcbacc57$var$rp,
    circlearrowright: $b19ca0fdfcbacc57$var$op,
    circledast: $b19ca0fdfcbacc57$var$sp,
    circledcirc: $b19ca0fdfcbacc57$var$cp,
    circleddash: $b19ca0fdfcbacc57$var$ip,
    CircleDot: $b19ca0fdfcbacc57$var$ap,
    circledR: $b19ca0fdfcbacc57$var$lp,
    circledS: $b19ca0fdfcbacc57$var$up,
    CircleMinus: $b19ca0fdfcbacc57$var$fp,
    CirclePlus: $b19ca0fdfcbacc57$var$pp,
    CircleTimes: $b19ca0fdfcbacc57$var$hp,
    cir: $b19ca0fdfcbacc57$var$dp,
    cirE: $b19ca0fdfcbacc57$var$gp,
    cire: $b19ca0fdfcbacc57$var$mp,
    cirfnint: $b19ca0fdfcbacc57$var$_p,
    cirmid: $b19ca0fdfcbacc57$var$bp,
    cirscir: $b19ca0fdfcbacc57$var$vp,
    ClockwiseContourIntegral: $b19ca0fdfcbacc57$var$kp,
    CloseCurlyDoubleQuote: $b19ca0fdfcbacc57$var$xp,
    CloseCurlyQuote: $b19ca0fdfcbacc57$var$yp,
    clubs: $b19ca0fdfcbacc57$var$Ep,
    clubsuit: $b19ca0fdfcbacc57$var$wp,
    colon: $b19ca0fdfcbacc57$var$Ap,
    Colon: $b19ca0fdfcbacc57$var$Cp,
    Colone: $b19ca0fdfcbacc57$var$Sp,
    colone: $b19ca0fdfcbacc57$var$Dp,
    coloneq: $b19ca0fdfcbacc57$var$Tp,
    comma: $b19ca0fdfcbacc57$var$Rp,
    commat: $b19ca0fdfcbacc57$var$Lp,
    comp: $b19ca0fdfcbacc57$var$Np,
    compfn: $b19ca0fdfcbacc57$var$qp,
    complement: $b19ca0fdfcbacc57$var$Mp,
    complexes: $b19ca0fdfcbacc57$var$Ip,
    cong: $b19ca0fdfcbacc57$var$Op,
    congdot: $b19ca0fdfcbacc57$var$Fp,
    Congruent: $b19ca0fdfcbacc57$var$Bp,
    conint: $b19ca0fdfcbacc57$var$Pp,
    Conint: $b19ca0fdfcbacc57$var$$p,
    ContourIntegral: $b19ca0fdfcbacc57$var$zp,
    copf: $b19ca0fdfcbacc57$var$Up,
    Copf: $b19ca0fdfcbacc57$var$Hp,
    coprod: $b19ca0fdfcbacc57$var$Vp,
    Coproduct: $b19ca0fdfcbacc57$var$Gp,
    copy: $b19ca0fdfcbacc57$var$jp,
    COPY: $b19ca0fdfcbacc57$var$Zp,
    copysr: $b19ca0fdfcbacc57$var$Kp,
    CounterClockwiseContourIntegral: $b19ca0fdfcbacc57$var$Wp,
    crarr: $b19ca0fdfcbacc57$var$Yp,
    cross: $b19ca0fdfcbacc57$var$Jp,
    Cross: $b19ca0fdfcbacc57$var$Xp,
    Cscr: $b19ca0fdfcbacc57$var$Qp,
    cscr: $b19ca0fdfcbacc57$var$eh,
    csub: $b19ca0fdfcbacc57$var$nh,
    csube: $b19ca0fdfcbacc57$var$th,
    csup: $b19ca0fdfcbacc57$var$rh,
    csupe: $b19ca0fdfcbacc57$var$oh,
    ctdot: $b19ca0fdfcbacc57$var$sh,
    cudarrl: $b19ca0fdfcbacc57$var$ch,
    cudarrr: $b19ca0fdfcbacc57$var$ih,
    cuepr: $b19ca0fdfcbacc57$var$ah,
    cuesc: $b19ca0fdfcbacc57$var$lh,
    cularr: $b19ca0fdfcbacc57$var$uh,
    cularrp: $b19ca0fdfcbacc57$var$fh,
    cupbrcap: $b19ca0fdfcbacc57$var$ph,
    cupcap: $b19ca0fdfcbacc57$var$hh,
    CupCap: $b19ca0fdfcbacc57$var$dh,
    cup: $b19ca0fdfcbacc57$var$gh,
    Cup: $b19ca0fdfcbacc57$var$mh,
    cupcup: $b19ca0fdfcbacc57$var$_h,
    cupdot: $b19ca0fdfcbacc57$var$bh,
    cupor: $b19ca0fdfcbacc57$var$vh,
    cups: $b19ca0fdfcbacc57$var$kh,
    curarr: $b19ca0fdfcbacc57$var$xh,
    curarrm: $b19ca0fdfcbacc57$var$yh,
    curlyeqprec: $b19ca0fdfcbacc57$var$Eh,
    curlyeqsucc: $b19ca0fdfcbacc57$var$wh,
    curlyvee: $b19ca0fdfcbacc57$var$Ah,
    curlywedge: $b19ca0fdfcbacc57$var$Ch,
    curren: $b19ca0fdfcbacc57$var$Sh,
    curvearrowleft: $b19ca0fdfcbacc57$var$Dh,
    curvearrowright: $b19ca0fdfcbacc57$var$Th,
    cuvee: $b19ca0fdfcbacc57$var$Rh,
    cuwed: $b19ca0fdfcbacc57$var$Lh,
    cwconint: $b19ca0fdfcbacc57$var$Nh,
    cwint: $b19ca0fdfcbacc57$var$qh,
    cylcty: $b19ca0fdfcbacc57$var$Mh,
    dagger: $b19ca0fdfcbacc57$var$Ih,
    Dagger: $b19ca0fdfcbacc57$var$Oh,
    daleth: $b19ca0fdfcbacc57$var$Fh,
    darr: $b19ca0fdfcbacc57$var$Bh,
    Darr: $b19ca0fdfcbacc57$var$Ph,
    dArr: $b19ca0fdfcbacc57$var$$h,
    dash: $b19ca0fdfcbacc57$var$zh,
    Dashv: $b19ca0fdfcbacc57$var$Uh,
    dashv: $b19ca0fdfcbacc57$var$Hh,
    dbkarow: $b19ca0fdfcbacc57$var$Vh,
    dblac: $b19ca0fdfcbacc57$var$Gh,
    Dcaron: $b19ca0fdfcbacc57$var$jh,
    dcaron: $b19ca0fdfcbacc57$var$Zh,
    Dcy: $b19ca0fdfcbacc57$var$Kh,
    dcy: $b19ca0fdfcbacc57$var$Wh,
    ddagger: $b19ca0fdfcbacc57$var$Yh,
    ddarr: $b19ca0fdfcbacc57$var$Jh,
    DD: $b19ca0fdfcbacc57$var$Xh,
    dd: $b19ca0fdfcbacc57$var$Qh,
    DDotrahd: $b19ca0fdfcbacc57$var$ed,
    ddotseq: $b19ca0fdfcbacc57$var$nd,
    deg: $b19ca0fdfcbacc57$var$td,
    Del: $b19ca0fdfcbacc57$var$rd,
    Delta: $b19ca0fdfcbacc57$var$od,
    delta: $b19ca0fdfcbacc57$var$sd,
    demptyv: $b19ca0fdfcbacc57$var$cd,
    dfisht: $b19ca0fdfcbacc57$var$id,
    Dfr: $b19ca0fdfcbacc57$var$ad,
    dfr: $b19ca0fdfcbacc57$var$ld,
    dHar: $b19ca0fdfcbacc57$var$ud,
    dharl: $b19ca0fdfcbacc57$var$fd,
    dharr: $b19ca0fdfcbacc57$var$pd,
    DiacriticalAcute: $b19ca0fdfcbacc57$var$hd,
    DiacriticalDot: $b19ca0fdfcbacc57$var$dd,
    DiacriticalDoubleAcute: $b19ca0fdfcbacc57$var$gd,
    DiacriticalGrave: $b19ca0fdfcbacc57$var$md,
    DiacriticalTilde: $b19ca0fdfcbacc57$var$_d,
    diam: $b19ca0fdfcbacc57$var$bd,
    diamond: $b19ca0fdfcbacc57$var$vd,
    Diamond: $b19ca0fdfcbacc57$var$kd,
    diamondsuit: $b19ca0fdfcbacc57$var$xd,
    diams: $b19ca0fdfcbacc57$var$yd,
    die: $b19ca0fdfcbacc57$var$Ed,
    DifferentialD: $b19ca0fdfcbacc57$var$wd,
    digamma: $b19ca0fdfcbacc57$var$Ad,
    disin: $b19ca0fdfcbacc57$var$Cd,
    div: $b19ca0fdfcbacc57$var$Sd,
    divide: $b19ca0fdfcbacc57$var$Dd,
    divideontimes: $b19ca0fdfcbacc57$var$Td,
    divonx: $b19ca0fdfcbacc57$var$Rd,
    DJcy: $b19ca0fdfcbacc57$var$Ld,
    djcy: $b19ca0fdfcbacc57$var$Nd,
    dlcorn: $b19ca0fdfcbacc57$var$qd,
    dlcrop: $b19ca0fdfcbacc57$var$Md,
    dollar: $b19ca0fdfcbacc57$var$Id,
    Dopf: $b19ca0fdfcbacc57$var$Od,
    dopf: $b19ca0fdfcbacc57$var$Fd,
    Dot: $b19ca0fdfcbacc57$var$Bd,
    dot: $b19ca0fdfcbacc57$var$Pd,
    DotDot: $b19ca0fdfcbacc57$var$$d,
    doteq: $b19ca0fdfcbacc57$var$zd,
    doteqdot: $b19ca0fdfcbacc57$var$Ud,
    DotEqual: $b19ca0fdfcbacc57$var$Hd,
    dotminus: $b19ca0fdfcbacc57$var$Vd,
    dotplus: $b19ca0fdfcbacc57$var$Gd,
    dotsquare: $b19ca0fdfcbacc57$var$jd,
    doublebarwedge: $b19ca0fdfcbacc57$var$Zd,
    DoubleContourIntegral: $b19ca0fdfcbacc57$var$Kd,
    DoubleDot: $b19ca0fdfcbacc57$var$Wd,
    DoubleDownArrow: $b19ca0fdfcbacc57$var$Yd,
    DoubleLeftArrow: $b19ca0fdfcbacc57$var$Jd,
    DoubleLeftRightArrow: $b19ca0fdfcbacc57$var$Xd,
    DoubleLeftTee: $b19ca0fdfcbacc57$var$Qd,
    DoubleLongLeftArrow: $b19ca0fdfcbacc57$var$eg,
    DoubleLongLeftRightArrow: $b19ca0fdfcbacc57$var$ng,
    DoubleLongRightArrow: $b19ca0fdfcbacc57$var$tg,
    DoubleRightArrow: $b19ca0fdfcbacc57$var$rg,
    DoubleRightTee: $b19ca0fdfcbacc57$var$og,
    DoubleUpArrow: $b19ca0fdfcbacc57$var$sg,
    DoubleUpDownArrow: $b19ca0fdfcbacc57$var$cg,
    DoubleVerticalBar: $b19ca0fdfcbacc57$var$ig,
    DownArrowBar: $b19ca0fdfcbacc57$var$ag,
    downarrow: $b19ca0fdfcbacc57$var$lg,
    DownArrow: $b19ca0fdfcbacc57$var$ug,
    Downarrow: $b19ca0fdfcbacc57$var$fg,
    DownArrowUpArrow: $b19ca0fdfcbacc57$var$pg,
    DownBreve: $b19ca0fdfcbacc57$var$hg,
    downdownarrows: $b19ca0fdfcbacc57$var$dg,
    downharpoonleft: $b19ca0fdfcbacc57$var$gg,
    downharpoonright: $b19ca0fdfcbacc57$var$mg,
    DownLeftRightVector: $b19ca0fdfcbacc57$var$_g,
    DownLeftTeeVector: $b19ca0fdfcbacc57$var$bg,
    DownLeftVectorBar: $b19ca0fdfcbacc57$var$vg,
    DownLeftVector: $b19ca0fdfcbacc57$var$kg,
    DownRightTeeVector: $b19ca0fdfcbacc57$var$xg,
    DownRightVectorBar: $b19ca0fdfcbacc57$var$yg,
    DownRightVector: $b19ca0fdfcbacc57$var$Eg,
    DownTeeArrow: $b19ca0fdfcbacc57$var$wg,
    DownTee: $b19ca0fdfcbacc57$var$Ag,
    drbkarow: $b19ca0fdfcbacc57$var$Cg,
    drcorn: $b19ca0fdfcbacc57$var$Sg,
    drcrop: $b19ca0fdfcbacc57$var$Dg,
    Dscr: $b19ca0fdfcbacc57$var$Tg,
    dscr: $b19ca0fdfcbacc57$var$Rg,
    DScy: $b19ca0fdfcbacc57$var$Lg,
    dscy: $b19ca0fdfcbacc57$var$Ng,
    dsol: $b19ca0fdfcbacc57$var$qg,
    Dstrok: $b19ca0fdfcbacc57$var$Mg,
    dstrok: $b19ca0fdfcbacc57$var$Ig,
    dtdot: $b19ca0fdfcbacc57$var$Og,
    dtri: $b19ca0fdfcbacc57$var$Fg,
    dtrif: $b19ca0fdfcbacc57$var$Bg,
    duarr: $b19ca0fdfcbacc57$var$Pg,
    duhar: $b19ca0fdfcbacc57$var$$g,
    dwangle: $b19ca0fdfcbacc57$var$zg,
    DZcy: $b19ca0fdfcbacc57$var$Ug,
    dzcy: $b19ca0fdfcbacc57$var$Hg,
    dzigrarr: $b19ca0fdfcbacc57$var$Vg,
    Eacute: $b19ca0fdfcbacc57$var$Gg,
    eacute: $b19ca0fdfcbacc57$var$jg,
    easter: $b19ca0fdfcbacc57$var$Zg,
    Ecaron: $b19ca0fdfcbacc57$var$Kg,
    ecaron: $b19ca0fdfcbacc57$var$Wg,
    Ecirc: $b19ca0fdfcbacc57$var$Yg,
    ecirc: $b19ca0fdfcbacc57$var$Jg,
    ecir: $b19ca0fdfcbacc57$var$Xg,
    ecolon: $b19ca0fdfcbacc57$var$Qg,
    Ecy: $b19ca0fdfcbacc57$var$em,
    ecy: $b19ca0fdfcbacc57$var$nm,
    eDDot: $b19ca0fdfcbacc57$var$tm,
    Edot: $b19ca0fdfcbacc57$var$rm,
    edot: $b19ca0fdfcbacc57$var$om,
    eDot: $b19ca0fdfcbacc57$var$sm,
    ee: $b19ca0fdfcbacc57$var$cm,
    efDot: $b19ca0fdfcbacc57$var$im,
    Efr: $b19ca0fdfcbacc57$var$am,
    efr: $b19ca0fdfcbacc57$var$lm,
    eg: $b19ca0fdfcbacc57$var$um,
    Egrave: $b19ca0fdfcbacc57$var$fm,
    egrave: $b19ca0fdfcbacc57$var$pm,
    egs: $b19ca0fdfcbacc57$var$hm,
    egsdot: $b19ca0fdfcbacc57$var$dm,
    el: $b19ca0fdfcbacc57$var$gm,
    Element: $b19ca0fdfcbacc57$var$mm,
    elinters: $b19ca0fdfcbacc57$var$_m,
    ell: $b19ca0fdfcbacc57$var$bm,
    els: $b19ca0fdfcbacc57$var$vm,
    elsdot: $b19ca0fdfcbacc57$var$km,
    Emacr: $b19ca0fdfcbacc57$var$xm,
    emacr: $b19ca0fdfcbacc57$var$ym,
    empty: $b19ca0fdfcbacc57$var$Em,
    emptyset: $b19ca0fdfcbacc57$var$wm,
    EmptySmallSquare: $b19ca0fdfcbacc57$var$Am,
    emptyv: $b19ca0fdfcbacc57$var$Cm,
    EmptyVerySmallSquare: $b19ca0fdfcbacc57$var$Sm,
    emsp13: $b19ca0fdfcbacc57$var$Dm,
    emsp14: $b19ca0fdfcbacc57$var$Tm,
    emsp: $b19ca0fdfcbacc57$var$Rm,
    ENG: $b19ca0fdfcbacc57$var$Lm,
    eng: $b19ca0fdfcbacc57$var$Nm,
    ensp: $b19ca0fdfcbacc57$var$qm,
    Eogon: $b19ca0fdfcbacc57$var$Mm,
    eogon: $b19ca0fdfcbacc57$var$Im,
    Eopf: $b19ca0fdfcbacc57$var$Om,
    eopf: $b19ca0fdfcbacc57$var$Fm,
    epar: $b19ca0fdfcbacc57$var$Bm,
    eparsl: $b19ca0fdfcbacc57$var$Pm,
    eplus: $b19ca0fdfcbacc57$var$$m,
    epsi: $b19ca0fdfcbacc57$var$zm,
    Epsilon: $b19ca0fdfcbacc57$var$Um,
    epsilon: $b19ca0fdfcbacc57$var$Hm,
    epsiv: $b19ca0fdfcbacc57$var$Vm,
    eqcirc: $b19ca0fdfcbacc57$var$Gm,
    eqcolon: $b19ca0fdfcbacc57$var$jm,
    eqsim: $b19ca0fdfcbacc57$var$Zm,
    eqslantgtr: $b19ca0fdfcbacc57$var$Km,
    eqslantless: $b19ca0fdfcbacc57$var$Wm,
    Equal: $b19ca0fdfcbacc57$var$Ym,
    equals: $b19ca0fdfcbacc57$var$Jm,
    EqualTilde: $b19ca0fdfcbacc57$var$Xm,
    equest: $b19ca0fdfcbacc57$var$Qm,
    Equilibrium: $b19ca0fdfcbacc57$var$e_,
    equiv: $b19ca0fdfcbacc57$var$n_,
    equivDD: $b19ca0fdfcbacc57$var$t_,
    eqvparsl: $b19ca0fdfcbacc57$var$r_,
    erarr: $b19ca0fdfcbacc57$var$o_,
    erDot: $b19ca0fdfcbacc57$var$s_,
    escr: $b19ca0fdfcbacc57$var$c_,
    Escr: $b19ca0fdfcbacc57$var$i_,
    esdot: $b19ca0fdfcbacc57$var$a_,
    Esim: $b19ca0fdfcbacc57$var$l_,
    esim: $b19ca0fdfcbacc57$var$u_,
    Eta: $b19ca0fdfcbacc57$var$f_,
    eta: $b19ca0fdfcbacc57$var$p_,
    ETH: $b19ca0fdfcbacc57$var$h_,
    eth: $b19ca0fdfcbacc57$var$d_,
    Euml: $b19ca0fdfcbacc57$var$g_,
    euml: $b19ca0fdfcbacc57$var$m_,
    euro: $b19ca0fdfcbacc57$var$__,
    excl: $b19ca0fdfcbacc57$var$b_,
    exist: $b19ca0fdfcbacc57$var$v_,
    Exists: $b19ca0fdfcbacc57$var$k_,
    expectation: $b19ca0fdfcbacc57$var$x_,
    exponentiale: $b19ca0fdfcbacc57$var$y_,
    ExponentialE: $b19ca0fdfcbacc57$var$E_,
    fallingdotseq: $b19ca0fdfcbacc57$var$w_,
    Fcy: $b19ca0fdfcbacc57$var$A_,
    fcy: $b19ca0fdfcbacc57$var$C_,
    female: $b19ca0fdfcbacc57$var$S_,
    ffilig: $b19ca0fdfcbacc57$var$D_,
    fflig: $b19ca0fdfcbacc57$var$T_,
    ffllig: $b19ca0fdfcbacc57$var$R_,
    Ffr: $b19ca0fdfcbacc57$var$L_,
    ffr: $b19ca0fdfcbacc57$var$N_,
    filig: $b19ca0fdfcbacc57$var$q_,
    FilledSmallSquare: $b19ca0fdfcbacc57$var$M_,
    FilledVerySmallSquare: $b19ca0fdfcbacc57$var$I_,
    fjlig: $b19ca0fdfcbacc57$var$O_,
    flat: $b19ca0fdfcbacc57$var$F_,
    fllig: $b19ca0fdfcbacc57$var$B_,
    fltns: $b19ca0fdfcbacc57$var$P_,
    fnof: $b19ca0fdfcbacc57$var$$_,
    Fopf: $b19ca0fdfcbacc57$var$z_,
    fopf: $b19ca0fdfcbacc57$var$U_,
    forall: $b19ca0fdfcbacc57$var$H_,
    ForAll: $b19ca0fdfcbacc57$var$V_,
    fork: $b19ca0fdfcbacc57$var$G_,
    forkv: $b19ca0fdfcbacc57$var$j_,
    Fouriertrf: $b19ca0fdfcbacc57$var$Z_,
    fpartint: $b19ca0fdfcbacc57$var$K_,
    frac12: $b19ca0fdfcbacc57$var$W_,
    frac13: $b19ca0fdfcbacc57$var$Y_,
    frac14: $b19ca0fdfcbacc57$var$J_,
    frac15: $b19ca0fdfcbacc57$var$X_,
    frac16: $b19ca0fdfcbacc57$var$Q_,
    frac18: $b19ca0fdfcbacc57$var$eb,
    frac23: $b19ca0fdfcbacc57$var$nb,
    frac25: $b19ca0fdfcbacc57$var$tb,
    frac34: $b19ca0fdfcbacc57$var$rb,
    frac35: $b19ca0fdfcbacc57$var$ob,
    frac38: $b19ca0fdfcbacc57$var$sb,
    frac45: $b19ca0fdfcbacc57$var$cb,
    frac56: $b19ca0fdfcbacc57$var$ib,
    frac58: $b19ca0fdfcbacc57$var$ab,
    frac78: $b19ca0fdfcbacc57$var$lb,
    frasl: $b19ca0fdfcbacc57$var$ub,
    frown: $b19ca0fdfcbacc57$var$fb,
    fscr: $b19ca0fdfcbacc57$var$pb,
    Fscr: $b19ca0fdfcbacc57$var$hb,
    gacute: $b19ca0fdfcbacc57$var$db,
    Gamma: $b19ca0fdfcbacc57$var$gb,
    gamma: $b19ca0fdfcbacc57$var$mb,
    Gammad: $b19ca0fdfcbacc57$var$_b,
    gammad: $b19ca0fdfcbacc57$var$bb,
    gap: $b19ca0fdfcbacc57$var$vb,
    Gbreve: $b19ca0fdfcbacc57$var$kb,
    gbreve: $b19ca0fdfcbacc57$var$xb,
    Gcedil: $b19ca0fdfcbacc57$var$yb,
    Gcirc: $b19ca0fdfcbacc57$var$Eb,
    gcirc: $b19ca0fdfcbacc57$var$wb,
    Gcy: $b19ca0fdfcbacc57$var$Ab,
    gcy: $b19ca0fdfcbacc57$var$Cb,
    Gdot: $b19ca0fdfcbacc57$var$Sb,
    gdot: $b19ca0fdfcbacc57$var$Db,
    ge: $b19ca0fdfcbacc57$var$Tb,
    gE: $b19ca0fdfcbacc57$var$Rb,
    gEl: $b19ca0fdfcbacc57$var$Lb,
    gel: $b19ca0fdfcbacc57$var$Nb,
    geq: $b19ca0fdfcbacc57$var$qb,
    geqq: $b19ca0fdfcbacc57$var$Mb,
    geqslant: $b19ca0fdfcbacc57$var$Ib,
    gescc: $b19ca0fdfcbacc57$var$Ob,
    ges: $b19ca0fdfcbacc57$var$Fb,
    gesdot: $b19ca0fdfcbacc57$var$Bb,
    gesdoto: $b19ca0fdfcbacc57$var$Pb,
    gesdotol: $b19ca0fdfcbacc57$var$$b,
    gesl: $b19ca0fdfcbacc57$var$zb,
    gesles: $b19ca0fdfcbacc57$var$Ub,
    Gfr: $b19ca0fdfcbacc57$var$Hb,
    gfr: $b19ca0fdfcbacc57$var$Vb,
    gg: $b19ca0fdfcbacc57$var$Gb,
    Gg: $b19ca0fdfcbacc57$var$jb,
    ggg: $b19ca0fdfcbacc57$var$Zb,
    gimel: $b19ca0fdfcbacc57$var$Kb,
    GJcy: $b19ca0fdfcbacc57$var$Wb,
    gjcy: $b19ca0fdfcbacc57$var$Yb,
    gla: $b19ca0fdfcbacc57$var$Jb,
    gl: $b19ca0fdfcbacc57$var$Xb,
    glE: $b19ca0fdfcbacc57$var$Qb,
    glj: $b19ca0fdfcbacc57$var$e0,
    gnap: $b19ca0fdfcbacc57$var$n0,
    gnapprox: $b19ca0fdfcbacc57$var$t0,
    gne: $b19ca0fdfcbacc57$var$r0,
    gnE: $b19ca0fdfcbacc57$var$o0,
    gneq: $b19ca0fdfcbacc57$var$s0,
    gneqq: $b19ca0fdfcbacc57$var$c0,
    gnsim: $b19ca0fdfcbacc57$var$i0,
    Gopf: $b19ca0fdfcbacc57$var$a0,
    gopf: $b19ca0fdfcbacc57$var$l0,
    grave: $b19ca0fdfcbacc57$var$u0,
    GreaterEqual: $b19ca0fdfcbacc57$var$f0,
    GreaterEqualLess: $b19ca0fdfcbacc57$var$p0,
    GreaterFullEqual: $b19ca0fdfcbacc57$var$h0,
    GreaterGreater: $b19ca0fdfcbacc57$var$d0,
    GreaterLess: $b19ca0fdfcbacc57$var$g0,
    GreaterSlantEqual: $b19ca0fdfcbacc57$var$m0,
    GreaterTilde: $b19ca0fdfcbacc57$var$_0,
    Gscr: $b19ca0fdfcbacc57$var$b0,
    gscr: $b19ca0fdfcbacc57$var$v0,
    gsim: $b19ca0fdfcbacc57$var$k0,
    gsime: $b19ca0fdfcbacc57$var$x0,
    gsiml: $b19ca0fdfcbacc57$var$y0,
    gtcc: $b19ca0fdfcbacc57$var$E0,
    gtcir: $b19ca0fdfcbacc57$var$w0,
    gt: $b19ca0fdfcbacc57$var$A0,
    GT: $b19ca0fdfcbacc57$var$C0,
    Gt: $b19ca0fdfcbacc57$var$S0,
    gtdot: $b19ca0fdfcbacc57$var$D0,
    gtlPar: $b19ca0fdfcbacc57$var$T0,
    gtquest: $b19ca0fdfcbacc57$var$R0,
    gtrapprox: $b19ca0fdfcbacc57$var$L0,
    gtrarr: $b19ca0fdfcbacc57$var$N0,
    gtrdot: $b19ca0fdfcbacc57$var$q0,
    gtreqless: $b19ca0fdfcbacc57$var$M0,
    gtreqqless: $b19ca0fdfcbacc57$var$I0,
    gtrless: $b19ca0fdfcbacc57$var$O0,
    gtrsim: $b19ca0fdfcbacc57$var$F0,
    gvertneqq: $b19ca0fdfcbacc57$var$B0,
    gvnE: $b19ca0fdfcbacc57$var$P0,
    Hacek: $b19ca0fdfcbacc57$var$$0,
    hairsp: $b19ca0fdfcbacc57$var$z0,
    half: $b19ca0fdfcbacc57$var$U0,
    hamilt: $b19ca0fdfcbacc57$var$H0,
    HARDcy: $b19ca0fdfcbacc57$var$V0,
    hardcy: $b19ca0fdfcbacc57$var$G0,
    harrcir: $b19ca0fdfcbacc57$var$j0,
    harr: $b19ca0fdfcbacc57$var$Z0,
    hArr: $b19ca0fdfcbacc57$var$K0,
    harrw: $b19ca0fdfcbacc57$var$W0,
    Hat: $b19ca0fdfcbacc57$var$Y0,
    hbar: $b19ca0fdfcbacc57$var$J0,
    Hcirc: $b19ca0fdfcbacc57$var$X0,
    hcirc: $b19ca0fdfcbacc57$var$Q0,
    hearts: $b19ca0fdfcbacc57$var$ev,
    heartsuit: $b19ca0fdfcbacc57$var$nv,
    hellip: $b19ca0fdfcbacc57$var$tv,
    hercon: $b19ca0fdfcbacc57$var$rv,
    hfr: $b19ca0fdfcbacc57$var$ov,
    Hfr: $b19ca0fdfcbacc57$var$sv,
    HilbertSpace: $b19ca0fdfcbacc57$var$cv,
    hksearow: $b19ca0fdfcbacc57$var$iv,
    hkswarow: $b19ca0fdfcbacc57$var$av,
    hoarr: $b19ca0fdfcbacc57$var$lv,
    homtht: $b19ca0fdfcbacc57$var$uv,
    hookleftarrow: $b19ca0fdfcbacc57$var$fv,
    hookrightarrow: $b19ca0fdfcbacc57$var$pv,
    hopf: $b19ca0fdfcbacc57$var$hv,
    Hopf: $b19ca0fdfcbacc57$var$dv,
    horbar: $b19ca0fdfcbacc57$var$gv,
    HorizontalLine: $b19ca0fdfcbacc57$var$mv,
    hscr: $b19ca0fdfcbacc57$var$_v,
    Hscr: $b19ca0fdfcbacc57$var$bv,
    hslash: $b19ca0fdfcbacc57$var$vv,
    Hstrok: $b19ca0fdfcbacc57$var$kv,
    hstrok: $b19ca0fdfcbacc57$var$xv,
    HumpDownHump: $b19ca0fdfcbacc57$var$yv,
    HumpEqual: $b19ca0fdfcbacc57$var$Ev,
    hybull: $b19ca0fdfcbacc57$var$wv,
    hyphen: $b19ca0fdfcbacc57$var$Av,
    Iacute: $b19ca0fdfcbacc57$var$Cv,
    iacute: $b19ca0fdfcbacc57$var$Sv,
    ic: $b19ca0fdfcbacc57$var$Dv,
    Icirc: $b19ca0fdfcbacc57$var$Tv,
    icirc: $b19ca0fdfcbacc57$var$Rv,
    Icy: $b19ca0fdfcbacc57$var$Lv,
    icy: $b19ca0fdfcbacc57$var$Nv,
    Idot: $b19ca0fdfcbacc57$var$qv,
    IEcy: $b19ca0fdfcbacc57$var$Mv,
    iecy: $b19ca0fdfcbacc57$var$Iv,
    iexcl: $b19ca0fdfcbacc57$var$Ov,
    iff: $b19ca0fdfcbacc57$var$Fv,
    ifr: $b19ca0fdfcbacc57$var$Bv,
    Ifr: $b19ca0fdfcbacc57$var$Pv,
    Igrave: $b19ca0fdfcbacc57$var$$v,
    igrave: $b19ca0fdfcbacc57$var$zv,
    ii: $b19ca0fdfcbacc57$var$Uv,
    iiiint: $b19ca0fdfcbacc57$var$Hv,
    iiint: $b19ca0fdfcbacc57$var$Vv,
    iinfin: $b19ca0fdfcbacc57$var$Gv,
    iiota: $b19ca0fdfcbacc57$var$jv,
    IJlig: $b19ca0fdfcbacc57$var$Zv,
    ijlig: $b19ca0fdfcbacc57$var$Kv,
    Imacr: $b19ca0fdfcbacc57$var$Wv,
    imacr: $b19ca0fdfcbacc57$var$Yv,
    image: $b19ca0fdfcbacc57$var$Jv,
    ImaginaryI: $b19ca0fdfcbacc57$var$Xv,
    imagline: $b19ca0fdfcbacc57$var$Qv,
    imagpart: $b19ca0fdfcbacc57$var$ek,
    imath: $b19ca0fdfcbacc57$var$nk,
    Im: $b19ca0fdfcbacc57$var$tk,
    imof: $b19ca0fdfcbacc57$var$rk,
    imped: $b19ca0fdfcbacc57$var$ok,
    Implies: $b19ca0fdfcbacc57$var$sk,
    incare: $b19ca0fdfcbacc57$var$ck,
    in: "\u2208",
    infin: $b19ca0fdfcbacc57$var$ik,
    infintie: $b19ca0fdfcbacc57$var$ak,
    inodot: $b19ca0fdfcbacc57$var$lk,
    intcal: $b19ca0fdfcbacc57$var$uk,
    int: $b19ca0fdfcbacc57$var$fk,
    Int: $b19ca0fdfcbacc57$var$pk,
    integers: $b19ca0fdfcbacc57$var$hk,
    Integral: $b19ca0fdfcbacc57$var$dk,
    intercal: $b19ca0fdfcbacc57$var$gk,
    Intersection: $b19ca0fdfcbacc57$var$mk,
    intlarhk: $b19ca0fdfcbacc57$var$_k,
    intprod: $b19ca0fdfcbacc57$var$bk,
    InvisibleComma: $b19ca0fdfcbacc57$var$vk,
    InvisibleTimes: $b19ca0fdfcbacc57$var$kk,
    IOcy: $b19ca0fdfcbacc57$var$xk,
    iocy: $b19ca0fdfcbacc57$var$yk,
    Iogon: $b19ca0fdfcbacc57$var$Ek,
    iogon: $b19ca0fdfcbacc57$var$wk,
    Iopf: $b19ca0fdfcbacc57$var$Ak,
    iopf: $b19ca0fdfcbacc57$var$Ck,
    Iota: $b19ca0fdfcbacc57$var$Sk,
    iota: $b19ca0fdfcbacc57$var$Dk,
    iprod: $b19ca0fdfcbacc57$var$Tk,
    iquest: $b19ca0fdfcbacc57$var$Rk,
    iscr: $b19ca0fdfcbacc57$var$Lk,
    Iscr: $b19ca0fdfcbacc57$var$Nk,
    isin: $b19ca0fdfcbacc57$var$qk,
    isindot: $b19ca0fdfcbacc57$var$Mk,
    isinE: $b19ca0fdfcbacc57$var$Ik,
    isins: $b19ca0fdfcbacc57$var$Ok,
    isinsv: $b19ca0fdfcbacc57$var$Fk,
    isinv: $b19ca0fdfcbacc57$var$Bk,
    it: $b19ca0fdfcbacc57$var$Pk,
    Itilde: $b19ca0fdfcbacc57$var$$k,
    itilde: $b19ca0fdfcbacc57$var$zk,
    Iukcy: $b19ca0fdfcbacc57$var$Uk,
    iukcy: $b19ca0fdfcbacc57$var$Hk,
    Iuml: $b19ca0fdfcbacc57$var$Vk,
    iuml: $b19ca0fdfcbacc57$var$Gk,
    Jcirc: $b19ca0fdfcbacc57$var$jk,
    jcirc: $b19ca0fdfcbacc57$var$Zk,
    Jcy: $b19ca0fdfcbacc57$var$Kk,
    jcy: $b19ca0fdfcbacc57$var$Wk,
    Jfr: $b19ca0fdfcbacc57$var$Yk,
    jfr: $b19ca0fdfcbacc57$var$Jk,
    jmath: $b19ca0fdfcbacc57$var$Xk,
    Jopf: $b19ca0fdfcbacc57$var$Qk,
    jopf: $b19ca0fdfcbacc57$var$ex,
    Jscr: $b19ca0fdfcbacc57$var$nx,
    jscr: $b19ca0fdfcbacc57$var$tx,
    Jsercy: $b19ca0fdfcbacc57$var$rx,
    jsercy: $b19ca0fdfcbacc57$var$ox,
    Jukcy: $b19ca0fdfcbacc57$var$sx,
    jukcy: $b19ca0fdfcbacc57$var$cx,
    Kappa: $b19ca0fdfcbacc57$var$ix,
    kappa: $b19ca0fdfcbacc57$var$ax,
    kappav: $b19ca0fdfcbacc57$var$lx,
    Kcedil: $b19ca0fdfcbacc57$var$ux,
    kcedil: $b19ca0fdfcbacc57$var$fx,
    Kcy: $b19ca0fdfcbacc57$var$px,
    kcy: $b19ca0fdfcbacc57$var$hx,
    Kfr: $b19ca0fdfcbacc57$var$dx,
    kfr: $b19ca0fdfcbacc57$var$gx,
    kgreen: $b19ca0fdfcbacc57$var$mx,
    KHcy: $b19ca0fdfcbacc57$var$_x,
    khcy: $b19ca0fdfcbacc57$var$bx,
    KJcy: $b19ca0fdfcbacc57$var$vx,
    kjcy: $b19ca0fdfcbacc57$var$kx,
    Kopf: $b19ca0fdfcbacc57$var$xx,
    kopf: $b19ca0fdfcbacc57$var$yx,
    Kscr: $b19ca0fdfcbacc57$var$Ex,
    kscr: $b19ca0fdfcbacc57$var$wx,
    lAarr: $b19ca0fdfcbacc57$var$Ax,
    Lacute: $b19ca0fdfcbacc57$var$Cx,
    lacute: $b19ca0fdfcbacc57$var$Sx,
    laemptyv: $b19ca0fdfcbacc57$var$Dx,
    lagran: $b19ca0fdfcbacc57$var$Tx,
    Lambda: $b19ca0fdfcbacc57$var$Rx,
    lambda: $b19ca0fdfcbacc57$var$Lx,
    lang: $b19ca0fdfcbacc57$var$Nx,
    Lang: $b19ca0fdfcbacc57$var$qx,
    langd: $b19ca0fdfcbacc57$var$Mx,
    langle: $b19ca0fdfcbacc57$var$Ix,
    lap: $b19ca0fdfcbacc57$var$Ox,
    Laplacetrf: $b19ca0fdfcbacc57$var$Fx,
    laquo: $b19ca0fdfcbacc57$var$Bx,
    larrb: $b19ca0fdfcbacc57$var$Px,
    larrbfs: $b19ca0fdfcbacc57$var$$x,
    larr: $b19ca0fdfcbacc57$var$zx,
    Larr: $b19ca0fdfcbacc57$var$Ux,
    lArr: $b19ca0fdfcbacc57$var$Hx,
    larrfs: $b19ca0fdfcbacc57$var$Vx,
    larrhk: $b19ca0fdfcbacc57$var$Gx,
    larrlp: $b19ca0fdfcbacc57$var$jx,
    larrpl: $b19ca0fdfcbacc57$var$Zx,
    larrsim: $b19ca0fdfcbacc57$var$Kx,
    larrtl: $b19ca0fdfcbacc57$var$Wx,
    latail: $b19ca0fdfcbacc57$var$Yx,
    lAtail: $b19ca0fdfcbacc57$var$Jx,
    lat: $b19ca0fdfcbacc57$var$Xx,
    late: $b19ca0fdfcbacc57$var$Qx,
    lates: $b19ca0fdfcbacc57$var$ey,
    lbarr: $b19ca0fdfcbacc57$var$ny,
    lBarr: $b19ca0fdfcbacc57$var$ty,
    lbbrk: $b19ca0fdfcbacc57$var$ry,
    lbrace: $b19ca0fdfcbacc57$var$oy,
    lbrack: $b19ca0fdfcbacc57$var$sy,
    lbrke: $b19ca0fdfcbacc57$var$cy,
    lbrksld: $b19ca0fdfcbacc57$var$iy,
    lbrkslu: $b19ca0fdfcbacc57$var$ay,
    Lcaron: $b19ca0fdfcbacc57$var$ly,
    lcaron: $b19ca0fdfcbacc57$var$uy,
    Lcedil: $b19ca0fdfcbacc57$var$fy,
    lcedil: $b19ca0fdfcbacc57$var$py,
    lceil: $b19ca0fdfcbacc57$var$hy,
    lcub: $b19ca0fdfcbacc57$var$dy,
    Lcy: $b19ca0fdfcbacc57$var$gy,
    lcy: $b19ca0fdfcbacc57$var$my,
    ldca: $b19ca0fdfcbacc57$var$_y,
    ldquo: $b19ca0fdfcbacc57$var$by,
    ldquor: $b19ca0fdfcbacc57$var$vy,
    ldrdhar: $b19ca0fdfcbacc57$var$ky,
    ldrushar: $b19ca0fdfcbacc57$var$xy,
    ldsh: $b19ca0fdfcbacc57$var$yy,
    le: $b19ca0fdfcbacc57$var$Ey,
    lE: $b19ca0fdfcbacc57$var$wy,
    LeftAngleBracket: $b19ca0fdfcbacc57$var$Ay,
    LeftArrowBar: $b19ca0fdfcbacc57$var$Cy,
    leftarrow: $b19ca0fdfcbacc57$var$Sy,
    LeftArrow: $b19ca0fdfcbacc57$var$Dy,
    Leftarrow: $b19ca0fdfcbacc57$var$Ty,
    LeftArrowRightArrow: $b19ca0fdfcbacc57$var$Ry,
    leftarrowtail: $b19ca0fdfcbacc57$var$Ly,
    LeftCeiling: $b19ca0fdfcbacc57$var$Ny,
    LeftDoubleBracket: $b19ca0fdfcbacc57$var$qy,
    LeftDownTeeVector: $b19ca0fdfcbacc57$var$My,
    LeftDownVectorBar: $b19ca0fdfcbacc57$var$Iy,
    LeftDownVector: $b19ca0fdfcbacc57$var$Oy,
    LeftFloor: $b19ca0fdfcbacc57$var$Fy,
    leftharpoondown: $b19ca0fdfcbacc57$var$By,
    leftharpoonup: $b19ca0fdfcbacc57$var$Py,
    leftleftarrows: $b19ca0fdfcbacc57$var$$y,
    leftrightarrow: $b19ca0fdfcbacc57$var$zy,
    LeftRightArrow: $b19ca0fdfcbacc57$var$Uy,
    Leftrightarrow: $b19ca0fdfcbacc57$var$Hy,
    leftrightarrows: $b19ca0fdfcbacc57$var$Vy,
    leftrightharpoons: $b19ca0fdfcbacc57$var$Gy,
    leftrightsquigarrow: $b19ca0fdfcbacc57$var$jy,
    LeftRightVector: $b19ca0fdfcbacc57$var$Zy,
    LeftTeeArrow: $b19ca0fdfcbacc57$var$Ky,
    LeftTee: $b19ca0fdfcbacc57$var$Wy,
    LeftTeeVector: $b19ca0fdfcbacc57$var$Yy,
    leftthreetimes: $b19ca0fdfcbacc57$var$Jy,
    LeftTriangleBar: $b19ca0fdfcbacc57$var$Xy,
    LeftTriangle: $b19ca0fdfcbacc57$var$Qy,
    LeftTriangleEqual: $b19ca0fdfcbacc57$var$eE,
    LeftUpDownVector: $b19ca0fdfcbacc57$var$nE,
    LeftUpTeeVector: $b19ca0fdfcbacc57$var$tE,
    LeftUpVectorBar: $b19ca0fdfcbacc57$var$rE,
    LeftUpVector: $b19ca0fdfcbacc57$var$oE,
    LeftVectorBar: $b19ca0fdfcbacc57$var$sE,
    LeftVector: $b19ca0fdfcbacc57$var$cE,
    lEg: $b19ca0fdfcbacc57$var$iE,
    leg: $b19ca0fdfcbacc57$var$aE,
    leq: $b19ca0fdfcbacc57$var$lE,
    leqq: $b19ca0fdfcbacc57$var$uE,
    leqslant: $b19ca0fdfcbacc57$var$fE,
    lescc: $b19ca0fdfcbacc57$var$pE,
    les: $b19ca0fdfcbacc57$var$hE,
    lesdot: $b19ca0fdfcbacc57$var$dE,
    lesdoto: $b19ca0fdfcbacc57$var$gE,
    lesdotor: $b19ca0fdfcbacc57$var$mE,
    lesg: $b19ca0fdfcbacc57$var$_E,
    lesges: $b19ca0fdfcbacc57$var$bE,
    lessapprox: $b19ca0fdfcbacc57$var$vE,
    lessdot: $b19ca0fdfcbacc57$var$kE,
    lesseqgtr: $b19ca0fdfcbacc57$var$xE,
    lesseqqgtr: $b19ca0fdfcbacc57$var$yE,
    LessEqualGreater: $b19ca0fdfcbacc57$var$EE,
    LessFullEqual: $b19ca0fdfcbacc57$var$wE,
    LessGreater: $b19ca0fdfcbacc57$var$AE,
    lessgtr: $b19ca0fdfcbacc57$var$CE,
    LessLess: $b19ca0fdfcbacc57$var$SE,
    lesssim: $b19ca0fdfcbacc57$var$DE,
    LessSlantEqual: $b19ca0fdfcbacc57$var$TE,
    LessTilde: $b19ca0fdfcbacc57$var$RE,
    lfisht: $b19ca0fdfcbacc57$var$LE,
    lfloor: $b19ca0fdfcbacc57$var$NE,
    Lfr: $b19ca0fdfcbacc57$var$qE,
    lfr: $b19ca0fdfcbacc57$var$ME,
    lg: $b19ca0fdfcbacc57$var$IE,
    lgE: $b19ca0fdfcbacc57$var$OE,
    lHar: $b19ca0fdfcbacc57$var$FE,
    lhard: $b19ca0fdfcbacc57$var$BE,
    lharu: $b19ca0fdfcbacc57$var$PE,
    lharul: $b19ca0fdfcbacc57$var$$E,
    lhblk: $b19ca0fdfcbacc57$var$zE,
    LJcy: $b19ca0fdfcbacc57$var$UE,
    ljcy: $b19ca0fdfcbacc57$var$HE,
    llarr: $b19ca0fdfcbacc57$var$VE,
    ll: $b19ca0fdfcbacc57$var$GE,
    Ll: $b19ca0fdfcbacc57$var$jE,
    llcorner: $b19ca0fdfcbacc57$var$ZE,
    Lleftarrow: $b19ca0fdfcbacc57$var$KE,
    llhard: $b19ca0fdfcbacc57$var$WE,
    lltri: $b19ca0fdfcbacc57$var$YE,
    Lmidot: $b19ca0fdfcbacc57$var$JE,
    lmidot: $b19ca0fdfcbacc57$var$XE,
    lmoustache: $b19ca0fdfcbacc57$var$QE,
    lmoust: $b19ca0fdfcbacc57$var$ew,
    lnap: $b19ca0fdfcbacc57$var$nw,
    lnapprox: $b19ca0fdfcbacc57$var$tw,
    lne: $b19ca0fdfcbacc57$var$rw,
    lnE: $b19ca0fdfcbacc57$var$ow,
    lneq: $b19ca0fdfcbacc57$var$sw,
    lneqq: $b19ca0fdfcbacc57$var$cw,
    lnsim: $b19ca0fdfcbacc57$var$iw,
    loang: $b19ca0fdfcbacc57$var$aw,
    loarr: $b19ca0fdfcbacc57$var$lw,
    lobrk: $b19ca0fdfcbacc57$var$uw,
    longleftarrow: $b19ca0fdfcbacc57$var$fw,
    LongLeftArrow: $b19ca0fdfcbacc57$var$pw,
    Longleftarrow: $b19ca0fdfcbacc57$var$hw,
    longleftrightarrow: $b19ca0fdfcbacc57$var$dw,
    LongLeftRightArrow: $b19ca0fdfcbacc57$var$gw,
    Longleftrightarrow: $b19ca0fdfcbacc57$var$mw,
    longmapsto: $b19ca0fdfcbacc57$var$_w,
    longrightarrow: $b19ca0fdfcbacc57$var$bw,
    LongRightArrow: $b19ca0fdfcbacc57$var$vw,
    Longrightarrow: $b19ca0fdfcbacc57$var$kw,
    looparrowleft: $b19ca0fdfcbacc57$var$xw,
    looparrowright: $b19ca0fdfcbacc57$var$yw,
    lopar: $b19ca0fdfcbacc57$var$Ew,
    Lopf: $b19ca0fdfcbacc57$var$ww,
    lopf: $b19ca0fdfcbacc57$var$Aw,
    loplus: $b19ca0fdfcbacc57$var$Cw,
    lotimes: $b19ca0fdfcbacc57$var$Sw,
    lowast: $b19ca0fdfcbacc57$var$Dw,
    lowbar: $b19ca0fdfcbacc57$var$Tw,
    LowerLeftArrow: $b19ca0fdfcbacc57$var$Rw,
    LowerRightArrow: $b19ca0fdfcbacc57$var$Lw,
    loz: $b19ca0fdfcbacc57$var$Nw,
    lozenge: $b19ca0fdfcbacc57$var$qw,
    lozf: $b19ca0fdfcbacc57$var$Mw,
    lpar: $b19ca0fdfcbacc57$var$Iw,
    lparlt: $b19ca0fdfcbacc57$var$Ow,
    lrarr: $b19ca0fdfcbacc57$var$Fw,
    lrcorner: $b19ca0fdfcbacc57$var$Bw,
    lrhar: $b19ca0fdfcbacc57$var$Pw,
    lrhard: $b19ca0fdfcbacc57$var$$w,
    lrm: $b19ca0fdfcbacc57$var$zw,
    lrtri: $b19ca0fdfcbacc57$var$Uw,
    lsaquo: $b19ca0fdfcbacc57$var$Hw,
    lscr: $b19ca0fdfcbacc57$var$Vw,
    Lscr: $b19ca0fdfcbacc57$var$Gw,
    lsh: $b19ca0fdfcbacc57$var$jw,
    Lsh: $b19ca0fdfcbacc57$var$Zw,
    lsim: $b19ca0fdfcbacc57$var$Kw,
    lsime: $b19ca0fdfcbacc57$var$Ww,
    lsimg: $b19ca0fdfcbacc57$var$Yw,
    lsqb: $b19ca0fdfcbacc57$var$Jw,
    lsquo: $b19ca0fdfcbacc57$var$Xw,
    lsquor: $b19ca0fdfcbacc57$var$Qw,
    Lstrok: $b19ca0fdfcbacc57$var$e1,
    lstrok: $b19ca0fdfcbacc57$var$n1,
    ltcc: $b19ca0fdfcbacc57$var$t1,
    ltcir: $b19ca0fdfcbacc57$var$r1,
    lt: $b19ca0fdfcbacc57$var$o1,
    LT: $b19ca0fdfcbacc57$var$s1,
    Lt: $b19ca0fdfcbacc57$var$c1,
    ltdot: $b19ca0fdfcbacc57$var$i1,
    lthree: $b19ca0fdfcbacc57$var$a1,
    ltimes: $b19ca0fdfcbacc57$var$l1,
    ltlarr: $b19ca0fdfcbacc57$var$u1,
    ltquest: $b19ca0fdfcbacc57$var$f1,
    ltri: $b19ca0fdfcbacc57$var$p1,
    ltrie: $b19ca0fdfcbacc57$var$h1,
    ltrif: $b19ca0fdfcbacc57$var$d1,
    ltrPar: $b19ca0fdfcbacc57$var$g1,
    lurdshar: $b19ca0fdfcbacc57$var$m1,
    luruhar: $b19ca0fdfcbacc57$var$_1,
    lvertneqq: $b19ca0fdfcbacc57$var$b1,
    lvnE: $b19ca0fdfcbacc57$var$v1,
    macr: $b19ca0fdfcbacc57$var$k1,
    male: $b19ca0fdfcbacc57$var$x1,
    malt: $b19ca0fdfcbacc57$var$y1,
    maltese: $b19ca0fdfcbacc57$var$E1,
    Map: "\u2905",
    map: $b19ca0fdfcbacc57$var$w1,
    mapsto: $b19ca0fdfcbacc57$var$A1,
    mapstodown: $b19ca0fdfcbacc57$var$C1,
    mapstoleft: $b19ca0fdfcbacc57$var$S1,
    mapstoup: $b19ca0fdfcbacc57$var$D1,
    marker: $b19ca0fdfcbacc57$var$T1,
    mcomma: $b19ca0fdfcbacc57$var$R1,
    Mcy: $b19ca0fdfcbacc57$var$L1,
    mcy: $b19ca0fdfcbacc57$var$N1,
    mdash: $b19ca0fdfcbacc57$var$q1,
    mDDot: $b19ca0fdfcbacc57$var$M1,
    measuredangle: $b19ca0fdfcbacc57$var$I1,
    MediumSpace: $b19ca0fdfcbacc57$var$O1,
    Mellintrf: $b19ca0fdfcbacc57$var$F1,
    Mfr: $b19ca0fdfcbacc57$var$B1,
    mfr: $b19ca0fdfcbacc57$var$P1,
    mho: $b19ca0fdfcbacc57$var$$1,
    micro: $b19ca0fdfcbacc57$var$z1,
    midast: $b19ca0fdfcbacc57$var$U1,
    midcir: $b19ca0fdfcbacc57$var$H1,
    mid: $b19ca0fdfcbacc57$var$V1,
    middot: $b19ca0fdfcbacc57$var$G1,
    minusb: $b19ca0fdfcbacc57$var$j1,
    minus: $b19ca0fdfcbacc57$var$Z1,
    minusd: $b19ca0fdfcbacc57$var$K1,
    minusdu: $b19ca0fdfcbacc57$var$W1,
    MinusPlus: $b19ca0fdfcbacc57$var$Y1,
    mlcp: $b19ca0fdfcbacc57$var$J1,
    mldr: $b19ca0fdfcbacc57$var$X1,
    mnplus: $b19ca0fdfcbacc57$var$Q1,
    models: $b19ca0fdfcbacc57$var$eA,
    Mopf: $b19ca0fdfcbacc57$var$nA,
    mopf: $b19ca0fdfcbacc57$var$tA,
    mp: $b19ca0fdfcbacc57$var$rA,
    mscr: $b19ca0fdfcbacc57$var$oA,
    Mscr: $b19ca0fdfcbacc57$var$sA,
    mstpos: $b19ca0fdfcbacc57$var$cA,
    Mu: $b19ca0fdfcbacc57$var$iA,
    mu: $b19ca0fdfcbacc57$var$aA,
    multimap: $b19ca0fdfcbacc57$var$lA,
    mumap: $b19ca0fdfcbacc57$var$uA,
    nabla: $b19ca0fdfcbacc57$var$fA,
    Nacute: $b19ca0fdfcbacc57$var$pA,
    nacute: $b19ca0fdfcbacc57$var$hA,
    nang: $b19ca0fdfcbacc57$var$dA,
    nap: $b19ca0fdfcbacc57$var$gA,
    napE: $b19ca0fdfcbacc57$var$mA,
    napid: $b19ca0fdfcbacc57$var$_A,
    napos: $b19ca0fdfcbacc57$var$bA,
    napprox: $b19ca0fdfcbacc57$var$vA,
    natural: $b19ca0fdfcbacc57$var$kA,
    naturals: $b19ca0fdfcbacc57$var$xA,
    natur: $b19ca0fdfcbacc57$var$yA,
    nbsp: $b19ca0fdfcbacc57$var$EA,
    nbump: $b19ca0fdfcbacc57$var$wA,
    nbumpe: $b19ca0fdfcbacc57$var$AA,
    ncap: $b19ca0fdfcbacc57$var$CA,
    Ncaron: $b19ca0fdfcbacc57$var$SA,
    ncaron: $b19ca0fdfcbacc57$var$DA,
    Ncedil: $b19ca0fdfcbacc57$var$TA,
    ncedil: $b19ca0fdfcbacc57$var$RA,
    ncong: $b19ca0fdfcbacc57$var$LA,
    ncongdot: $b19ca0fdfcbacc57$var$NA,
    ncup: $b19ca0fdfcbacc57$var$qA,
    Ncy: $b19ca0fdfcbacc57$var$MA,
    ncy: $b19ca0fdfcbacc57$var$IA,
    ndash: $b19ca0fdfcbacc57$var$OA,
    nearhk: $b19ca0fdfcbacc57$var$FA,
    nearr: $b19ca0fdfcbacc57$var$BA,
    neArr: $b19ca0fdfcbacc57$var$PA,
    nearrow: $b19ca0fdfcbacc57$var$$A,
    ne: $b19ca0fdfcbacc57$var$zA,
    nedot: $b19ca0fdfcbacc57$var$UA,
    NegativeMediumSpace: $b19ca0fdfcbacc57$var$HA,
    NegativeThickSpace: $b19ca0fdfcbacc57$var$VA,
    NegativeThinSpace: $b19ca0fdfcbacc57$var$GA,
    NegativeVeryThinSpace: $b19ca0fdfcbacc57$var$jA,
    nequiv: $b19ca0fdfcbacc57$var$ZA,
    nesear: $b19ca0fdfcbacc57$var$KA,
    nesim: $b19ca0fdfcbacc57$var$WA,
    NestedGreaterGreater: $b19ca0fdfcbacc57$var$YA,
    NestedLessLess: $b19ca0fdfcbacc57$var$JA,
    NewLine: $b19ca0fdfcbacc57$var$XA,
    nexist: $b19ca0fdfcbacc57$var$QA,
    nexists: $b19ca0fdfcbacc57$var$eC,
    Nfr: $b19ca0fdfcbacc57$var$nC,
    nfr: $b19ca0fdfcbacc57$var$tC,
    ngE: $b19ca0fdfcbacc57$var$rC,
    nge: $b19ca0fdfcbacc57$var$oC,
    ngeq: $b19ca0fdfcbacc57$var$sC,
    ngeqq: $b19ca0fdfcbacc57$var$cC,
    ngeqslant: $b19ca0fdfcbacc57$var$iC,
    nges: $b19ca0fdfcbacc57$var$aC,
    nGg: $b19ca0fdfcbacc57$var$lC,
    ngsim: $b19ca0fdfcbacc57$var$uC,
    nGt: $b19ca0fdfcbacc57$var$fC,
    ngt: $b19ca0fdfcbacc57$var$pC,
    ngtr: $b19ca0fdfcbacc57$var$hC,
    nGtv: $b19ca0fdfcbacc57$var$dC,
    nharr: $b19ca0fdfcbacc57$var$gC,
    nhArr: $b19ca0fdfcbacc57$var$mC,
    nhpar: $b19ca0fdfcbacc57$var$_C,
    ni: $b19ca0fdfcbacc57$var$bC,
    nis: $b19ca0fdfcbacc57$var$vC,
    nisd: $b19ca0fdfcbacc57$var$kC,
    niv: $b19ca0fdfcbacc57$var$xC,
    NJcy: $b19ca0fdfcbacc57$var$yC,
    njcy: $b19ca0fdfcbacc57$var$EC,
    nlarr: $b19ca0fdfcbacc57$var$wC,
    nlArr: $b19ca0fdfcbacc57$var$AC,
    nldr: $b19ca0fdfcbacc57$var$CC,
    nlE: $b19ca0fdfcbacc57$var$SC,
    nle: $b19ca0fdfcbacc57$var$DC,
    nleftarrow: $b19ca0fdfcbacc57$var$TC,
    nLeftarrow: $b19ca0fdfcbacc57$var$RC,
    nleftrightarrow: $b19ca0fdfcbacc57$var$LC,
    nLeftrightarrow: $b19ca0fdfcbacc57$var$NC,
    nleq: $b19ca0fdfcbacc57$var$qC,
    nleqq: $b19ca0fdfcbacc57$var$MC,
    nleqslant: $b19ca0fdfcbacc57$var$IC,
    nles: $b19ca0fdfcbacc57$var$OC,
    nless: $b19ca0fdfcbacc57$var$FC,
    nLl: $b19ca0fdfcbacc57$var$BC,
    nlsim: $b19ca0fdfcbacc57$var$PC,
    nLt: $b19ca0fdfcbacc57$var$$C,
    nlt: $b19ca0fdfcbacc57$var$zC,
    nltri: $b19ca0fdfcbacc57$var$UC,
    nltrie: $b19ca0fdfcbacc57$var$HC,
    nLtv: $b19ca0fdfcbacc57$var$VC,
    nmid: $b19ca0fdfcbacc57$var$GC,
    NoBreak: $b19ca0fdfcbacc57$var$jC,
    NonBreakingSpace: $b19ca0fdfcbacc57$var$ZC,
    nopf: $b19ca0fdfcbacc57$var$KC,
    Nopf: $b19ca0fdfcbacc57$var$WC,
    Not: $b19ca0fdfcbacc57$var$YC,
    not: $b19ca0fdfcbacc57$var$JC,
    NotCongruent: $b19ca0fdfcbacc57$var$XC,
    NotCupCap: $b19ca0fdfcbacc57$var$QC,
    NotDoubleVerticalBar: $b19ca0fdfcbacc57$var$eS,
    NotElement: $b19ca0fdfcbacc57$var$nS,
    NotEqual: $b19ca0fdfcbacc57$var$tS,
    NotEqualTilde: $b19ca0fdfcbacc57$var$rS,
    NotExists: $b19ca0fdfcbacc57$var$oS,
    NotGreater: $b19ca0fdfcbacc57$var$sS,
    NotGreaterEqual: $b19ca0fdfcbacc57$var$cS,
    NotGreaterFullEqual: $b19ca0fdfcbacc57$var$iS,
    NotGreaterGreater: $b19ca0fdfcbacc57$var$aS,
    NotGreaterLess: $b19ca0fdfcbacc57$var$lS,
    NotGreaterSlantEqual: $b19ca0fdfcbacc57$var$uS,
    NotGreaterTilde: $b19ca0fdfcbacc57$var$fS,
    NotHumpDownHump: $b19ca0fdfcbacc57$var$pS,
    NotHumpEqual: $b19ca0fdfcbacc57$var$hS,
    notin: $b19ca0fdfcbacc57$var$dS,
    notindot: $b19ca0fdfcbacc57$var$gS,
    notinE: $b19ca0fdfcbacc57$var$mS,
    notinva: $b19ca0fdfcbacc57$var$_S,
    notinvb: $b19ca0fdfcbacc57$var$bS,
    notinvc: $b19ca0fdfcbacc57$var$vS,
    NotLeftTriangleBar: $b19ca0fdfcbacc57$var$kS,
    NotLeftTriangle: $b19ca0fdfcbacc57$var$xS,
    NotLeftTriangleEqual: $b19ca0fdfcbacc57$var$yS,
    NotLess: $b19ca0fdfcbacc57$var$ES,
    NotLessEqual: $b19ca0fdfcbacc57$var$wS,
    NotLessGreater: $b19ca0fdfcbacc57$var$AS,
    NotLessLess: $b19ca0fdfcbacc57$var$CS,
    NotLessSlantEqual: $b19ca0fdfcbacc57$var$SS,
    NotLessTilde: $b19ca0fdfcbacc57$var$DS,
    NotNestedGreaterGreater: $b19ca0fdfcbacc57$var$TS,
    NotNestedLessLess: $b19ca0fdfcbacc57$var$RS,
    notni: $b19ca0fdfcbacc57$var$LS,
    notniva: $b19ca0fdfcbacc57$var$NS,
    notnivb: $b19ca0fdfcbacc57$var$qS,
    notnivc: $b19ca0fdfcbacc57$var$MS,
    NotPrecedes: $b19ca0fdfcbacc57$var$IS,
    NotPrecedesEqual: $b19ca0fdfcbacc57$var$OS,
    NotPrecedesSlantEqual: $b19ca0fdfcbacc57$var$FS,
    NotReverseElement: $b19ca0fdfcbacc57$var$BS,
    NotRightTriangleBar: $b19ca0fdfcbacc57$var$PS,
    NotRightTriangle: $b19ca0fdfcbacc57$var$$S,
    NotRightTriangleEqual: $b19ca0fdfcbacc57$var$zS,
    NotSquareSubset: $b19ca0fdfcbacc57$var$US,
    NotSquareSubsetEqual: $b19ca0fdfcbacc57$var$HS,
    NotSquareSuperset: $b19ca0fdfcbacc57$var$VS,
    NotSquareSupersetEqual: $b19ca0fdfcbacc57$var$GS,
    NotSubset: $b19ca0fdfcbacc57$var$jS,
    NotSubsetEqual: $b19ca0fdfcbacc57$var$ZS,
    NotSucceeds: $b19ca0fdfcbacc57$var$KS,
    NotSucceedsEqual: $b19ca0fdfcbacc57$var$WS,
    NotSucceedsSlantEqual: $b19ca0fdfcbacc57$var$YS,
    NotSucceedsTilde: $b19ca0fdfcbacc57$var$JS,
    NotSuperset: $b19ca0fdfcbacc57$var$XS,
    NotSupersetEqual: $b19ca0fdfcbacc57$var$QS,
    NotTilde: $b19ca0fdfcbacc57$var$eD,
    NotTildeEqual: $b19ca0fdfcbacc57$var$nD,
    NotTildeFullEqual: $b19ca0fdfcbacc57$var$tD,
    NotTildeTilde: $b19ca0fdfcbacc57$var$rD,
    NotVerticalBar: $b19ca0fdfcbacc57$var$oD,
    nparallel: $b19ca0fdfcbacc57$var$sD,
    npar: $b19ca0fdfcbacc57$var$cD,
    nparsl: $b19ca0fdfcbacc57$var$iD,
    npart: $b19ca0fdfcbacc57$var$aD,
    npolint: $b19ca0fdfcbacc57$var$lD,
    npr: $b19ca0fdfcbacc57$var$uD,
    nprcue: $b19ca0fdfcbacc57$var$fD,
    nprec: $b19ca0fdfcbacc57$var$pD,
    npreceq: $b19ca0fdfcbacc57$var$hD,
    npre: $b19ca0fdfcbacc57$var$dD,
    nrarrc: $b19ca0fdfcbacc57$var$gD,
    nrarr: $b19ca0fdfcbacc57$var$mD,
    nrArr: $b19ca0fdfcbacc57$var$_D,
    nrarrw: $b19ca0fdfcbacc57$var$bD,
    nrightarrow: $b19ca0fdfcbacc57$var$vD,
    nRightarrow: $b19ca0fdfcbacc57$var$kD,
    nrtri: $b19ca0fdfcbacc57$var$xD,
    nrtrie: $b19ca0fdfcbacc57$var$yD,
    nsc: $b19ca0fdfcbacc57$var$ED,
    nsccue: $b19ca0fdfcbacc57$var$wD,
    nsce: $b19ca0fdfcbacc57$var$AD,
    Nscr: $b19ca0fdfcbacc57$var$CD,
    nscr: $b19ca0fdfcbacc57$var$SD,
    nshortmid: $b19ca0fdfcbacc57$var$DD,
    nshortparallel: $b19ca0fdfcbacc57$var$TD,
    nsim: $b19ca0fdfcbacc57$var$RD,
    nsime: $b19ca0fdfcbacc57$var$LD,
    nsimeq: $b19ca0fdfcbacc57$var$ND,
    nsmid: $b19ca0fdfcbacc57$var$qD,
    nspar: $b19ca0fdfcbacc57$var$MD,
    nsqsube: $b19ca0fdfcbacc57$var$ID,
    nsqsupe: $b19ca0fdfcbacc57$var$OD,
    nsub: $b19ca0fdfcbacc57$var$FD,
    nsubE: $b19ca0fdfcbacc57$var$BD,
    nsube: $b19ca0fdfcbacc57$var$PD,
    nsubset: $b19ca0fdfcbacc57$var$$D,
    nsubseteq: $b19ca0fdfcbacc57$var$zD,
    nsubseteqq: $b19ca0fdfcbacc57$var$UD,
    nsucc: $b19ca0fdfcbacc57$var$HD,
    nsucceq: $b19ca0fdfcbacc57$var$VD,
    nsup: $b19ca0fdfcbacc57$var$GD,
    nsupE: $b19ca0fdfcbacc57$var$jD,
    nsupe: $b19ca0fdfcbacc57$var$ZD,
    nsupset: $b19ca0fdfcbacc57$var$KD,
    nsupseteq: $b19ca0fdfcbacc57$var$WD,
    nsupseteqq: $b19ca0fdfcbacc57$var$YD,
    ntgl: $b19ca0fdfcbacc57$var$JD,
    Ntilde: $b19ca0fdfcbacc57$var$XD,
    ntilde: $b19ca0fdfcbacc57$var$QD,
    ntlg: $b19ca0fdfcbacc57$var$eT,
    ntriangleleft: $b19ca0fdfcbacc57$var$nT,
    ntrianglelefteq: $b19ca0fdfcbacc57$var$tT,
    ntriangleright: $b19ca0fdfcbacc57$var$rT,
    ntrianglerighteq: $b19ca0fdfcbacc57$var$oT,
    Nu: $b19ca0fdfcbacc57$var$sT,
    nu: $b19ca0fdfcbacc57$var$cT,
    num: $b19ca0fdfcbacc57$var$iT,
    numero: $b19ca0fdfcbacc57$var$aT,
    numsp: $b19ca0fdfcbacc57$var$lT,
    nvap: $b19ca0fdfcbacc57$var$uT,
    nvdash: $b19ca0fdfcbacc57$var$fT,
    nvDash: $b19ca0fdfcbacc57$var$pT,
    nVdash: $b19ca0fdfcbacc57$var$hT,
    nVDash: $b19ca0fdfcbacc57$var$dT,
    nvge: $b19ca0fdfcbacc57$var$gT,
    nvgt: $b19ca0fdfcbacc57$var$mT,
    nvHarr: $b19ca0fdfcbacc57$var$_T,
    nvinfin: $b19ca0fdfcbacc57$var$bT,
    nvlArr: $b19ca0fdfcbacc57$var$vT,
    nvle: $b19ca0fdfcbacc57$var$kT,
    nvlt: $b19ca0fdfcbacc57$var$xT,
    nvltrie: $b19ca0fdfcbacc57$var$yT,
    nvrArr: $b19ca0fdfcbacc57$var$ET,
    nvrtrie: $b19ca0fdfcbacc57$var$wT,
    nvsim: $b19ca0fdfcbacc57$var$AT,
    nwarhk: $b19ca0fdfcbacc57$var$CT,
    nwarr: $b19ca0fdfcbacc57$var$ST,
    nwArr: $b19ca0fdfcbacc57$var$DT,
    nwarrow: $b19ca0fdfcbacc57$var$TT,
    nwnear: $b19ca0fdfcbacc57$var$RT,
    Oacute: $b19ca0fdfcbacc57$var$LT,
    oacute: $b19ca0fdfcbacc57$var$NT,
    oast: $b19ca0fdfcbacc57$var$qT,
    Ocirc: $b19ca0fdfcbacc57$var$MT,
    ocirc: $b19ca0fdfcbacc57$var$IT,
    ocir: $b19ca0fdfcbacc57$var$OT,
    Ocy: $b19ca0fdfcbacc57$var$FT,
    ocy: $b19ca0fdfcbacc57$var$BT,
    odash: $b19ca0fdfcbacc57$var$PT,
    Odblac: $b19ca0fdfcbacc57$var$$T,
    odblac: $b19ca0fdfcbacc57$var$zT,
    odiv: $b19ca0fdfcbacc57$var$UT,
    odot: $b19ca0fdfcbacc57$var$HT,
    odsold: $b19ca0fdfcbacc57$var$VT,
    OElig: $b19ca0fdfcbacc57$var$GT,
    oelig: $b19ca0fdfcbacc57$var$jT,
    ofcir: $b19ca0fdfcbacc57$var$ZT,
    Ofr: $b19ca0fdfcbacc57$var$KT,
    ofr: $b19ca0fdfcbacc57$var$WT,
    ogon: $b19ca0fdfcbacc57$var$YT,
    Ograve: $b19ca0fdfcbacc57$var$JT,
    ograve: $b19ca0fdfcbacc57$var$XT,
    ogt: $b19ca0fdfcbacc57$var$QT,
    ohbar: $b19ca0fdfcbacc57$var$eR,
    ohm: $b19ca0fdfcbacc57$var$nR,
    oint: $b19ca0fdfcbacc57$var$tR,
    olarr: $b19ca0fdfcbacc57$var$rR,
    olcir: $b19ca0fdfcbacc57$var$oR,
    olcross: $b19ca0fdfcbacc57$var$sR,
    oline: $b19ca0fdfcbacc57$var$cR,
    olt: $b19ca0fdfcbacc57$var$iR,
    Omacr: $b19ca0fdfcbacc57$var$aR,
    omacr: $b19ca0fdfcbacc57$var$lR,
    Omega: $b19ca0fdfcbacc57$var$uR,
    omega: $b19ca0fdfcbacc57$var$fR,
    Omicron: $b19ca0fdfcbacc57$var$pR,
    omicron: $b19ca0fdfcbacc57$var$hR,
    omid: $b19ca0fdfcbacc57$var$dR,
    ominus: $b19ca0fdfcbacc57$var$gR,
    Oopf: $b19ca0fdfcbacc57$var$mR,
    oopf: $b19ca0fdfcbacc57$var$_R,
    opar: $b19ca0fdfcbacc57$var$bR,
    OpenCurlyDoubleQuote: $b19ca0fdfcbacc57$var$vR,
    OpenCurlyQuote: $b19ca0fdfcbacc57$var$kR,
    operp: $b19ca0fdfcbacc57$var$xR,
    oplus: $b19ca0fdfcbacc57$var$yR,
    orarr: $b19ca0fdfcbacc57$var$ER,
    Or: $b19ca0fdfcbacc57$var$wR,
    or: $b19ca0fdfcbacc57$var$AR,
    ord: $b19ca0fdfcbacc57$var$CR,
    order: $b19ca0fdfcbacc57$var$SR,
    orderof: $b19ca0fdfcbacc57$var$DR,
    ordf: $b19ca0fdfcbacc57$var$TR,
    ordm: $b19ca0fdfcbacc57$var$RR,
    origof: $b19ca0fdfcbacc57$var$LR,
    oror: $b19ca0fdfcbacc57$var$NR,
    orslope: $b19ca0fdfcbacc57$var$qR,
    orv: $b19ca0fdfcbacc57$var$MR,
    oS: $b19ca0fdfcbacc57$var$IR,
    Oscr: $b19ca0fdfcbacc57$var$OR,
    oscr: $b19ca0fdfcbacc57$var$FR,
    Oslash: $b19ca0fdfcbacc57$var$BR,
    oslash: $b19ca0fdfcbacc57$var$PR,
    osol: $b19ca0fdfcbacc57$var$$R,
    Otilde: $b19ca0fdfcbacc57$var$zR,
    otilde: $b19ca0fdfcbacc57$var$UR,
    otimesas: $b19ca0fdfcbacc57$var$HR,
    Otimes: $b19ca0fdfcbacc57$var$VR,
    otimes: $b19ca0fdfcbacc57$var$GR,
    Ouml: $b19ca0fdfcbacc57$var$jR,
    ouml: $b19ca0fdfcbacc57$var$ZR,
    ovbar: $b19ca0fdfcbacc57$var$KR,
    OverBar: $b19ca0fdfcbacc57$var$WR,
    OverBrace: $b19ca0fdfcbacc57$var$YR,
    OverBracket: $b19ca0fdfcbacc57$var$JR,
    OverParenthesis: $b19ca0fdfcbacc57$var$XR,
    para: $b19ca0fdfcbacc57$var$QR,
    parallel: $b19ca0fdfcbacc57$var$e2,
    par: $b19ca0fdfcbacc57$var$n2,
    parsim: $b19ca0fdfcbacc57$var$t2,
    parsl: $b19ca0fdfcbacc57$var$r2,
    part: $b19ca0fdfcbacc57$var$o2,
    PartialD: $b19ca0fdfcbacc57$var$s2,
    Pcy: $b19ca0fdfcbacc57$var$c2,
    pcy: $b19ca0fdfcbacc57$var$i2,
    percnt: $b19ca0fdfcbacc57$var$a2,
    period: $b19ca0fdfcbacc57$var$l2,
    permil: $b19ca0fdfcbacc57$var$u2,
    perp: $b19ca0fdfcbacc57$var$f2,
    pertenk: $b19ca0fdfcbacc57$var$p2,
    Pfr: $b19ca0fdfcbacc57$var$h2,
    pfr: $b19ca0fdfcbacc57$var$d2,
    Phi: $b19ca0fdfcbacc57$var$g2,
    phi: $b19ca0fdfcbacc57$var$m2,
    phiv: $b19ca0fdfcbacc57$var$_2,
    phmmat: $b19ca0fdfcbacc57$var$b2,
    phone: $b19ca0fdfcbacc57$var$v2,
    Pi: $b19ca0fdfcbacc57$var$k2,
    pi: $b19ca0fdfcbacc57$var$x2,
    pitchfork: $b19ca0fdfcbacc57$var$y2,
    piv: $b19ca0fdfcbacc57$var$E2,
    planck: $b19ca0fdfcbacc57$var$w2,
    planckh: $b19ca0fdfcbacc57$var$A2,
    plankv: $b19ca0fdfcbacc57$var$C2,
    plusacir: $b19ca0fdfcbacc57$var$S2,
    plusb: $b19ca0fdfcbacc57$var$D2,
    pluscir: $b19ca0fdfcbacc57$var$T2,
    plus: $b19ca0fdfcbacc57$var$R2,
    plusdo: $b19ca0fdfcbacc57$var$L2,
    plusdu: $b19ca0fdfcbacc57$var$N2,
    pluse: $b19ca0fdfcbacc57$var$q2,
    PlusMinus: $b19ca0fdfcbacc57$var$M2,
    plusmn: $b19ca0fdfcbacc57$var$I2,
    plussim: $b19ca0fdfcbacc57$var$O2,
    plustwo: $b19ca0fdfcbacc57$var$F2,
    pm: $b19ca0fdfcbacc57$var$B2,
    Poincareplane: $b19ca0fdfcbacc57$var$P2,
    pointint: $b19ca0fdfcbacc57$var$$2,
    popf: $b19ca0fdfcbacc57$var$z2,
    Popf: $b19ca0fdfcbacc57$var$U2,
    pound: $b19ca0fdfcbacc57$var$H2,
    prap: $b19ca0fdfcbacc57$var$V2,
    Pr: $b19ca0fdfcbacc57$var$G2,
    pr: $b19ca0fdfcbacc57$var$j2,
    prcue: $b19ca0fdfcbacc57$var$Z2,
    precapprox: $b19ca0fdfcbacc57$var$K2,
    prec: $b19ca0fdfcbacc57$var$W2,
    preccurlyeq: $b19ca0fdfcbacc57$var$Y2,
    Precedes: $b19ca0fdfcbacc57$var$J2,
    PrecedesEqual: $b19ca0fdfcbacc57$var$X2,
    PrecedesSlantEqual: $b19ca0fdfcbacc57$var$Q2,
    PrecedesTilde: $b19ca0fdfcbacc57$var$eL,
    preceq: $b19ca0fdfcbacc57$var$nL,
    precnapprox: $b19ca0fdfcbacc57$var$tL,
    precneqq: $b19ca0fdfcbacc57$var$rL,
    precnsim: $b19ca0fdfcbacc57$var$oL,
    pre: $b19ca0fdfcbacc57$var$sL,
    prE: $b19ca0fdfcbacc57$var$cL,
    precsim: $b19ca0fdfcbacc57$var$iL,
    prime: $b19ca0fdfcbacc57$var$aL,
    Prime: $b19ca0fdfcbacc57$var$lL,
    primes: $b19ca0fdfcbacc57$var$uL,
    prnap: $b19ca0fdfcbacc57$var$fL,
    prnE: $b19ca0fdfcbacc57$var$pL,
    prnsim: $b19ca0fdfcbacc57$var$hL,
    prod: $b19ca0fdfcbacc57$var$dL,
    Product: $b19ca0fdfcbacc57$var$gL,
    profalar: $b19ca0fdfcbacc57$var$mL,
    profline: $b19ca0fdfcbacc57$var$_L,
    profsurf: $b19ca0fdfcbacc57$var$bL,
    prop: $b19ca0fdfcbacc57$var$vL,
    Proportional: $b19ca0fdfcbacc57$var$kL,
    Proportion: $b19ca0fdfcbacc57$var$xL,
    propto: $b19ca0fdfcbacc57$var$yL,
    prsim: $b19ca0fdfcbacc57$var$EL,
    prurel: $b19ca0fdfcbacc57$var$wL,
    Pscr: $b19ca0fdfcbacc57$var$AL,
    pscr: $b19ca0fdfcbacc57$var$CL,
    Psi: $b19ca0fdfcbacc57$var$SL,
    psi: $b19ca0fdfcbacc57$var$DL,
    puncsp: $b19ca0fdfcbacc57$var$TL,
    Qfr: $b19ca0fdfcbacc57$var$RL,
    qfr: $b19ca0fdfcbacc57$var$LL,
    qint: $b19ca0fdfcbacc57$var$NL,
    qopf: $b19ca0fdfcbacc57$var$qL,
    Qopf: $b19ca0fdfcbacc57$var$ML,
    qprime: $b19ca0fdfcbacc57$var$IL,
    Qscr: $b19ca0fdfcbacc57$var$OL,
    qscr: $b19ca0fdfcbacc57$var$FL,
    quaternions: $b19ca0fdfcbacc57$var$BL,
    quatint: $b19ca0fdfcbacc57$var$PL,
    quest: $b19ca0fdfcbacc57$var$$L,
    questeq: $b19ca0fdfcbacc57$var$zL,
    quot: $b19ca0fdfcbacc57$var$UL,
    QUOT: $b19ca0fdfcbacc57$var$HL,
    rAarr: $b19ca0fdfcbacc57$var$VL,
    race: $b19ca0fdfcbacc57$var$GL,
    Racute: $b19ca0fdfcbacc57$var$jL,
    racute: $b19ca0fdfcbacc57$var$ZL,
    radic: $b19ca0fdfcbacc57$var$KL,
    raemptyv: $b19ca0fdfcbacc57$var$WL,
    rang: $b19ca0fdfcbacc57$var$YL,
    Rang: $b19ca0fdfcbacc57$var$JL,
    rangd: $b19ca0fdfcbacc57$var$XL,
    range: $b19ca0fdfcbacc57$var$QL,
    rangle: $b19ca0fdfcbacc57$var$eN,
    raquo: $b19ca0fdfcbacc57$var$nN,
    rarrap: $b19ca0fdfcbacc57$var$tN,
    rarrb: $b19ca0fdfcbacc57$var$rN,
    rarrbfs: $b19ca0fdfcbacc57$var$oN,
    rarrc: $b19ca0fdfcbacc57$var$sN,
    rarr: $b19ca0fdfcbacc57$var$cN,
    Rarr: $b19ca0fdfcbacc57$var$iN,
    rArr: $b19ca0fdfcbacc57$var$aN,
    rarrfs: $b19ca0fdfcbacc57$var$lN,
    rarrhk: $b19ca0fdfcbacc57$var$uN,
    rarrlp: $b19ca0fdfcbacc57$var$fN,
    rarrpl: $b19ca0fdfcbacc57$var$pN,
    rarrsim: $b19ca0fdfcbacc57$var$hN,
    Rarrtl: $b19ca0fdfcbacc57$var$dN,
    rarrtl: $b19ca0fdfcbacc57$var$gN,
    rarrw: $b19ca0fdfcbacc57$var$mN,
    ratail: $b19ca0fdfcbacc57$var$_N,
    rAtail: $b19ca0fdfcbacc57$var$bN,
    ratio: $b19ca0fdfcbacc57$var$vN,
    rationals: $b19ca0fdfcbacc57$var$kN,
    rbarr: $b19ca0fdfcbacc57$var$xN,
    rBarr: $b19ca0fdfcbacc57$var$yN,
    RBarr: $b19ca0fdfcbacc57$var$EN,
    rbbrk: $b19ca0fdfcbacc57$var$wN,
    rbrace: $b19ca0fdfcbacc57$var$AN,
    rbrack: $b19ca0fdfcbacc57$var$CN,
    rbrke: $b19ca0fdfcbacc57$var$SN,
    rbrksld: $b19ca0fdfcbacc57$var$DN,
    rbrkslu: $b19ca0fdfcbacc57$var$TN,
    Rcaron: $b19ca0fdfcbacc57$var$RN,
    rcaron: $b19ca0fdfcbacc57$var$LN,
    Rcedil: $b19ca0fdfcbacc57$var$NN,
    rcedil: $b19ca0fdfcbacc57$var$qN,
    rceil: $b19ca0fdfcbacc57$var$MN,
    rcub: $b19ca0fdfcbacc57$var$IN,
    Rcy: $b19ca0fdfcbacc57$var$ON,
    rcy: $b19ca0fdfcbacc57$var$FN,
    rdca: $b19ca0fdfcbacc57$var$BN,
    rdldhar: $b19ca0fdfcbacc57$var$PN,
    rdquo: $b19ca0fdfcbacc57$var$$N,
    rdquor: $b19ca0fdfcbacc57$var$zN,
    rdsh: $b19ca0fdfcbacc57$var$UN,
    real: $b19ca0fdfcbacc57$var$HN,
    realine: $b19ca0fdfcbacc57$var$VN,
    realpart: $b19ca0fdfcbacc57$var$GN,
    reals: $b19ca0fdfcbacc57$var$jN,
    Re: $b19ca0fdfcbacc57$var$ZN,
    rect: $b19ca0fdfcbacc57$var$KN,
    reg: $b19ca0fdfcbacc57$var$WN,
    REG: $b19ca0fdfcbacc57$var$YN,
    ReverseElement: $b19ca0fdfcbacc57$var$JN,
    ReverseEquilibrium: $b19ca0fdfcbacc57$var$XN,
    ReverseUpEquilibrium: $b19ca0fdfcbacc57$var$QN,
    rfisht: $b19ca0fdfcbacc57$var$eq,
    rfloor: $b19ca0fdfcbacc57$var$nq,
    rfr: $b19ca0fdfcbacc57$var$tq,
    Rfr: $b19ca0fdfcbacc57$var$rq,
    rHar: $b19ca0fdfcbacc57$var$oq,
    rhard: $b19ca0fdfcbacc57$var$sq,
    rharu: $b19ca0fdfcbacc57$var$cq,
    rharul: $b19ca0fdfcbacc57$var$iq,
    Rho: $b19ca0fdfcbacc57$var$aq,
    rho: $b19ca0fdfcbacc57$var$lq,
    rhov: $b19ca0fdfcbacc57$var$uq,
    RightAngleBracket: $b19ca0fdfcbacc57$var$fq,
    RightArrowBar: $b19ca0fdfcbacc57$var$pq,
    rightarrow: $b19ca0fdfcbacc57$var$hq,
    RightArrow: $b19ca0fdfcbacc57$var$dq,
    Rightarrow: $b19ca0fdfcbacc57$var$gq,
    RightArrowLeftArrow: $b19ca0fdfcbacc57$var$mq,
    rightarrowtail: $b19ca0fdfcbacc57$var$_q,
    RightCeiling: $b19ca0fdfcbacc57$var$bq,
    RightDoubleBracket: $b19ca0fdfcbacc57$var$vq,
    RightDownTeeVector: $b19ca0fdfcbacc57$var$kq,
    RightDownVectorBar: $b19ca0fdfcbacc57$var$xq,
    RightDownVector: $b19ca0fdfcbacc57$var$yq,
    RightFloor: $b19ca0fdfcbacc57$var$Eq,
    rightharpoondown: $b19ca0fdfcbacc57$var$wq,
    rightharpoonup: $b19ca0fdfcbacc57$var$Aq,
    rightleftarrows: $b19ca0fdfcbacc57$var$Cq,
    rightleftharpoons: $b19ca0fdfcbacc57$var$Sq,
    rightrightarrows: $b19ca0fdfcbacc57$var$Dq,
    rightsquigarrow: $b19ca0fdfcbacc57$var$Tq,
    RightTeeArrow: $b19ca0fdfcbacc57$var$Rq,
    RightTee: $b19ca0fdfcbacc57$var$Lq,
    RightTeeVector: $b19ca0fdfcbacc57$var$Nq,
    rightthreetimes: $b19ca0fdfcbacc57$var$qq,
    RightTriangleBar: $b19ca0fdfcbacc57$var$Mq,
    RightTriangle: $b19ca0fdfcbacc57$var$Iq,
    RightTriangleEqual: $b19ca0fdfcbacc57$var$Oq,
    RightUpDownVector: $b19ca0fdfcbacc57$var$Fq,
    RightUpTeeVector: $b19ca0fdfcbacc57$var$Bq,
    RightUpVectorBar: $b19ca0fdfcbacc57$var$Pq,
    RightUpVector: $b19ca0fdfcbacc57$var$$q,
    RightVectorBar: $b19ca0fdfcbacc57$var$zq,
    RightVector: $b19ca0fdfcbacc57$var$Uq,
    ring: $b19ca0fdfcbacc57$var$Hq,
    risingdotseq: $b19ca0fdfcbacc57$var$Vq,
    rlarr: $b19ca0fdfcbacc57$var$Gq,
    rlhar: $b19ca0fdfcbacc57$var$jq,
    rlm: $b19ca0fdfcbacc57$var$Zq,
    rmoustache: $b19ca0fdfcbacc57$var$Kq,
    rmoust: $b19ca0fdfcbacc57$var$Wq,
    rnmid: $b19ca0fdfcbacc57$var$Yq,
    roang: $b19ca0fdfcbacc57$var$Jq,
    roarr: $b19ca0fdfcbacc57$var$Xq,
    robrk: $b19ca0fdfcbacc57$var$Qq,
    ropar: $b19ca0fdfcbacc57$var$eM,
    ropf: $b19ca0fdfcbacc57$var$nM,
    Ropf: $b19ca0fdfcbacc57$var$tM,
    roplus: $b19ca0fdfcbacc57$var$rM,
    rotimes: $b19ca0fdfcbacc57$var$oM,
    RoundImplies: $b19ca0fdfcbacc57$var$sM,
    rpar: $b19ca0fdfcbacc57$var$cM,
    rpargt: $b19ca0fdfcbacc57$var$iM,
    rppolint: $b19ca0fdfcbacc57$var$aM,
    rrarr: $b19ca0fdfcbacc57$var$lM,
    Rrightarrow: $b19ca0fdfcbacc57$var$uM,
    rsaquo: $b19ca0fdfcbacc57$var$fM,
    rscr: $b19ca0fdfcbacc57$var$pM,
    Rscr: $b19ca0fdfcbacc57$var$hM,
    rsh: $b19ca0fdfcbacc57$var$dM,
    Rsh: $b19ca0fdfcbacc57$var$gM,
    rsqb: $b19ca0fdfcbacc57$var$mM,
    rsquo: $b19ca0fdfcbacc57$var$_M,
    rsquor: $b19ca0fdfcbacc57$var$bM,
    rthree: $b19ca0fdfcbacc57$var$vM,
    rtimes: $b19ca0fdfcbacc57$var$kM,
    rtri: $b19ca0fdfcbacc57$var$xM,
    rtrie: $b19ca0fdfcbacc57$var$yM,
    rtrif: $b19ca0fdfcbacc57$var$EM,
    rtriltri: $b19ca0fdfcbacc57$var$wM,
    RuleDelayed: $b19ca0fdfcbacc57$var$AM,
    ruluhar: $b19ca0fdfcbacc57$var$CM,
    rx: $b19ca0fdfcbacc57$var$SM,
    Sacute: $b19ca0fdfcbacc57$var$DM,
    sacute: $b19ca0fdfcbacc57$var$TM,
    sbquo: $b19ca0fdfcbacc57$var$RM,
    scap: $b19ca0fdfcbacc57$var$LM,
    Scaron: $b19ca0fdfcbacc57$var$NM,
    scaron: $b19ca0fdfcbacc57$var$qM,
    Sc: $b19ca0fdfcbacc57$var$MM,
    sc: $b19ca0fdfcbacc57$var$IM,
    sccue: $b19ca0fdfcbacc57$var$OM,
    sce: $b19ca0fdfcbacc57$var$FM,
    scE: $b19ca0fdfcbacc57$var$BM,
    Scedil: $b19ca0fdfcbacc57$var$PM,
    scedil: $b19ca0fdfcbacc57$var$$M,
    Scirc: $b19ca0fdfcbacc57$var$zM,
    scirc: $b19ca0fdfcbacc57$var$UM,
    scnap: $b19ca0fdfcbacc57$var$HM,
    scnE: $b19ca0fdfcbacc57$var$VM,
    scnsim: $b19ca0fdfcbacc57$var$GM,
    scpolint: $b19ca0fdfcbacc57$var$jM,
    scsim: $b19ca0fdfcbacc57$var$ZM,
    Scy: $b19ca0fdfcbacc57$var$KM,
    scy: $b19ca0fdfcbacc57$var$WM,
    sdotb: $b19ca0fdfcbacc57$var$YM,
    sdot: $b19ca0fdfcbacc57$var$JM,
    sdote: $b19ca0fdfcbacc57$var$XM,
    searhk: $b19ca0fdfcbacc57$var$QM,
    searr: $b19ca0fdfcbacc57$var$eI,
    seArr: $b19ca0fdfcbacc57$var$nI,
    searrow: $b19ca0fdfcbacc57$var$tI,
    sect: $b19ca0fdfcbacc57$var$rI,
    semi: $b19ca0fdfcbacc57$var$oI,
    seswar: $b19ca0fdfcbacc57$var$sI,
    setminus: $b19ca0fdfcbacc57$var$cI,
    setmn: $b19ca0fdfcbacc57$var$iI,
    sext: $b19ca0fdfcbacc57$var$aI,
    Sfr: $b19ca0fdfcbacc57$var$lI,
    sfr: $b19ca0fdfcbacc57$var$uI,
    sfrown: $b19ca0fdfcbacc57$var$fI,
    sharp: $b19ca0fdfcbacc57$var$pI,
    SHCHcy: $b19ca0fdfcbacc57$var$hI,
    shchcy: $b19ca0fdfcbacc57$var$dI,
    SHcy: $b19ca0fdfcbacc57$var$gI,
    shcy: $b19ca0fdfcbacc57$var$mI,
    ShortDownArrow: $b19ca0fdfcbacc57$var$_I,
    ShortLeftArrow: $b19ca0fdfcbacc57$var$bI,
    shortmid: $b19ca0fdfcbacc57$var$vI,
    shortparallel: $b19ca0fdfcbacc57$var$kI,
    ShortRightArrow: $b19ca0fdfcbacc57$var$xI,
    ShortUpArrow: $b19ca0fdfcbacc57$var$yI,
    shy: $b19ca0fdfcbacc57$var$EI,
    Sigma: $b19ca0fdfcbacc57$var$wI,
    sigma: $b19ca0fdfcbacc57$var$AI,
    sigmaf: $b19ca0fdfcbacc57$var$CI,
    sigmav: $b19ca0fdfcbacc57$var$SI,
    sim: $b19ca0fdfcbacc57$var$DI,
    simdot: $b19ca0fdfcbacc57$var$TI,
    sime: $b19ca0fdfcbacc57$var$RI,
    simeq: $b19ca0fdfcbacc57$var$LI,
    simg: $b19ca0fdfcbacc57$var$NI,
    simgE: $b19ca0fdfcbacc57$var$qI,
    siml: $b19ca0fdfcbacc57$var$MI,
    simlE: $b19ca0fdfcbacc57$var$II,
    simne: $b19ca0fdfcbacc57$var$OI,
    simplus: $b19ca0fdfcbacc57$var$FI,
    simrarr: $b19ca0fdfcbacc57$var$BI,
    slarr: $b19ca0fdfcbacc57$var$PI,
    SmallCircle: $b19ca0fdfcbacc57$var$$I,
    smallsetminus: $b19ca0fdfcbacc57$var$zI,
    smashp: $b19ca0fdfcbacc57$var$UI,
    smeparsl: $b19ca0fdfcbacc57$var$HI,
    smid: $b19ca0fdfcbacc57$var$VI,
    smile: $b19ca0fdfcbacc57$var$GI,
    smt: $b19ca0fdfcbacc57$var$jI,
    smte: $b19ca0fdfcbacc57$var$ZI,
    smtes: $b19ca0fdfcbacc57$var$KI,
    SOFTcy: $b19ca0fdfcbacc57$var$WI,
    softcy: $b19ca0fdfcbacc57$var$YI,
    solbar: $b19ca0fdfcbacc57$var$JI,
    solb: $b19ca0fdfcbacc57$var$XI,
    sol: $b19ca0fdfcbacc57$var$QI,
    Sopf: $b19ca0fdfcbacc57$var$eO,
    sopf: $b19ca0fdfcbacc57$var$nO,
    spades: $b19ca0fdfcbacc57$var$tO,
    spadesuit: $b19ca0fdfcbacc57$var$rO,
    spar: $b19ca0fdfcbacc57$var$oO,
    sqcap: $b19ca0fdfcbacc57$var$sO,
    sqcaps: $b19ca0fdfcbacc57$var$cO,
    sqcup: $b19ca0fdfcbacc57$var$iO,
    sqcups: $b19ca0fdfcbacc57$var$aO,
    Sqrt: $b19ca0fdfcbacc57$var$lO,
    sqsub: $b19ca0fdfcbacc57$var$uO,
    sqsube: $b19ca0fdfcbacc57$var$fO,
    sqsubset: $b19ca0fdfcbacc57$var$pO,
    sqsubseteq: $b19ca0fdfcbacc57$var$hO,
    sqsup: $b19ca0fdfcbacc57$var$dO,
    sqsupe: $b19ca0fdfcbacc57$var$gO,
    sqsupset: $b19ca0fdfcbacc57$var$mO,
    sqsupseteq: $b19ca0fdfcbacc57$var$_O,
    square: $b19ca0fdfcbacc57$var$bO,
    Square: $b19ca0fdfcbacc57$var$vO,
    SquareIntersection: $b19ca0fdfcbacc57$var$kO,
    SquareSubset: $b19ca0fdfcbacc57$var$xO,
    SquareSubsetEqual: $b19ca0fdfcbacc57$var$yO,
    SquareSuperset: $b19ca0fdfcbacc57$var$EO,
    SquareSupersetEqual: $b19ca0fdfcbacc57$var$wO,
    SquareUnion: $b19ca0fdfcbacc57$var$AO,
    squarf: $b19ca0fdfcbacc57$var$CO,
    squ: $b19ca0fdfcbacc57$var$SO,
    squf: $b19ca0fdfcbacc57$var$DO,
    srarr: $b19ca0fdfcbacc57$var$TO,
    Sscr: $b19ca0fdfcbacc57$var$RO,
    sscr: $b19ca0fdfcbacc57$var$LO,
    ssetmn: $b19ca0fdfcbacc57$var$NO,
    ssmile: $b19ca0fdfcbacc57$var$qO,
    sstarf: $b19ca0fdfcbacc57$var$MO,
    Star: $b19ca0fdfcbacc57$var$IO,
    star: $b19ca0fdfcbacc57$var$OO,
    starf: $b19ca0fdfcbacc57$var$FO,
    straightepsilon: $b19ca0fdfcbacc57$var$BO,
    straightphi: $b19ca0fdfcbacc57$var$PO,
    strns: $b19ca0fdfcbacc57$var$$O,
    sub: $b19ca0fdfcbacc57$var$zO,
    Sub: $b19ca0fdfcbacc57$var$UO,
    subdot: $b19ca0fdfcbacc57$var$HO,
    subE: $b19ca0fdfcbacc57$var$VO,
    sube: $b19ca0fdfcbacc57$var$GO,
    subedot: $b19ca0fdfcbacc57$var$jO,
    submult: $b19ca0fdfcbacc57$var$ZO,
    subnE: $b19ca0fdfcbacc57$var$KO,
    subne: $b19ca0fdfcbacc57$var$WO,
    subplus: $b19ca0fdfcbacc57$var$YO,
    subrarr: $b19ca0fdfcbacc57$var$JO,
    subset: $b19ca0fdfcbacc57$var$XO,
    Subset: $b19ca0fdfcbacc57$var$QO,
    subseteq: $b19ca0fdfcbacc57$var$eF,
    subseteqq: $b19ca0fdfcbacc57$var$nF,
    SubsetEqual: $b19ca0fdfcbacc57$var$tF,
    subsetneq: $b19ca0fdfcbacc57$var$rF,
    subsetneqq: $b19ca0fdfcbacc57$var$oF,
    subsim: $b19ca0fdfcbacc57$var$sF,
    subsub: $b19ca0fdfcbacc57$var$cF,
    subsup: $b19ca0fdfcbacc57$var$iF,
    succapprox: $b19ca0fdfcbacc57$var$aF,
    succ: $b19ca0fdfcbacc57$var$lF,
    succcurlyeq: $b19ca0fdfcbacc57$var$uF,
    Succeeds: $b19ca0fdfcbacc57$var$fF,
    SucceedsEqual: $b19ca0fdfcbacc57$var$pF,
    SucceedsSlantEqual: $b19ca0fdfcbacc57$var$hF,
    SucceedsTilde: $b19ca0fdfcbacc57$var$dF,
    succeq: $b19ca0fdfcbacc57$var$gF,
    succnapprox: $b19ca0fdfcbacc57$var$mF,
    succneqq: $b19ca0fdfcbacc57$var$_F,
    succnsim: $b19ca0fdfcbacc57$var$bF,
    succsim: $b19ca0fdfcbacc57$var$vF,
    SuchThat: $b19ca0fdfcbacc57$var$kF,
    sum: $b19ca0fdfcbacc57$var$xF,
    Sum: $b19ca0fdfcbacc57$var$yF,
    sung: $b19ca0fdfcbacc57$var$EF,
    sup1: $b19ca0fdfcbacc57$var$wF,
    sup2: $b19ca0fdfcbacc57$var$AF,
    sup3: $b19ca0fdfcbacc57$var$CF,
    sup: $b19ca0fdfcbacc57$var$SF,
    Sup: $b19ca0fdfcbacc57$var$DF,
    supdot: $b19ca0fdfcbacc57$var$TF,
    supdsub: $b19ca0fdfcbacc57$var$RF,
    supE: $b19ca0fdfcbacc57$var$LF,
    supe: $b19ca0fdfcbacc57$var$NF,
    supedot: $b19ca0fdfcbacc57$var$qF,
    Superset: $b19ca0fdfcbacc57$var$MF,
    SupersetEqual: $b19ca0fdfcbacc57$var$IF,
    suphsol: $b19ca0fdfcbacc57$var$OF,
    suphsub: $b19ca0fdfcbacc57$var$FF,
    suplarr: $b19ca0fdfcbacc57$var$BF,
    supmult: $b19ca0fdfcbacc57$var$PF,
    supnE: $b19ca0fdfcbacc57$var$$F,
    supne: $b19ca0fdfcbacc57$var$zF,
    supplus: $b19ca0fdfcbacc57$var$UF,
    supset: $b19ca0fdfcbacc57$var$HF,
    Supset: $b19ca0fdfcbacc57$var$VF,
    supseteq: $b19ca0fdfcbacc57$var$GF,
    supseteqq: $b19ca0fdfcbacc57$var$jF,
    supsetneq: $b19ca0fdfcbacc57$var$ZF,
    supsetneqq: $b19ca0fdfcbacc57$var$KF,
    supsim: $b19ca0fdfcbacc57$var$WF,
    supsub: $b19ca0fdfcbacc57$var$YF,
    supsup: $b19ca0fdfcbacc57$var$JF,
    swarhk: $b19ca0fdfcbacc57$var$XF,
    swarr: $b19ca0fdfcbacc57$var$QF,
    swArr: $b19ca0fdfcbacc57$var$eB,
    swarrow: $b19ca0fdfcbacc57$var$nB,
    swnwar: $b19ca0fdfcbacc57$var$tB,
    szlig: $b19ca0fdfcbacc57$var$rB,
    Tab: $b19ca0fdfcbacc57$var$oB,
    target: $b19ca0fdfcbacc57$var$sB,
    Tau: $b19ca0fdfcbacc57$var$cB,
    tau: $b19ca0fdfcbacc57$var$iB,
    tbrk: $b19ca0fdfcbacc57$var$aB,
    Tcaron: $b19ca0fdfcbacc57$var$lB,
    tcaron: $b19ca0fdfcbacc57$var$uB,
    Tcedil: $b19ca0fdfcbacc57$var$fB,
    tcedil: $b19ca0fdfcbacc57$var$pB,
    Tcy: $b19ca0fdfcbacc57$var$hB,
    tcy: $b19ca0fdfcbacc57$var$dB,
    tdot: $b19ca0fdfcbacc57$var$gB,
    telrec: $b19ca0fdfcbacc57$var$mB,
    Tfr: $b19ca0fdfcbacc57$var$_B,
    tfr: $b19ca0fdfcbacc57$var$bB,
    there4: $b19ca0fdfcbacc57$var$vB,
    therefore: $b19ca0fdfcbacc57$var$kB,
    Therefore: $b19ca0fdfcbacc57$var$xB,
    Theta: $b19ca0fdfcbacc57$var$yB,
    theta: $b19ca0fdfcbacc57$var$EB,
    thetasym: $b19ca0fdfcbacc57$var$wB,
    thetav: $b19ca0fdfcbacc57$var$AB,
    thickapprox: $b19ca0fdfcbacc57$var$CB,
    thicksim: $b19ca0fdfcbacc57$var$SB,
    ThickSpace: $b19ca0fdfcbacc57$var$DB,
    ThinSpace: $b19ca0fdfcbacc57$var$TB,
    thinsp: $b19ca0fdfcbacc57$var$RB,
    thkap: $b19ca0fdfcbacc57$var$LB,
    thksim: $b19ca0fdfcbacc57$var$NB,
    THORN: $b19ca0fdfcbacc57$var$qB,
    thorn: $b19ca0fdfcbacc57$var$MB,
    tilde: $b19ca0fdfcbacc57$var$IB,
    Tilde: $b19ca0fdfcbacc57$var$OB,
    TildeEqual: $b19ca0fdfcbacc57$var$FB,
    TildeFullEqual: $b19ca0fdfcbacc57$var$BB,
    TildeTilde: $b19ca0fdfcbacc57$var$PB,
    timesbar: $b19ca0fdfcbacc57$var$$B,
    timesb: $b19ca0fdfcbacc57$var$zB,
    times: $b19ca0fdfcbacc57$var$UB,
    timesd: $b19ca0fdfcbacc57$var$HB,
    tint: $b19ca0fdfcbacc57$var$VB,
    toea: $b19ca0fdfcbacc57$var$GB,
    topbot: $b19ca0fdfcbacc57$var$jB,
    topcir: $b19ca0fdfcbacc57$var$ZB,
    top: $b19ca0fdfcbacc57$var$KB,
    Topf: $b19ca0fdfcbacc57$var$WB,
    topf: $b19ca0fdfcbacc57$var$YB,
    topfork: $b19ca0fdfcbacc57$var$JB,
    tosa: $b19ca0fdfcbacc57$var$XB,
    tprime: $b19ca0fdfcbacc57$var$QB,
    trade: $b19ca0fdfcbacc57$var$eP,
    TRADE: $b19ca0fdfcbacc57$var$nP,
    triangle: $b19ca0fdfcbacc57$var$tP,
    triangledown: $b19ca0fdfcbacc57$var$rP,
    triangleleft: $b19ca0fdfcbacc57$var$oP,
    trianglelefteq: $b19ca0fdfcbacc57$var$sP,
    triangleq: $b19ca0fdfcbacc57$var$cP,
    triangleright: $b19ca0fdfcbacc57$var$iP,
    trianglerighteq: $b19ca0fdfcbacc57$var$aP,
    tridot: $b19ca0fdfcbacc57$var$lP,
    trie: $b19ca0fdfcbacc57$var$uP,
    triminus: $b19ca0fdfcbacc57$var$fP,
    TripleDot: $b19ca0fdfcbacc57$var$pP,
    triplus: $b19ca0fdfcbacc57$var$hP,
    trisb: $b19ca0fdfcbacc57$var$dP,
    tritime: $b19ca0fdfcbacc57$var$gP,
    trpezium: $b19ca0fdfcbacc57$var$mP,
    Tscr: $b19ca0fdfcbacc57$var$_P,
    tscr: $b19ca0fdfcbacc57$var$bP,
    TScy: $b19ca0fdfcbacc57$var$vP,
    tscy: $b19ca0fdfcbacc57$var$kP,
    TSHcy: $b19ca0fdfcbacc57$var$xP,
    tshcy: $b19ca0fdfcbacc57$var$yP,
    Tstrok: $b19ca0fdfcbacc57$var$EP,
    tstrok: $b19ca0fdfcbacc57$var$wP,
    twixt: $b19ca0fdfcbacc57$var$AP,
    twoheadleftarrow: $b19ca0fdfcbacc57$var$CP,
    twoheadrightarrow: $b19ca0fdfcbacc57$var$SP,
    Uacute: $b19ca0fdfcbacc57$var$DP,
    uacute: $b19ca0fdfcbacc57$var$TP,
    uarr: $b19ca0fdfcbacc57$var$RP,
    Uarr: $b19ca0fdfcbacc57$var$LP,
    uArr: $b19ca0fdfcbacc57$var$NP,
    Uarrocir: $b19ca0fdfcbacc57$var$qP,
    Ubrcy: $b19ca0fdfcbacc57$var$MP,
    ubrcy: $b19ca0fdfcbacc57$var$IP,
    Ubreve: $b19ca0fdfcbacc57$var$OP,
    ubreve: $b19ca0fdfcbacc57$var$FP,
    Ucirc: $b19ca0fdfcbacc57$var$BP,
    ucirc: $b19ca0fdfcbacc57$var$PP,
    Ucy: $b19ca0fdfcbacc57$var$$P,
    ucy: $b19ca0fdfcbacc57$var$zP,
    udarr: $b19ca0fdfcbacc57$var$UP,
    Udblac: $b19ca0fdfcbacc57$var$HP,
    udblac: $b19ca0fdfcbacc57$var$VP,
    udhar: $b19ca0fdfcbacc57$var$GP,
    ufisht: $b19ca0fdfcbacc57$var$jP,
    Ufr: $b19ca0fdfcbacc57$var$ZP,
    ufr: $b19ca0fdfcbacc57$var$KP,
    Ugrave: $b19ca0fdfcbacc57$var$WP,
    ugrave: $b19ca0fdfcbacc57$var$YP,
    uHar: $b19ca0fdfcbacc57$var$JP,
    uharl: $b19ca0fdfcbacc57$var$XP,
    uharr: $b19ca0fdfcbacc57$var$QP,
    uhblk: $b19ca0fdfcbacc57$var$e$,
    ulcorn: $b19ca0fdfcbacc57$var$n$,
    ulcorner: $b19ca0fdfcbacc57$var$t$,
    ulcrop: $b19ca0fdfcbacc57$var$r$,
    ultri: $b19ca0fdfcbacc57$var$o$,
    Umacr: $b19ca0fdfcbacc57$var$s$,
    umacr: $b19ca0fdfcbacc57$var$c$,
    uml: $b19ca0fdfcbacc57$var$i$,
    UnderBar: $b19ca0fdfcbacc57$var$a$,
    UnderBrace: $b19ca0fdfcbacc57$var$l$,
    UnderBracket: $b19ca0fdfcbacc57$var$u$,
    UnderParenthesis: $b19ca0fdfcbacc57$var$f$,
    Union: $b19ca0fdfcbacc57$var$p$,
    UnionPlus: $b19ca0fdfcbacc57$var$h$,
    Uogon: $b19ca0fdfcbacc57$var$d$,
    uogon: $b19ca0fdfcbacc57$var$g$,
    Uopf: $b19ca0fdfcbacc57$var$m$,
    uopf: $b19ca0fdfcbacc57$var$_$,
    UpArrowBar: $b19ca0fdfcbacc57$var$b$,
    uparrow: $b19ca0fdfcbacc57$var$v$,
    UpArrow: $b19ca0fdfcbacc57$var$k$,
    Uparrow: $b19ca0fdfcbacc57$var$x$,
    UpArrowDownArrow: $b19ca0fdfcbacc57$var$y$,
    updownarrow: $b19ca0fdfcbacc57$var$E$,
    UpDownArrow: $b19ca0fdfcbacc57$var$w$,
    Updownarrow: $b19ca0fdfcbacc57$var$A$,
    UpEquilibrium: $b19ca0fdfcbacc57$var$C$,
    upharpoonleft: $b19ca0fdfcbacc57$var$S$,
    upharpoonright: $b19ca0fdfcbacc57$var$D$,
    uplus: $b19ca0fdfcbacc57$var$T$,
    UpperLeftArrow: $b19ca0fdfcbacc57$var$R$,
    UpperRightArrow: $b19ca0fdfcbacc57$var$L$,
    upsi: $b19ca0fdfcbacc57$var$N$,
    Upsi: $b19ca0fdfcbacc57$var$q$,
    upsih: $b19ca0fdfcbacc57$var$M$,
    Upsilon: $b19ca0fdfcbacc57$var$I$,
    upsilon: $b19ca0fdfcbacc57$var$O$,
    UpTeeArrow: $b19ca0fdfcbacc57$var$F$,
    UpTee: $b19ca0fdfcbacc57$var$B$,
    upuparrows: $b19ca0fdfcbacc57$var$P$,
    urcorn: $b19ca0fdfcbacc57$var$$$,
    urcorner: $b19ca0fdfcbacc57$var$z$,
    urcrop: $b19ca0fdfcbacc57$var$U$,
    Uring: $b19ca0fdfcbacc57$var$H$,
    uring: $b19ca0fdfcbacc57$var$V$,
    urtri: $b19ca0fdfcbacc57$var$G$,
    Uscr: $b19ca0fdfcbacc57$var$j$,
    uscr: $b19ca0fdfcbacc57$var$Z$,
    utdot: $b19ca0fdfcbacc57$var$K$,
    Utilde: $b19ca0fdfcbacc57$var$W$,
    utilde: $b19ca0fdfcbacc57$var$Y$,
    utri: $b19ca0fdfcbacc57$var$J$,
    utrif: $b19ca0fdfcbacc57$var$X$,
    uuarr: $b19ca0fdfcbacc57$var$Q$,
    Uuml: $b19ca0fdfcbacc57$var$ez,
    uuml: $b19ca0fdfcbacc57$var$nz,
    uwangle: $b19ca0fdfcbacc57$var$tz,
    vangrt: $b19ca0fdfcbacc57$var$rz,
    varepsilon: $b19ca0fdfcbacc57$var$oz,
    varkappa: $b19ca0fdfcbacc57$var$sz,
    varnothing: $b19ca0fdfcbacc57$var$cz,
    varphi: $b19ca0fdfcbacc57$var$iz,
    varpi: $b19ca0fdfcbacc57$var$az,
    varpropto: $b19ca0fdfcbacc57$var$lz,
    varr: $b19ca0fdfcbacc57$var$uz,
    vArr: $b19ca0fdfcbacc57$var$fz,
    varrho: $b19ca0fdfcbacc57$var$pz,
    varsigma: $b19ca0fdfcbacc57$var$hz,
    varsubsetneq: $b19ca0fdfcbacc57$var$dz,
    varsubsetneqq: $b19ca0fdfcbacc57$var$gz,
    varsupsetneq: $b19ca0fdfcbacc57$var$mz,
    varsupsetneqq: $b19ca0fdfcbacc57$var$_z,
    vartheta: $b19ca0fdfcbacc57$var$bz,
    vartriangleleft: $b19ca0fdfcbacc57$var$vz,
    vartriangleright: $b19ca0fdfcbacc57$var$kz,
    vBar: $b19ca0fdfcbacc57$var$xz,
    Vbar: $b19ca0fdfcbacc57$var$yz,
    vBarv: $b19ca0fdfcbacc57$var$Ez,
    Vcy: $b19ca0fdfcbacc57$var$wz,
    vcy: $b19ca0fdfcbacc57$var$Az,
    vdash: $b19ca0fdfcbacc57$var$Cz,
    vDash: $b19ca0fdfcbacc57$var$Sz,
    Vdash: $b19ca0fdfcbacc57$var$Dz,
    VDash: $b19ca0fdfcbacc57$var$Tz,
    Vdashl: $b19ca0fdfcbacc57$var$Rz,
    veebar: $b19ca0fdfcbacc57$var$Lz,
    vee: $b19ca0fdfcbacc57$var$Nz,
    Vee: $b19ca0fdfcbacc57$var$qz,
    veeeq: $b19ca0fdfcbacc57$var$Mz,
    vellip: $b19ca0fdfcbacc57$var$Iz,
    verbar: $b19ca0fdfcbacc57$var$Oz,
    Verbar: $b19ca0fdfcbacc57$var$Fz,
    vert: $b19ca0fdfcbacc57$var$Bz,
    Vert: $b19ca0fdfcbacc57$var$Pz,
    VerticalBar: $b19ca0fdfcbacc57$var$$z,
    VerticalLine: $b19ca0fdfcbacc57$var$zz,
    VerticalSeparator: $b19ca0fdfcbacc57$var$Uz,
    VerticalTilde: $b19ca0fdfcbacc57$var$Hz,
    VeryThinSpace: $b19ca0fdfcbacc57$var$Vz,
    Vfr: $b19ca0fdfcbacc57$var$Gz,
    vfr: $b19ca0fdfcbacc57$var$jz,
    vltri: $b19ca0fdfcbacc57$var$Zz,
    vnsub: $b19ca0fdfcbacc57$var$Kz,
    vnsup: $b19ca0fdfcbacc57$var$Wz,
    Vopf: $b19ca0fdfcbacc57$var$Yz,
    vopf: $b19ca0fdfcbacc57$var$Jz,
    vprop: $b19ca0fdfcbacc57$var$Xz,
    vrtri: $b19ca0fdfcbacc57$var$Qz,
    Vscr: $b19ca0fdfcbacc57$var$e3,
    vscr: $b19ca0fdfcbacc57$var$n3,
    vsubnE: $b19ca0fdfcbacc57$var$t3,
    vsubne: $b19ca0fdfcbacc57$var$r3,
    vsupnE: $b19ca0fdfcbacc57$var$o3,
    vsupne: $b19ca0fdfcbacc57$var$s3,
    Vvdash: $b19ca0fdfcbacc57$var$c3,
    vzigzag: $b19ca0fdfcbacc57$var$i3,
    Wcirc: $b19ca0fdfcbacc57$var$a3,
    wcirc: $b19ca0fdfcbacc57$var$l3,
    wedbar: $b19ca0fdfcbacc57$var$u3,
    wedge: $b19ca0fdfcbacc57$var$f3,
    Wedge: $b19ca0fdfcbacc57$var$p3,
    wedgeq: $b19ca0fdfcbacc57$var$h3,
    weierp: $b19ca0fdfcbacc57$var$d3,
    Wfr: $b19ca0fdfcbacc57$var$g3,
    wfr: $b19ca0fdfcbacc57$var$m3,
    Wopf: $b19ca0fdfcbacc57$var$_3,
    wopf: $b19ca0fdfcbacc57$var$b3,
    wp: $b19ca0fdfcbacc57$var$v3,
    wr: $b19ca0fdfcbacc57$var$k3,
    wreath: $b19ca0fdfcbacc57$var$x3,
    Wscr: $b19ca0fdfcbacc57$var$y3,
    wscr: $b19ca0fdfcbacc57$var$E3,
    xcap: $b19ca0fdfcbacc57$var$w3,
    xcirc: $b19ca0fdfcbacc57$var$A3,
    xcup: $b19ca0fdfcbacc57$var$C3,
    xdtri: $b19ca0fdfcbacc57$var$S3,
    Xfr: $b19ca0fdfcbacc57$var$D3,
    xfr: $b19ca0fdfcbacc57$var$T3,
    xharr: $b19ca0fdfcbacc57$var$R3,
    xhArr: $b19ca0fdfcbacc57$var$L3,
    Xi: $b19ca0fdfcbacc57$var$N3,
    xi: $b19ca0fdfcbacc57$var$q3,
    xlarr: $b19ca0fdfcbacc57$var$M3,
    xlArr: $b19ca0fdfcbacc57$var$I3,
    xmap: $b19ca0fdfcbacc57$var$O3,
    xnis: $b19ca0fdfcbacc57$var$F3,
    xodot: $b19ca0fdfcbacc57$var$B3,
    Xopf: $b19ca0fdfcbacc57$var$P3,
    xopf: $b19ca0fdfcbacc57$var$$3,
    xoplus: $b19ca0fdfcbacc57$var$z3,
    xotime: $b19ca0fdfcbacc57$var$U3,
    xrarr: $b19ca0fdfcbacc57$var$H3,
    xrArr: $b19ca0fdfcbacc57$var$V3,
    Xscr: $b19ca0fdfcbacc57$var$G3,
    xscr: $b19ca0fdfcbacc57$var$j3,
    xsqcup: $b19ca0fdfcbacc57$var$Z3,
    xuplus: $b19ca0fdfcbacc57$var$K3,
    xutri: $b19ca0fdfcbacc57$var$W3,
    xvee: $b19ca0fdfcbacc57$var$Y3,
    xwedge: $b19ca0fdfcbacc57$var$J3,
    Yacute: $b19ca0fdfcbacc57$var$X3,
    yacute: $b19ca0fdfcbacc57$var$Q3,
    YAcy: $b19ca0fdfcbacc57$var$eU,
    yacy: $b19ca0fdfcbacc57$var$nU,
    Ycirc: $b19ca0fdfcbacc57$var$tU,
    ycirc: $b19ca0fdfcbacc57$var$rU,
    Ycy: $b19ca0fdfcbacc57$var$oU,
    ycy: $b19ca0fdfcbacc57$var$sU,
    yen: $b19ca0fdfcbacc57$var$cU,
    Yfr: $b19ca0fdfcbacc57$var$iU,
    yfr: $b19ca0fdfcbacc57$var$aU,
    YIcy: $b19ca0fdfcbacc57$var$lU,
    yicy: $b19ca0fdfcbacc57$var$uU,
    Yopf: $b19ca0fdfcbacc57$var$fU,
    yopf: $b19ca0fdfcbacc57$var$pU,
    Yscr: $b19ca0fdfcbacc57$var$hU,
    yscr: $b19ca0fdfcbacc57$var$dU,
    YUcy: $b19ca0fdfcbacc57$var$gU,
    yucy: $b19ca0fdfcbacc57$var$mU,
    yuml: $b19ca0fdfcbacc57$var$_U,
    Yuml: $b19ca0fdfcbacc57$var$bU,
    Zacute: $b19ca0fdfcbacc57$var$vU,
    zacute: $b19ca0fdfcbacc57$var$kU,
    Zcaron: $b19ca0fdfcbacc57$var$xU,
    zcaron: $b19ca0fdfcbacc57$var$yU,
    Zcy: $b19ca0fdfcbacc57$var$EU,
    zcy: $b19ca0fdfcbacc57$var$wU,
    Zdot: $b19ca0fdfcbacc57$var$AU,
    zdot: $b19ca0fdfcbacc57$var$CU,
    zeetrf: $b19ca0fdfcbacc57$var$SU,
    ZeroWidthSpace: $b19ca0fdfcbacc57$var$DU,
    Zeta: $b19ca0fdfcbacc57$var$TU,
    zeta: $b19ca0fdfcbacc57$var$RU,
    zfr: $b19ca0fdfcbacc57$var$LU,
    Zfr: $b19ca0fdfcbacc57$var$NU,
    ZHcy: $b19ca0fdfcbacc57$var$qU,
    zhcy: $b19ca0fdfcbacc57$var$MU,
    zigrarr: $b19ca0fdfcbacc57$var$IU,
    zopf: $b19ca0fdfcbacc57$var$OU,
    Zopf: $b19ca0fdfcbacc57$var$FU,
    Zscr: $b19ca0fdfcbacc57$var$BU,
    zscr: $b19ca0fdfcbacc57$var$PU,
    zwj: $b19ca0fdfcbacc57$var$$U,
    zwnj: $b19ca0fdfcbacc57$var$zU
};
var $b19ca0fdfcbacc57$var$zr = $b19ca0fdfcbacc57$var$UU, $b19ca0fdfcbacc57$var$Jn = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, $b19ca0fdfcbacc57$var$Me = {}, $b19ca0fdfcbacc57$var$wt = {};
function $b19ca0fdfcbacc57$var$HU(n) {
    var e, t, r = $b19ca0fdfcbacc57$var$wt[n];
    if (r) return r;
    for(r = $b19ca0fdfcbacc57$var$wt[n] = [], e = 0; e < 128; e++)t = String.fromCharCode(e), /^[0-9a-z]$/i.test(t) ? r.push(t) : r.push("%" + ("0" + e.toString(16).toUpperCase()).slice(-2));
    for(e = 0; e < n.length; e++)r[n.charCodeAt(e)] = n[e];
    return r;
}
function $b19ca0fdfcbacc57$var$pn(n, e, t) {
    var r, o, s, i, c, a = "";
    for(typeof e != "string" && (t = e, e = $b19ca0fdfcbacc57$var$pn.defaultChars), typeof t > "u" && (t = !0), c = $b19ca0fdfcbacc57$var$HU(e), r = 0, o = n.length; r < o; r++){
        if (s = n.charCodeAt(r), t && s === 37 && r + 2 < o && /^[0-9a-f]{2}$/i.test(n.slice(r + 1, r + 3))) {
            a += n.slice(r, r + 3), r += 2;
            continue;
        }
        if (s < 128) {
            a += c[s];
            continue;
        }
        if (s >= 55296 && s <= 57343) {
            if (s >= 55296 && s <= 56319 && r + 1 < o && (i = n.charCodeAt(r + 1), i >= 56320 && i <= 57343)) {
                a += encodeURIComponent(n[r] + n[r + 1]), r++;
                continue;
            }
            a += "%EF%BF%BD";
            continue;
        }
        a += encodeURIComponent(n[r]);
    }
    return a;
}
$b19ca0fdfcbacc57$var$pn.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$b19ca0fdfcbacc57$var$pn.componentChars = "-_.!~*'()";
var $b19ca0fdfcbacc57$var$VU = $b19ca0fdfcbacc57$var$pn, $b19ca0fdfcbacc57$var$At = {};
function $b19ca0fdfcbacc57$var$GU(n) {
    var e, t, r = $b19ca0fdfcbacc57$var$At[n];
    if (r) return r;
    for(r = $b19ca0fdfcbacc57$var$At[n] = [], e = 0; e < 128; e++)t = String.fromCharCode(e), r.push(t);
    for(e = 0; e < n.length; e++)t = n.charCodeAt(e), r[t] = "%" + ("0" + t.toString(16).toUpperCase()).slice(-2);
    return r;
}
function $b19ca0fdfcbacc57$var$hn(n, e) {
    var t;
    return typeof e != "string" && (e = $b19ca0fdfcbacc57$var$hn.defaultChars), t = $b19ca0fdfcbacc57$var$GU(e), n.replace(/(%[a-f0-9]{2})+/gi, function(r) {
        var o, s, i, c, a, l, u, p = "";
        for(o = 0, s = r.length; o < s; o += 3){
            if (i = parseInt(r.slice(o + 1, o + 3), 16), i < 128) {
                p += t[i];
                continue;
            }
            if ((i & 224) === 192 && o + 3 < s && (c = parseInt(r.slice(o + 4, o + 6), 16), (c & 192) === 128)) {
                u = i << 6 & 1984 | c & 63, u < 128 ? p += "\uFFFD\uFFFD" : p += String.fromCharCode(u), o += 3;
                continue;
            }
            if ((i & 240) === 224 && o + 6 < s && (c = parseInt(r.slice(o + 4, o + 6), 16), a = parseInt(r.slice(o + 7, o + 9), 16), (c & 192) === 128 && (a & 192) === 128)) {
                u = i << 12 & 61440 | c << 6 & 4032 | a & 63, u < 2048 || u >= 55296 && u <= 57343 ? p += "\uFFFD\uFFFD\uFFFD" : p += String.fromCharCode(u), o += 6;
                continue;
            }
            if ((i & 248) === 240 && o + 9 < s && (c = parseInt(r.slice(o + 4, o + 6), 16), a = parseInt(r.slice(o + 7, o + 9), 16), l = parseInt(r.slice(o + 10, o + 12), 16), (c & 192) === 128 && (a & 192) === 128 && (l & 192) === 128)) {
                u = i << 18 & 1835008 | c << 12 & 258048 | a << 6 & 4032 | l & 63, u < 65536 || u > 1114111 ? p += "\uFFFD\uFFFD\uFFFD\uFFFD" : (u -= 65536, p += String.fromCharCode(55296 + (u >> 10), 56320 + (u & 1023))), o += 9;
                continue;
            }
            p += "\uFFFD";
        }
        return p;
    });
}
$b19ca0fdfcbacc57$var$hn.defaultChars = ";/?:@&=+$,#";
$b19ca0fdfcbacc57$var$hn.componentChars = "";
var $b19ca0fdfcbacc57$var$jU = $b19ca0fdfcbacc57$var$hn, $b19ca0fdfcbacc57$var$ZU = function(e) {
    var t = "";
    return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
};
function $b19ca0fdfcbacc57$var$cn() {
    this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
var $b19ca0fdfcbacc57$var$KU = /^([a-z0-9.+-]+:)/i, $b19ca0fdfcbacc57$var$WU = /:[0-9]*$/, $b19ca0fdfcbacc57$var$YU = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, $b19ca0fdfcbacc57$var$JU = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
], $b19ca0fdfcbacc57$var$XU = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($b19ca0fdfcbacc57$var$JU), $b19ca0fdfcbacc57$var$QU = [
    "'"
].concat($b19ca0fdfcbacc57$var$XU), $b19ca0fdfcbacc57$var$Ct = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($b19ca0fdfcbacc57$var$QU), $b19ca0fdfcbacc57$var$St = [
    "/",
    "?",
    "#"
], $b19ca0fdfcbacc57$var$e9 = 255, $b19ca0fdfcbacc57$var$Dt = /^[+a-z0-9A-Z_-]{0,63}$/, $b19ca0fdfcbacc57$var$n9 = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, $b19ca0fdfcbacc57$var$Tt = {
    javascript: !0,
    "javascript:": !0
}, $b19ca0fdfcbacc57$var$Rt = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
};
function $b19ca0fdfcbacc57$var$t9(n, e) {
    if (n && n instanceof $b19ca0fdfcbacc57$var$cn) return n;
    var t = new $b19ca0fdfcbacc57$var$cn();
    return t.parse(n, e), t;
}
$b19ca0fdfcbacc57$var$cn.prototype.parse = function(n, e) {
    var t, r, o, s, i, c = n;
    if (c = c.trim(), !e && n.split("#").length === 1) {
        var a = $b19ca0fdfcbacc57$var$YU.exec(c);
        if (a) return this.pathname = a[1], a[2] && (this.search = a[2]), this;
    }
    var l = $b19ca0fdfcbacc57$var$KU.exec(c);
    if (l && (l = l[0], o = l.toLowerCase(), this.protocol = l, c = c.substr(l.length)), (e || l || c.match(/^\/\/[^@\/]+@[^@\/]+/)) && (i = c.substr(0, 2) === "//", i && !(l && $b19ca0fdfcbacc57$var$Tt[l]) && (c = c.substr(2), this.slashes = !0)), !$b19ca0fdfcbacc57$var$Tt[l] && (i || l && !$b19ca0fdfcbacc57$var$Rt[l])) {
        var u = -1;
        for(t = 0; t < $b19ca0fdfcbacc57$var$St.length; t++)s = c.indexOf($b19ca0fdfcbacc57$var$St[t]), s !== -1 && (u === -1 || s < u) && (u = s);
        var p, f;
        for(u === -1 ? f = c.lastIndexOf("@") : f = c.lastIndexOf("@", u), f !== -1 && (p = c.slice(0, f), c = c.slice(f + 1), this.auth = p), u = -1, t = 0; t < $b19ca0fdfcbacc57$var$Ct.length; t++)s = c.indexOf($b19ca0fdfcbacc57$var$Ct[t]), s !== -1 && (u === -1 || s < u) && (u = s);
        u === -1 && (u = c.length), c[u - 1] === ":" && u--;
        var h = c.slice(0, u);
        c = c.slice(u), this.parseHost(h), this.hostname = this.hostname || "";
        var d = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        if (!d) {
            var g = this.hostname.split(/\./);
            for(t = 0, r = g.length; t < r; t++){
                var E = g[t];
                if (E && !E.match($b19ca0fdfcbacc57$var$Dt)) {
                    for(var x = "", b = 0, A = E.length; b < A; b++)E.charCodeAt(b) > 127 ? x += "x" : x += E[b];
                    if (!x.match($b19ca0fdfcbacc57$var$Dt)) {
                        var D = g.slice(0, t), L = g.slice(t + 1), v = E.match($b19ca0fdfcbacc57$var$n9);
                        v && (D.push(v[1]), L.unshift(v[2])), L.length && (c = L.join(".") + c), this.hostname = D.join(".");
                        break;
                    }
                }
            }
        }
        this.hostname.length > $b19ca0fdfcbacc57$var$e9 && (this.hostname = ""), d && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
    }
    var O = c.indexOf("#");
    O !== -1 && (this.hash = c.substr(O), c = c.slice(0, O));
    var z = c.indexOf("?");
    return z !== -1 && (this.search = c.substr(z), c = c.slice(0, z)), c && (this.pathname = c), $b19ca0fdfcbacc57$var$Rt[o] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
$b19ca0fdfcbacc57$var$cn.prototype.parseHost = function(n) {
    var e = $b19ca0fdfcbacc57$var$WU.exec(n);
    e && (e = e[0], e !== ":" && (this.port = e.substr(1)), n = n.substr(0, n.length - e.length)), n && (this.hostname = n);
};
var $b19ca0fdfcbacc57$var$r9 = $b19ca0fdfcbacc57$var$t9;
$b19ca0fdfcbacc57$var$Me.encode = $b19ca0fdfcbacc57$var$VU;
$b19ca0fdfcbacc57$var$Me.decode = $b19ca0fdfcbacc57$var$jU;
$b19ca0fdfcbacc57$var$Me.format = $b19ca0fdfcbacc57$var$ZU;
$b19ca0fdfcbacc57$var$Me.parse = $b19ca0fdfcbacc57$var$r9;
var $b19ca0fdfcbacc57$var$Ee = {}, $b19ca0fdfcbacc57$var$Cn, $b19ca0fdfcbacc57$var$Lt;
function $b19ca0fdfcbacc57$var$Ur() {
    return $b19ca0fdfcbacc57$var$Lt || ($b19ca0fdfcbacc57$var$Lt = 1, $b19ca0fdfcbacc57$var$Cn = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), $b19ca0fdfcbacc57$var$Cn;
}
var $b19ca0fdfcbacc57$var$Sn, $b19ca0fdfcbacc57$var$Nt;
function $b19ca0fdfcbacc57$var$Hr() {
    return $b19ca0fdfcbacc57$var$Nt || ($b19ca0fdfcbacc57$var$Nt = 1, $b19ca0fdfcbacc57$var$Sn = /[\0-\x1F\x7F-\x9F]/), $b19ca0fdfcbacc57$var$Sn;
}
var $b19ca0fdfcbacc57$var$Dn, $b19ca0fdfcbacc57$var$qt;
function $b19ca0fdfcbacc57$var$o9() {
    return $b19ca0fdfcbacc57$var$qt || ($b19ca0fdfcbacc57$var$qt = 1, $b19ca0fdfcbacc57$var$Dn = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), $b19ca0fdfcbacc57$var$Dn;
}
var $b19ca0fdfcbacc57$var$Tn, $b19ca0fdfcbacc57$var$Mt;
function $b19ca0fdfcbacc57$var$Vr() {
    return $b19ca0fdfcbacc57$var$Mt || ($b19ca0fdfcbacc57$var$Mt = 1, $b19ca0fdfcbacc57$var$Tn = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), $b19ca0fdfcbacc57$var$Tn;
}
var $b19ca0fdfcbacc57$var$It;
function $b19ca0fdfcbacc57$var$s9() {
    return $b19ca0fdfcbacc57$var$It || ($b19ca0fdfcbacc57$var$It = 1, $b19ca0fdfcbacc57$var$Ee.Any = $b19ca0fdfcbacc57$var$Ur(), $b19ca0fdfcbacc57$var$Ee.Cc = $b19ca0fdfcbacc57$var$Hr(), $b19ca0fdfcbacc57$var$Ee.Cf = $b19ca0fdfcbacc57$var$o9(), $b19ca0fdfcbacc57$var$Ee.P = $b19ca0fdfcbacc57$var$Jn, $b19ca0fdfcbacc57$var$Ee.Z = $b19ca0fdfcbacc57$var$Vr()), $b19ca0fdfcbacc57$var$Ee;
}
(function(n) {
    function e(_) {
        return Object.prototype.toString.call(_);
    }
    function t(_) {
        return e(_) === "[object String]";
    }
    var r = Object.prototype.hasOwnProperty;
    function o(_, T) {
        return r.call(_, T);
    }
    function s(_) {
        var T = Array.prototype.slice.call(arguments, 1);
        return T.forEach(function(w) {
            if (w) {
                if (typeof w != "object") throw new TypeError(w + "must be object");
                Object.keys(w).forEach(function(m) {
                    _[m] = w[m];
                });
            }
        }), _;
    }
    function i(_, T, w) {
        return [].concat(_.slice(0, T), w, _.slice(T + 1));
    }
    function c(_) {
        return !(_ >= 55296 && _ <= 57343 || _ >= 64976 && _ <= 65007 || (_ & 65535) === 65535 || (_ & 65535) === 65534 || _ >= 0 && _ <= 8 || _ === 11 || _ >= 14 && _ <= 31 || _ >= 127 && _ <= 159 || _ > 1114111);
    }
    function a(_) {
        if (_ > 65535) {
            _ -= 65536;
            var T = 55296 + (_ >> 10), w = 56320 + (_ & 1023);
            return String.fromCharCode(T, w);
        }
        return String.fromCharCode(_);
    }
    var l = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g, u = /&([a-z#][a-z0-9]{1,31});/gi, p = new RegExp(l.source + "|" + u.source, "gi"), f = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i, h = $b19ca0fdfcbacc57$var$zr;
    function d(_, T) {
        var w;
        return o(h, T) ? h[T] : T.charCodeAt(0) === 35 && f.test(T) && (w = T[1].toLowerCase() === "x" ? parseInt(T.slice(2), 16) : parseInt(T.slice(1), 10), c(w)) ? a(w) : _;
    }
    function g(_) {
        return _.indexOf("\\") < 0 ? _ : _.replace(l, "$1");
    }
    function E(_) {
        return _.indexOf("\\") < 0 && _.indexOf("&") < 0 ? _ : _.replace(p, function(T, w, m) {
            return w || d(T, m);
        });
    }
    var x = /[&<>"]/, b = /[&<>"]/g, A = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;"
    };
    function D(_) {
        return A[_];
    }
    function L(_) {
        return x.test(_) ? _.replace(b, D) : _;
    }
    var v = /[.?*+^$[\]\\(){}|-]/g;
    function O(_) {
        return _.replace(v, "\\$&");
    }
    function z(_) {
        switch(_){
            case 9:
            case 32:
                return !0;
        }
        return !1;
    }
    function j(_) {
        if (_ >= 8192 && _ <= 8202) return !0;
        switch(_){
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 32:
            case 160:
            case 5760:
            case 8239:
            case 8287:
            case 12288:
                return !0;
        }
        return !1;
    }
    var M = $b19ca0fdfcbacc57$var$Jn;
    function K(_) {
        return M.test(_);
    }
    function q(_) {
        switch(_){
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 43:
            case 44:
            case 45:
            case 46:
            case 47:
            case 58:
            case 59:
            case 60:
            case 61:
            case 62:
            case 63:
            case 64:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 123:
            case 124:
            case 125:
            case 126:
                return !0;
            default:
                return !1;
        }
    }
    function Z(_) {
        return _ = _.trim().replace(/\s+/g, " "), "\u1E9E".toLowerCase() === "\u1E7E" && (_ = _.replace(/ẞ/g, "\xdf")), _.toLowerCase().toUpperCase();
    }
    n.lib = {}, n.lib.mdurl = $b19ca0fdfcbacc57$var$Me, n.lib.ucmicro = $b19ca0fdfcbacc57$var$s9(), n.assign = s, n.isString = t, n.has = o, n.unescapeMd = g, n.unescapeAll = E, n.isValidEntityCode = c, n.fromCodePoint = a, n.escapeHtml = L, n.arrayReplaceAt = i, n.isSpace = z, n.isWhiteSpace = j, n.isMdAsciiPunct = q, n.isPunctChar = K, n.escapeRE = O, n.normalizeReference = Z;
})($b19ca0fdfcbacc57$var$$);
var $b19ca0fdfcbacc57$var$dn = {}, $b19ca0fdfcbacc57$var$c9 = function(e, t, r) {
    var o, s, i, c, a = -1, l = e.posMax, u = e.pos;
    for(e.pos = t + 1, o = 1; e.pos < l;){
        if (i = e.src.charCodeAt(e.pos), i === 93 && (o--, o === 0)) {
            s = !0;
            break;
        }
        if (c = e.pos, e.md.inline.skipToken(e), i === 91) {
            if (c === e.pos - 1) o++;
            else if (r) return e.pos = u, -1;
        }
    }
    return s && (a = e.pos), e.pos = u, a;
}, $b19ca0fdfcbacc57$var$Ot = $b19ca0fdfcbacc57$var$$.unescapeAll, $b19ca0fdfcbacc57$var$i9 = function(e, t, r) {
    var o, s, i = t, c = {
        ok: !1,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (e.charCodeAt(i) === 60) {
        for(i++; i < r;){
            if (o = e.charCodeAt(i), o === 10 || o === 60) return c;
            if (o === 62) return c.pos = i + 1, c.str = $b19ca0fdfcbacc57$var$Ot(e.slice(t + 1, i)), c.ok = !0, c;
            if (o === 92 && i + 1 < r) {
                i += 2;
                continue;
            }
            i++;
        }
        return c;
    }
    for(s = 0; i < r && (o = e.charCodeAt(i), !(o === 32 || o < 32 || o === 127));){
        if (o === 92 && i + 1 < r) {
            if (e.charCodeAt(i + 1) === 32) break;
            i += 2;
            continue;
        }
        if (o === 40 && (s++, s > 32)) return c;
        if (o === 41) {
            if (s === 0) break;
            s--;
        }
        i++;
    }
    return t === i || s !== 0 || (c.str = $b19ca0fdfcbacc57$var$Ot(e.slice(t, i)), c.pos = i, c.ok = !0), c;
}, $b19ca0fdfcbacc57$var$a9 = $b19ca0fdfcbacc57$var$$.unescapeAll, $b19ca0fdfcbacc57$var$l9 = function(e, t, r) {
    var o, s, i = 0, c = t, a = {
        ok: !1,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (c >= r || (s = e.charCodeAt(c), s !== 34 && s !== 39 && s !== 40)) return a;
    for(c++, s === 40 && (s = 41); c < r;){
        if (o = e.charCodeAt(c), o === s) return a.pos = c + 1, a.lines = i, a.str = $b19ca0fdfcbacc57$var$a9(e.slice(t + 1, c)), a.ok = !0, a;
        if (o === 40 && s === 41) return a;
        o === 10 ? i++ : o === 92 && c + 1 < r && (c++, e.charCodeAt(c) === 10 && i++), c++;
    }
    return a;
};
$b19ca0fdfcbacc57$var$dn.parseLinkLabel = $b19ca0fdfcbacc57$var$c9;
$b19ca0fdfcbacc57$var$dn.parseLinkDestination = $b19ca0fdfcbacc57$var$i9;
$b19ca0fdfcbacc57$var$dn.parseLinkTitle = $b19ca0fdfcbacc57$var$l9;
var $b19ca0fdfcbacc57$var$u9 = $b19ca0fdfcbacc57$var$$.assign, $b19ca0fdfcbacc57$var$f9 = $b19ca0fdfcbacc57$var$$.unescapeAll, $b19ca0fdfcbacc57$var$Se = $b19ca0fdfcbacc57$var$$.escapeHtml, $b19ca0fdfcbacc57$var$ge = {};
$b19ca0fdfcbacc57$var$ge.code_inline = function(n, e, t, r, o) {
    var s = n[e];
    return "<code" + o.renderAttrs(s) + ">" + $b19ca0fdfcbacc57$var$Se(s.content) + "</code>";
};
$b19ca0fdfcbacc57$var$ge.code_block = function(n, e, t, r, o) {
    var s = n[e];
    return "<pre" + o.renderAttrs(s) + "><code>" + $b19ca0fdfcbacc57$var$Se(n[e].content) + `</code></pre>
`;
};
$b19ca0fdfcbacc57$var$ge.fence = function(n, e, t, r, o) {
    var s = n[e], i = s.info ? $b19ca0fdfcbacc57$var$f9(s.info).trim() : "", c = "", a = "", l, u, p, f, h;
    return i && (p = i.split(/(\s+)/g), c = p[0], a = p.slice(2).join("")), t.highlight ? l = t.highlight(s.content, c, a) || $b19ca0fdfcbacc57$var$Se(s.content) : l = $b19ca0fdfcbacc57$var$Se(s.content), l.indexOf("<pre") === 0 ? l + `
` : i ? (u = s.attrIndex("class"), f = s.attrs ? s.attrs.slice() : [], u < 0 ? f.push([
        "class",
        t.langPrefix + c
    ]) : (f[u] = f[u].slice(), f[u][1] += " " + t.langPrefix + c), h = {
        attrs: f
    }, "<pre><code" + o.renderAttrs(h) + ">" + l + `</code></pre>
`) : "<pre><code" + o.renderAttrs(s) + ">" + l + `</code></pre>
`;
};
$b19ca0fdfcbacc57$var$ge.image = function(n, e, t, r, o) {
    var s = n[e];
    return s.attrs[s.attrIndex("alt")][1] = o.renderInlineAsText(s.children, t, r), o.renderToken(n, e, t);
};
$b19ca0fdfcbacc57$var$ge.hardbreak = function(n, e, t) {
    return t.xhtmlOut ? `<br />
` : `<br>
`;
};
$b19ca0fdfcbacc57$var$ge.softbreak = function(n, e, t) {
    return t.breaks ? t.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
$b19ca0fdfcbacc57$var$ge.text = function(n, e) {
    return $b19ca0fdfcbacc57$var$Se(n[e].content);
};
$b19ca0fdfcbacc57$var$ge.html_block = function(n, e) {
    return n[e].content;
};
$b19ca0fdfcbacc57$var$ge.html_inline = function(n, e) {
    return n[e].content;
};
function $b19ca0fdfcbacc57$var$Ie() {
    this.rules = $b19ca0fdfcbacc57$var$u9({}, $b19ca0fdfcbacc57$var$ge);
}
$b19ca0fdfcbacc57$var$Ie.prototype.renderAttrs = function(e) {
    var t, r, o;
    if (!e.attrs) return "";
    for(o = "", t = 0, r = e.attrs.length; t < r; t++)o += " " + $b19ca0fdfcbacc57$var$Se(e.attrs[t][0]) + '="' + $b19ca0fdfcbacc57$var$Se(e.attrs[t][1]) + '"';
    return o;
};
$b19ca0fdfcbacc57$var$Ie.prototype.renderToken = function(e, t, r) {
    var o, s = "", i = !1, c = e[t];
    return c.hidden ? "" : (c.block && c.nesting !== -1 && t && e[t - 1].hidden && (s += `
`), s += (c.nesting === -1 ? "</" : "<") + c.tag, s += this.renderAttrs(c), c.nesting === 0 && r.xhtmlOut && (s += " /"), c.block && (i = !0, c.nesting === 1 && t + 1 < e.length && (o = e[t + 1], (o.type === "inline" || o.hidden || o.nesting === -1 && o.tag === c.tag) && (i = !1))), s += i ? `>
` : ">", s);
};
$b19ca0fdfcbacc57$var$Ie.prototype.renderInline = function(n, e, t) {
    for(var r, o = "", s = this.rules, i = 0, c = n.length; i < c; i++)r = n[i].type, typeof s[r] < "u" ? o += s[r](n, i, e, t, this) : o += this.renderToken(n, i, e);
    return o;
};
$b19ca0fdfcbacc57$var$Ie.prototype.renderInlineAsText = function(n, e, t) {
    for(var r = "", o = 0, s = n.length; o < s; o++)n[o].type === "text" ? r += n[o].content : n[o].type === "image" ? r += this.renderInlineAsText(n[o].children, e, t) : n[o].type === "softbreak" && (r += `
`);
    return r;
};
$b19ca0fdfcbacc57$var$Ie.prototype.render = function(n, e, t) {
    var r, o, s, i = "", c = this.rules;
    for(r = 0, o = n.length; r < o; r++)s = n[r].type, s === "inline" ? i += this.renderInline(n[r].children, e, t) : typeof c[s] < "u" ? i += c[s](n, r, e, t, this) : i += this.renderToken(n, r, e, t);
    return i;
};
var $b19ca0fdfcbacc57$var$p9 = $b19ca0fdfcbacc57$var$Ie;
function $b19ca0fdfcbacc57$var$le() {
    this.__rules__ = [], this.__cache__ = null;
}
$b19ca0fdfcbacc57$var$le.prototype.__find__ = function(n) {
    for(var e = 0; e < this.__rules__.length; e++)if (this.__rules__[e].name === n) return e;
    return -1;
};
$b19ca0fdfcbacc57$var$le.prototype.__compile__ = function() {
    var n = this, e = [
        ""
    ];
    n.__rules__.forEach(function(t) {
        t.enabled && t.alt.forEach(function(r) {
            e.indexOf(r) < 0 && e.push(r);
        });
    }), n.__cache__ = {}, e.forEach(function(t) {
        n.__cache__[t] = [], n.__rules__.forEach(function(r) {
            r.enabled && (t && r.alt.indexOf(t) < 0 || n.__cache__[t].push(r.fn));
        });
    });
};
$b19ca0fdfcbacc57$var$le.prototype.at = function(n, e, t) {
    var r = this.__find__(n), o = t || {};
    if (r === -1) throw new Error("Parser rule not found: " + n);
    this.__rules__[r].fn = e, this.__rules__[r].alt = o.alt || [], this.__cache__ = null;
};
$b19ca0fdfcbacc57$var$le.prototype.before = function(n, e, t, r) {
    var o = this.__find__(n), s = r || {};
    if (o === -1) throw new Error("Parser rule not found: " + n);
    this.__rules__.splice(o, 0, {
        name: e,
        enabled: !0,
        fn: t,
        alt: s.alt || []
    }), this.__cache__ = null;
};
$b19ca0fdfcbacc57$var$le.prototype.after = function(n, e, t, r) {
    var o = this.__find__(n), s = r || {};
    if (o === -1) throw new Error("Parser rule not found: " + n);
    this.__rules__.splice(o + 1, 0, {
        name: e,
        enabled: !0,
        fn: t,
        alt: s.alt || []
    }), this.__cache__ = null;
};
$b19ca0fdfcbacc57$var$le.prototype.push = function(n, e, t) {
    var r = t || {};
    this.__rules__.push({
        name: n,
        enabled: !0,
        fn: e,
        alt: r.alt || []
    }), this.__cache__ = null;
};
$b19ca0fdfcbacc57$var$le.prototype.enable = function(n, e) {
    Array.isArray(n) || (n = [
        n
    ]);
    var t = [];
    return n.forEach(function(r) {
        var o = this.__find__(r);
        if (o < 0) {
            if (e) return;
            throw new Error("Rules manager: invalid rule name " + r);
        }
        this.__rules__[o].enabled = !0, t.push(r);
    }, this), this.__cache__ = null, t;
};
$b19ca0fdfcbacc57$var$le.prototype.enableOnly = function(n, e) {
    Array.isArray(n) || (n = [
        n
    ]), this.__rules__.forEach(function(t) {
        t.enabled = !1;
    }), this.enable(n, e);
};
$b19ca0fdfcbacc57$var$le.prototype.disable = function(n, e) {
    Array.isArray(n) || (n = [
        n
    ]);
    var t = [];
    return n.forEach(function(r) {
        var o = this.__find__(r);
        if (o < 0) {
            if (e) return;
            throw new Error("Rules manager: invalid rule name " + r);
        }
        this.__rules__[o].enabled = !1, t.push(r);
    }, this), this.__cache__ = null, t;
};
$b19ca0fdfcbacc57$var$le.prototype.getRules = function(n) {
    return this.__cache__ === null && this.__compile__(), this.__cache__[n] || [];
};
var $b19ca0fdfcbacc57$var$Xn = $b19ca0fdfcbacc57$var$le, $b19ca0fdfcbacc57$var$h9 = /\r\n?|\n/g, $b19ca0fdfcbacc57$var$d9 = /\0/g, $b19ca0fdfcbacc57$var$g9 = function(e) {
    var t;
    t = e.src.replace($b19ca0fdfcbacc57$var$h9, `
`), t = t.replace($b19ca0fdfcbacc57$var$d9, "\uFFFD"), e.src = t;
}, $b19ca0fdfcbacc57$var$m9 = function(e) {
    var t;
    e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [
        0,
        1
    ], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}, $b19ca0fdfcbacc57$var$_9 = function(e) {
    var t = e.tokens, r, o, s;
    for(o = 0, s = t.length; o < s; o++)r = t[o], r.type === "inline" && e.md.inline.parse(r.content, e.md, e.env, r.children);
}, $b19ca0fdfcbacc57$var$b9 = $b19ca0fdfcbacc57$var$$.arrayReplaceAt;
function $b19ca0fdfcbacc57$var$v9(n) {
    return /^<a[>\s]/i.test(n);
}
function $b19ca0fdfcbacc57$var$k9(n) {
    return /^<\/a\s*>/i.test(n);
}
var $b19ca0fdfcbacc57$var$x9 = function(e) {
    var t, r, o, s, i, c, a, l, u, p, f, h, d, g, E, x, b = e.tokens, A;
    if (e.md.options.linkify) {
        for(r = 0, o = b.length; r < o; r++)if (!(b[r].type !== "inline" || !e.md.linkify.pretest(b[r].content))) for(s = b[r].children, d = 0, t = s.length - 1; t >= 0; t--){
            if (c = s[t], c.type === "link_close") {
                for(t--; s[t].level !== c.level && s[t].type !== "link_open";)t--;
                continue;
            }
            if (c.type === "html_inline" && ($b19ca0fdfcbacc57$var$v9(c.content) && d > 0 && d--, $b19ca0fdfcbacc57$var$k9(c.content) && d++), !(d > 0) && c.type === "text" && e.md.linkify.test(c.content)) {
                for(u = c.content, A = e.md.linkify.match(u), a = [], h = c.level, f = 0, A.length > 0 && A[0].index === 0 && t > 0 && s[t - 1].type === "text_special" && (A = A.slice(1)), l = 0; l < A.length; l++)g = A[l].url, E = e.md.normalizeLink(g), e.md.validateLink(E) && (x = A[l].text, A[l].schema ? A[l].schema === "mailto:" && !/^mailto:/i.test(x) ? x = e.md.normalizeLinkText("mailto:" + x).replace(/^mailto:/, "") : x = e.md.normalizeLinkText(x) : x = e.md.normalizeLinkText("http://" + x).replace(/^http:\/\//, ""), p = A[l].index, p > f && (i = new e.Token("text", "", 0), i.content = u.slice(f, p), i.level = h, a.push(i)), i = new e.Token("link_open", "a", 1), i.attrs = [
                    [
                        "href",
                        E
                    ]
                ], i.level = h++, i.markup = "linkify", i.info = "auto", a.push(i), i = new e.Token("text", "", 0), i.content = x, i.level = h, a.push(i), i = new e.Token("link_close", "a", -1), i.level = --h, i.markup = "linkify", i.info = "auto", a.push(i), f = A[l].lastIndex);
                f < u.length && (i = new e.Token("text", "", 0), i.content = u.slice(f), i.level = h, a.push(i)), b[r].children = s = $b19ca0fdfcbacc57$var$b9(s, t, a);
            }
        }
    }
}, $b19ca0fdfcbacc57$var$Gr = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, $b19ca0fdfcbacc57$var$y9 = /\((c|tm|r)\)/i, $b19ca0fdfcbacc57$var$E9 = /\((c|tm|r)\)/ig, $b19ca0fdfcbacc57$var$w9 = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $b19ca0fdfcbacc57$var$A9(n, e) {
    return $b19ca0fdfcbacc57$var$w9[e.toLowerCase()];
}
function $b19ca0fdfcbacc57$var$C9(n) {
    var e, t, r = 0;
    for(e = n.length - 1; e >= 0; e--)t = n[e], t.type === "text" && !r && (t.content = t.content.replace($b19ca0fdfcbacc57$var$E9, $b19ca0fdfcbacc57$var$A9)), t.type === "link_open" && t.info === "auto" && r--, t.type === "link_close" && t.info === "auto" && r++;
}
function $b19ca0fdfcbacc57$var$S9(n) {
    var e, t, r = 0;
    for(e = n.length - 1; e >= 0; e--)t = n[e], t.type === "text" && !r && $b19ca0fdfcbacc57$var$Gr.test(t.content) && (t.content = t.content.replace(/\+-/g, "\xb1").replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014").replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013")), t.type === "link_open" && t.info === "auto" && r--, t.type === "link_close" && t.info === "auto" && r++;
}
var $b19ca0fdfcbacc57$var$D9 = function(e) {
    var t;
    if (e.md.options.typographer) for(t = e.tokens.length - 1; t >= 0; t--)e.tokens[t].type === "inline" && ($b19ca0fdfcbacc57$var$y9.test(e.tokens[t].content) && $b19ca0fdfcbacc57$var$C9(e.tokens[t].children), $b19ca0fdfcbacc57$var$Gr.test(e.tokens[t].content) && $b19ca0fdfcbacc57$var$S9(e.tokens[t].children));
}, $b19ca0fdfcbacc57$var$Ft = $b19ca0fdfcbacc57$var$$.isWhiteSpace, $b19ca0fdfcbacc57$var$Bt = $b19ca0fdfcbacc57$var$$.isPunctChar, $b19ca0fdfcbacc57$var$Pt = $b19ca0fdfcbacc57$var$$.isMdAsciiPunct, $b19ca0fdfcbacc57$var$T9 = /['"]/, $b19ca0fdfcbacc57$var$$t = /['"]/g, $b19ca0fdfcbacc57$var$zt = "\u2019";
function $b19ca0fdfcbacc57$var$Qe(n, e, t) {
    return n.slice(0, e) + t + n.slice(e + 1);
}
function $b19ca0fdfcbacc57$var$R9(n, e) {
    var t, r, o, s, i, c, a, l, u, p, f, h, d, g, E, x, b, A, D, L, v;
    for(D = [], t = 0; t < n.length; t++){
        for(r = n[t], a = n[t].level, b = D.length - 1; b >= 0 && !(D[b].level <= a); b--);
        if (D.length = b + 1, r.type === "text") {
            o = r.content, i = 0, c = o.length;
            e: for(; i < c && ($b19ca0fdfcbacc57$var$$t.lastIndex = i, s = $b19ca0fdfcbacc57$var$$t.exec(o), !!s);){
                if (E = x = !0, i = s.index + 1, A = s[0] === "'", u = 32, s.index - 1 >= 0) u = o.charCodeAt(s.index - 1);
                else for(b = t - 1; b >= 0 && !(n[b].type === "softbreak" || n[b].type === "hardbreak"); b--)if (n[b].content) {
                    u = n[b].content.charCodeAt(n[b].content.length - 1);
                    break;
                }
                if (p = 32, i < c) p = o.charCodeAt(i);
                else for(b = t + 1; b < n.length && !(n[b].type === "softbreak" || n[b].type === "hardbreak"); b++)if (n[b].content) {
                    p = n[b].content.charCodeAt(0);
                    break;
                }
                if (f = $b19ca0fdfcbacc57$var$Pt(u) || $b19ca0fdfcbacc57$var$Bt(String.fromCharCode(u)), h = $b19ca0fdfcbacc57$var$Pt(p) || $b19ca0fdfcbacc57$var$Bt(String.fromCharCode(p)), d = $b19ca0fdfcbacc57$var$Ft(u), g = $b19ca0fdfcbacc57$var$Ft(p), g ? E = !1 : h && (d || f || (E = !1)), d ? x = !1 : f && (g || h || (x = !1)), p === 34 && s[0] === '"' && u >= 48 && u <= 57 && (x = E = !1), E && x && (E = f, x = h), !E && !x) {
                    A && (r.content = $b19ca0fdfcbacc57$var$Qe(r.content, s.index, $b19ca0fdfcbacc57$var$zt));
                    continue;
                }
                if (x) {
                    for(b = D.length - 1; b >= 0 && (l = D[b], !(D[b].level < a)); b--)if (l.single === A && D[b].level === a) {
                        l = D[b], A ? (L = e.md.options.quotes[2], v = e.md.options.quotes[3]) : (L = e.md.options.quotes[0], v = e.md.options.quotes[1]), r.content = $b19ca0fdfcbacc57$var$Qe(r.content, s.index, v), n[l.token].content = $b19ca0fdfcbacc57$var$Qe(n[l.token].content, l.pos, L), i += v.length - 1, l.token === t && (i += L.length - 1), o = r.content, c = o.length, D.length = b;
                        continue e;
                    }
                }
                E ? D.push({
                    token: t,
                    pos: s.index,
                    single: A,
                    level: a
                }) : x && A && (r.content = $b19ca0fdfcbacc57$var$Qe(r.content, s.index, $b19ca0fdfcbacc57$var$zt));
            }
        }
    }
}
var $b19ca0fdfcbacc57$var$L9 = function(e) {
    var t;
    if (e.md.options.typographer) for(t = e.tokens.length - 1; t >= 0; t--)e.tokens[t].type !== "inline" || !$b19ca0fdfcbacc57$var$T9.test(e.tokens[t].content) || $b19ca0fdfcbacc57$var$R9(e.tokens[t].children, e);
}, $b19ca0fdfcbacc57$var$N9 = function(e) {
    var t, r, o, s, i, c, a = e.tokens;
    for(t = 0, r = a.length; t < r; t++)if (a[t].type === "inline") {
        for(o = a[t].children, i = o.length, s = 0; s < i; s++)o[s].type === "text_special" && (o[s].type = "text");
        for(s = c = 0; s < i; s++)o[s].type === "text" && s + 1 < i && o[s + 1].type === "text" ? o[s + 1].content = o[s].content + o[s + 1].content : (s !== c && (o[c] = o[s]), c++);
        s !== c && (o.length = c);
    }
};
function $b19ca0fdfcbacc57$var$Oe(n, e, t) {
    this.type = n, this.tag = e, this.attrs = null, this.map = null, this.nesting = t, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
$b19ca0fdfcbacc57$var$Oe.prototype.attrIndex = function(e) {
    var t, r, o;
    if (!this.attrs) return -1;
    for(t = this.attrs, r = 0, o = t.length; r < o; r++)if (t[r][0] === e) return r;
    return -1;
};
$b19ca0fdfcbacc57$var$Oe.prototype.attrPush = function(e) {
    this.attrs ? this.attrs.push(e) : this.attrs = [
        e
    ];
};
$b19ca0fdfcbacc57$var$Oe.prototype.attrSet = function(e, t) {
    var r = this.attrIndex(e), o = [
        e,
        t
    ];
    r < 0 ? this.attrPush(o) : this.attrs[r] = o;
};
$b19ca0fdfcbacc57$var$Oe.prototype.attrGet = function(e) {
    var t = this.attrIndex(e), r = null;
    return t >= 0 && (r = this.attrs[t][1]), r;
};
$b19ca0fdfcbacc57$var$Oe.prototype.attrJoin = function(e, t) {
    var r = this.attrIndex(e);
    r < 0 ? this.attrPush([
        e,
        t
    ]) : this.attrs[r][1] = this.attrs[r][1] + " " + t;
};
var $b19ca0fdfcbacc57$var$Qn = $b19ca0fdfcbacc57$var$Oe, $b19ca0fdfcbacc57$var$q9 = $b19ca0fdfcbacc57$var$Qn;
function $b19ca0fdfcbacc57$var$jr(n, e, t) {
    this.src = n, this.env = t, this.tokens = [], this.inlineMode = !1, this.md = e;
}
$b19ca0fdfcbacc57$var$jr.prototype.Token = $b19ca0fdfcbacc57$var$q9;
var $b19ca0fdfcbacc57$var$M9 = $b19ca0fdfcbacc57$var$jr, $b19ca0fdfcbacc57$var$I9 = $b19ca0fdfcbacc57$var$Xn, $b19ca0fdfcbacc57$var$Rn = [
    [
        "normalize",
        $b19ca0fdfcbacc57$var$g9
    ],
    [
        "block",
        $b19ca0fdfcbacc57$var$m9
    ],
    [
        "inline",
        $b19ca0fdfcbacc57$var$_9
    ],
    [
        "linkify",
        $b19ca0fdfcbacc57$var$x9
    ],
    [
        "replacements",
        $b19ca0fdfcbacc57$var$D9
    ],
    [
        "smartquotes",
        $b19ca0fdfcbacc57$var$L9
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        $b19ca0fdfcbacc57$var$N9
    ]
];
function $b19ca0fdfcbacc57$var$et() {
    this.ruler = new $b19ca0fdfcbacc57$var$I9();
    for(var n = 0; n < $b19ca0fdfcbacc57$var$Rn.length; n++)this.ruler.push($b19ca0fdfcbacc57$var$Rn[n][0], $b19ca0fdfcbacc57$var$Rn[n][1]);
}
$b19ca0fdfcbacc57$var$et.prototype.process = function(n) {
    var e, t, r;
    for(r = this.ruler.getRules(""), e = 0, t = r.length; e < t; e++)r[e](n);
};
$b19ca0fdfcbacc57$var$et.prototype.State = $b19ca0fdfcbacc57$var$M9;
var $b19ca0fdfcbacc57$var$O9 = $b19ca0fdfcbacc57$var$et, $b19ca0fdfcbacc57$var$Ln = $b19ca0fdfcbacc57$var$$.isSpace;
function $b19ca0fdfcbacc57$var$Nn(n, e) {
    var t = n.bMarks[e] + n.tShift[e], r = n.eMarks[e];
    return n.src.slice(t, r);
}
function $b19ca0fdfcbacc57$var$Ut(n) {
    var e = [], t = 0, r = n.length, o, s = !1, i = 0, c = "";
    for(o = n.charCodeAt(t); t < r;)o === 124 && (s ? (c += n.substring(i, t - 1), i = t) : (e.push(c + n.substring(i, t)), c = "", i = t + 1)), s = o === 92, t++, o = n.charCodeAt(t);
    return e.push(c + n.substring(i)), e;
}
var $b19ca0fdfcbacc57$var$F9 = function(e, t, r, o) {
    var s, i, c, a, l, u, p, f, h, d, g, E, x, b, A, D, L, v;
    if (t + 2 > r || (u = t + 1, e.sCount[u] < e.blkIndent) || e.sCount[u] - e.blkIndent >= 4 || (c = e.bMarks[u] + e.tShift[u], c >= e.eMarks[u]) || (L = e.src.charCodeAt(c++), L !== 124 && L !== 45 && L !== 58) || c >= e.eMarks[u] || (v = e.src.charCodeAt(c++), v !== 124 && v !== 45 && v !== 58 && !$b19ca0fdfcbacc57$var$Ln(v)) || L === 45 && $b19ca0fdfcbacc57$var$Ln(v)) return !1;
    for(; c < e.eMarks[u];){
        if (s = e.src.charCodeAt(c), s !== 124 && s !== 45 && s !== 58 && !$b19ca0fdfcbacc57$var$Ln(s)) return !1;
        c++;
    }
    for(i = $b19ca0fdfcbacc57$var$Nn(e, t + 1), p = i.split("|"), d = [], a = 0; a < p.length; a++){
        if (g = p[a].trim(), !g) {
            if (a === 0 || a === p.length - 1) continue;
            return !1;
        }
        if (!/^:?-+:?$/.test(g)) return !1;
        g.charCodeAt(g.length - 1) === 58 ? d.push(g.charCodeAt(0) === 58 ? "center" : "right") : g.charCodeAt(0) === 58 ? d.push("left") : d.push("");
    }
    if (i = $b19ca0fdfcbacc57$var$Nn(e, t).trim(), i.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4 || (p = $b19ca0fdfcbacc57$var$Ut(i), p.length && p[0] === "" && p.shift(), p.length && p[p.length - 1] === "" && p.pop(), f = p.length, f === 0 || f !== d.length)) return !1;
    if (o) return !0;
    for(b = e.parentType, e.parentType = "table", D = e.md.block.ruler.getRules("blockquote"), h = e.push("table_open", "table", 1), h.map = E = [
        t,
        0
    ], h = e.push("thead_open", "thead", 1), h.map = [
        t,
        t + 1
    ], h = e.push("tr_open", "tr", 1), h.map = [
        t,
        t + 1
    ], a = 0; a < p.length; a++)h = e.push("th_open", "th", 1), d[a] && (h.attrs = [
        [
            "style",
            "text-align:" + d[a]
        ]
    ]), h = e.push("inline", "", 0), h.content = p[a].trim(), h.children = [], h = e.push("th_close", "th", -1);
    for(h = e.push("tr_close", "tr", -1), h = e.push("thead_close", "thead", -1), u = t + 2; u < r && !(e.sCount[u] < e.blkIndent); u++){
        for(A = !1, a = 0, l = D.length; a < l; a++)if (D[a](e, u, r, !0)) {
            A = !0;
            break;
        }
        if (A || (i = $b19ca0fdfcbacc57$var$Nn(e, u).trim(), !i) || e.sCount[u] - e.blkIndent >= 4) break;
        for(p = $b19ca0fdfcbacc57$var$Ut(i), p.length && p[0] === "" && p.shift(), p.length && p[p.length - 1] === "" && p.pop(), u === t + 2 && (h = e.push("tbody_open", "tbody", 1), h.map = x = [
            t + 2,
            0
        ]), h = e.push("tr_open", "tr", 1), h.map = [
            u,
            u + 1
        ], a = 0; a < f; a++)h = e.push("td_open", "td", 1), d[a] && (h.attrs = [
            [
                "style",
                "text-align:" + d[a]
            ]
        ]), h = e.push("inline", "", 0), h.content = p[a] ? p[a].trim() : "", h.children = [], h = e.push("td_close", "td", -1);
        h = e.push("tr_close", "tr", -1);
    }
    return x && (h = e.push("tbody_close", "tbody", -1), x[1] = u), h = e.push("table_close", "table", -1), E[1] = u, e.parentType = b, e.line = u, !0;
}, $b19ca0fdfcbacc57$var$B9 = function(e, t, r) {
    var o, s, i;
    if (e.sCount[t] - e.blkIndent < 4) return !1;
    for(s = o = t + 1; o < r;){
        if (e.isEmpty(o)) {
            o++;
            continue;
        }
        if (e.sCount[o] - e.blkIndent >= 4) {
            o++, s = o;
            continue;
        }
        break;
    }
    return e.line = s, i = e.push("code_block", "code", 0), i.content = e.getLines(t, s, 4 + e.blkIndent, !1) + `
`, i.map = [
        t,
        e.line
    ], !0;
}, $b19ca0fdfcbacc57$var$P9 = function(e, t, r, o) {
    var s, i, c, a, l, u, p, f = !1, h = e.bMarks[t] + e.tShift[t], d = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || h + 3 > d || (s = e.src.charCodeAt(h), s !== 126 && s !== 96) || (l = h, h = e.skipChars(h, s), i = h - l, i < 3) || (p = e.src.slice(l, h), c = e.src.slice(h, d), s === 96 && c.indexOf(String.fromCharCode(s)) >= 0)) return !1;
    if (o) return !0;
    for(a = t; a++, !(a >= r || (h = l = e.bMarks[a] + e.tShift[a], d = e.eMarks[a], h < d && e.sCount[a] < e.blkIndent));)if (e.src.charCodeAt(h) === s && !(e.sCount[a] - e.blkIndent >= 4) && (h = e.skipChars(h, s), !(h - l < i) && (h = e.skipSpaces(h), !(h < d)))) {
        f = !0;
        break;
    }
    return i = e.sCount[t], e.line = a + (f ? 1 : 0), u = e.push("fence", "code", 0), u.info = c, u.content = e.getLines(t + 1, a, i, !0), u.markup = p, u.map = [
        t,
        e.line
    ], !0;
}, $b19ca0fdfcbacc57$var$$9 = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$z9 = function(e, t, r, o) {
    var s, i, c, a, l, u, p, f, h, d, g, E, x, b, A, D, L, v, O, z, j = e.lineMax, M = e.bMarks[t] + e.tShift[t], K = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(M) !== 62) return !1;
    if (o) return !0;
    for(d = [], g = [], b = [], A = [], v = e.md.block.ruler.getRules("blockquote"), x = e.parentType, e.parentType = "blockquote", f = t; f < r && (z = e.sCount[f] < e.blkIndent, M = e.bMarks[f] + e.tShift[f], K = e.eMarks[f], !(M >= K)); f++){
        if (e.src.charCodeAt(M++) === 62 && !z) {
            for(a = e.sCount[f] + 1, e.src.charCodeAt(M) === 32 ? (M++, a++, s = !1, D = !0) : e.src.charCodeAt(M) === 9 ? (D = !0, (e.bsCount[f] + a) % 4 === 3 ? (M++, a++, s = !1) : s = !0) : D = !1, h = a, d.push(e.bMarks[f]), e.bMarks[f] = M; M < K && (i = e.src.charCodeAt(M), $b19ca0fdfcbacc57$var$$9(i));){
                i === 9 ? h += 4 - (h + e.bsCount[f] + (s ? 1 : 0)) % 4 : h++;
                M++;
            }
            u = M >= K, g.push(e.bsCount[f]), e.bsCount[f] = e.sCount[f] + 1 + (D ? 1 : 0), b.push(e.sCount[f]), e.sCount[f] = h - a, A.push(e.tShift[f]), e.tShift[f] = M - e.bMarks[f];
            continue;
        }
        if (u) break;
        for(L = !1, c = 0, l = v.length; c < l; c++)if (v[c](e, f, r, !0)) {
            L = !0;
            break;
        }
        if (L) {
            e.lineMax = f, e.blkIndent !== 0 && (d.push(e.bMarks[f]), g.push(e.bsCount[f]), A.push(e.tShift[f]), b.push(e.sCount[f]), e.sCount[f] -= e.blkIndent);
            break;
        }
        d.push(e.bMarks[f]), g.push(e.bsCount[f]), A.push(e.tShift[f]), b.push(e.sCount[f]), e.sCount[f] = -1;
    }
    for(E = e.blkIndent, e.blkIndent = 0, O = e.push("blockquote_open", "blockquote", 1), O.markup = ">", O.map = p = [
        t,
        0
    ], e.md.block.tokenize(e, t, f), O = e.push("blockquote_close", "blockquote", -1), O.markup = ">", e.lineMax = j, e.parentType = x, p[1] = e.line, c = 0; c < A.length; c++)e.bMarks[c + t] = d[c], e.tShift[c + t] = A[c], e.sCount[c + t] = b[c], e.bsCount[c + t] = g[c];
    return e.blkIndent = E, !0;
}, $b19ca0fdfcbacc57$var$U9 = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$H9 = function(e, t, r, o) {
    var s, i, c, a, l = e.bMarks[t] + e.tShift[t], u = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || (s = e.src.charCodeAt(l++), s !== 42 && s !== 45 && s !== 95)) return !1;
    for(i = 1; l < u;){
        if (c = e.src.charCodeAt(l++), c !== s && !$b19ca0fdfcbacc57$var$U9(c)) return !1;
        c === s && i++;
    }
    return i < 3 ? !1 : (o || (e.line = t + 1, a = e.push("hr", "hr", 0), a.map = [
        t,
        e.line
    ], a.markup = Array(i + 1).join(String.fromCharCode(s))), !0);
}, $b19ca0fdfcbacc57$var$Zr = $b19ca0fdfcbacc57$var$$.isSpace;
function $b19ca0fdfcbacc57$var$Ht(n, e) {
    var t, r, o, s;
    return r = n.bMarks[e] + n.tShift[e], o = n.eMarks[e], t = n.src.charCodeAt(r++), t !== 42 && t !== 45 && t !== 43 || r < o && (s = n.src.charCodeAt(r), !$b19ca0fdfcbacc57$var$Zr(s)) ? -1 : r;
}
function $b19ca0fdfcbacc57$var$Vt(n, e) {
    var t, r = n.bMarks[e] + n.tShift[e], o = r, s = n.eMarks[e];
    if (o + 1 >= s || (t = n.src.charCodeAt(o++), t < 48 || t > 57)) return -1;
    for(;;){
        if (o >= s) return -1;
        if (t = n.src.charCodeAt(o++), t >= 48 && t <= 57) {
            if (o - r >= 10) return -1;
            continue;
        }
        if (t === 41 || t === 46) break;
        return -1;
    }
    return o < s && (t = n.src.charCodeAt(o), !$b19ca0fdfcbacc57$var$Zr(t)) ? -1 : o;
}
function $b19ca0fdfcbacc57$var$V9(n, e) {
    var t, r, o = n.level + 2;
    for(t = e + 2, r = n.tokens.length - 2; t < r; t++)n.tokens[t].level === o && n.tokens[t].type === "paragraph_open" && (n.tokens[t + 2].hidden = !0, n.tokens[t].hidden = !0, t += 2);
}
var $b19ca0fdfcbacc57$var$G9 = function(e, t, r, o) {
    var s, i, c, a, l, u, p, f, h, d, g, E, x, b, A, D, L, v, O, z, j, M, K, q, Z, _, T, w = t, m = !1, k = !0;
    if (e.sCount[w] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[w] - e.listIndent >= 4 && e.sCount[w] < e.blkIndent) return !1;
    if (o && e.parentType === "paragraph" && e.sCount[w] >= e.blkIndent && (m = !0), (M = $b19ca0fdfcbacc57$var$Vt(e, w)) >= 0) {
        if (p = !0, q = e.bMarks[w] + e.tShift[w], x = Number(e.src.slice(q, M - 1)), m && x !== 1) return !1;
    } else if ((M = $b19ca0fdfcbacc57$var$Ht(e, w)) >= 0) p = !1;
    else return !1;
    if (m && e.skipSpaces(M) >= e.eMarks[w]) return !1;
    if (o) return !0;
    for(E = e.src.charCodeAt(M - 1), g = e.tokens.length, p ? (T = e.push("ordered_list_open", "ol", 1), x !== 1 && (T.attrs = [
        [
            "start",
            x
        ]
    ])) : T = e.push("bullet_list_open", "ul", 1), T.map = d = [
        w,
        0
    ], T.markup = String.fromCharCode(E), K = !1, _ = e.md.block.ruler.getRules("list"), L = e.parentType, e.parentType = "list"; w < r;){
        for(j = M, b = e.eMarks[w], u = A = e.sCount[w] + M - (e.bMarks[w] + e.tShift[w]); j < b;){
            if (s = e.src.charCodeAt(j), s === 9) A += 4 - (A + e.bsCount[w]) % 4;
            else if (s === 32) A++;
            else break;
            j++;
        }
        if (i = j, i >= b ? l = 1 : l = A - u, l > 4 && (l = 1), a = u + l, T = e.push("list_item_open", "li", 1), T.markup = String.fromCharCode(E), T.map = f = [
            w,
            0
        ], p && (T.info = e.src.slice(q, M - 1)), z = e.tight, O = e.tShift[w], v = e.sCount[w], D = e.listIndent, e.listIndent = e.blkIndent, e.blkIndent = a, e.tight = !0, e.tShift[w] = i - e.bMarks[w], e.sCount[w] = A, i >= b && e.isEmpty(w + 1) ? e.line = Math.min(e.line + 2, r) : e.md.block.tokenize(e, w, r, !0), (!e.tight || K) && (k = !1), K = e.line - w > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = D, e.tShift[w] = O, e.sCount[w] = v, e.tight = z, T = e.push("list_item_close", "li", -1), T.markup = String.fromCharCode(E), w = e.line, f[1] = w, w >= r || e.sCount[w] < e.blkIndent || e.sCount[w] - e.blkIndent >= 4) break;
        for(Z = !1, c = 0, h = _.length; c < h; c++)if (_[c](e, w, r, !0)) {
            Z = !0;
            break;
        }
        if (Z) break;
        if (p) {
            if (M = $b19ca0fdfcbacc57$var$Vt(e, w), M < 0) break;
            q = e.bMarks[w] + e.tShift[w];
        } else if (M = $b19ca0fdfcbacc57$var$Ht(e, w), M < 0) break;
        if (E !== e.src.charCodeAt(M - 1)) break;
    }
    return p ? T = e.push("ordered_list_close", "ol", -1) : T = e.push("bullet_list_close", "ul", -1), T.markup = String.fromCharCode(E), d[1] = w, e.line = w, e.parentType = L, k && $b19ca0fdfcbacc57$var$V9(e, g), !0;
}, $b19ca0fdfcbacc57$var$j9 = $b19ca0fdfcbacc57$var$$.normalizeReference, $b19ca0fdfcbacc57$var$en = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$Z9 = function(e, t, r, o) {
    var s, i, c, a, l, u, p, f, h, d, g, E, x, b, A, D, L = 0, v = e.bMarks[t] + e.tShift[t], O = e.eMarks[t], z = t + 1;
    if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(v) !== 91) return !1;
    for(; ++v < O;)if (e.src.charCodeAt(v) === 93 && e.src.charCodeAt(v - 1) !== 92) {
        if (v + 1 === O || e.src.charCodeAt(v + 1) !== 58) return !1;
        break;
    }
    for(a = e.lineMax, A = e.md.block.ruler.getRules("reference"), d = e.parentType, e.parentType = "reference"; z < a && !e.isEmpty(z); z++)if (!(e.sCount[z] - e.blkIndent > 3) && !(e.sCount[z] < 0)) {
        for(b = !1, u = 0, p = A.length; u < p; u++)if (A[u](e, z, a, !0)) {
            b = !0;
            break;
        }
        if (b) break;
    }
    for(x = e.getLines(t, z, e.blkIndent, !1).trim(), O = x.length, v = 1; v < O; v++){
        if (s = x.charCodeAt(v), s === 91) return !1;
        if (s === 93) {
            h = v;
            break;
        } else s === 10 ? L++ : s === 92 && (v++, v < O && x.charCodeAt(v) === 10 && L++);
    }
    if (h < 0 || x.charCodeAt(h + 1) !== 58) return !1;
    for(v = h + 2; v < O; v++)if (s = x.charCodeAt(v), s === 10) L++;
    else if (!$b19ca0fdfcbacc57$var$en(s)) break;
    if (g = e.md.helpers.parseLinkDestination(x, v, O), !g.ok || (l = e.md.normalizeLink(g.str), !e.md.validateLink(l))) return !1;
    for(v = g.pos, L += g.lines, i = v, c = L, E = v; v < O; v++)if (s = x.charCodeAt(v), s === 10) L++;
    else if (!$b19ca0fdfcbacc57$var$en(s)) break;
    for(g = e.md.helpers.parseLinkTitle(x, v, O), v < O && E !== v && g.ok ? (D = g.str, v = g.pos, L += g.lines) : (D = "", v = i, L = c); v < O && (s = x.charCodeAt(v), !!$b19ca0fdfcbacc57$var$en(s));)v++;
    if (v < O && x.charCodeAt(v) !== 10 && D) for(D = "", v = i, L = c; v < O && (s = x.charCodeAt(v), !!$b19ca0fdfcbacc57$var$en(s));)v++;
    return v < O && x.charCodeAt(v) !== 10 || (f = $b19ca0fdfcbacc57$var$j9(x.slice(1, h)), !f) ? !1 : (o || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[f] > "u" && (e.env.references[f] = {
        title: D,
        href: l
    }), e.parentType = d, e.line = t + L + 1), !0);
}, $b19ca0fdfcbacc57$var$K9 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
], $b19ca0fdfcbacc57$var$gn = {}, $b19ca0fdfcbacc57$var$W9 = "[a-zA-Z_:][a-zA-Z0-9:._-]*", $b19ca0fdfcbacc57$var$Y9 = "[^\"'=<>`\\x00-\\x20]+", $b19ca0fdfcbacc57$var$J9 = "'[^']*'", $b19ca0fdfcbacc57$var$X9 = '"[^"]*"', $b19ca0fdfcbacc57$var$Q9 = "(?:" + $b19ca0fdfcbacc57$var$Y9 + "|" + $b19ca0fdfcbacc57$var$J9 + "|" + $b19ca0fdfcbacc57$var$X9 + ")", $b19ca0fdfcbacc57$var$e4 = "(?:\\s+" + $b19ca0fdfcbacc57$var$W9 + "(?:\\s*=\\s*" + $b19ca0fdfcbacc57$var$Q9 + ")?)", $b19ca0fdfcbacc57$var$Kr = "<[A-Za-z][A-Za-z0-9\\-]*" + $b19ca0fdfcbacc57$var$e4 + "*\\s*\\/?>", $b19ca0fdfcbacc57$var$Wr = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", $b19ca0fdfcbacc57$var$n4 = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", $b19ca0fdfcbacc57$var$t4 = "<[?][\\s\\S]*?[?]>", $b19ca0fdfcbacc57$var$r4 = "<![A-Z]+\\s+[^>]*>", $b19ca0fdfcbacc57$var$o4 = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", $b19ca0fdfcbacc57$var$s4 = new RegExp("^(?:" + $b19ca0fdfcbacc57$var$Kr + "|" + $b19ca0fdfcbacc57$var$Wr + "|" + $b19ca0fdfcbacc57$var$n4 + "|" + $b19ca0fdfcbacc57$var$t4 + "|" + $b19ca0fdfcbacc57$var$r4 + "|" + $b19ca0fdfcbacc57$var$o4 + ")"), $b19ca0fdfcbacc57$var$c4 = new RegExp("^(?:" + $b19ca0fdfcbacc57$var$Kr + "|" + $b19ca0fdfcbacc57$var$Wr + ")");
$b19ca0fdfcbacc57$var$gn.HTML_TAG_RE = $b19ca0fdfcbacc57$var$s4;
$b19ca0fdfcbacc57$var$gn.HTML_OPEN_CLOSE_TAG_RE = $b19ca0fdfcbacc57$var$c4;
var $b19ca0fdfcbacc57$var$i4 = $b19ca0fdfcbacc57$var$K9, $b19ca0fdfcbacc57$var$a4 = $b19ca0fdfcbacc57$var$gn.HTML_OPEN_CLOSE_TAG_RE, $b19ca0fdfcbacc57$var$Re = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        !0
    ],
    [
        /^<!--/,
        /-->/,
        !0
    ],
    [
        /^<\?/,
        /\?>/,
        !0
    ],
    [
        /^<![A-Z]/,
        />/,
        !0
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        !0
    ],
    [
        new RegExp("^</?(" + $b19ca0fdfcbacc57$var$i4.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        !0
    ],
    [
        new RegExp($b19ca0fdfcbacc57$var$a4.source + "\\s*$"),
        /^$/,
        !1
    ]
], $b19ca0fdfcbacc57$var$l4 = function(e, t, r, o) {
    var s, i, c, a, l = e.bMarks[t] + e.tShift[t], u = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(l) !== 60) return !1;
    for(a = e.src.slice(l, u), s = 0; s < $b19ca0fdfcbacc57$var$Re.length && !$b19ca0fdfcbacc57$var$Re[s][0].test(a); s++);
    if (s === $b19ca0fdfcbacc57$var$Re.length) return !1;
    if (o) return $b19ca0fdfcbacc57$var$Re[s][2];
    if (i = t + 1, !$b19ca0fdfcbacc57$var$Re[s][1].test(a)) {
        for(; i < r && !(e.sCount[i] < e.blkIndent); i++)if (l = e.bMarks[i] + e.tShift[i], u = e.eMarks[i], a = e.src.slice(l, u), $b19ca0fdfcbacc57$var$Re[s][1].test(a)) {
            a.length !== 0 && i++;
            break;
        }
    }
    return e.line = i, c = e.push("html_block", "", 0), c.map = [
        t,
        i
    ], c.content = e.getLines(t, i, e.blkIndent, !0), !0;
}, $b19ca0fdfcbacc57$var$Gt = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$u4 = function(e, t, r, o) {
    var s, i, c, a, l = e.bMarks[t] + e.tShift[t], u = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4 || (s = e.src.charCodeAt(l), s !== 35 || l >= u)) return !1;
    for(i = 1, s = e.src.charCodeAt(++l); s === 35 && l < u && i <= 6;)i++, s = e.src.charCodeAt(++l);
    return i > 6 || l < u && !$b19ca0fdfcbacc57$var$Gt(s) ? !1 : (o || (u = e.skipSpacesBack(u, l), c = e.skipCharsBack(u, 35, l), c > l && $b19ca0fdfcbacc57$var$Gt(e.src.charCodeAt(c - 1)) && (u = c), e.line = t + 1, a = e.push("heading_open", "h" + String(i), 1), a.markup = "########".slice(0, i), a.map = [
        t,
        e.line
    ], a = e.push("inline", "", 0), a.content = e.src.slice(l, u).trim(), a.map = [
        t,
        e.line
    ], a.children = [], a = e.push("heading_close", "h" + String(i), -1), a.markup = "########".slice(0, i)), !0);
}, $b19ca0fdfcbacc57$var$f4 = function(e, t, r) {
    var o, s, i, c, a, l, u, p, f, h = t + 1, d, g = e.md.block.ruler.getRules("paragraph");
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    for(d = e.parentType, e.parentType = "paragraph"; h < r && !e.isEmpty(h); h++)if (!(e.sCount[h] - e.blkIndent > 3)) {
        if (e.sCount[h] >= e.blkIndent && (l = e.bMarks[h] + e.tShift[h], u = e.eMarks[h], l < u && (f = e.src.charCodeAt(l), (f === 45 || f === 61) && (l = e.skipChars(l, f), l = e.skipSpaces(l), l >= u)))) {
            p = f === 61 ? 1 : 2;
            break;
        }
        if (!(e.sCount[h] < 0)) {
            for(s = !1, i = 0, c = g.length; i < c; i++)if (g[i](e, h, r, !0)) {
                s = !0;
                break;
            }
            if (s) break;
        }
    }
    return p ? (o = e.getLines(t, h, e.blkIndent, !1).trim(), e.line = h + 1, a = e.push("heading_open", "h" + String(p), 1), a.markup = String.fromCharCode(f), a.map = [
        t,
        e.line
    ], a = e.push("inline", "", 0), a.content = o, a.map = [
        t,
        e.line - 1
    ], a.children = [], a = e.push("heading_close", "h" + String(p), -1), a.markup = String.fromCharCode(f), e.parentType = d, !0) : !1;
}, $b19ca0fdfcbacc57$var$p4 = function(e, t, r) {
    var o, s, i, c, a, l, u = t + 1, p = e.md.block.ruler.getRules("paragraph");
    for(l = e.parentType, e.parentType = "paragraph"; u < r && !e.isEmpty(u); u++)if (!(e.sCount[u] - e.blkIndent > 3) && !(e.sCount[u] < 0)) {
        for(s = !1, i = 0, c = p.length; i < c; i++)if (p[i](e, u, r, !0)) {
            s = !0;
            break;
        }
        if (s) break;
    }
    return o = e.getLines(t, u, e.blkIndent, !1).trim(), e.line = u, a = e.push("paragraph_open", "p", 1), a.map = [
        t,
        e.line
    ], a = e.push("inline", "", 0), a.content = o, a.map = [
        t,
        e.line
    ], a.children = [], a = e.push("paragraph_close", "p", -1), e.parentType = l, !0;
}, $b19ca0fdfcbacc57$var$Yr = $b19ca0fdfcbacc57$var$Qn, $b19ca0fdfcbacc57$var$mn = $b19ca0fdfcbacc57$var$$.isSpace;
function $b19ca0fdfcbacc57$var$me(n, e, t, r) {
    var o, s, i, c, a, l, u, p;
    for(this.src = n, this.md = e, this.env = t, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", s = this.src, p = !1, i = c = l = u = 0, a = s.length; c < a; c++){
        if (o = s.charCodeAt(c), !p) {
            if ($b19ca0fdfcbacc57$var$mn(o)) {
                l++, o === 9 ? u += 4 - u % 4 : u++;
                continue;
            } else p = !0;
        }
        (o === 10 || c === a - 1) && (o !== 10 && c++, this.bMarks.push(i), this.eMarks.push(c), this.tShift.push(l), this.sCount.push(u), this.bsCount.push(0), p = !1, l = 0, u = 0, i = c + 1);
    }
    this.bMarks.push(s.length), this.eMarks.push(s.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
$b19ca0fdfcbacc57$var$me.prototype.push = function(n, e, t) {
    var r = new $b19ca0fdfcbacc57$var$Yr(n, e, t);
    return r.block = !0, t < 0 && this.level--, r.level = this.level, t > 0 && this.level++, this.tokens.push(r), r;
};
$b19ca0fdfcbacc57$var$me.prototype.isEmpty = function(e) {
    return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
$b19ca0fdfcbacc57$var$me.prototype.skipEmptyLines = function(e) {
    for(var t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++);
    return e;
};
$b19ca0fdfcbacc57$var$me.prototype.skipSpaces = function(e) {
    for(var t, r = this.src.length; e < r && (t = this.src.charCodeAt(e), !!$b19ca0fdfcbacc57$var$mn(t)); e++);
    return e;
};
$b19ca0fdfcbacc57$var$me.prototype.skipSpacesBack = function(e, t) {
    if (e <= t) return e;
    for(; e > t;)if (!$b19ca0fdfcbacc57$var$mn(this.src.charCodeAt(--e))) return e + 1;
    return e;
};
$b19ca0fdfcbacc57$var$me.prototype.skipChars = function(e, t) {
    for(var r = this.src.length; e < r && this.src.charCodeAt(e) === t; e++);
    return e;
};
$b19ca0fdfcbacc57$var$me.prototype.skipCharsBack = function(e, t, r) {
    if (e <= r) return e;
    for(; e > r;)if (t !== this.src.charCodeAt(--e)) return e + 1;
    return e;
};
$b19ca0fdfcbacc57$var$me.prototype.getLines = function(e, t, r, o) {
    var s, i, c, a, l, u, p, f = e;
    if (e >= t) return "";
    for(u = new Array(t - e), s = 0; f < t; f++, s++){
        for(i = 0, p = a = this.bMarks[f], f + 1 < t || o ? l = this.eMarks[f] + 1 : l = this.eMarks[f]; a < l && i < r;){
            if (c = this.src.charCodeAt(a), $b19ca0fdfcbacc57$var$mn(c)) c === 9 ? i += 4 - (i + this.bsCount[f]) % 4 : i++;
            else if (a - p < this.tShift[f]) i++;
            else break;
            a++;
        }
        i > r ? u[s] = new Array(i - r + 1).join(" ") + this.src.slice(a, l) : u[s] = this.src.slice(a, l);
    }
    return u.join("");
};
$b19ca0fdfcbacc57$var$me.prototype.Token = $b19ca0fdfcbacc57$var$Yr;
var $b19ca0fdfcbacc57$var$h4 = $b19ca0fdfcbacc57$var$me, $b19ca0fdfcbacc57$var$d4 = $b19ca0fdfcbacc57$var$Xn, $b19ca0fdfcbacc57$var$nn = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        $b19ca0fdfcbacc57$var$F9,
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        $b19ca0fdfcbacc57$var$B9
    ],
    [
        "fence",
        $b19ca0fdfcbacc57$var$P9,
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        $b19ca0fdfcbacc57$var$z9,
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        $b19ca0fdfcbacc57$var$H9,
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        $b19ca0fdfcbacc57$var$G9,
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        $b19ca0fdfcbacc57$var$Z9
    ],
    [
        "html_block",
        $b19ca0fdfcbacc57$var$l4,
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        $b19ca0fdfcbacc57$var$u4,
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        $b19ca0fdfcbacc57$var$f4
    ],
    [
        "paragraph",
        $b19ca0fdfcbacc57$var$p4
    ]
];
function $b19ca0fdfcbacc57$var$_n() {
    this.ruler = new $b19ca0fdfcbacc57$var$d4();
    for(var n = 0; n < $b19ca0fdfcbacc57$var$nn.length; n++)this.ruler.push($b19ca0fdfcbacc57$var$nn[n][0], $b19ca0fdfcbacc57$var$nn[n][1], {
        alt: ($b19ca0fdfcbacc57$var$nn[n][2] || []).slice()
    });
}
$b19ca0fdfcbacc57$var$_n.prototype.tokenize = function(n, e, t) {
    for(var r, o, s, i = this.ruler.getRules(""), c = i.length, a = e, l = !1, u = n.md.options.maxNesting; a < t && (n.line = a = n.skipEmptyLines(a), !(a >= t || n.sCount[a] < n.blkIndent));){
        if (n.level >= u) {
            n.line = t;
            break;
        }
        for(s = n.line, o = 0; o < c; o++)if (r = i[o](n, a, t, !1), r) {
            if (s >= n.line) throw new Error("block rule didn't increment state.line");
            break;
        }
        if (!r) throw new Error("none of the block rules matched");
        n.tight = !l, n.isEmpty(n.line - 1) && (l = !0), a = n.line, a < t && n.isEmpty(a) && (l = !0, a++, n.line = a);
    }
};
$b19ca0fdfcbacc57$var$_n.prototype.parse = function(n, e, t, r) {
    var o;
    n && (o = new this.State(n, e, t, r), this.tokenize(o, o.line, o.lineMax));
};
$b19ca0fdfcbacc57$var$_n.prototype.State = $b19ca0fdfcbacc57$var$h4;
var $b19ca0fdfcbacc57$var$g4 = $b19ca0fdfcbacc57$var$_n;
function $b19ca0fdfcbacc57$var$m4(n) {
    switch(n){
        case 10:
        case 33:
        case 35:
        case 36:
        case 37:
        case 38:
        case 42:
        case 43:
        case 45:
        case 58:
        case 60:
        case 61:
        case 62:
        case 64:
        case 91:
        case 92:
        case 93:
        case 94:
        case 95:
        case 96:
        case 123:
        case 125:
        case 126:
            return !0;
        default:
            return !1;
    }
}
var $b19ca0fdfcbacc57$var$_4 = function(e, t) {
    for(var r = e.pos; r < e.posMax && !$b19ca0fdfcbacc57$var$m4(e.src.charCodeAt(r));)r++;
    return r === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, r)), e.pos = r, !0);
}, $b19ca0fdfcbacc57$var$b4 = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i, $b19ca0fdfcbacc57$var$v4 = function(e, t) {
    var r, o, s, i, c, a, l, u;
    return !e.md.options.linkify || e.linkLevel > 0 || (r = e.pos, o = e.posMax, r + 3 > o) || e.src.charCodeAt(r) !== 58 || e.src.charCodeAt(r + 1) !== 47 || e.src.charCodeAt(r + 2) !== 47 || (s = e.pending.match($b19ca0fdfcbacc57$var$b4), !s) || (i = s[1], c = e.md.linkify.matchAtStart(e.src.slice(r - i.length)), !c) || (a = c.url, a.length <= i.length) || (a = a.replace(/\*+$/, ""), l = e.md.normalizeLink(a), !e.md.validateLink(l)) ? !1 : (t || (e.pending = e.pending.slice(0, -i.length), u = e.push("link_open", "a", 1), u.attrs = [
        [
            "href",
            l
        ]
    ], u.markup = "linkify", u.info = "auto", u = e.push("text", "", 0), u.content = e.md.normalizeLinkText(a), u = e.push("link_close", "a", -1), u.markup = "linkify", u.info = "auto"), e.pos += a.length - i.length, !0);
}, $b19ca0fdfcbacc57$var$k4 = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$x4 = function(e, t) {
    var r, o, s, i = e.pos;
    if (e.src.charCodeAt(i) !== 10) return !1;
    if (r = e.pending.length - 1, o = e.posMax, !t) {
        if (r >= 0 && e.pending.charCodeAt(r) === 32) {
            if (r >= 1 && e.pending.charCodeAt(r - 1) === 32) {
                for(s = r - 1; s >= 1 && e.pending.charCodeAt(s - 1) === 32;)s--;
                e.pending = e.pending.slice(0, s), e.push("hardbreak", "br", 0);
            } else e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
        } else e.push("softbreak", "br", 0);
    }
    for(i++; i < o && $b19ca0fdfcbacc57$var$k4(e.src.charCodeAt(i));)i++;
    return e.pos = i, !0;
}, $b19ca0fdfcbacc57$var$y4 = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$nt = [];
for(var $b19ca0fdfcbacc57$var$jt = 0; $b19ca0fdfcbacc57$var$jt < 256; $b19ca0fdfcbacc57$var$jt++)$b19ca0fdfcbacc57$var$nt.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(n) {
    $b19ca0fdfcbacc57$var$nt[n.charCodeAt(0)] = 1;
});
var $b19ca0fdfcbacc57$var$E4 = function(e, t) {
    var r, o, s, i, c, a = e.pos, l = e.posMax;
    if (e.src.charCodeAt(a) !== 92 || (a++, a >= l)) return !1;
    if (r = e.src.charCodeAt(a), r === 10) {
        for(t || e.push("hardbreak", "br", 0), a++; a < l && (r = e.src.charCodeAt(a), !!$b19ca0fdfcbacc57$var$y4(r));)a++;
        return e.pos = a, !0;
    }
    return i = e.src[a], r >= 55296 && r <= 56319 && a + 1 < l && (o = e.src.charCodeAt(a + 1), o >= 56320 && o <= 57343 && (i += e.src[a + 1], a++)), s = "\\" + i, t || (c = e.push("text_special", "", 0), r < 256 && $b19ca0fdfcbacc57$var$nt[r] !== 0 ? c.content = i : c.content = s, c.markup = s, c.info = "escape"), e.pos = a + 1, !0;
}, $b19ca0fdfcbacc57$var$w4 = function(e, t) {
    var r, o, s, i, c, a, l, u, p = e.pos, f = e.src.charCodeAt(p);
    if (f !== 96) return !1;
    for(r = p, p++, o = e.posMax; p < o && e.src.charCodeAt(p) === 96;)p++;
    if (s = e.src.slice(r, p), l = s.length, e.backticksScanned && (e.backticks[l] || 0) <= r) return t || (e.pending += s), e.pos += l, !0;
    for(a = p; (c = e.src.indexOf("`", a)) !== -1;){
        for(a = c + 1; a < o && e.src.charCodeAt(a) === 96;)a++;
        if (u = a - c, u === l) return t || (i = e.push("code_inline", "code", 0), i.markup = s, i.content = e.src.slice(p, c).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), e.pos = a, !0;
        e.backticks[u] = c;
    }
    return e.backticksScanned = !0, t || (e.pending += s), e.pos += l, !0;
}, $b19ca0fdfcbacc57$var$bn = {};
$b19ca0fdfcbacc57$var$bn.tokenize = function(e, t) {
    var r, o, s, i, c, a = e.pos, l = e.src.charCodeAt(a);
    if (t || l !== 126 || (o = e.scanDelims(e.pos, !0), i = o.length, c = String.fromCharCode(l), i < 2)) return !1;
    for(i % 2 && (s = e.push("text", "", 0), s.content = c, i--), r = 0; r < i; r += 2)s = e.push("text", "", 0), s.content = c + c, e.delimiters.push({
        marker: l,
        length: 0,
        // disable "rule of 3" length checks meant for emphasis
        token: e.tokens.length - 1,
        end: -1,
        open: o.can_open,
        close: o.can_close
    });
    return e.pos += o.length, !0;
};
function $b19ca0fdfcbacc57$var$Zt(n, e) {
    var t, r, o, s, i, c = [], a = e.length;
    for(t = 0; t < a; t++)o = e[t], o.marker === 126 && o.end !== -1 && (s = e[o.end], i = n.tokens[o.token], i.type = "s_open", i.tag = "s", i.nesting = 1, i.markup = "~~", i.content = "", i = n.tokens[s.token], i.type = "s_close", i.tag = "s", i.nesting = -1, i.markup = "~~", i.content = "", n.tokens[s.token - 1].type === "text" && n.tokens[s.token - 1].content === "~" && c.push(s.token - 1));
    for(; c.length;){
        for(t = c.pop(), r = t + 1; r < n.tokens.length && n.tokens[r].type === "s_close";)r++;
        r--, t !== r && (i = n.tokens[r], n.tokens[r] = n.tokens[t], n.tokens[t] = i);
    }
}
$b19ca0fdfcbacc57$var$bn.postProcess = function(e) {
    var t, r = e.tokens_meta, o = e.tokens_meta.length;
    for($b19ca0fdfcbacc57$var$Zt(e, e.delimiters), t = 0; t < o; t++)r[t] && r[t].delimiters && $b19ca0fdfcbacc57$var$Zt(e, r[t].delimiters);
};
var $b19ca0fdfcbacc57$var$vn = {};
$b19ca0fdfcbacc57$var$vn.tokenize = function(e, t) {
    var r, o, s, i = e.pos, c = e.src.charCodeAt(i);
    if (t || c !== 95 && c !== 42) return !1;
    for(o = e.scanDelims(e.pos, c === 42), r = 0; r < o.length; r++)s = e.push("text", "", 0), s.content = String.fromCharCode(c), e.delimiters.push({
        // Char code of the starting marker (number).
        //
        marker: c,
        // Total length of these series of delimiters.
        //
        length: o.length,
        // A position of the token this delimiter corresponds to.
        //
        token: e.tokens.length - 1,
        // If this delimiter is matched as a valid opener, `end` will be
        // equal to its position, otherwise it's `-1`.
        //
        end: -1,
        // Boolean flags that determine if this delimiter could open or close
        // an emphasis.
        //
        open: o.can_open,
        close: o.can_close
    });
    return e.pos += o.length, !0;
};
function $b19ca0fdfcbacc57$var$Kt(n, e) {
    var t, r, o, s, i, c, a = e.length;
    for(t = a - 1; t >= 0; t--)r = e[t], !(r.marker !== 95 && r.marker !== 42) && r.end !== -1 && (o = e[r.end], c = t > 0 && e[t - 1].end === r.end + 1 && // check that first two markers match and adjacent
    e[t - 1].marker === r.marker && e[t - 1].token === r.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    e[r.end + 1].token === o.token + 1, i = String.fromCharCode(r.marker), s = n.tokens[r.token], s.type = c ? "strong_open" : "em_open", s.tag = c ? "strong" : "em", s.nesting = 1, s.markup = c ? i + i : i, s.content = "", s = n.tokens[o.token], s.type = c ? "strong_close" : "em_close", s.tag = c ? "strong" : "em", s.nesting = -1, s.markup = c ? i + i : i, s.content = "", c && (n.tokens[e[t - 1].token].content = "", n.tokens[e[r.end + 1].token].content = "", t--));
}
$b19ca0fdfcbacc57$var$vn.postProcess = function(e) {
    var t, r = e.tokens_meta, o = e.tokens_meta.length;
    for($b19ca0fdfcbacc57$var$Kt(e, e.delimiters), t = 0; t < o; t++)r[t] && r[t].delimiters && $b19ca0fdfcbacc57$var$Kt(e, r[t].delimiters);
};
var $b19ca0fdfcbacc57$var$A4 = $b19ca0fdfcbacc57$var$$.normalizeReference, $b19ca0fdfcbacc57$var$qn = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$C4 = function(e, t) {
    var r, o, s, i, c, a, l, u, p, f = "", h = "", d = e.pos, g = e.posMax, E = e.pos, x = !0;
    if (e.src.charCodeAt(e.pos) !== 91 || (c = e.pos + 1, i = e.md.helpers.parseLinkLabel(e, e.pos, !0), i < 0)) return !1;
    if (a = i + 1, a < g && e.src.charCodeAt(a) === 40) {
        for(x = !1, a++; a < g && (o = e.src.charCodeAt(a), !(!$b19ca0fdfcbacc57$var$qn(o) && o !== 10)); a++);
        if (a >= g) return !1;
        if (E = a, l = e.md.helpers.parseLinkDestination(e.src, a, e.posMax), l.ok) {
            for(f = e.md.normalizeLink(l.str), e.md.validateLink(f) ? a = l.pos : f = "", E = a; a < g && (o = e.src.charCodeAt(a), !(!$b19ca0fdfcbacc57$var$qn(o) && o !== 10)); a++);
            if (l = e.md.helpers.parseLinkTitle(e.src, a, e.posMax), a < g && E !== a && l.ok) for(h = l.str, a = l.pos; a < g && (o = e.src.charCodeAt(a), !(!$b19ca0fdfcbacc57$var$qn(o) && o !== 10)); a++);
        }
        (a >= g || e.src.charCodeAt(a) !== 41) && (x = !0), a++;
    }
    if (x) {
        if (typeof e.env.references > "u") return !1;
        if (a < g && e.src.charCodeAt(a) === 91 ? (E = a + 1, a = e.md.helpers.parseLinkLabel(e, a), a >= 0 ? s = e.src.slice(E, a++) : a = i + 1) : a = i + 1, s || (s = e.src.slice(c, i)), u = e.env.references[$b19ca0fdfcbacc57$var$A4(s)], !u) return e.pos = d, !1;
        f = u.href, h = u.title;
    }
    return t || (e.pos = c, e.posMax = i, p = e.push("link_open", "a", 1), p.attrs = r = [
        [
            "href",
            f
        ]
    ], h && r.push([
        "title",
        h
    ]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, p = e.push("link_close", "a", -1)), e.pos = a, e.posMax = g, !0;
}, $b19ca0fdfcbacc57$var$S4 = $b19ca0fdfcbacc57$var$$.normalizeReference, $b19ca0fdfcbacc57$var$Mn = $b19ca0fdfcbacc57$var$$.isSpace, $b19ca0fdfcbacc57$var$D4 = function(e, t) {
    var r, o, s, i, c, a, l, u, p, f, h, d, g, E = "", x = e.pos, b = e.posMax;
    if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91 || (a = e.pos + 2, c = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1), c < 0)) return !1;
    if (l = c + 1, l < b && e.src.charCodeAt(l) === 40) {
        for(l++; l < b && (o = e.src.charCodeAt(l), !(!$b19ca0fdfcbacc57$var$Mn(o) && o !== 10)); l++);
        if (l >= b) return !1;
        for(g = l, p = e.md.helpers.parseLinkDestination(e.src, l, e.posMax), p.ok && (E = e.md.normalizeLink(p.str), e.md.validateLink(E) ? l = p.pos : E = ""), g = l; l < b && (o = e.src.charCodeAt(l), !(!$b19ca0fdfcbacc57$var$Mn(o) && o !== 10)); l++);
        if (p = e.md.helpers.parseLinkTitle(e.src, l, e.posMax), l < b && g !== l && p.ok) for(f = p.str, l = p.pos; l < b && (o = e.src.charCodeAt(l), !(!$b19ca0fdfcbacc57$var$Mn(o) && o !== 10)); l++);
        else f = "";
        if (l >= b || e.src.charCodeAt(l) !== 41) return e.pos = x, !1;
        l++;
    } else {
        if (typeof e.env.references > "u") return !1;
        if (l < b && e.src.charCodeAt(l) === 91 ? (g = l + 1, l = e.md.helpers.parseLinkLabel(e, l), l >= 0 ? i = e.src.slice(g, l++) : l = c + 1) : l = c + 1, i || (i = e.src.slice(a, c)), u = e.env.references[$b19ca0fdfcbacc57$var$S4(i)], !u) return e.pos = x, !1;
        E = u.href, f = u.title;
    }
    return t || (s = e.src.slice(a, c), e.md.inline.parse(s, e.md, e.env, d = []), h = e.push("image", "img", 0), h.attrs = r = [
        [
            "src",
            E
        ],
        [
            "alt",
            ""
        ]
    ], h.children = d, h.content = s, f && r.push([
        "title",
        f
    ])), e.pos = l, e.posMax = b, !0;
}, $b19ca0fdfcbacc57$var$T4 = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, $b19ca0fdfcbacc57$var$R4 = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/, $b19ca0fdfcbacc57$var$L4 = function(e, t) {
    var r, o, s, i, c, a, l = e.pos;
    if (e.src.charCodeAt(l) !== 60) return !1;
    for(c = e.pos, a = e.posMax;;){
        if (++l >= a || (i = e.src.charCodeAt(l), i === 60)) return !1;
        if (i === 62) break;
    }
    return r = e.src.slice(c + 1, l), $b19ca0fdfcbacc57$var$R4.test(r) ? (o = e.md.normalizeLink(r), e.md.validateLink(o) ? (t || (s = e.push("link_open", "a", 1), s.attrs = [
        [
            "href",
            o
        ]
    ], s.markup = "autolink", s.info = "auto", s = e.push("text", "", 0), s.content = e.md.normalizeLinkText(r), s = e.push("link_close", "a", -1), s.markup = "autolink", s.info = "auto"), e.pos += r.length + 2, !0) : !1) : $b19ca0fdfcbacc57$var$T4.test(r) ? (o = e.md.normalizeLink("mailto:" + r), e.md.validateLink(o) ? (t || (s = e.push("link_open", "a", 1), s.attrs = [
        [
            "href",
            o
        ]
    ], s.markup = "autolink", s.info = "auto", s = e.push("text", "", 0), s.content = e.md.normalizeLinkText(r), s = e.push("link_close", "a", -1), s.markup = "autolink", s.info = "auto"), e.pos += r.length + 2, !0) : !1) : !1;
}, $b19ca0fdfcbacc57$var$N4 = $b19ca0fdfcbacc57$var$gn.HTML_TAG_RE;
function $b19ca0fdfcbacc57$var$q4(n) {
    return /^<a[>\s]/i.test(n);
}
function $b19ca0fdfcbacc57$var$M4(n) {
    return /^<\/a\s*>/i.test(n);
}
function $b19ca0fdfcbacc57$var$I4(n) {
    var e = n | 32;
    return e >= 97 && e <= 122;
}
var $b19ca0fdfcbacc57$var$O4 = function(e, t) {
    var r, o, s, i, c = e.pos;
    return !e.md.options.html || (s = e.posMax, e.src.charCodeAt(c) !== 60 || c + 2 >= s) || (r = e.src.charCodeAt(c + 1), r !== 33 && r !== 63 && r !== 47 && !$b19ca0fdfcbacc57$var$I4(r)) || (o = e.src.slice(c).match($b19ca0fdfcbacc57$var$N4), !o) ? !1 : (t || (i = e.push("html_inline", "", 0), i.content = o[0], $b19ca0fdfcbacc57$var$q4(i.content) && e.linkLevel++, $b19ca0fdfcbacc57$var$M4(i.content) && e.linkLevel--), e.pos += o[0].length, !0);
}, $b19ca0fdfcbacc57$var$Wt = $b19ca0fdfcbacc57$var$zr, $b19ca0fdfcbacc57$var$F4 = $b19ca0fdfcbacc57$var$$.has, $b19ca0fdfcbacc57$var$B4 = $b19ca0fdfcbacc57$var$$.isValidEntityCode, $b19ca0fdfcbacc57$var$Yt = $b19ca0fdfcbacc57$var$$.fromCodePoint, $b19ca0fdfcbacc57$var$P4 = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, $b19ca0fdfcbacc57$var$$4 = /^&([a-z][a-z0-9]{1,31});/i, $b19ca0fdfcbacc57$var$z4 = function(e, t) {
    var r, o, s, i, c = e.pos, a = e.posMax;
    if (e.src.charCodeAt(c) !== 38 || c + 1 >= a) return !1;
    if (r = e.src.charCodeAt(c + 1), r === 35) {
        if (s = e.src.slice(c).match($b19ca0fdfcbacc57$var$P4), s) return t || (o = s[1][0].toLowerCase() === "x" ? parseInt(s[1].slice(1), 16) : parseInt(s[1], 10), i = e.push("text_special", "", 0), i.content = $b19ca0fdfcbacc57$var$B4(o) ? $b19ca0fdfcbacc57$var$Yt(o) : $b19ca0fdfcbacc57$var$Yt(65533), i.markup = s[0], i.info = "entity"), e.pos += s[0].length, !0;
    } else if (s = e.src.slice(c).match($b19ca0fdfcbacc57$var$$4), s && $b19ca0fdfcbacc57$var$F4($b19ca0fdfcbacc57$var$Wt, s[1])) return t || (i = e.push("text_special", "", 0), i.content = $b19ca0fdfcbacc57$var$Wt[s[1]], i.markup = s[0], i.info = "entity"), e.pos += s[0].length, !0;
    return !1;
};
function $b19ca0fdfcbacc57$var$Jt(n) {
    var e, t, r, o, s, i, c, a, l = {}, u = n.length;
    if (u) {
        var p = 0, f = -2, h = [];
        for(e = 0; e < u; e++)if (r = n[e], h.push(0), (n[p].marker !== r.marker || f !== r.token - 1) && (p = e), f = r.token, r.length = r.length || 0, !!r.close) {
            for(l.hasOwnProperty(r.marker) || (l[r.marker] = [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ]), s = l[r.marker][(r.open ? 3 : 0) + r.length % 3], t = p - h[p] - 1, i = t; t > s; t -= h[t] + 1)if (o = n[t], o.marker === r.marker && o.open && o.end < 0 && (c = !1, (o.close || r.open) && (o.length + r.length) % 3 === 0 && (o.length % 3 !== 0 || r.length % 3 !== 0) && (c = !0), !c)) {
                a = t > 0 && !n[t - 1].open ? h[t - 1] + 1 : 0, h[e] = e - t + a, h[t] = a, r.open = !1, o.end = e, o.close = !1, i = -1, f = -2;
                break;
            }
            i !== -1 && (l[r.marker][(r.open ? 3 : 0) + (r.length || 0) % 3] = i);
        }
    }
}
var $b19ca0fdfcbacc57$var$U4 = function(e) {
    var t, r = e.tokens_meta, o = e.tokens_meta.length;
    for($b19ca0fdfcbacc57$var$Jt(e.delimiters), t = 0; t < o; t++)r[t] && r[t].delimiters && $b19ca0fdfcbacc57$var$Jt(r[t].delimiters);
}, $b19ca0fdfcbacc57$var$H4 = function(e) {
    var t, r, o = 0, s = e.tokens, i = e.tokens.length;
    for(t = r = 0; t < i; t++)s[t].nesting < 0 && o--, s[t].level = o, s[t].nesting > 0 && o++, s[t].type === "text" && t + 1 < i && s[t + 1].type === "text" ? s[t + 1].content = s[t].content + s[t + 1].content : (t !== r && (s[r] = s[t]), r++);
    t !== r && (s.length = r);
}, $b19ca0fdfcbacc57$var$tt = $b19ca0fdfcbacc57$var$Qn, $b19ca0fdfcbacc57$var$Xt = $b19ca0fdfcbacc57$var$$.isWhiteSpace, $b19ca0fdfcbacc57$var$Qt = $b19ca0fdfcbacc57$var$$.isPunctChar, $b19ca0fdfcbacc57$var$er = $b19ca0fdfcbacc57$var$$.isMdAsciiPunct;
function $b19ca0fdfcbacc57$var$je(n, e, t, r) {
    this.src = n, this.env = t, this.md = e, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
$b19ca0fdfcbacc57$var$je.prototype.pushPending = function() {
    var n = new $b19ca0fdfcbacc57$var$tt("text", "", 0);
    return n.content = this.pending, n.level = this.pendingLevel, this.tokens.push(n), this.pending = "", n;
};
$b19ca0fdfcbacc57$var$je.prototype.push = function(n, e, t) {
    this.pending && this.pushPending();
    var r = new $b19ca0fdfcbacc57$var$tt(n, e, t), o = null;
    return t < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, t > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], o = {
        delimiters: this.delimiters
    }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(o), r;
};
$b19ca0fdfcbacc57$var$je.prototype.scanDelims = function(n, e) {
    var t = n, r, o, s, i, c, a, l, u, p, f = !0, h = !0, d = this.posMax, g = this.src.charCodeAt(n);
    for(r = n > 0 ? this.src.charCodeAt(n - 1) : 32; t < d && this.src.charCodeAt(t) === g;)t++;
    return s = t - n, o = t < d ? this.src.charCodeAt(t) : 32, l = $b19ca0fdfcbacc57$var$er(r) || $b19ca0fdfcbacc57$var$Qt(String.fromCharCode(r)), p = $b19ca0fdfcbacc57$var$er(o) || $b19ca0fdfcbacc57$var$Qt(String.fromCharCode(o)), a = $b19ca0fdfcbacc57$var$Xt(r), u = $b19ca0fdfcbacc57$var$Xt(o), u ? f = !1 : p && (a || l || (f = !1)), a ? h = !1 : l && (u || p || (h = !1)), e ? (i = f, c = h) : (i = f && (!h || l), c = h && (!f || p)), {
        can_open: i,
        can_close: c,
        length: s
    };
};
$b19ca0fdfcbacc57$var$je.prototype.Token = $b19ca0fdfcbacc57$var$tt;
var $b19ca0fdfcbacc57$var$V4 = $b19ca0fdfcbacc57$var$je, $b19ca0fdfcbacc57$var$nr = $b19ca0fdfcbacc57$var$Xn, $b19ca0fdfcbacc57$var$In = [
    [
        "text",
        $b19ca0fdfcbacc57$var$_4
    ],
    [
        "linkify",
        $b19ca0fdfcbacc57$var$v4
    ],
    [
        "newline",
        $b19ca0fdfcbacc57$var$x4
    ],
    [
        "escape",
        $b19ca0fdfcbacc57$var$E4
    ],
    [
        "backticks",
        $b19ca0fdfcbacc57$var$w4
    ],
    [
        "strikethrough",
        $b19ca0fdfcbacc57$var$bn.tokenize
    ],
    [
        "emphasis",
        $b19ca0fdfcbacc57$var$vn.tokenize
    ],
    [
        "link",
        $b19ca0fdfcbacc57$var$C4
    ],
    [
        "image",
        $b19ca0fdfcbacc57$var$D4
    ],
    [
        "autolink",
        $b19ca0fdfcbacc57$var$L4
    ],
    [
        "html_inline",
        $b19ca0fdfcbacc57$var$O4
    ],
    [
        "entity",
        $b19ca0fdfcbacc57$var$z4
    ]
], $b19ca0fdfcbacc57$var$On = [
    [
        "balance_pairs",
        $b19ca0fdfcbacc57$var$U4
    ],
    [
        "strikethrough",
        $b19ca0fdfcbacc57$var$bn.postProcess
    ],
    [
        "emphasis",
        $b19ca0fdfcbacc57$var$vn.postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        $b19ca0fdfcbacc57$var$H4
    ]
];
function $b19ca0fdfcbacc57$var$Ze() {
    var n;
    for(this.ruler = new $b19ca0fdfcbacc57$var$nr(), n = 0; n < $b19ca0fdfcbacc57$var$In.length; n++)this.ruler.push($b19ca0fdfcbacc57$var$In[n][0], $b19ca0fdfcbacc57$var$In[n][1]);
    for(this.ruler2 = new $b19ca0fdfcbacc57$var$nr(), n = 0; n < $b19ca0fdfcbacc57$var$On.length; n++)this.ruler2.push($b19ca0fdfcbacc57$var$On[n][0], $b19ca0fdfcbacc57$var$On[n][1]);
}
$b19ca0fdfcbacc57$var$Ze.prototype.skipToken = function(n) {
    var e, t, r = n.pos, o = this.ruler.getRules(""), s = o.length, i = n.md.options.maxNesting, c = n.cache;
    if (typeof c[r] < "u") {
        n.pos = c[r];
        return;
    }
    if (n.level < i) {
        for(t = 0; t < s; t++)if (n.level++, e = o[t](n, !0), n.level--, e) {
            if (r >= n.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    } else n.pos = n.posMax;
    e || n.pos++, c[r] = n.pos;
};
$b19ca0fdfcbacc57$var$Ze.prototype.tokenize = function(n) {
    for(var e, t, r, o = this.ruler.getRules(""), s = o.length, i = n.posMax, c = n.md.options.maxNesting; n.pos < i;){
        if (r = n.pos, n.level < c) {
            for(t = 0; t < s; t++)if (e = o[t](n, !1), e) {
                if (r >= n.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (e) {
            if (n.pos >= i) break;
            continue;
        }
        n.pending += n.src[n.pos++];
    }
    n.pending && n.pushPending();
};
$b19ca0fdfcbacc57$var$Ze.prototype.parse = function(n, e, t, r) {
    var o, s, i, c = new this.State(n, e, t, r);
    for(this.tokenize(c), s = this.ruler2.getRules(""), i = s.length, o = 0; o < i; o++)s[o](c);
};
$b19ca0fdfcbacc57$var$Ze.prototype.State = $b19ca0fdfcbacc57$var$V4;
var $b19ca0fdfcbacc57$var$G4 = $b19ca0fdfcbacc57$var$Ze, $b19ca0fdfcbacc57$var$Fn, $b19ca0fdfcbacc57$var$tr;
function $b19ca0fdfcbacc57$var$j4() {
    return $b19ca0fdfcbacc57$var$tr || ($b19ca0fdfcbacc57$var$tr = 1, $b19ca0fdfcbacc57$var$Fn = function(n) {
        var e = {};
        n = n || {}, e.src_Any = $b19ca0fdfcbacc57$var$Ur().source, e.src_Cc = $b19ca0fdfcbacc57$var$Hr().source, e.src_Z = $b19ca0fdfcbacc57$var$Vr().source, e.src_P = $b19ca0fdfcbacc57$var$Jn.source, e.src_ZPCc = [
            e.src_Z,
            e.src_P,
            e.src_Cc
        ].join("|"), e.src_ZCc = [
            e.src_Z,
            e.src_Cc
        ].join("|");
        var t = "[><\uFF5C]";
        return e.src_pseudo_letter = "(?:(?!" + t + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + t + "|" + e.src_ZPCc + ")(?!" + (n["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + t + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (n["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + t + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // but can start with > (markdown blockquote)
        "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + e.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // but can start with > (markdown blockquote)
        "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + e.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
    }), $b19ca0fdfcbacc57$var$Fn;
}
function $b19ca0fdfcbacc57$var$zn(n) {
    var e = Array.prototype.slice.call(arguments, 1);
    return e.forEach(function(t) {
        t && Object.keys(t).forEach(function(r) {
            n[r] = t[r];
        });
    }), n;
}
function $b19ca0fdfcbacc57$var$kn(n) {
    return Object.prototype.toString.call(n);
}
function $b19ca0fdfcbacc57$var$Z4(n) {
    return $b19ca0fdfcbacc57$var$kn(n) === "[object String]";
}
function $b19ca0fdfcbacc57$var$K4(n) {
    return $b19ca0fdfcbacc57$var$kn(n) === "[object Object]";
}
function $b19ca0fdfcbacc57$var$W4(n) {
    return $b19ca0fdfcbacc57$var$kn(n) === "[object RegExp]";
}
function $b19ca0fdfcbacc57$var$rr(n) {
    return $b19ca0fdfcbacc57$var$kn(n) === "[object Function]";
}
function $b19ca0fdfcbacc57$var$Y4(n) {
    return n.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
var $b19ca0fdfcbacc57$var$Jr = {
    fuzzyLink: !0,
    fuzzyEmail: !0,
    fuzzyIP: !1
};
function $b19ca0fdfcbacc57$var$J4(n) {
    return Object.keys(n || {}).reduce(function(e, t) {
        return e || $b19ca0fdfcbacc57$var$Jr.hasOwnProperty(t);
    }, !1);
}
var $b19ca0fdfcbacc57$var$X4 = {
    "http:": {
        validate: function(n, e, t) {
            var r = n.slice(e);
            return t.re.http || (t.re.http = new RegExp("^\\/\\/" + t.re.src_auth + t.re.src_host_port_strict + t.re.src_path, "i")), t.re.http.test(r) ? r.match(t.re.http)[0].length : 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(n, e, t) {
            var r = n.slice(e);
            return t.re.no_http || (t.re.no_http = new RegExp("^" + t.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + t.re.src_domain + ")\\.)+" + t.re.src_domain_root + ")" + t.re.src_port + t.re.src_host_terminator + t.re.src_path, "i")), t.re.no_http.test(r) ? e >= 3 && n[e - 3] === ":" || e >= 3 && n[e - 3] === "/" ? 0 : r.match(t.re.no_http)[0].length : 0;
        }
    },
    "mailto:": {
        validate: function(n, e, t) {
            var r = n.slice(e);
            return t.re.mailto || (t.re.mailto = new RegExp("^" + t.re.src_email_name + "@" + t.re.src_host_strict, "i")), t.re.mailto.test(r) ? r.match(t.re.mailto)[0].length : 0;
        }
    }
}, $b19ca0fdfcbacc57$var$Q4 = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", $b19ca0fdfcbacc57$var$e8 = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $b19ca0fdfcbacc57$var$n8(n) {
    n.__index__ = -1, n.__text_cache__ = "";
}
function $b19ca0fdfcbacc57$var$t8(n) {
    return function(e, t) {
        var r = e.slice(t);
        return n.test(r) ? r.match(n)[0].length : 0;
    };
}
function $b19ca0fdfcbacc57$var$or() {
    return function(n, e) {
        e.normalize(n);
    };
}
function $b19ca0fdfcbacc57$var$an(n) {
    var e = n.re = $b19ca0fdfcbacc57$var$j4()(n.__opts__), t = n.__tlds__.slice();
    n.onCompile(), n.__tlds_replaced__ || t.push($b19ca0fdfcbacc57$var$Q4), t.push(e.src_xn), e.src_tlds = t.join("|");
    function r(c) {
        return c.replace("%TLDS%", e.src_tlds);
    }
    e.email_fuzzy = RegExp(r(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(r(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(r(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(r(e.tpl_host_fuzzy_test), "i");
    var o = [];
    n.__compiled__ = {};
    function s(c, a) {
        throw new Error('(LinkifyIt) Invalid schema "' + c + '": ' + a);
    }
    Object.keys(n.__schemas__).forEach(function(c) {
        var a = n.__schemas__[c];
        if (a !== null) {
            var l = {
                validate: null,
                link: null
            };
            if (n.__compiled__[c] = l, $b19ca0fdfcbacc57$var$K4(a)) {
                $b19ca0fdfcbacc57$var$W4(a.validate) ? l.validate = $b19ca0fdfcbacc57$var$t8(a.validate) : $b19ca0fdfcbacc57$var$rr(a.validate) ? l.validate = a.validate : s(c, a), $b19ca0fdfcbacc57$var$rr(a.normalize) ? l.normalize = a.normalize : a.normalize ? s(c, a) : l.normalize = $b19ca0fdfcbacc57$var$or();
                return;
            }
            if ($b19ca0fdfcbacc57$var$Z4(a)) {
                o.push(c);
                return;
            }
            s(c, a);
        }
    }), o.forEach(function(c) {
        n.__compiled__[n.__schemas__[c]] && (n.__compiled__[c].validate = n.__compiled__[n.__schemas__[c]].validate, n.__compiled__[c].normalize = n.__compiled__[n.__schemas__[c]].normalize);
    }), n.__compiled__[""] = {
        validate: null,
        normalize: $b19ca0fdfcbacc57$var$or()
    };
    var i = Object.keys(n.__compiled__).filter(function(c) {
        return c.length > 0 && n.__compiled__[c];
    }).map($b19ca0fdfcbacc57$var$Y4).join("|");
    n.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + e.src_ZPCc + "))(" + i + ")", "i"), n.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + e.src_ZPCc + "))(" + i + ")", "ig"), n.re.schema_at_start = RegExp("^" + n.re.schema_search.source, "i"), n.re.pretest = RegExp("(" + n.re.schema_test.source + ")|(" + n.re.host_fuzzy_test.source + ")|@", "i"), $b19ca0fdfcbacc57$var$n8(n);
}
function $b19ca0fdfcbacc57$var$r8(n, e) {
    var t = n.__index__, r = n.__last_index__, o = n.__text_cache__.slice(t, r);
    this.schema = n.__schema__.toLowerCase(), this.index = t + e, this.lastIndex = r + e, this.raw = o, this.text = o, this.url = o;
}
function $b19ca0fdfcbacc57$var$Un(n, e) {
    var t = new $b19ca0fdfcbacc57$var$r8(n, e);
    return n.__compiled__[t.schema].normalize(t, n), t;
}
function $b19ca0fdfcbacc57$var$ce(n, e) {
    if (!(this instanceof $b19ca0fdfcbacc57$var$ce)) return new $b19ca0fdfcbacc57$var$ce(n, e);
    e || $b19ca0fdfcbacc57$var$J4(n) && (e = n, n = {}), this.__opts__ = $b19ca0fdfcbacc57$var$zn({}, $b19ca0fdfcbacc57$var$Jr, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = $b19ca0fdfcbacc57$var$zn({}, $b19ca0fdfcbacc57$var$X4, n), this.__compiled__ = {}, this.__tlds__ = $b19ca0fdfcbacc57$var$e8, this.__tlds_replaced__ = !1, this.re = {}, $b19ca0fdfcbacc57$var$an(this);
}
$b19ca0fdfcbacc57$var$ce.prototype.add = function(e, t) {
    return this.__schemas__[e] = t, $b19ca0fdfcbacc57$var$an(this), this;
};
$b19ca0fdfcbacc57$var$ce.prototype.set = function(e) {
    return this.__opts__ = $b19ca0fdfcbacc57$var$zn(this.__opts__, e), this;
};
$b19ca0fdfcbacc57$var$ce.prototype.test = function(e) {
    if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return !1;
    var t, r, o, s, i, c, a, l, u;
    if (this.re.schema_test.test(e)) {
        for(a = this.re.schema_search, a.lastIndex = 0; (t = a.exec(e)) !== null;)if (s = this.testSchemaAt(e, t[2], a.lastIndex), s) {
            this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + s;
            break;
        }
    }
    return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = e.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && (r = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (i = r.index + r[1].length, (this.__index__ < 0 || i < this.__index__) && (this.__schema__ = "", this.__index__ = i, this.__last_index__ = r.index + r[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (u = e.indexOf("@"), u >= 0 && (o = e.match(this.re.email_fuzzy)) !== null && (i = o.index + o[1].length, c = o.index + o[0].length, (this.__index__ < 0 || i < this.__index__ || i === this.__index__ && c > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = i, this.__last_index__ = c))), this.__index__ >= 0;
};
$b19ca0fdfcbacc57$var$ce.prototype.pretest = function(e) {
    return this.re.pretest.test(e);
};
$b19ca0fdfcbacc57$var$ce.prototype.testSchemaAt = function(e, t, r) {
    return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(e, r, this) : 0;
};
$b19ca0fdfcbacc57$var$ce.prototype.match = function(e) {
    var t = 0, r = [];
    this.__index__ >= 0 && this.__text_cache__ === e && (r.push($b19ca0fdfcbacc57$var$Un(this, t)), t = this.__last_index__);
    for(var o = t ? e.slice(t) : e; this.test(o);)r.push($b19ca0fdfcbacc57$var$Un(this, t)), o = o.slice(this.__last_index__), t += this.__last_index__;
    return r.length ? r : null;
};
$b19ca0fdfcbacc57$var$ce.prototype.matchAtStart = function(e) {
    if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
    var t = this.re.schema_at_start.exec(e);
    if (!t) return null;
    var r = this.testSchemaAt(e, t[2], t[0].length);
    return r ? (this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + r, $b19ca0fdfcbacc57$var$Un(this, 0)) : null;
};
$b19ca0fdfcbacc57$var$ce.prototype.tlds = function(e, t) {
    return e = Array.isArray(e) ? e : [
        e
    ], t ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(r, o, s) {
        return r !== s[o - 1];
    }).reverse(), $b19ca0fdfcbacc57$var$an(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, $b19ca0fdfcbacc57$var$an(this), this);
};
$b19ca0fdfcbacc57$var$ce.prototype.normalize = function(e) {
    e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
$b19ca0fdfcbacc57$var$ce.prototype.onCompile = function() {};
var $b19ca0fdfcbacc57$var$o8 = $b19ca0fdfcbacc57$var$ce;
const $b19ca0fdfcbacc57$var$Le = 2147483647, $b19ca0fdfcbacc57$var$pe = 36, $b19ca0fdfcbacc57$var$rt = 1, $b19ca0fdfcbacc57$var$Ve = 26, $b19ca0fdfcbacc57$var$s8 = 38, $b19ca0fdfcbacc57$var$c8 = 700, $b19ca0fdfcbacc57$var$Xr = 72, $b19ca0fdfcbacc57$var$Qr = 128, $b19ca0fdfcbacc57$var$eo = "-", $b19ca0fdfcbacc57$var$i8 = /^xn--/, $b19ca0fdfcbacc57$var$a8 = /[^\0-\x7F]/, $b19ca0fdfcbacc57$var$l8 = /[\x2E\u3002\uFF0E\uFF61]/g, $b19ca0fdfcbacc57$var$u8 = {
    overflow: "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
}, $b19ca0fdfcbacc57$var$Bn = $b19ca0fdfcbacc57$var$pe - $b19ca0fdfcbacc57$var$rt, $b19ca0fdfcbacc57$var$he = Math.floor, $b19ca0fdfcbacc57$var$Pn = String.fromCharCode;
function $b19ca0fdfcbacc57$var$ve(n) {
    throw new RangeError($b19ca0fdfcbacc57$var$u8[n]);
}
function $b19ca0fdfcbacc57$var$f8(n, e) {
    const t = [];
    let r = n.length;
    for(; r--;)t[r] = e(n[r]);
    return t;
}
function $b19ca0fdfcbacc57$var$no(n, e) {
    const t = n.split("@");
    let r = "";
    t.length > 1 && (r = t[0] + "@", n = t[1]), n = n.replace($b19ca0fdfcbacc57$var$l8, ".");
    const o = n.split("."), s = $b19ca0fdfcbacc57$var$f8(o, e).join(".");
    return r + s;
}
function $b19ca0fdfcbacc57$var$ot(n) {
    const e = [];
    let t = 0;
    const r = n.length;
    for(; t < r;){
        const o = n.charCodeAt(t++);
        if (o >= 55296 && o <= 56319 && t < r) {
            const s = n.charCodeAt(t++);
            (s & 64512) == 56320 ? e.push(((o & 1023) << 10) + (s & 1023) + 65536) : (e.push(o), t--);
        } else e.push(o);
    }
    return e;
}
const $b19ca0fdfcbacc57$var$to = (n)=>String.fromCodePoint(...n), $b19ca0fdfcbacc57$var$p8 = function(n) {
    return n >= 48 && n < 58 ? 26 + (n - 48) : n >= 65 && n < 91 ? n - 65 : n >= 97 && n < 123 ? n - 97 : $b19ca0fdfcbacc57$var$pe;
}, $b19ca0fdfcbacc57$var$sr = function(n, e) {
    return n + 22 + 75 * (n < 26) - ((e != 0) << 5);
}, $b19ca0fdfcbacc57$var$ro = function(n, e, t) {
    let r = 0;
    for(n = t ? $b19ca0fdfcbacc57$var$he(n / $b19ca0fdfcbacc57$var$c8) : n >> 1, n += $b19ca0fdfcbacc57$var$he(n / e); n > $b19ca0fdfcbacc57$var$Bn * $b19ca0fdfcbacc57$var$Ve >> 1; r += $b19ca0fdfcbacc57$var$pe)n = $b19ca0fdfcbacc57$var$he(n / $b19ca0fdfcbacc57$var$Bn);
    return $b19ca0fdfcbacc57$var$he(r + ($b19ca0fdfcbacc57$var$Bn + 1) * n / (n + $b19ca0fdfcbacc57$var$s8));
}, $b19ca0fdfcbacc57$var$st = function(n) {
    const e = [], t = n.length;
    let r = 0, o = $b19ca0fdfcbacc57$var$Qr, s = $b19ca0fdfcbacc57$var$Xr, i = n.lastIndexOf($b19ca0fdfcbacc57$var$eo);
    i < 0 && (i = 0);
    for(let c = 0; c < i; ++c)n.charCodeAt(c) >= 128 && $b19ca0fdfcbacc57$var$ve("not-basic"), e.push(n.charCodeAt(c));
    for(let c = i > 0 ? i + 1 : 0; c < t;){
        const a = r;
        for(let u = 1, p = $b19ca0fdfcbacc57$var$pe;; p += $b19ca0fdfcbacc57$var$pe){
            c >= t && $b19ca0fdfcbacc57$var$ve("invalid-input");
            const f = $b19ca0fdfcbacc57$var$p8(n.charCodeAt(c++));
            f >= $b19ca0fdfcbacc57$var$pe && $b19ca0fdfcbacc57$var$ve("invalid-input"), f > $b19ca0fdfcbacc57$var$he(($b19ca0fdfcbacc57$var$Le - r) / u) && $b19ca0fdfcbacc57$var$ve("overflow"), r += f * u;
            const h = p <= s ? $b19ca0fdfcbacc57$var$rt : p >= s + $b19ca0fdfcbacc57$var$Ve ? $b19ca0fdfcbacc57$var$Ve : p - s;
            if (f < h) break;
            const d = $b19ca0fdfcbacc57$var$pe - h;
            u > $b19ca0fdfcbacc57$var$he($b19ca0fdfcbacc57$var$Le / d) && $b19ca0fdfcbacc57$var$ve("overflow"), u *= d;
        }
        const l = e.length + 1;
        s = $b19ca0fdfcbacc57$var$ro(r - a, l, a == 0), $b19ca0fdfcbacc57$var$he(r / l) > $b19ca0fdfcbacc57$var$Le - o && $b19ca0fdfcbacc57$var$ve("overflow"), o += $b19ca0fdfcbacc57$var$he(r / l), r %= l, e.splice(r++, 0, o);
    }
    return String.fromCodePoint(...e);
}, $b19ca0fdfcbacc57$var$ct = function(n) {
    const e = [];
    n = $b19ca0fdfcbacc57$var$ot(n);
    const t = n.length;
    let r = $b19ca0fdfcbacc57$var$Qr, o = 0, s = $b19ca0fdfcbacc57$var$Xr;
    for (const a of n)a < 128 && e.push($b19ca0fdfcbacc57$var$Pn(a));
    const i = e.length;
    let c = i;
    for(i && e.push($b19ca0fdfcbacc57$var$eo); c < t;){
        let a = $b19ca0fdfcbacc57$var$Le;
        for (const u of n)u >= r && u < a && (a = u);
        const l = c + 1;
        a - r > $b19ca0fdfcbacc57$var$he(($b19ca0fdfcbacc57$var$Le - o) / l) && $b19ca0fdfcbacc57$var$ve("overflow"), o += (a - r) * l, r = a;
        for (const u of n)if (u < r && ++o > $b19ca0fdfcbacc57$var$Le && $b19ca0fdfcbacc57$var$ve("overflow"), u === r) {
            let p = o;
            for(let f = $b19ca0fdfcbacc57$var$pe;; f += $b19ca0fdfcbacc57$var$pe){
                const h = f <= s ? $b19ca0fdfcbacc57$var$rt : f >= s + $b19ca0fdfcbacc57$var$Ve ? $b19ca0fdfcbacc57$var$Ve : f - s;
                if (p < h) break;
                const d = p - h, g = $b19ca0fdfcbacc57$var$pe - h;
                e.push($b19ca0fdfcbacc57$var$Pn($b19ca0fdfcbacc57$var$sr(h + d % g, 0))), p = $b19ca0fdfcbacc57$var$he(d / g);
            }
            e.push($b19ca0fdfcbacc57$var$Pn($b19ca0fdfcbacc57$var$sr(p, 0))), s = $b19ca0fdfcbacc57$var$ro(o, l, c === i), o = 0, ++c;
        }
        ++o, ++r;
    }
    return e.join("");
}, $b19ca0fdfcbacc57$var$oo = function(n) {
    return $b19ca0fdfcbacc57$var$no(n, function(e) {
        return $b19ca0fdfcbacc57$var$i8.test(e) ? $b19ca0fdfcbacc57$var$st(e.slice(4).toLowerCase()) : e;
    });
}, $b19ca0fdfcbacc57$var$so = function(n) {
    return $b19ca0fdfcbacc57$var$no(n, function(e) {
        return $b19ca0fdfcbacc57$var$a8.test(e) ? "xn--" + $b19ca0fdfcbacc57$var$ct(e) : e;
    });
}, $b19ca0fdfcbacc57$var$h8 = {
    /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */ version: "2.3.1",
    /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */ ucs2: {
        decode: $b19ca0fdfcbacc57$var$ot,
        encode: $b19ca0fdfcbacc57$var$to
    },
    decode: $b19ca0fdfcbacc57$var$st,
    encode: $b19ca0fdfcbacc57$var$ct,
    toASCII: $b19ca0fdfcbacc57$var$so,
    toUnicode: $b19ca0fdfcbacc57$var$oo
}, $b19ca0fdfcbacc57$var$d8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    decode: $b19ca0fdfcbacc57$var$st,
    default: $b19ca0fdfcbacc57$var$h8,
    encode: $b19ca0fdfcbacc57$var$ct,
    toASCII: $b19ca0fdfcbacc57$var$so,
    toUnicode: $b19ca0fdfcbacc57$var$oo,
    ucs2decode: $b19ca0fdfcbacc57$var$ot,
    ucs2encode: $b19ca0fdfcbacc57$var$to
}, Symbol.toStringTag, {
    value: "Module"
})), $b19ca0fdfcbacc57$var$g8 = /* @__PURE__ */ $b19ca0fdfcbacc57$var$Zo($b19ca0fdfcbacc57$var$d8);
var $b19ca0fdfcbacc57$var$m8 = {
    options: {
        html: !1,
        // Enable HTML tags in source
        xhtmlOut: !1,
        // Use '/' to close single tags (<br />)
        breaks: !1,
        // Convert '\n' in paragraphs into <br>
        langPrefix: "language-",
        // CSS language prefix for fenced blocks
        linkify: !1,
        // autoconvert URL-like texts to links
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
}, $b19ca0fdfcbacc57$var$_8 = {
    options: {
        html: !1,
        // Enable HTML tags in source
        xhtmlOut: !1,
        // Use '/' to close single tags (<br />)
        breaks: !1,
        // Convert '\n' in paragraphs into <br>
        langPrefix: "language-",
        // CSS language prefix for fenced blocks
        linkify: !1,
        // autoconvert URL-like texts to links
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
}, $b19ca0fdfcbacc57$var$b8 = {
    options: {
        html: !0,
        // Enable HTML tags in source
        xhtmlOut: !0,
        // Use '/' to close single tags (<br />)
        breaks: !1,
        // Convert '\n' in paragraphs into <br>
        langPrefix: "language-",
        // CSS language prefix for fenced blocks
        linkify: !1,
        // autoconvert URL-like texts to links
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
}, $b19ca0fdfcbacc57$var$Pe = $b19ca0fdfcbacc57$var$$, $b19ca0fdfcbacc57$var$v8 = $b19ca0fdfcbacc57$var$dn, $b19ca0fdfcbacc57$var$k8 = $b19ca0fdfcbacc57$var$p9, $b19ca0fdfcbacc57$var$x8 = $b19ca0fdfcbacc57$var$O9, $b19ca0fdfcbacc57$var$y8 = $b19ca0fdfcbacc57$var$g4, $b19ca0fdfcbacc57$var$E8 = $b19ca0fdfcbacc57$var$G4, $b19ca0fdfcbacc57$var$w8 = $b19ca0fdfcbacc57$var$o8, $b19ca0fdfcbacc57$var$we = $b19ca0fdfcbacc57$var$Me, $b19ca0fdfcbacc57$var$co = $b19ca0fdfcbacc57$var$g8, $b19ca0fdfcbacc57$var$A8 = {
    default: $b19ca0fdfcbacc57$var$m8,
    zero: $b19ca0fdfcbacc57$var$_8,
    commonmark: $b19ca0fdfcbacc57$var$b8
}, $b19ca0fdfcbacc57$var$C8 = /^(vbscript|javascript|file|data):/, $b19ca0fdfcbacc57$var$S8 = /^data:image\/(gif|png|jpeg|webp);/;
function $b19ca0fdfcbacc57$var$D8(n) {
    var e = n.trim().toLowerCase();
    return $b19ca0fdfcbacc57$var$C8.test(e) ? !!$b19ca0fdfcbacc57$var$S8.test(e) : !0;
}
var $b19ca0fdfcbacc57$var$io = [
    "http:",
    "https:",
    "mailto:"
];
function $b19ca0fdfcbacc57$var$T8(n) {
    var e = $b19ca0fdfcbacc57$var$we.parse(n, !0);
    if (e.hostname && (!e.protocol || $b19ca0fdfcbacc57$var$io.indexOf(e.protocol) >= 0)) try {
        e.hostname = $b19ca0fdfcbacc57$var$co.toASCII(e.hostname);
    } catch  {}
    return $b19ca0fdfcbacc57$var$we.encode($b19ca0fdfcbacc57$var$we.format(e));
}
function $b19ca0fdfcbacc57$var$R8(n) {
    var e = $b19ca0fdfcbacc57$var$we.parse(n, !0);
    if (e.hostname && (!e.protocol || $b19ca0fdfcbacc57$var$io.indexOf(e.protocol) >= 0)) try {
        e.hostname = $b19ca0fdfcbacc57$var$co.toUnicode(e.hostname);
    } catch  {}
    return $b19ca0fdfcbacc57$var$we.decode($b19ca0fdfcbacc57$var$we.format(e), $b19ca0fdfcbacc57$var$we.decode.defaultChars + "%");
}
function $b19ca0fdfcbacc57$var$ie(n, e) {
    if (!(this instanceof $b19ca0fdfcbacc57$var$ie)) return new $b19ca0fdfcbacc57$var$ie(n, e);
    e || $b19ca0fdfcbacc57$var$Pe.isString(n) || (e = n || {}, n = "default"), this.inline = new $b19ca0fdfcbacc57$var$E8(), this.block = new $b19ca0fdfcbacc57$var$y8(), this.core = new $b19ca0fdfcbacc57$var$x8(), this.renderer = new $b19ca0fdfcbacc57$var$k8(), this.linkify = new $b19ca0fdfcbacc57$var$w8(), this.validateLink = $b19ca0fdfcbacc57$var$D8, this.normalizeLink = $b19ca0fdfcbacc57$var$T8, this.normalizeLinkText = $b19ca0fdfcbacc57$var$R8, this.utils = $b19ca0fdfcbacc57$var$Pe, this.helpers = $b19ca0fdfcbacc57$var$Pe.assign({}, $b19ca0fdfcbacc57$var$v8), this.options = {}, this.configure(n), e && this.set(e);
}
$b19ca0fdfcbacc57$var$ie.prototype.set = function(n) {
    return $b19ca0fdfcbacc57$var$Pe.assign(this.options, n), this;
};
$b19ca0fdfcbacc57$var$ie.prototype.configure = function(n) {
    var e = this, t;
    if ($b19ca0fdfcbacc57$var$Pe.isString(n) && (t = n, n = $b19ca0fdfcbacc57$var$A8[t], !n)) throw new Error('Wrong `markdown-it` preset "' + t + '", check name');
    if (!n) throw new Error("Wrong `markdown-it` preset, can't be empty");
    return n.options && e.set(n.options), n.components && Object.keys(n.components).forEach(function(r) {
        n.components[r].rules && e[r].ruler.enableOnly(n.components[r].rules), n.components[r].rules2 && e[r].ruler2.enableOnly(n.components[r].rules2);
    }), this;
};
$b19ca0fdfcbacc57$var$ie.prototype.enable = function(n, e) {
    var t = [];
    Array.isArray(n) || (n = [
        n
    ]), [
        "core",
        "block",
        "inline"
    ].forEach(function(o) {
        t = t.concat(this[o].ruler.enable(n, !0));
    }, this), t = t.concat(this.inline.ruler2.enable(n, !0));
    var r = n.filter(function(o) {
        return t.indexOf(o) < 0;
    });
    if (r.length && !e) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
    return this;
};
$b19ca0fdfcbacc57$var$ie.prototype.disable = function(n, e) {
    var t = [];
    Array.isArray(n) || (n = [
        n
    ]), [
        "core",
        "block",
        "inline"
    ].forEach(function(o) {
        t = t.concat(this[o].ruler.disable(n, !0));
    }, this), t = t.concat(this.inline.ruler2.disable(n, !0));
    var r = n.filter(function(o) {
        return t.indexOf(o) < 0;
    });
    if (r.length && !e) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
    return this;
};
$b19ca0fdfcbacc57$var$ie.prototype.use = function(n) {
    var e = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    return n.apply(n, e), this;
};
$b19ca0fdfcbacc57$var$ie.prototype.parse = function(n, e) {
    if (typeof n != "string") throw new Error("Input data should be a String");
    var t = new this.core.State(n, this, e);
    return this.core.process(t), t.tokens;
};
$b19ca0fdfcbacc57$var$ie.prototype.render = function(n, e) {
    return e = e || {}, this.renderer.render(this.parse(n, e), this.options, e);
};
$b19ca0fdfcbacc57$var$ie.prototype.parseInline = function(n, e) {
    var t = new this.core.State(n, this, e);
    return t.inlineMode = !0, this.core.process(t), t.tokens;
};
$b19ca0fdfcbacc57$var$ie.prototype.renderInline = function(n, e) {
    return e = e || {}, this.renderer.render(this.parseInline(n, e), this.options, e);
};
var $b19ca0fdfcbacc57$var$L8 = $b19ca0fdfcbacc57$var$ie, $b19ca0fdfcbacc57$var$N8 = $b19ca0fdfcbacc57$var$L8;
const $b19ca0fdfcbacc57$var$q8 = /* @__PURE__ */ $b19ca0fdfcbacc57$var$Gn($b19ca0fdfcbacc57$var$N8), $b19ca0fdfcbacc57$var$M8 = (0, $TusQn.defineComponent)({
    name: "VueMarkdown",
    props: {
        source: {
            type: String,
            required: !0
        },
        options: {
            type: Object,
            required: !1
        },
        plugins: {
            type: Array,
            required: !1
        }
    },
    setup (n) {
        const e = (0, $01W3b.ref)(new $b19ca0fdfcbacc57$var$q8(n.options ?? {}));
        for (const r of n.plugins ?? [])e.value.use(r);
        const t = (0, $01W3b.computed)(()=>e.value.render(n.source));
        return ()=>(0, $TusQn.h)("div", {
                innerHTML: t.value
            });
    }
}), $b19ca0fdfcbacc57$var$I8 = {
    key: 0,
    class: "chat-message-actions"
}, $b19ca0fdfcbacc57$var$O8 = {
    key: 2,
    class: "chat-message-files"
}, $b19ca0fdfcbacc57$var$Hn = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "Message",
    props: {
        message: {}
    },
    setup (n, { expose: e }) {
        const t = n;
        $b19ca0fdfcbacc57$var$be.registerLanguage("javascript", $b19ca0fdfcbacc57$var$Rr), $b19ca0fdfcbacc57$var$be.registerLanguage("typescript", $b19ca0fdfcbacc57$var$vi), $b19ca0fdfcbacc57$var$be.registerLanguage("python", $b19ca0fdfcbacc57$var$_i), $b19ca0fdfcbacc57$var$be.registerLanguage("xml", $b19ca0fdfcbacc57$var$Lr), $b19ca0fdfcbacc57$var$be.registerLanguage("bash", $b19ca0fdfcbacc57$var$mi);
        const { message: r } = (0, $01W3b.toRefs)(t), { options: o } = $b19ca0fdfcbacc57$var$Ge(), s = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)({}), c = (0, $01W3b.computed)(()=>r.value.text || "&lt;Empty response&gt;"), a = (0, $01W3b.computed)(()=>({
                "chat-message-from-user": r.value.sender === "user",
                "chat-message-from-bot": r.value.sender === "bot",
                "chat-message-transparent": r.value.transparent === !0
            })), l = (d)=>{
            d.use($b19ca0fdfcbacc57$var$Ei, {
                attrs: {
                    target: "_blank",
                    rel: "noopener"
                }
            });
        }, u = ()=>{
            var d;
            (d = s.value) != null && d.scrollIntoView && s.value.scrollIntoView({
                block: "center"
            });
        }, p = {
            highlight (d, g) {
                if (g && $b19ca0fdfcbacc57$var$be.getLanguage(g)) try {
                    return $b19ca0fdfcbacc57$var$be.highlight(d, {
                        language: g
                    }).value;
                } catch  {}
                return "";
            }
        }, f = {
            ...(o == null ? void 0 : o.messageComponents) ?? {}
        };
        e({
            scrollToView: u
        });
        const h = async (d)=>await new Promise((g, E)=>{
                const x = new FileReader();
                x.onload = ()=>g(x.result), x.onerror = E, x.readAsDataURL(d);
            });
        return (0, $TusQn.onMounted)(async ()=>{
            if (r.value.files) for (const d of r.value.files)try {
                const g = await h(d);
                i.value[d.name] = g;
            } catch (g) {
                console.error("Error reading file:", g);
            }
        }), (d, g)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                ref_key: "messageContainer",
                ref: s,
                class: (0, $8POXm.normalizeClass)([
                    "chat-message",
                    a.value
                ])
            }, [
                d.$slots.beforeMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$I8, [
                    (0, $TusQn.renderSlot)(d.$slots, "beforeMessage", (0, $8POXm.normalizeProps)((0, $TusQn.guardReactiveProps)({
                        message: (0, $01W3b.unref)(r)
                    })))
                ])) : (0, $TusQn.createCommentVNode)("", !0),
                (0, $TusQn.renderSlot)(d.$slots, "default", {}, ()=>[
                        (0, $01W3b.unref)(r).type === "component" && f[(0, $01W3b.unref)(r).key] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(f[(0, $01W3b.unref)(r).key]), (0, $8POXm.normalizeProps)((0, $TusQn.mergeProps)({
                            key: 0
                        }, (0, $01W3b.unref)(r).arguments)), null, 16)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$M8), {
                            key: 1,
                            class: "chat-message-markdown",
                            source: c.value,
                            options: p,
                            plugins: [
                                l
                            ]
                        }, null, 8, [
                            "source",
                            "plugins"
                        ])),
                        ((0, $01W3b.unref)(r).files ?? []).length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$O8, [
                            ((0, $TusQn.openBlock)(!0), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)((0, $01W3b.unref)(r).files ?? [], (E)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                    key: E.name,
                                    class: "chat-message-file"
                                }, [
                                    (0, $TusQn.createVNode)($b19ca0fdfcbacc57$var$Nr, {
                                        file: E,
                                        "is-removable": !1,
                                        "is-previewable": !0
                                    }, null, 8, [
                                        "file"
                                    ])
                                ]))), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", !0)
                    ])
            ], 2));
    }
}), $b19ca0fdfcbacc57$var$F8 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("div", {
    class: "chat-message-typing-body"
}, [
    /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
        class: "chat-message-typing-circle"
    }),
    /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
        class: "chat-message-typing-circle"
    }),
    /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
        class: "chat-message-typing-circle"
    })
], -1), $b19ca0fdfcbacc57$var$B8 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "MessageTyping",
    props: {
        animation: {
            default: "bouncing"
        }
    },
    setup (n) {
        const e = n, t = {
            id: "typing",
            text: "",
            sender: "bot",
            createdAt: ""
        }, r = (0, $01W3b.ref)(), o = (0, $01W3b.computed)(()=>({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "chat-message-typing": !0,
                [`chat-message-typing-animation-${e.animation}`]: !0
            }));
        return (0, $TusQn.onMounted)(()=>{
            var s;
            (s = r.value) == null || s.scrollToView();
        }), (s, i)=>((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$Hn), {
                ref_key: "messageContainer",
                ref: r,
                class: (0, $8POXm.normalizeClass)(o.value),
                message: t
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        $b19ca0fdfcbacc57$var$F8
                    ]),
                _: 1
            }, 8, [
                "class"
            ]));
    }
}), $b19ca0fdfcbacc57$var$P8 = {
    class: "chat-messages-list"
}, $b19ca0fdfcbacc57$var$$8 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "MessagesList",
    props: {
        messages: {}
    },
    setup (n) {
        const e = $b19ca0fdfcbacc57$var$Yn(), t = (0, $01W3b.ref)([]), { initialMessages: r, waitingForResponse: o } = e;
        return (0, $01W3b.watch)(()=>t.value.length, ()=>{
            const s = t.value[t.value.length - 1];
            s && s.scrollToView();
        }), (s, i)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$P8, [
                ((0, $TusQn.openBlock)(!0), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)((0, $01W3b.unref)(r), (c)=>((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$Hn, {
                        key: c.id,
                        message: c
                    }, null, 8, [
                        "message"
                    ]))), 128)),
                ((0, $TusQn.openBlock)(!0), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(s.messages, (c)=>((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$Hn, {
                        key: c.id,
                        ref_for: !0,
                        ref_key: "messageComponents",
                        ref: t,
                        message: c
                    }, {
                        beforeMessage: (0, $TusQn.withCtx)(({ message: a })=>[
                                (0, $TusQn.renderSlot)(s.$slots, "beforeMessage", (0, $8POXm.normalizeProps)((0, $TusQn.guardReactiveProps)({
                                    message: a
                                })))
                            ]),
                        _: 2
                    }, 1032, [
                        "message"
                    ]))), 128)),
                (0, $01W3b.unref)(o) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$B8, {
                    key: 0
                })) : (0, $TusQn.createCommentVNode)("", !0)
            ]));
    }
}), $b19ca0fdfcbacc57$var$z8 = {
    class: "chat-heading"
}, $b19ca0fdfcbacc57$var$U8 = [
    "title"
], $b19ca0fdfcbacc57$var$H8 = {
    key: 0
}, $b19ca0fdfcbacc57$var$ao = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "Chat",
    setup (n) {
        const { t: e } = $b19ca0fdfcbacc57$var$fn(), t = $b19ca0fdfcbacc57$var$Yn(), { messages: r, currentSessionId: o } = t, { options: s } = $b19ca0fdfcbacc57$var$Ge(), i = (0, $01W3b.computed)(()=>s.mode === "window" && s.showWindowCloseButton);
        async function c() {
            t.startNewSession && (t.startNewSession(), (0, $TusQn.nextTick)(()=>{
                $b19ca0fdfcbacc57$var$re.emit("scrollToBottom");
            }));
        }
        async function a() {
            t.loadPreviousSession && (await t.loadPreviousSession(), (0, $TusQn.nextTick)(()=>{
                $b19ca0fdfcbacc57$var$re.emit("scrollToBottom");
            }));
        }
        function l() {
            $b19ca0fdfcbacc57$var$re.emit("close");
        }
        return (0, $TusQn.onMounted)(async ()=>{
            await a(), !s.showWelcomeScreen && !o.value && await c();
        }), (u, p)=>((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$gi, {
                class: "chat-wrapper"
            }, {
                header: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("div", $b19ca0fdfcbacc57$var$z8, [
                            (0, $TusQn.createElementVNode)("h1", null, (0, $8POXm.toDisplayString)((0, $01W3b.unref)(e)("title")), 1),
                            i.value ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: 0,
                                class: "chat-close-button",
                                title: (0, $01W3b.unref)(e)("closeButtonTooltip"),
                                onClick: l
                            }, [
                                (0, $TusQn.createVNode)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$Qs), {
                                    height: "18",
                                    width: "18"
                                })
                            ], 8, $b19ca0fdfcbacc57$var$U8)) : (0, $TusQn.createCommentVNode)("", !0)
                        ]),
                        (0, $01W3b.unref)(e)("subtitle") ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $b19ca0fdfcbacc57$var$H8, (0, $8POXm.toDisplayString)((0, $01W3b.unref)(e)("subtitle")), 1)) : (0, $TusQn.createCommentVNode)("", !0)
                    ]),
                footer: (0, $TusQn.withCtx)(()=>[
                        (0, $01W3b.unref)(o) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$fi, {
                            key: 0
                        })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$lc, {
                            key: 1
                        }))
                    ]),
                default: (0, $TusQn.withCtx)(()=>[
                        !(0, $01W3b.unref)(o) && (0, $01W3b.unref)(s).showWelcomeScreen ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$nc, {
                            key: 0,
                            "onClick:button": c
                        })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($b19ca0fdfcbacc57$var$$8, {
                            key: 1,
                            messages: (0, $01W3b.unref)(r)
                        }, null, 8, [
                            "messages"
                        ]))
                    ]),
                _: 1
            }));
    }
}), $b19ca0fdfcbacc57$var$V8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$G8 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M12 3c5.5 0 10 3.58 10 8s-4.5 8-10 8c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.13 2 11c0-4.42 4.5-8 10-8"
}, null, -1), $b19ca0fdfcbacc57$var$j8 = [
    $b19ca0fdfcbacc57$var$G8
];
function $b19ca0fdfcbacc57$var$Z8(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$V8, [
        ...$b19ca0fdfcbacc57$var$j8
    ]);
}
const $b19ca0fdfcbacc57$var$K8 = {
    name: "mdi-chat",
    render: $b19ca0fdfcbacc57$var$Z8
}, $b19ca0fdfcbacc57$var$W8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
}, $b19ca0fdfcbacc57$var$Y8 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("path", {
    fill: "currentColor",
    d: "M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"
}, null, -1), $b19ca0fdfcbacc57$var$J8 = [
    $b19ca0fdfcbacc57$var$Y8
];
function $b19ca0fdfcbacc57$var$X8(n, e) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $b19ca0fdfcbacc57$var$W8, [
        ...$b19ca0fdfcbacc57$var$J8
    ]);
}
const $b19ca0fdfcbacc57$var$Q8 = {
    name: "mdi-chevron-down",
    render: $b19ca0fdfcbacc57$var$X8
}, $b19ca0fdfcbacc57$var$eH = {
    class: "chat-window-wrapper"
}, $b19ca0fdfcbacc57$var$nH = {
    class: "chat-window"
}, $b19ca0fdfcbacc57$var$tH = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "ChatWindow",
    setup (n) {
        const e = (0, $01W3b.ref)(!1);
        function t() {
            e.value = !e.value, e.value && (0, $TusQn.nextTick)(()=>{
                $b19ca0fdfcbacc57$var$re.emit("scrollToBottom");
            });
        }
        return (r, o)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b19ca0fdfcbacc57$var$eH, [
                (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                    name: "chat-window-transition"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $b19ca0fdfcbacc57$var$nH, [
                                (0, $TusQn.createVNode)($b19ca0fdfcbacc57$var$ao)
                            ], 512), [
                                [
                                    (0, $eeJ70.vShow),
                                    e.value
                                ]
                            ])
                        ]),
                    _: 1
                }),
                (0, $TusQn.createElementVNode)("div", {
                    class: "chat-window-toggle",
                    onClick: t
                }, [
                    (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                        name: "chat-window-toggle-transition",
                        mode: "out-in"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                e.value ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$Q8), {
                                    key: 1,
                                    height: "32",
                                    width: "32"
                                })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$K8), {
                                    key: 0,
                                    height: "32",
                                    width: "32"
                                }))
                            ]),
                        _: 1
                    })
                ])
            ]));
    }
}), $b19ca0fdfcbacc57$var$rH = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    __name: "App",
    props: {},
    setup (n) {
        const { options: e } = $b19ca0fdfcbacc57$var$Ge(), t = (0, $01W3b.computed)(()=>e.mode === "fullscreen");
        return (0, $TusQn.onMounted)(()=>{
            $b19ca0fdfcbacc57$var$be.registerLanguage("xml", $b19ca0fdfcbacc57$var$Lr), $b19ca0fdfcbacc57$var$be.registerLanguage("javascript", $b19ca0fdfcbacc57$var$Rr);
        }), (r, o)=>t.value ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$ao), {
                key: 0,
                class: "n8n-chat"
            })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)($b19ca0fdfcbacc57$var$tH), {
                key: 1,
                class: "n8n-chat"
            }));
    }
});
function $b19ca0fdfcbacc57$export$f680e1eadf80e402(n) {
    var o, s;
    const e = {
        ...$b19ca0fdfcbacc57$var$Fe,
        ...n,
        webhookConfig: {
            ...$b19ca0fdfcbacc57$var$Fe.webhookConfig,
            ...n == null ? void 0 : n.webhookConfig
        },
        i18n: {
            ...$b19ca0fdfcbacc57$var$Fe.i18n,
            ...n == null ? void 0 : n.i18n,
            en: {
                ...(o = $b19ca0fdfcbacc57$var$Fe.i18n) == null ? void 0 : o.en,
                ...(s = n == null ? void 0 : n.i18n) == null ? void 0 : s.en
            }
        },
        theme: {
            ...$b19ca0fdfcbacc57$var$Fe.theme,
            ...n == null ? void 0 : n.theme
        }
    }, t = e.target ?? $b19ca0fdfcbacc57$var$Mo;
    typeof t == "string" && $b19ca0fdfcbacc57$var$Go(t);
    const r = (0, $eeJ70.createApp)($b19ca0fdfcbacc57$var$rH);
    return r.use($b19ca0fdfcbacc57$var$jo, e), r.mount(t), r;
}

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("TusQn")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            $0a6cc4ba868319ae$var$isHmrUpdating = true;
            instance.parent.update();
            $0a6cc4ba868319ae$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$TeleportEndKey = Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $0a6cc4ba868319ae$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                mountToTarget();
                n2.el.__isMounted = true;
            }, parentSuspense);
            else mountToTarget();
        } else {
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    $0a6cc4ba868319ae$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                    delete n1.el.__isMounted;
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $0a6cc4ba868319ae$var$findNonCommentChild(children);
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, emittedValue) && (0, $8POXm.hasChanged)(value, prevSetValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(root, vnode.transition);
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.13";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope && $005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !$005d1fb7704e278c$var$isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, $005d1fb7704e278c$export$45c769cf449a508c);
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map($005d1fb7704e278c$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", $005d1fb7704e278c$export$45c769cf449a508c);
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $66ea9d0aaa418c4d$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("TusQn")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow();
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow();
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) (0, $8POXm.extend)(Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});




//# sourceMappingURL=akkasolstice3091.6ee333e1.js.map
